
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8rWe0"));

});
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "act", () => $72b03fdf46effee2$export$3ba232387fd5d6dd, (v) => $72b03fdf46effee2$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$3ba232387fd5d6dd;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $hPtJY && "function" === typeof $hPtJY.emit) {
        $hPtJY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $dca0ddb82b882518$var$getOwnHostContext(fiber), nextRootInstance = $dca0ddb82b882518$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, nextRootInstance);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$onCommitRoot(root) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 128, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194176) && ($dca0ddb82b882518$var$nextTransitionLane = 128);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_418) {
            var $dca0ddb82b882518$var$element$jscomp$inline_419 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_418 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_419.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 = $dca0ddb82b882518$var$isSupported$jscomp$inline_418;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $dca0ddb82b882518$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $dca0ddb82b882518$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $dca0ddb82b882518$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {}, $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $dca0ddb82b882518$var$SuspenseException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $dca0ddb82b882518$var$SuspenseException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
var $dca0ddb82b882518$var$createFunctionComponentUpdateQueue;
$dca0ddb82b882518$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber$1;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber$1, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 60) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$60);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber$1;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $dca0ddb82b882518$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= 2048, $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushEffect(hookFlags, create, inst, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$63 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$63, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber$1;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useCacheRefresh = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useMemoCache = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useHostTransitionStatus = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useFormState = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useActionState = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useOptimistic = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber$1, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 60) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1);
    }
};
$dca0ddb82b882518$var$HooksDispatcherOnMount.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useFormState = $dca0ddb82b882518$var$mountActionState;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useActionState = $dca0ddb82b882518$var$mountActionState;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useCacheRefresh = $dca0ddb82b882518$var$updateRefresh;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useFormState = $dca0ddb82b882518$var$updateActionState;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useActionState = $dca0ddb82b882518$var$updateActionState;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
};
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useCacheRefresh = $dca0ddb82b882518$var$updateRefresh;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useFormState = $dca0ddb82b882518$var$rerenderActionState;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useActionState = $dca0ddb82b882518$var$rerenderActionState;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $dca0ddb82b882518$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $hPtJY && "function" === typeof $hPtJY.emit) {
        $hPtJY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $dca0ddb82b882518$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, nextProps);
                nextProps !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(lazyComponent);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !0, renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, nextProps = $dca0ddb82b882518$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur;
    $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return) : $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $dca0ddb82b882518$var$detachDeletedInstance(deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParent;
            var prevHostParentIsContainer$119 = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParentIsContainer;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    finishedRoot = $dca0ddb82b882518$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (nearestMountedAncestor = $dca0ddb82b882518$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $dca0ddb82b882518$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $dca0ddb82b882518$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $dca0ddb82b882518$var$retryIfBlockedOn(nearestMountedAncestor)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$dca0ddb82b882518$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $dca0ddb82b882518$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$dca0ddb82b882518$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            type = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = nodeName || node;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = type || nextNode;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = type;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = nodeName;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($dca0ddb82b882518$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE:
            return $dca0ddb82b882518$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $dca0ddb82b882518$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194176) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $dca0ddb82b882518$var$hydrationErrors && ($dca0ddb82b882518$var$queueRecoverableErrors($dca0ddb82b882518$var$hydrationErrors), $dca0ddb82b882518$var$hydrationErrors = null));
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $dca0ddb82b882518$var$hydrationErrors && ($dca0ddb82b882518$var$queueRecoverableErrors($dca0ddb82b882518$var$hydrationErrors), $dca0ddb82b882518$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$rootDoesHavePassiveEffects = !1, $dca0ddb82b882518$var$rootWithPendingPassiveEffects = null, $dca0ddb82b882518$var$pendingPassiveEffectsLanes = 0, $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && 2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $dca0ddb82b882518$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < renderWasConcurrent)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$queueRecoverableErrors(errors) {
    null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = errors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, errors);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($dca0ddb82b882518$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194176) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $dca0ddb82b882518$var$workInProgressSuspendedReason && $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrent() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousUpdateLanePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$ReactSharedInternals.T = null, $dca0ddb82b882518$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $dca0ddb82b882518$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $dca0ddb82b882518$var$flushPassiveEffects();
    while (null !== $dca0ddb82b882518$var$rootWithPendingPassiveEffects);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $dca0ddb82b882518$var$rootDoesHavePassiveEffects || ($dca0ddb82b882518$var$rootDoesHavePassiveEffects = !0, $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $dca0ddb82b882518$var$pendingPassiveTransitions = transitions, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $dca0ddb82b882518$var$ReactSharedInternals.T, $dca0ddb82b882518$var$ReactSharedInternals.T = null, spawnedLane = $dca0ddb82b882518$var$ReactDOMSharedInternals.p, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, updatedLanes = $dca0ddb82b882518$var$executionContext, $dca0ddb82b882518$var$executionContext |= 4, $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root), $dca0ddb82b882518$var$restoreSelection($dca0ddb82b882518$var$selectionInformation, root.containerInfo), $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled, $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null, root.current = finishedWork, $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $dca0ddb82b882518$var$requestPaint(), $dca0ddb82b882518$var$executionContext = updatedLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = spawnedLane, $dca0ddb82b882518$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $dca0ddb82b882518$var$rootDoesHavePassiveEffects ? ($dca0ddb82b882518$var$rootDoesHavePassiveEffects = !1, $dca0ddb82b882518$var$rootWithPendingPassiveEffects = root, $dca0ddb82b882518$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $dca0ddb82b882518$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($dca0ddb82b882518$var$pendingPassiveEffectsLanes & 3) && $dca0ddb82b882518$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (null !== $dca0ddb82b882518$var$rootWithPendingPassiveEffects) {
        var root$170 = $dca0ddb82b882518$var$rootWithPendingPassiveEffects, remainingLanes = $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes;
        $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingPassiveEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        try {
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            if (null === $dca0ddb82b882518$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
                $dca0ddb82b882518$var$pendingPassiveTransitions = null;
                var root = $dca0ddb82b882518$var$rootWithPendingPassiveEffects, lanes = $dca0ddb82b882518$var$pendingPassiveEffectsLanes;
                $dca0ddb82b882518$var$rootWithPendingPassiveEffects = null;
                $dca0ddb82b882518$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
                var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
                $dca0ddb82b882518$var$executionContext |= 4;
                $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root.current);
                $dca0ddb82b882518$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $dca0ddb82b882518$var$executionContext = prevExecutionContext;
                $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
                    $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateTask($dca0ddb82b882518$var$processRootScheduleInMicrotask));
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$172, root$172 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPassiveEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateTask(cb) {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, cb) : cb();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1439 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1439 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1439++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1440 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1439], $dca0ddb82b882518$var$domEventName$jscomp$inline_1441 = $dca0ddb82b882518$var$eventName$jscomp$inline_1440.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1442 = $dca0ddb82b882518$var$eventName$jscomp$inline_1440[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1440.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1441, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1442);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$242 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$242 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $dca0ddb82b882518$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$248)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane(), root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $dca0ddb82b882518$var$flushPassiveEffects();
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $acw62.version;
if ("19.0.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    findFiberByHostInstance: $dca0ddb82b882518$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2166.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2166.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2166.inject($dca0ddb82b882518$var$internals$jscomp$inline_2165), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, isStrictMode);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $11c56e2ffb2d6006$export$8352ce38b91d0c62, (v) => $11c56e2ffb2d6006$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $11c56e2ffb2d6006$export$839f9183b0465a69, (v) => $11c56e2ffb2d6006$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $11c56e2ffb2d6006$export$4b844e58a3e414b4, (v) => $11c56e2ffb2d6006$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$8352ce38b91d0c62;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$839f9183b0465a69;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$4b844e58a3e414b4;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback();
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostCallback() {
    $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
}
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$8352ce38b91d0c62 = function() {
    $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback());
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$839f9183b0465a69 = function() {
    return $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$4b844e58a3e414b4 = function() {};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback()));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("4eM2B", function(module, exports) {

$parcel$export(module.exports, "LOGO_URL", () => $315dbc24fdcb29cb$export$8878ead86ed0da0b);
$parcel$export(module.exports, "CDN_URL", () => $315dbc24fdcb29cb$export$31adfacaf07ffe63);
$parcel$export(module.exports, "SWIGGY_API", () => $315dbc24fdcb29cb$export$85dc8a20c452aa8a);
$parcel$export(module.exports, "MENU_API", () => $315dbc24fdcb29cb$export$b77c1aa4fb57bd1c);
$parcel$export(module.exports, "GITHUB_API", () => $315dbc24fdcb29cb$export$7a2941050c51c7bc);
const $315dbc24fdcb29cb$export$8878ead86ed0da0b = 'https://img.freepik.com/free-vector/delivery-service-illustrated_23-2148505081.jpg?ga=GA1.1.273618505.1698651423&semt=ais_hybrid';
const $315dbc24fdcb29cb$export$31adfacaf07ffe63 = 'https://dineout-media-assets.swiggy.com/swiggy/image/upload/';
const $315dbc24fdcb29cb$export$85dc8a20c452aa8a = 'https://www.swiggy.com/dapi/restaurants/search/v3?lat=20.2959847&lng=85.8246101&str=restaurants&trackingId=dc51a832-70ee-c5fe-5ffe-e5eba69a27d7&submitAction=ENTER&queryUniqueId=37060c32-3f8c-5784-403e-43076add24f8 ';
const $315dbc24fdcb29cb$export$18b61346441d8f20 = 'http://localhost:2345/data';
const $315dbc24fdcb29cb$export$b77c1aa4fb57bd1c = 'https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=20.2959847&lng=85.8246101&restaurantId=';
const $315dbc24fdcb29cb$export$7a2941050c51c7bc = 'https://api.github.com/users/rahul1227';

});

parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});

parcelRegister("YVclQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b71f915dc7b7210$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $0b71f915dc7b7210$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "shimmer-wrapper",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "shimmer-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "shimmer-page-top"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "shimmer-search"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "shimmer-top-rated"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "shimmer-container",
                children: Array(12).fill("").map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "shimmer",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "shimmer-img"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "inside-shimmer1"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "inside-shimmer2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "inside-shimmer3"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "inside-shimmer4"
                            })
                        ]
                    }, index))
            })
        ]
    });
};
var $0b71f915dc7b7210$export$2e2bcd8739ae039 = $0b71f915dc7b7210$var$Shimmer;

});

parcelRegister("cc1va", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");


module.exports = Promise.all([
    (parcelRequire("fFMZG"))((parcelRequire("27Lyk")).resolve("8VALw")),
    $Gr8vk("jmW5S")
]).then(()=>parcelRequire('h0EEC'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});

parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f9345ad2c034f768$var$cachedPreloads;
        case 'prefetch':
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $0c5bdcfdc7a57842$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"Y15zO\",\"index.b341fade.js\",\"jmW5S\",\"About.e7b721ce.js\",\"8VALw\",\"About.733704e5.css\",\"8koGT\",\"index.cad5df4d.css\"]"));


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4eM2B = parcelRequire("4eM2B");
/**
 * React Router DOM v6.4.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.0.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref (to) {
            return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            index = clampIndex(index + delta);
            if (listener) listener({
                action: action,
                location: getCurrentLocation()
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$var$warning$1(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location) {
    return {
        usr: location.state,
        key: location.key
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$createClientSideURL(location) {
    // window.location.origin is "null" (the literal string value) in Firefox
    // under certain conditions, notably when serving from a local HTML file
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
    let base = typeof window !== "undefined" && typeof window.location !== "undefined" && window.location.origin !== "null" ? window.location.origin : window.location.href;
    let href = typeof location === "string" ? location : $1d34d5c4a288b213$export$fe53371bee54353d(location);
    $1d34d5c4a288b213$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL for href: " + href);
    return new URL(href, base);
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        if (listener) listener({
            action: action,
            location: history.location
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location
        });
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = $1d34d5c4a288b213$var$createClientSideURL(typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, parentPath, allIds) {
    if (parentPath === void 0) parentPath = [];
    if (allIds === void 0) allIds = new Set();
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$f5708dca728d7177(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$f5708dca728d7177(!allIds.has(id), "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        allIds.add(id);
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, {
                id: id
            });
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, {
                id: id,
                children: route.children ? $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, treePath, allIds) : undefined
            });
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    routes.forEach((route, index)=>{
        let meta = {
            relativePath: route.path || "",
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$f5708dca728d7177(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(path, params) {
    if (params === void 0) params = {};
    return path.replace(/:(\w+)/g, (_, key)=>{
        $1d34d5c4a288b213$export$f5708dca728d7177(params[key] != null, "Missing \":" + key + "\" param");
        return params[key];
    }).replace(/(\/?)\*/, (_, prefix, __, str)=>{
        const star = "*";
        if (params[star] == null) // If no splat was provided, trim the trailing slash _unless_ it's
        // the entire path
        return str === "/*" ? "/" : "";
         // Apply the splat
        return "" + prefix + params[star];
    });
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$491112666e282270(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$491112666e282270(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$491112666e282270(false, "The value for the URL param \"" + paramName + "\" will not be decoded because" + (" the string \"" + value + "\" is a malformed URL segment. This is probably") + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$491112666e282270(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$var$DeferredData {
    constructor(data){
        this.pendingKeys = new Set();
        this.subscriber = undefined;
        $1d34d5c4a288b213$export$f5708dca728d7177(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.pendingKeys.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeys.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        const subscriber = this.subscriber;
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            subscriber && subscriber(false);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        subscriber && subscriber(false);
        return data;
    }
    subscribe(fn) {
        this.subscriber = fn;
    }
    cancel() {
        this.controller.abort();
        this.pendingKeys.forEach((v, k)=>this.pendingKeys.delete(k));
        let subscriber = this.subscriber;
        subscriber && subscriber(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeys.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$f5708dca728d7177(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
function $1d34d5c4a288b213$export$260e5c0943f31606(data) {
    return new $1d34d5c4a288b213$var$DeferredData(data);
}
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $1d34d5c4a288b213$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response throw from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(e) {
    return e instanceof $1d34d5c4a288b213$export$acf1a680051f5031;
}
const $1d34d5c4a288b213$var$validActionMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validActionMethods = new Set($1d34d5c4a288b213$var$validActionMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validActionMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $1d34d5c4a288b213$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $1d34d5c4a288b213$var$isServer = !$1d34d5c4a288b213$var$isBrowser; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    $1d34d5c4a288b213$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    let initialScrollRestored = false;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = !initialMatches.some((m)=>m.route.loader) || init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        restoreScrollPosition: null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location } = _ref;
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _state$navigation$for;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a submission
        // - We're past the submitting state and into the loading state
        // - The location we've finished loading is different from the submission
        //   location, indicating we redirected from the action (avoids false
        //   positives for loading/submissionRedirect when actionData returned
        //   on a prior submission)
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && state.navigation.state === "loading" && ((_state$navigation$for = state.navigation.formAction) == null ? void 0 : _state$navigation$for.split("?")[0]) === location.pathname; // Always preserve any existing loaderData from re-used routes
        let newLoaderData = newState.loaderData ? {
            loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [])
        } : {};
        updateState($1d34d5c4a288b213$var$_extends({}, isActionReload ? {} : {
            actionData: null
        }, newState, newLoaderData, {
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            // Don't restore on submission navigations
            restoreScrollPosition: state.navigation.formData ? false : getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: pendingPreventScrollReset
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(to, opts);
        let location = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        location = $1d34d5c4a288b213$var$_extends({}, location, init.history.encodeLocation(location));
        let historyAction = (opts && opts.replace) === true || submission != null ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        return await startNavigation(historyAction, location, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change
        if ($1d34d5c4a288b213$var$isHashChangeOnly(state.location, location)) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $1d34d5c4a288b213$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: matches,
            loaderData: loaderData,
            errors: errors
        });
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result, opts && opts.replace === true);
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw new Error("defer() is not supported in actions");
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = {
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            loadingNavigation = navigation;
        }
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, {
                matches: matches,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, {}, matches),
                // Commit pending error if we're short circuiting
                errors: pendingError || null,
                actionData: pendingActionData || null
            });
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((_ref2)=>{
                let [key] = _ref2;
                let fetcher = state.fetchers.get(key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined
                };
                state.fetchers.set(key, revalidatingFetcher);
            });
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation,
                actionData: pendingActionData || state.actionData || null
            }, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((_ref3)=>{
            let [key] = _ref3;
            return fetchControllers.set(key, pendingNavigationController);
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((_ref4)=>{
            let [key] = _ref4;
            return fetchControllers.delete(key);
        }); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, replace);
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($1d34d5c4a288b213$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path: path, submission: submission } = $1d34d5c4a288b213$var$normalizeNavigateOptions(href, opts, true);
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        if (submission) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, [
            path,
            match,
            matches
        ]);
        handleFetcherLoader(key, routeId, path, match, matches);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $1d34d5c4a288b213$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult);
        } // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) $1d34d5c4a288b213$export$f5708dca728d7177(false, "defer() is not supported in actions");
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, state.navigation.location, init.basename) : state.matches;
        $1d34d5c4a288b213$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, {
            [match.route.id]: actionResult.data
        }, undefined, fetchLoadMatches); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((_ref5)=>{
            let [staleKey] = _ref5;
            return staleKey !== key;
        }).forEach((_ref6)=>{
            let [staleKey] = _ref6;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((_ref7)=>{
            let [staleKey] = _ref7;
            return fetchControllers.delete(staleKey);
        });
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            data: existingFetcher && existingFetcher.data
        };
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, router.basename); // Deferred isn't supported or fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$f5708dca728d7177(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, replace) {
        var _window;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location);
        $1d34d5c4a288b213$export$f5708dca728d7177(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an external redirect that goes to a new origin
        if (typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let newOrigin = $1d34d5c4a288b213$var$createClientSideURL(redirect.location).origin;
            if (window.location.origin !== newOrigin) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation; // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && formMethod && $1d34d5c4a288b213$var$isSubmissionMethod(formMethod) && formEncType && formData) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: {
                formMethod: formMethod,
                formAction: redirect.location,
                formEncType: formEncType,
                formData: formData
            }
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: formMethod || undefined,
                formAction: formAction || undefined,
                formEncType: formEncType || undefined,
                formData: formData || undefined
            }
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, router.basename)),
            ...fetchersToLoad.map((_ref8)=>{
                let [, href, match, fetchMatches] = _ref8;
                return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(href, request.signal), match, fetchMatches, router.basename);
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((_ref9)=>{
                let [, , match] = _ref9;
                return match;
            }), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$f5708dca728d7177(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
function $1d34d5c4a288b213$export$4791cb6e2df78547(routes, opts) {
    $1d34d5c4a288b213$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to unstable_createStaticHandler");
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp) {
        let { requestContext: requestContext } = _temp === void 0 ? {} : _temp;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "head") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp2) {
        let { routeId: routeId, requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "head") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        let routeData = [
            result.actionData,
            result.loaderData
        ].find((v)=>v);
        return Object.values(routeData || {})[0];
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isSubmissionMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error && !$1d34d5c4a288b213$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw new Error("defer() is not supported in actions");
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Can't do anything with these without the Remix side of things, so just
        // cancel them for now
        results.forEach((result)=>{
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) result.deferredData.cancel();
        }); // Process and commit output from loaders
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(to, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    if (opts.formMethod && $1d34d5c4a288b213$var$isSubmissionMethod(opts.formMethod)) return {
        path: path,
        submission: {
            formMethod: opts.formMethod,
            formAction: $1d34d5c4a288b213$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        }
    };
     // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    try {
        let searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
        // navigation GET submissions which run all loaders), we need to preserve
        // any incoming ?index params
        if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
        parsedPath.search = "?" + searchParams;
    } catch (e) {
        return {
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400)
        };
    }
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath)
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : null; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>match.route.loader != null && ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || // If this route had a pending deferred cancelled it must be revalidated
        cancelledDeferredRoutes.some((id)=>id === match.route.id) || $1d34d5c4a288b213$var$shouldRevalidateLoader(state.location, state.matches[index], submission, location, match, isRevalidationRequired, actionResult))); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches && fetchLoadMatches.forEach((_ref10, key)=>{
        let [href, match, fetchMatches] = _ref10;
        // This fetcher was cancelled from a prior action submission - force reload
        if (cancelledFetcherLoads.includes(key)) revalidatingFetchers.push([
            key,
            href,
            match,
            fetchMatches
        ]);
        else if (isRevalidationRequired) {
            let shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(href, match, submission, href, match, isRevalidationRequired, actionResult);
            if (shouldRevalidate) revalidatingFetchers.push([
                key,
                href,
                match,
                fetchMatches
            ]);
        }
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(currentLocation, currentMatch, submission, location, match, isRevalidationRequired, actionResult) {
    let currentUrl = $1d34d5c4a288b213$var$createClientSideURL(currentLocation);
    let currentParams = currentMatch.params;
    let nextUrl = $1d34d5c4a288b213$var$createClientSideURL(location);
    let nextParams = match.params; // This is the default implementation as to when we revalidate.  If the route
    // provides it's own implementation, then we give them full control but
    // provide this value so they can leverage it if needed after they check
    // their own specific use cases
    // Note that fetchers always provide the same current/next locations so the
    // URL-based checks here don't apply to fetcher shouldRevalidate calls
    let defaultShouldRevalidate = $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search || // Forced revalidation due to submission, useRevalidate, or X-Remix-Revalidate
    isRevalidationRequired;
    if (match.route.shouldRevalidate) {
        let routeChoice = match.route.shouldRevalidate($1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentParams,
            nextUrl: nextUrl,
            nextParams: nextParams
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate
        }));
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return defaultShouldRevalidate;
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result; // Setup a promise we can race against so that abort signals short circuit
    let reject;
    let abortPromise = new Promise((_, r)=>reject = r);
    let onReject = ()=>reject();
    request.signal.addEventListener("abort", onReject);
    try {
        let handler = match.route[type];
        $1d34d5c4a288b213$export$f5708dca728d7177(handler, "Could not find the " + type + " to run on the \"" + match.route.id + "\" route");
        result = await Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
        $1d34d5c4a288b213$export$f5708dca728d7177(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            let isAbsolute = /^[a-z+]+:\/\//i.test(location) || location.startsWith("//"); // Support relative routing in internal redirects
            if (!isAbsolute) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(activeMatches).map((match)=>match.pathnameBase);
                let resolvedLocation = $1d34d5c4a288b213$export$cae722b0cc860f13(location, routePathnames, new URL(request.url).pathname);
                $1d34d5c4a288b213$export$f5708dca728d7177($1d34d5c4a288b213$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
                        basename,
                        path
                    ]);
                }
                location = $1d34d5c4a288b213$export$fe53371bee54353d(resolvedLocation);
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $1d34d5c4a288b213$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        if (contentType && contentType.startsWith("application/json")) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if (result instanceof $1d34d5c4a288b213$var$DeferredData) return {
        type: $1d34d5c4a288b213$var$ResultType.deferred,
        deferredData: result
    };
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(location, signal, submission) {
    let url = $1d34d5c4a288b213$var$createClientSideURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission;
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries()){
        $1d34d5c4a288b213$export$f5708dca728d7177(typeof value === "string", 'File inputs are not supported with encType "application/x-www-form-urlencoded", please use "multipart/form-data" instead.');
        searchParams.append(key, value);
    }
    return searchParams;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$f5708dca728d7177(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = Object.assign(errors || {}, {
                [boundaryMatch.route.id]: error
            }); // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds && activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data; // TODO: Add statusCode/headers once we wire up streaming in Remix
        } else {
            loaderData[id] = result.data; // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here
    if (pendingError) errors = pendingError;
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let [key, , match] = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$f5708dca728d7177(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        throw new Error("Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        throw new Error("Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    matches.forEach((match)=>{
        let id = match.route.id;
        if (newLoaderData[id] === undefined && loaderData[id] !== undefined) mergedLoaderData[id] = loaderData[id];
    });
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp3) {
    let { pathname: pathname, routeId: routeId, method: method } = _temp3 === void 0 ? {} : _temp3;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else errorMessage = "Cannot submit binary form data using GET";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return result;
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method);
}
function $1d34d5c4a288b213$var$isSubmissionMethod(method) {
    return $1d34d5c4a288b213$var$validActionMethods.has(method);
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $1d34d5c4a288b213$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.4.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $acw62 = parcelRequire("acw62");
function $5bf6248e1ceb144a$var$_extends() {
    $5bf6248e1ceb144a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5bf6248e1ceb144a$var$_extends.apply(this, arguments);
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $5bf6248e1ceb144a$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $5bf6248e1ceb144a$var$is = typeof Object.is === "function" ? Object.is : $5bf6248e1ceb144a$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $5bf6248e1ceb144a$var$useState, useEffect: $5bf6248e1ceb144a$var$useEffect, useLayoutEffect: $5bf6248e1ceb144a$var$useLayoutEffect, useDebugValue: $5bf6248e1ceb144a$var$useDebugValue } = $acw62;
let $5bf6248e1ceb144a$var$didWarnOld18Alpha = false;
let $5bf6248e1ceb144a$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $5bf6248e1ceb144a$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $5bf6248e1ceb144a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $5bf6248e1ceb144a$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($5bf6248e1ceb144a$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $5bf6248e1ceb144a$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($5bf6248e1ceb144a$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($5bf6248e1ceb144a$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $5bf6248e1ceb144a$var$useDebugValue(value);
    return value;
}
function $5bf6248e1ceb144a$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$5bf6248e1ceb144a$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $5bf6248e1ceb144a$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $5bf6248e1ceb144a$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $5bf6248e1ceb144a$var$isServerEnvironment = !$5bf6248e1ceb144a$var$canUseDOM;
const $5bf6248e1ceb144a$var$shim = $5bf6248e1ceb144a$var$isServerEnvironment ? $5bf6248e1ceb144a$var$useSyncExternalStore$1 : $5bf6248e1ceb144a$var$useSyncExternalStore$2;
const $5bf6248e1ceb144a$var$useSyncExternalStore = "useSyncExternalStore" in $acw62 ? ((module)=>module.useSyncExternalStore)($acw62) : $5bf6248e1ceb144a$var$shim;
// Contexts for data routers
const $5bf6248e1ceb144a$export$30522a91b9deeaa0 = /*#__PURE__*/ $acw62.createContext(null);
const $5bf6248e1ceb144a$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $5bf6248e1ceb144a$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $5bf6248e1ceb144a$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
const $5bf6248e1ceb144a$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $5bf6248e1ceb144a$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $5bf6248e1ceb144a$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: []
});
const $5bf6248e1ceb144a$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $5bf6248e1ceb144a$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$5bf6248e1ceb144a$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($5bf6248e1ceb144a$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $5bf6248e1ceb144a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $5bf6248e1ceb144a$export$9c954a9d03d32f4a() {
    return $acw62.useContext($5bf6248e1ceb144a$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $5bf6248e1ceb144a$export$45d76561a5302f2b() {
    !$5bf6248e1ceb144a$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return $acw62.useContext($5bf6248e1ceb144a$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $5bf6248e1ceb144a$export$1b3f31771c5d07c() {
    return $acw62.useContext($5bf6248e1ceb144a$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $5bf6248e1ceb144a$export$6c330e8992e8a295(pattern) {
    !$5bf6248e1ceb144a$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let { pathname: pathname } = $5bf6248e1ceb144a$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $5bf6248e1ceb144a$export$9770f232ac06a008() {
    !$5bf6248e1ceb144a$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($5bf6248e1ceb144a$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($5bf6248e1ceb144a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bf6248e1ceb144a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $5bf6248e1ceb144a$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $5bf6248e1ceb144a$export$4138103a3ae699cc() {
    return $acw62.useContext($5bf6248e1ceb144a$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $5bf6248e1ceb144a$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($5bf6248e1ceb144a$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $5bf6248e1ceb144a$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($5bf6248e1ceb144a$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $5bf6248e1ceb144a$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($5bf6248e1ceb144a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bf6248e1ceb144a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $5bf6248e1ceb144a$export$5d3fca4a98652595(routes, locationArg) {
    !$5bf6248e1ceb144a$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let { navigator: navigator } = $acw62.useContext($5bf6248e1ceb144a$export$26749e8557646306);
    let dataRouterStateContext = $acw62.useContext($5bf6248e1ceb144a$export$145dfa71566a64dc);
    let { matches: parentMatches } = $acw62.useContext($5bf6248e1ceb144a$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $5bf6248e1ceb144a$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $5bf6248e1ceb144a$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $5bf6248e1ceb144a$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5bf6248e1ceb144a$var$DefaultErrorElement() {
    let error = $5bf6248e1ceb144a$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unhandled Thrown Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, /*#__PURE__*/ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own\xA0", /*#__PURE__*/ $acw62.createElement("code", {
        style: codeStyles
    }, "errorElement"), " props on\xA0", /*#__PURE__*/ $acw62.createElement("code", {
        style: codeStyles
    }, "<Route>")));
}
class $5bf6248e1ceb144a$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        }) : this.props.children;
    }
}
function $5bf6248e1ceb144a$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataStaticRouterContext = $acw62.useContext($5bf6248e1ceb144a$export$30522a91b9deeaa0); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataStaticRouterContext && match.route.errorElement) dataStaticRouterContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $5bf6248e1ceb144a$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = dataRouterState ? match.route.errorElement || /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$var$DefaultErrorElement, null) : null;
        let getChildren = ()=>/*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: parentMatches.concat(renderedMatches.slice(0, index + 1))
                }
            }, error ? errorElement : match.route.element !== undefined ? match.route.element : outlet); // Only wrap in an error boundary within data router usages when we have an
        // errorElement on this route.  Otherwise let it bubble up to an ancestor
        // errorElement
        return dataRouterState && (match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren()
        }) : getChildren();
    }, null);
}
var $5bf6248e1ceb144a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($5bf6248e1ceb144a$var$DataRouterHook || ($5bf6248e1ceb144a$var$DataRouterHook = {}));
var $5bf6248e1ceb144a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($5bf6248e1ceb144a$var$DataRouterStateHook || ($5bf6248e1ceb144a$var$DataRouterStateHook = {}));
function $5bf6248e1ceb144a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $5bf6248e1ceb144a$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($5bf6248e1ceb144a$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return ctx;
}
function $5bf6248e1ceb144a$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($5bf6248e1ceb144a$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return state;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $5bf6248e1ceb144a$export$d0fd4b7106de2769() {
    let state = $5bf6248e1ceb144a$var$useDataRouterState($5bf6248e1ceb144a$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $5bf6248e1ceb144a$export$600dc272ed516c15() {
    let dataRouterContext = $5bf6248e1ceb144a$var$useDataRouterContext($5bf6248e1ceb144a$var$DataRouterHook.UseRevalidator);
    let state = $5bf6248e1ceb144a$var$useDataRouterState($5bf6248e1ceb144a$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $5bf6248e1ceb144a$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5bf6248e1ceb144a$var$useDataRouterState($5bf6248e1ceb144a$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $5bf6248e1ceb144a$export$1448a5050d252c4d() {
    let state = $5bf6248e1ceb144a$var$useDataRouterState($5bf6248e1ceb144a$var$DataRouterStateHook.UseLoaderData);
    let route = $acw62.useContext($5bf6248e1ceb144a$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return state.loaderData[thisRoute.route.id];
}
/**
 * Returns the loaderData for the given routeId
 */ function $5bf6248e1ceb144a$export$fd5d37484eab868d(routeId) {
    let state = $5bf6248e1ceb144a$var$useDataRouterState($5bf6248e1ceb144a$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $5bf6248e1ceb144a$export$fdc00f3f26066d5e() {
    let state = $5bf6248e1ceb144a$var$useDataRouterState($5bf6248e1ceb144a$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($5bf6248e1ceb144a$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * errorElement to display a proper error message.
 */ function $5bf6248e1ceb144a$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($5bf6248e1ceb144a$var$RouteErrorContext);
    let state = $5bf6248e1ceb144a$var$useDataRouterState($5bf6248e1ceb144a$var$DataRouterStateHook.UseRouteError);
    let route = $acw62.useContext($5bf6248e1ceb144a$export$9072aa6dd1f93057);
    let thisRoute = route.matches[route.matches.length - 1]; // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    !route && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false); // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[thisRoute.route.id];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $5bf6248e1ceb144a$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($5bf6248e1ceb144a$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $5bf6248e1ceb144a$export$17f53340677d5831() {
    let value = $acw62.useContext($5bf6248e1ceb144a$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
const $5bf6248e1ceb144a$var$alreadyWarned = {};
function $5bf6248e1ceb144a$var$warningOnce(key, cond, message) {
    if (!cond && !$5bf6248e1ceb144a$var$alreadyWarned[key]) $5bf6248e1ceb144a$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $5bf6248e1ceb144a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Sync router state to our component state to force re-renders
    let state = $5bf6248e1ceb144a$var$useSyncExternalStore(router.subscribe, ()=>router.state, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    ()=>router.state);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    return /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$export$3add0d5dce533e2e.Provider, {
        value: {
            router: router,
            navigator: navigator,
            static: false,
            basename: // Do we need this?
            basename
        }
    }, /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$export$3565eb3d00ca5a74, null) : fallbackElement)));
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $5bf6248e1ceb144a$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $5bf6248e1ceb144a$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$5bf6248e1ceb144a$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let dataRouterState = $acw62.useContext($5bf6248e1ceb144a$export$145dfa71566a64dc);
    let navigate = $5bf6248e1ceb144a$export$9770f232ac06a008();
    $acw62.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $5bf6248e1ceb144a$export$910ae8079b2c2852(props) {
    return $5bf6248e1ceb144a$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $5bf6248e1ceb144a$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $5bf6248e1ceb144a$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$5bf6248e1ceb144a$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $5bf6248e1ceb144a$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $acw62.useContext($5bf6248e1ceb144a$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $5bf6248e1ceb144a$export$16da398f5434bdec(children);
    return $5bf6248e1ceb144a$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $5bf6248e1ceb144a$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$var$ResolveAwait, null, children));
}
var $5bf6248e1ceb144a$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($5bf6248e1ceb144a$var$AwaitRenderStatus || ($5bf6248e1ceb144a$var$AwaitRenderStatus = {}));
const $5bf6248e1ceb144a$var$neverSettledPromise = new Promise(()=>{});
class $5bf6248e1ceb144a$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $5bf6248e1ceb144a$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $5bf6248e1ceb144a$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $5bf6248e1ceb144a$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $5bf6248e1ceb144a$var$AwaitRenderStatus.error : promise._data !== undefined ? $5bf6248e1ceb144a$var$AwaitRenderStatus.success : $5bf6248e1ceb144a$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $5bf6248e1ceb144a$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $5bf6248e1ceb144a$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $5bf6248e1ceb144a$var$neverSettledPromise;
        if (status === $5bf6248e1ceb144a$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $5bf6248e1ceb144a$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $5bf6248e1ceb144a$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($5bf6248e1ceb144a$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $5bf6248e1ceb144a$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $5bf6248e1ceb144a$export$78a72ddb39bdd145();
    if (typeof children === "function") return children(data);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, children);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $5bf6248e1ceb144a$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $5bf6248e1ceb144a$export$16da398f5434bdec(element.props.children, parentPath));
            return;
        }
        !(element.type === $5bf6248e1ceb144a$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
        let treePath = [
            ...parentPath,
            index
        ];
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            hasErrorBoundary: element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle
        };
        if (element.props.children) route.children = $5bf6248e1ceb144a$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $5bf6248e1ceb144a$export$daf73786167a7f72(matches) {
    return $5bf6248e1ceb144a$var$_renderMatches(matches);
}
/**
 * @private
 * Walk the route tree and add hasErrorBoundary if it's not provided, so that
 * users providing manual route arrays can just specify errorElement
 */ function $5bf6248e1ceb144a$export$c7b301c52f838c5f(routes) {
    return routes.map((route)=>{
        let routeClone = $5bf6248e1ceb144a$var$_extends({}, route);
        if (routeClone.hasErrorBoundary == null) routeClone.hasErrorBoundary = routeClone.errorElement != null;
        if (routeClone.children) routeClone.children = $5bf6248e1ceb144a$export$c7b301c52f838c5f(routeClone.children);
        return routeClone;
    });
}
function $5bf6248e1ceb144a$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: $5bf6248e1ceb144a$export$c7b301c52f838c5f(routes)
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
        searchParams.append(key, value);
    });
    return searchParams;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $040dbb9c344a508d$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method,
        encType: encType,
        formData: formData
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative"
];
//#region Routers
////////////////////////////////////////////////////////////////////////////////
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: (0, $5bf6248e1ceb144a$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: (0, $5bf6248e1ceb144a$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)// Hey you!  If you change this, please change the corresponding logic in
    // serializeErrors in react-router-dom/server.tsx :)
    if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
    else serialized[key] = val;
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $5bf6248e1ceb144a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $5bf6248e1ceb144a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $5bf6248e1ceb144a$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref4, $040dbb9c344a508d$var$_excluded);
    let href = (0, $5bf6248e1ceb144a$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: href,
        onClick: reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref5, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $5bf6248e1ceb144a$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $5bf6248e1ceb144a$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $5bf6248e1ceb144a$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $5bf6248e1ceb144a$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        ref: ref
    }));
});
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative } = _ref6, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref6, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        submit(submitter || event.currentTarget, {
            method: method,
            replace: replace,
            relative: relative
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $040dbb9c344a508d$var$useScrollRestoration({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $5bf6248e1ceb144a$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $5bf6248e1ceb144a$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $5bf6248e1ceb144a$export$9770f232ac06a008)();
    let location = (0, $5bf6248e1ceb144a$export$45d76561a5302f2b)();
    let path = (0, $5bf6248e1ceb144a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $5bf6248e1ceb144a$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>$040dbb9c344a508d$var$getSearchParamsForLocation(location.search, defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $5bf6248e1ceb144a$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    return $040dbb9c344a508d$var$useSubmitImpl();
}
function $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId) {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitImpl);
    let defaultAction = $040dbb9c344a508d$export$89a6bd6db0d97c56();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $5bf6248e1ceb144a$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $5bf6248e1ceb144a$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let [match] = routeContext.matches.slice(-1);
    let resolvedAction = action != null ? action : "."; // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $5bf6248e1ceb144a$export$e75d2a2d1b3c245b)(resolvedAction, {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $5bf6248e1ceb144a$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $5bf6248e1ceb144a$export$9072aa6dd1f93057));
    !route && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
            !routeId && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$var$useScrollRestoration(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $5bf6248e1ceb144a$export$45d76561a5302f2b)();
    let matches = (0, $5bf6248e1ceb144a$export$2378eb7f5ff86053)();
    let navigation = (0, $5bf6248e1ceb144a$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on unload
    $040dbb9c344a508d$var$useBeforeUnload($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    $acw62.useLayoutEffect(()=>{
        try {
            let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
            if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
        } catch (e) {}
    }, [
        storageKey
    ]); // Enable scroll restoration in the router
    $acw62.useLayoutEffect(()=>{
        let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKey);
        return ()=>disableScrollRestoration && disableScrollRestoration();
    }, [
        router,
        getKey
    ]); // Restore scrolling when state.restoreScrollPosition changes
    $acw62.useLayoutEffect(()=>{
        // Explicit false means don't do anything (used for submissions)
        if (restoreScrollPosition === false) return;
         // been here before, scroll to it
        if (typeof restoreScrollPosition === "number") {
            window.scrollTo(0, restoreScrollPosition);
            return;
        } // try to scroll to the hash
        if (location.hash) {
            let el = document.getElementById(location.hash.slice(1));
            if (el) {
                el.scrollIntoView();
                return;
            }
        } // Opt out of scroll reset if this link requested it
        if (preventScrollReset === true) return;
         // otherwise go to the top on new locations
        window.scrollTo(0, 0);
    }, [
        location,
        restoreScrollPosition,
        preventScrollReset
    ]);
}
function $040dbb9c344a508d$var$useBeforeUnload(callback) {
    $acw62.useEffect(()=>{
        window.addEventListener("beforeunload", callback);
        return ()=>{
            window.removeEventListener("beforeunload", callback);
        };
    }, [
        callback
    ]);
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Utils
////////////////////////////////////////////////////////////////////////////////
function $040dbb9c344a508d$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} //#endregion


// THIS FILE IS AUTO GENERATED
var $5df8b35a1e390d20$export$a0f7048edafc45cd = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "MIT",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $8f07b434b4aae80e$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $8f07b434b4aae80e$export$a49f528ae1a4d0ed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($8f07b434b4aae80e$export$4a4ef469214f8641);


var $979bbccfede4a2a2$var$_excluded = [
    "attr",
    "size",
    "title"
];
function $979bbccfede4a2a2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $979bbccfede4a2a2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $979bbccfede4a2a2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $979bbccfede4a2a2$var$_extends() {
    $979bbccfede4a2a2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $979bbccfede4a2a2$var$_extends.apply(this, arguments);
}
function $979bbccfede4a2a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $979bbccfede4a2a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $979bbccfede4a2a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $979bbccfede4a2a2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $979bbccfede4a2a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $979bbccfede4a2a2$var$_defineProperty(obj, key, value) {
    key = $979bbccfede4a2a2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $979bbccfede4a2a2$var$_toPropertyKey(t) {
    var i = $979bbccfede4a2a2$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $979bbccfede4a2a2$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $979bbccfede4a2a2$var$Tree2Element(tree) {
    return tree && tree.map((node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, $979bbccfede4a2a2$var$_objectSpread({
            key: i
        }, node.attr), $979bbccfede4a2a2$var$Tree2Element(node.child)));
}
function $979bbccfede4a2a2$export$6fce6cce1e9a936d(data) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($979bbccfede4a2a2$export$a188ecdd443fe91a, $979bbccfede4a2a2$var$_extends({
            attr: $979bbccfede4a2a2$var$_objectSpread({}, data.attr)
        }, props), $979bbccfede4a2a2$var$Tree2Element(data.child));
}
function $979bbccfede4a2a2$export$a188ecdd443fe91a(props) {
    var elem = (conf)=>{
        var { attr: attr, size: size, title: title } = props, svgProps = $979bbccfede4a2a2$var$_objectWithoutProperties(props, $979bbccfede4a2a2$var$_excluded);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $979bbccfede4a2a2$var$_extends({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: $979bbccfede4a2a2$var$_objectSpread($979bbccfede4a2a2$var$_objectSpread({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), props.children);
    };
    return (0, $8f07b434b4aae80e$export$a49f528ae1a4d0ed) !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f07b434b4aae80e$export$a49f528ae1a4d0ed).Consumer, null, (conf)=>elem(conf)) : elem((0, $8f07b434b4aae80e$export$4a4ef469214f8641));
}





function $4f2ab0198db0e6aa$export$5f00c504595fb34c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 13h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 16 4.5-9 4.5 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7v9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 12 4 4 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f390b8a01d014a05(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 13h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 16 4.5-9 4.5 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 11 4-4 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$61accdc9b388b74e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 13h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 16 4.5-9 4.5 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d6a58b2331955d15(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "4",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 19 1-7-6 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 8 3-3 5.5 3-2.36 3.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.24 14.5a5 5 0 0 0 6.88 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.76 17.5a5 5 0 0 0-6.88-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$637938b84ec795e9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6fc353ad88d2d033(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.6 15.6A2 2 0 1 0 10 17v-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$82807a4038f60286(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 15 5 6H7Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3edf052215b104f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3 2 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 6-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.38 18.7 4 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.64 18.67 20 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 13 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8e744ae8b3e9a5ac(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3 2 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 6-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.38 18.7 4 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.64 18.67 20 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$24c850a7663feedf(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.87 6.87a8 8 0 1 0 11.26 11.26"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.9 14.25a8 8 0 0 0-9.15-9.15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 6-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.26 18.67 4 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4 2 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$334f2cb804df5e0e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3 2 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 6-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.38 18.7 4 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.64 18.67 20 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$563050b7d49d8043(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9v4l2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3 2 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 6-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.38 18.7 4 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.64 18.67 20 21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4ad5910ed046afac(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21c0-2.5 2-2.5 2-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21c0-2.5 2-2.5 2-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 8-.8 3a1.25 1.25 0 0 1-1.2 1H7a1.25 1.25 0 0 1-1.2-1L5 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21c0-2.5 2-2.5 2-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7dc7543eacbd9bae(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "11 3 11 11 14 8 17 11 17 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$14ed3f66c1ce9ecc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ff43adba0c49b5ad(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f767dacbfd9cc655(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12H7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18H5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e995070f4f0fe6cc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "16",
                    "x": "4",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "9",
                    "x": "14",
                    "y": "9",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a3d167c676c0a33c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "6",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "9",
                    "height": "6",
                    "x": "9",
                    "y": "14",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22V2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$11192cd2532ab2e5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "14",
                    "x": "4",
                    "y": "5",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "10",
                    "x": "14",
                    "y": "7",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 22v-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5V2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$827c4a7a1859c85c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "14",
                    "x": "4",
                    "y": "5",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "10",
                    "x": "14",
                    "y": "7",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2v20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f0c17bc3ae5021f6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "14",
                    "x": "4",
                    "y": "5",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "10",
                    "x": "14",
                    "y": "7",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cb84297ebde96c2d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "14",
                    "x": "2",
                    "y": "5",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "10",
                    "x": "16",
                    "y": "7",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9975ace467ec732e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "14",
                    "x": "2",
                    "y": "5",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "10",
                    "x": "12",
                    "y": "7",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2v20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$488059187b42fd96(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "14",
                    "x": "6",
                    "y": "5",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "10",
                    "x": "16",
                    "y": "7",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2v20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1fd99c386f01ca10(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "10",
                    "x": "9",
                    "y": "7",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22V2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8d43b6cd3d2a59a1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "14",
                    "x": "3",
                    "y": "5",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "10",
                    "x": "15",
                    "y": "7",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2v20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2v20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cf5c139d754a093e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2f6df46043fc1674(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ef92a95ddbf886c7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12H9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18H7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f97a6d8beaa1fe11(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "16",
                    "x": "4",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "9",
                    "x": "14",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f6f8cf56ac6d1546(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "9",
                    "height": "6",
                    "x": "6",
                    "y": "14",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "6",
                    "x": "6",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2v20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f78790b53fd1bf45(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17h-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7H2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "14",
                    "width": "14",
                    "height": "6",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "4",
                    "width": "10",
                    "height": "6",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$75f0b216dd4f4b6c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "6",
                    "x": "5",
                    "y": "14",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "6",
                    "x": "7",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a9d39d29ad4451a2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "6",
                    "x": "5",
                    "y": "14",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "6",
                    "x": "7",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9ce44e6f06b83ca0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "6",
                    "x": "5",
                    "y": "16",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "6",
                    "x": "7",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a92c7ab92d29e3f1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "6",
                    "x": "5",
                    "y": "12",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "6",
                    "x": "7",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2caf67af7116160f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "6",
                    "x": "5",
                    "y": "16",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "6",
                    "x": "7",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7a630caf33cd3de4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "6",
                    "x": "7",
                    "y": "9",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1d165f02d74accb1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "6",
                    "x": "5",
                    "y": "15",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "6",
                    "x": "7",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$37132f7f7d865ce3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10H6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4c817b6f07633b1a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8e7fdb40ef1ad00b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ad8def0129bd5dff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v5.632c0 .424-.272.795-.653.982A6 6 0 0 0 6 14c.006 4 3 7 5 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5H8a2 2 0 0 0 0 4h.68"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v5.632c0 .424.272.795.652.982A6 6 0 0 1 18 14c0 4-3 7-5 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5h2a2 2 0 0 1 0 4h-.68"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22H6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$75108c47291a7036(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22V8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H2a10 10 0 0 0 20 0h-3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e8644e7689264eb6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16s-1.5-2-4-2-4 2-4 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 8 10 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 9 2.5-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1f07edf0de43a861(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$52f3666cf31035ff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12 7 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 12 5-10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 12 5-10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 12 5-10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 7h15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$76aa56af9738366b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2157ec5e6687dd28(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.31 8 5.74 9.94"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.69 8h11.48"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.38 12 5.74-9.94"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.69 16 3.95 6.06"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.31 16H2.83"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.62 12-5.74 9.94"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fd73e711e49dab98(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "16",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$680465af57d962e6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "4",
                    "width": "20",
                    "height": "16",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ee130ff8ce2f2076(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c1 .5 2 2 2 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7f6eb34fc69eb8a0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "5",
                    "x": "2",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8v11a2 2 0 0 0 2 2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8v11a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 15 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1cb82fae65bb7389(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "5",
                    "x": "2",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 17 5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 12 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$63825f5984b1264a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "5",
                    "x": "2",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$33431fb6af22f744(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$32591dfaf1be0829(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5H9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9v3h4l-7 7-7-7h4V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f22f584d3795da4e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6v6h4l-7 7-7-7h4V6h6z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4aab0bea51617043(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15h-3v4l-7-7 7-7v4h3v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$76ad59e78e31f59c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15h-6v4l-7-7 7-7v4h6v6z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7bf49aa88a76eac3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h3V5l7 7-7 7v-4H9V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$14a87381b5f1998f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9h6V5l7 7-7 7v-4H6V9z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$68584f3a1daab571(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15v-3H5l7-7 7 7h-4v3H9z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6aeaf47b956428d6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18v-6H5l7-7 7 7h-4v6H9z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5fb903ff3d4364cd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 16 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20V4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "15",
                    "y": "4",
                    "width": "4",
                    "height": "6",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20v-6h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 20h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$527bf588fdfb1ee5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 16 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20V4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10V4h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "15",
                    "y": "14",
                    "width": "4",
                    "height": "6",
                    "ry": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a0c91aaf6c2108f4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 16 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20V4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10V6.5a2.5 2.5 0 0 1 5 0V10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 14h5l-5 6h5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1ed0df5b50e41e33(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 15 6 6 6-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dbde50a4a4d4dc37(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7 7 17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17H7V7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$730b5d843f7db607(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 16 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20V4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12h10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7a0336ccc39398b0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 7 10 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7v10H7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2b4dacdf0620e4d7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 9-7 7-7-7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "21",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d8426b6114fa33d2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 11 6 6 6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21H5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$178248bc936d0fe3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 16 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20V4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 8-4-4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$75884139d13a5e39(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 16 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20V4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$708092b907eef690(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 16 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h5l-5 6h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$235778847432eed7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 12-7 7-7-7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ff92bb64ad7d7790(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 6-6 6 6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$28429984c8a702da(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3 4 7l4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 21 4-4-4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17H4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$109ac04c57200576(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19V5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 6-6 6 6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$814c97213a46f850(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 19-7-7 7-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12H5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$661d29e5643f9486(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12H7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 18 6-6-6-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1b7abca51fd50f69(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 3 4 4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7H4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 21-4-4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9c7b15e108abd8cc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 18 6-6-6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5v14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d07857bbc1dd2840(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 5 7 7-7 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9749c14f237d64a5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 8 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4v16"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "15",
                    "y": "4",
                    "width": "4",
                    "height": "6",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20v-6h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 20h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$62cb1a10b2171c19(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 8 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10V4h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "15",
                    "y": "14",
                    "width": "4",
                    "height": "6",
                    "ry": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b9ad996e7150f43e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 8 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10V6.5a2.5 2.5 0 0 1 5 0V10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 14h5l-5 6h5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f70f1795809f3ac2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21 16-4 4-4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20V4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 8 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7b2f198e3f9c10a9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5 9 7-7 7 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16V2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "21",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fba3c6f269cfd700(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 9-6-6-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a9dfb46912984c9f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17V7h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17 7 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1d6d7bc1285a9fb8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 8 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20h10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7091bef217865d0e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17 17 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f8e1036af5b61213(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 13-6-6-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2f09b0e9f7353165(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 8 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e12eab3e43b2fdce(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 8 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h5l-5 6h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9cfc22e926cde2e0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5 12 7-7 7 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19V5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fc08321620fcc93(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4 6 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 6 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$45b9641680065c05(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.196 9 6.804 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.804 9 10.392 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d9b7cbc6a9baf442(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4e52689bbd84cfa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$87805e949774b2f1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5v13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10v3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1a4b48a0e014c5af(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d78802524128c2b3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c9dce0c8ad14f719(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$871a5cf1eb1eba26(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v16h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4 20 7-7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$510c60f21e9eb66(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$72641561975ce894(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b4e470cd9812f16e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "8",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12.01",
                    "y1": "16",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$707f1e489bc1fc57(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4 10a4 4 0 1 0 0 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9d45006b64ec5369(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 12 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3f1706f2580fde64(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18V6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$29f3ffeeef097e32(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.4a4 4 0 1 0 0 5.2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$85a80922f8092e3a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12.01",
                    "y1": "17",
                    "y2": "17"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5887e6009a6301c4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 17-5-1h1a4 4 0 0 0 0-8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1ad1ddd095df9e74(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "16",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12.01",
                    "y1": "8",
                    "y2": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$27a13742f7ed7ee9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 8 3 3v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 11 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d5d916cef9fba71d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "16",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$47846979a59d07ce(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d91bb42b47aed7e6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "8",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "16",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b3c8e8c5c19cb670(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16V9.5a2.5 2.5 0 0 1 5 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6e99f9076c95ec95(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h5a2 2 0 1 0 0-4h-3v9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$48e92c190ab28ed4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17V8h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aa1b9bd81ef0e68d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "9",
                    "y1": "9",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "15",
                    "y1": "9",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2a3efa0df7a655f5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8c3e07f81d115ff2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "13",
                    "height": "8",
                    "x": "8",
                    "y": "6",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "20",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "20",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5e4282e8c4683245(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.9 4.9 14.2 14.2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bc48c95d1b4b7a07(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a0510a5c4f9228a0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.01h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14.01h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10.01h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.01h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6v11.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6v12"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "6",
                    "width": "20",
                    "height": "12",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eef68e82ab80a1ef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "12",
                    "x": "2",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h.01M18 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b1fcdb545f122a42(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5v14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1c5c55f006ddc221(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 16 6-12 6 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a6ae5170d08f5033(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4 8 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 19v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8e59531722a4450(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 7-3 5h4l-3 5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "22",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$989a39bb612b0076(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "10",
                    "x": "2",
                    "y": "7",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "22",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "x2": "10",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "x2": "14",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5d39b97785c83e6f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "10",
                    "x": "2",
                    "y": "7",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "22",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f2928b7e1db82823(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "10",
                    "x": "2",
                    "y": "7",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "22",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "x2": "10",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8f2470fc8c3efe80(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1c8b9177d72fe67a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "10",
                    "x": "2",
                    "y": "7",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "22",
                    "y1": "11",
                    "y2": "13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3e70c3f202b7782f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 3h15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b7a2aad1d23be03d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2a64d71765f1f8b3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.341 10.62a4 4 0 1 0 5.279-5.28"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d942dc5f39776421(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3bbb24a7167739a7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$257346e48a43e0b8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8h18a2 2 0 0 1 2 2v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8v9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aebef285047726e0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.5",
                    "cy": "8.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e1f8ab37ce15c1a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11.47V8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11h1a3 3 0 0 1 2.745 4.211"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14.6V18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dbae45275eb082fc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11h1a3 3 0 0 1 0 6h-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$698b078b52c28dbf(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.4 14.9C20.2 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 .7 0 1.3.1 1.9.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3 21a1.94 1.94 0 0 0 3.4 0"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "8",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2868bad915b9dff0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.8 4A6.3 8.7 0 0 1 20 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h.01"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "6",
                    "x": "4",
                    "y": "16",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19c3 0 4.6-1.6 4.6-1.6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "16",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a15ad1e84f26ccf6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.4 12c.8 3.8 2.6 5 2.6 5H3s3-2 3-9c0-3.3 2.7-6 6-6 1.8 0 3.4.8 4.5 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3 21a1.94 1.94 0 0 0 3.4 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8c2edd9fd24ab672(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3 21a1.94 1.94 0 0 0 3.4 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$954ed0a3e75b4a0f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3 14.8C20.1 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 1 0 1.9.2 2.8.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3 21a1.94 1.94 0 0 0 3.4 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2f7fd736560dcca2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3 21a1.94 1.94 0 0 0 3.4 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2C2.8 3.7 2 5.7 2 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8c0-2.3-.8-4.3-2-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cfc6816fe2e76a6c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3 21a1.94 1.94 0 0 0 3.4 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$78513e352b95412e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "13",
                    "height": "7",
                    "x": "3",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 15-3-3 3-3"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "13",
                    "height": "7",
                    "x": "3",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b69e9c6babf742be(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "13",
                    "height": "7",
                    "x": "8",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 9 3 3-3 3"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "13",
                    "height": "7",
                    "x": "8",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$447a7aff62db5c7d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "13",
                    "x": "3",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 22 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "13",
                    "x": "14",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b17eb88fc841799e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "13",
                    "x": "3",
                    "y": "8",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 2-3 3-3-3"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "13",
                    "x": "14",
                    "y": "8",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c063c8b2d6e74f6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 14a5 5 0 0 0-7.584 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.964 6.825C8.019 7.977 9.5 13 8 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a942fd775e3b64f6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "17.5",
                    "r": "3.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "17.5",
                    "r": "3.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "5",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.5V14l-3-3 4-3 2 3h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b4603d948686ca0e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "14",
                    "width": "4",
                    "height": "6",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "4",
                    "width": "4",
                    "height": "6",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h2v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4h2v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5bb2c13cc78e126b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M 22 16 L 2 16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fb46abc3b551752f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11.9",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.9 10.1 1.4.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.1 10.1-1.4.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.9v1.6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.4c-1-.2-2-.2-3 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.4c.7-.7 1.2-1.6 1.5-2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 13.9c.3.9.8 1.8 1.5 2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bc0dc86a5a487540(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 7 2 .5-2 .5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17.75V21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18a6 6 0 0 0 3.84-10.61"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5ca5edf5a49108ad(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aa9c917cc781d467(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "15",
                    "r": "7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ce78f8b791ac6b44(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3v14"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ff2f2c269195b781(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "14",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e41867ab541b5ac(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 7 10 10-5 5V2l5 5L7 17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "x2": "21",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "6",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$103ff28689f87b6a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17 17-5 5V12l-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 9.5 17 7l-5-5v4.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$13473534ccaa6658(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 7 10 10-5 5V2l5 5L7 17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.83 14.83a4 4 0 0 0 0-5.66"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$de3e0a54232b4012(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 7 10 10-5 5V2l5 5L7 17"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e1537ba8d92558a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e6d26e896527c54e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3893f0a8b20951d1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "13",
                    "r": "9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 2-1.5 1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$44264ce67a318150(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c471b9c119b57e25(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 13 4-7 4 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.1 11h5.7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$609d527509d262cc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8v3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$29df63bddc3ddf46(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 9.5 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4e87a912e73f736c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16V4a2 2 0 0 1 2-2h11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18H11a2 2 0 1 0 0 4h10.5a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H11a2 2 0 0 0-2 2v12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14H4a2 2 0 1 0 0 4h1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f73ea49fc5533c48(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22h1a1 1 0 0 0 1-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h1a1 1 0 0 1 1 1v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15v2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5V15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5v-.5A2.5 2.5 0 0 1 6.5 2H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22H6.5a1 1 0 0 1 0-5H8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1725b876c6931ec5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 10 3 3 3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c66767c322ee71c8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12v-2a4 4 0 0 1 8 0v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6a332425323b12ad(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8.2A2.22 2.22 0 0 0 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9A2.22 2.22 0 0 0 8 8.2c0 .6.3 1.2.7 1.6A226.652 226.652 0 0 0 12 13a404 404 0 0 0 3.3-3.1 2.413 2.413 0 0 0 .7-1.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dd6526f0045ffb99(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9c14344604a44c97(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 3 1 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 2-4.5 4.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8v13a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$be92122b1b4433a3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V4a2 2 0 1 0-4 0v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "12",
                    "y": "6",
                    "width": "8",
                    "height": "5",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4cc4bcc3186bf823(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v8l3-3 3 3V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$57fb3cbe64ee3e04(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$38b657eb7145fe6d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 12 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1v-1.3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$91c1f0c81e27c82a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$68c349676d9e8ad0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$850e082b059e95ce(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1c147bc91ea7e139(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ea069e7ee7b22f68(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8V6H8v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f3f5dffc280ad816(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h1a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 10 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 5 3-3 3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5a305894de5d352f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 10 3-3 3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d84fb1768c431ee8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13a3 3 0 1 0-6 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c17a19ade7baa4ff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 7-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 7 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$60c2bf49cce62143(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bf7d098e4539a96f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 10 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dcc4b92b64082871(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "9",
                    "y1": "10",
                    "y2": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b46f0180fc1195a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "7",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "9",
                    "y1": "10",
                    "y2": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d37fef268889b322(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 7.5-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 7.5 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$42398ffd30f97d5a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8f503bb7bfa9faa9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "12",
                    "x": "2",
                    "y": "9",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "15",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "15",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$89af44206d0c953d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6V2H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ed5d78003cb0a36f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.67 8H18a2 2 0 0 1 2 2v4.33"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 1.414-.586"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.67 4H12v2.33"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$66dfd6a93ab801e1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8V4H8"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "12",
                    "x": "4",
                    "y": "8",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cb3bdf642b747e25(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.3 7 8.7 5 8.7-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22V12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2b4376734a16bff6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 16.5-4.74-2.85"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 16.5 5-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16.5v5.17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 16.5-5-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 16.5 4.74-2.85"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.5v5.17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8 7.26 5.15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 8 4.74-2.85"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.5V8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$111e5c573a343aee(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b23a74d6ec0296e3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3h3v18h-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21H5V3h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c8ce13ca8769d7e6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13a4.5 4.5 0 0 0 3-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.003 5.125A3 3 0 0 0 6.401 6.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.477 10.896a4 4 0 0 1 .585-.396"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18a4 4 0 0 1-1.967-.516"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h6a2 2 0 0 1 2 2v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8V5a2 2 0 0 1 2-2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "13",
                    "r": ".5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "3",
                    "r": ".5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "21",
                    "r": ".5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "8",
                    "r": ".5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$45db29f7824403fa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.599 6.5a3 3 0 0 0 .399-1.375"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.003 5.125A3 3 0 0 0 6.401 6.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.477 10.896a4 4 0 0 1 .585-.396"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.938 10.5a4 4 0 0 1 .585.396"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18a4 4 0 0 1-1.967-.516"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.967 17.484A4 4 0 0 1 18 18"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.7 10.4-.9.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.2 13.2-.9.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.6 15.7-.4-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.8 9.2-.4-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.7 13.5-.9-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.2 10.9-.9-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.5 15.7.4-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.1 9.2.4-.9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e299c28ca5e2269c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.599 6.5a3 3 0 0 0 .399-1.375"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.003 5.125A3 3 0 0 0 6.401 6.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.477 10.896a4 4 0 0 1 .585-.396"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.938 10.5a4 4 0 0 1 .585.396"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18a4 4 0 0 1-1.967-.516"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.967 17.484A4 4 0 0 1 18 18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f99fa44d5282f1ba(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$271f92e1d1f439b4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13a18.15 18.15 0 0 1-20 0"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$76fec445c4529d42(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 20H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "6",
                    "width": "16",
                    "height": "10",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4c4852d9d484e965(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6v14"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$27772dfa0fc1a008(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$77a2594222654d3a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "8",
                    "width": "8",
                    "height": "8",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9d07df913c75c484(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$750508f870f15d01(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.12 3.88 16 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.97 5c0 2.1-1.6 3.8-3.5 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21c0-2.1 1.7-3.9 3.8-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aef625582d7f01a2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.765 21.522a.5.5 0 0 1-.765-.424v-8.196a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.12 3.88 16 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.97 5c0 2.1-1.6 3.8-3.5 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21c0-2.1 1.7-3.9 3.8-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.53 9C4.6 8.8 3 7.1 3 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 2 1.88 1.88"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4477a0cd410cb322(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 2 1.88 1.88"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.12 3.88 16 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.53 9C4.6 8.8 3 7.1 3 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21c0-2.1 1.7-3.9 3.8-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.97 5c0 2.1-1.6 3.8-3.5 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 17c2.1.1 3.8 1.9 3.8 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$77900aacd8b1e1cb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e9348eb81eb7ea57(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "20",
                    "x": "4",
                    "y": "2",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 22v-4h6v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7ae8316e5c17ee1e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6 2 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 7-2-1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "16",
                    "x": "4",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 21v-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$432301d19d12ab8a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h19.6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9aded303f0ecef18(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 9 20-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12V6.5"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "10",
                    "x": "4",
                    "y": "12",
                    "rx": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$347d1890bd5ad0d7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21v-2a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 21v-2h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5h4V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1V3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$977d67b599dfb7e6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6fe1adc26843706c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7d6aa11a04df17e0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "20",
                    "x": "4",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "16",
                    "y1": "6",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "x2": "16",
                    "y1": "14",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c408bd1495874d0a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h1v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "4",
                    "width": "18",
                    "height": "18",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5b3249b6bfcfe4aa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14 18 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a93b12a493f97c8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14 18 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22v-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.343V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f3acb37b7e5bdc99(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 20 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3b79bafe1ebd2f6d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 16 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5410b5f911a5e576(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 17.5 16 16.3V14"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cfbac3e9317fdb5f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.2 16.9-.9-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.2 19.1-.9.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.9 15.2-.4-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.9 20.8-.4.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.5 14.3-.4.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.5 21.7-.4-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.7 16.5-.9.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.7 19.5-.9-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2189f11a80562a16(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d9dddb5f496765c8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22v-4a2 2 0 0 1 2-2h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9fe499cdae26252d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9e6d216d74fa4cba(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ee1c238cf148b715(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 19h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f0450e543169f9f5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15.5V6a2 2 0 0 0-2-2H9.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-5.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b614d7652933a8e3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3ea927b5ee56279c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 19h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c238c55ce4becca7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14h-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18H7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d8d74a5fa83c6dfc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.75V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.25"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 22-1.875-1.875"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$28923e3109be1b28(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10v4h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 14 1.535-1.605a5 5 0 0 1 8 1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 18-1.535 1.605a5 5 0 0 1-8-1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 22v-4h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4f81311598915243(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 22 5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 17 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$de6882e92fddfacc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 14-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 14 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cfd0856fd50285fd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1752b51bcc50170(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.121 15.121A3 3 0 1 1 9.88 10.88"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fa626534d4195eeb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$35db42ad14e45cb6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.75 7 15 2.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9 4.8 13 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.9 9.7 2 4.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.9 14.7 7 18.9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cb60de0b95233b09(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 16.5V14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6.5v1.843"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10v7.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$469e9975946784a1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6.5v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7.5v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$222335e6e1ef33a8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$98f1ec5e4435f44a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 5H19a2 2 0 0 1 2 2v8.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11h-.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bf02858c51305b67(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "14",
                    "x": "3",
                    "y": "5",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h4M15 15h2M7 11h2M13 11h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$78ff64ce1302db20(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14h.01"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "8",
                    "x": "3",
                    "y": "10",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a34df031fee7329(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14h.01"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "8",
                    "x": "3",
                    "y": "10",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b7a729b5b38a50c0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "17",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17h6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "17",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5d461ecc17fe3038(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17v1a1 1 0 0 1-1 1H10v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c3bed6eca93319be(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8f89be2159f6648f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9v6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7v8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$156ea7a2c300e5c3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 15 4-8 4 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13h6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c9d3b5df44bfae0c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 15 4-8 4 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1d53508986ee03b9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "16",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$36873482ffbf2309(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12a9 9 0 0 1 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16a5 5 0 0 1 4 4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "2.01",
                    "y1": "20",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$35bf78d822fdcd47(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11V4H6v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22v-4a3 3 0 0 0-3-3a3 3 0 0 0-3 3v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4V2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$caee09306b0b280a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14v.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14v.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 16.25h1.5L12 17l-.75-.75Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$622bd1c20a087a40(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$14ee979736d7095d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6e30577f2dc5fc3a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "13",
                    "width": "9",
                    "height": "4",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "5",
                    "width": "12",
                    "height": "4",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$63f346c67e29e7b1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c135c2238d37773b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4e6db530cae76e6d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "13",
                    "width": "9",
                    "height": "4",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "5",
                    "width": "12",
                    "height": "4",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$132b043b29a256b8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4088b6497353e9df(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5v4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "4",
                    "height": "6",
                    "x": "7",
                    "y": "9",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3v2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "4",
                    "height": "8",
                    "x": "15",
                    "y": "5",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cf4578793236f489(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "15",
                    "y": "5",
                    "width": "4",
                    "height": "12",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "8",
                    "width": "4",
                    "height": "9",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$75a1f1d9f2a0669c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 17V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 17V5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$277023436df173e1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 17V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17V5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 17v-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$249ef93c057828a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13H7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "15",
                    "y": "5",
                    "width": "4",
                    "height": "12",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "8",
                    "width": "4",
                    "height": "9",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$85a462a1b53a912d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 17V5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 17v-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dae2271d8ec43b31(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4d79a01a415e6370(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 9-5 5-4-4-3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cb3e2b5e01a1d3bb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.11 7.664 1.78 2.672"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.162 12.788-3.324 1.424"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 4-6.06 1.515"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "15",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$711ead80347d6089(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20V10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20V4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$39243964f39afa9a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "20",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "x2": "18",
                    "y1": "20",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "20",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$599912709d7b6039(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "x2": "18",
                    "y1": "20",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "20",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "20",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ebd4fcdaeb4d04c4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14v7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a71fe788ec772511(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e258ca1ed154c331(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.21 15.89A10 10 0 1 1 8 2.83"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$83ab6ad5c87dcecc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "7.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "5.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "11.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "16.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "14.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4abdc39743f0817a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v16a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d3bc44701043229(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6 7 17l-5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 10-7.5 7.5L13 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b35e209c25ac52fa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6 9 17l-5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$351befc0ff2fdf11(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d80fb8a603cc9d7b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3adb99e6d8d137c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 9 6 6 6-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d550fd24dc3707cd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17 18-6-6 6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6v12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a33845a3b05c6283(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 18 6-6-6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6v12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b3f33577a663b823(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 18-6-6 6-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$96a1c23399e4419c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 18 6-6-6-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1d9dddce27b66486(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 15-6-6-6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$41f5188d73ab84a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 20 5-5 5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 4 5 5 5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c6a83bfee916db5c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 6 5 5 5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 13 5 5 5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9b7acc83eb6dd105(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 8 4 4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 8-4 4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$58016f658ded2335(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 7-5 5 5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 7 5 5-5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$440ee165608c8455(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11 17-5-5 5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 17-5-5 5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$acab8fa664804572(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20 17-5-5 5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4 17 5-5-5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a48d9e61e2b126e1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 17 5-5-5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 17 5-5-5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7e49f842229ae25e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 15 5 5 5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 9 5-5 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9b295009bcc8a508(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17 11-5-5-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 18-5-5-5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7dca740946d20b6f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21.17",
                    "x2": "12",
                    "y1": "8",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3.95",
                    "x2": "8.54",
                    "y1": "6.06",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10.88",
                    "x2": "15.46",
                    "y1": "21.94",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6a92c3592ada9a63(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 22v-4a2 2 0 0 0-4 0v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22V5.618a1 1 0 0 0-.553-.894l-4.553-2.277a2 2 0 0 0-1.788 0L6.553 4.724A1 1 0 0 0 6 5.618V22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 7 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.618a1 1 0 0 1 .553-.894L6 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d852a91d429c7c8d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c0-2.5-2-2.5-2-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12a1 1 0 0 1 1 1v2a1 1 0 0 1-.5.866"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8c0-2.5-2-2.5-2-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a23c4263ee353711(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c0-2.5-2-2.5-2-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8c0-2.5-2-2.5-2-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$11b836127873a5fe(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "8",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12.01",
                    "y1": "16",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c02be076257cfa64(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 12 4 4 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5c53f8039dd538cd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 8-4 4 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a2aaf585282ca501(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12a10 10 0 1 1 10 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 22 10-10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22H2v-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b2c5562f5d303deb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a10 10 0 1 1 10-10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22 12 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v6h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7bbfb2d16c1adb95(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8V2h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 10 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2A10 10 0 1 1 2 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e4ea8070fec98a8f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12A10 10 0 1 1 12 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2 12 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2h6v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4aa897aa9c7eab1d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 4-4-4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c69edcfcf60b3d3d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 12-4-4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16V8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$509a105cf0b2e957(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.801 10A10 10 0 1 1 17 3.335"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 11 3 3L22 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$10f989b470d33326(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 12 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f6db17ec7d06e5bd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 10-4 4-4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$495e22c405ad7928(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 16-4-4 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$98c68926121f962f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 8 4 4-4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d02afb0348e0eac8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 14 4-4 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$66122f968c827acc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 2.182a10 10 0 0 1 3.8 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 21.818a10 10 0 0 1-3.8 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.609 3.721a10 10 0 0 1 2.69 2.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.182 13.9a10 10 0 0 1 0-3.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.279 17.609a10 10 0 0 1-2.7 2.69"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.818 10.1a10 10 0 0 1 0 3.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.721 6.391a10 10 0 0 1 2.7-2.69"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.391 20.279a10 10 0 0 1-2.69-2.7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ed650a8d8a287716(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "16",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "16",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "8",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8bb92fbb6aa62444(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18V6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$464516de4cd0b8bb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 2.18a9.93 9.93 0 0 1 3.8 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.82 10.1a9.93 9.93 0 0 1 0 3.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 21.82a9.94 9.94 0 0 1-3.8 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.18 13.9a9.93 9.93 0 0 1 0-3.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ea51c961e33e3a73(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8032cba7c68e2059(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bc280b0eb6ffa131(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$889b3dfd10f6b35(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 0 1 7.38 16.75"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 12-4-4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16V8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 8.875a10 10 0 0 0-.5 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.83 16a10 10 0 0 0 2.43 3.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.636 5.235a10 10 0 0 1 .891-.857"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.644 21.42a10 10 0 0 0 7.631-.38"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b4e3e5cd6d6f506c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 0 1 7.38 16.75"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 8.875a10 10 0 0 0-.5 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.83 16a10 10 0 0 0 2.43 3.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.636 5.235a10 10 0 0 1 .891-.857"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.644 21.42a10 10 0 0 0 7.631-.38"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$be4b839e5ba6e5ce(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.6 2.7a10 10 0 1 0 5.7 5.7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4 10.6 19 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fed9964180a494b8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fca19e3c934cbac3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4be74d6084ed3cc6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.35 2.69A10 10 0 0 1 21.3 15.65"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.08 19.08A10 10 0 1 1 4.92 4.92"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$474a51e4508f8c07(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 5 14 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13a3 3 0 1 0 0-6H9v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17v-2.34"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ca18adfd10fc7cb9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17V7h4a3 3 0 0 1 0 6H9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$26e59d0dedd040cc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "x2": "10",
                    "y1": "15",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "x2": "14",
                    "y1": "15",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$606f19c347ca5c79(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c943423a26cc8c79(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "10 8 16 12 10 16 10 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$db7f2185d07518e9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5df4e0750c9ae5a9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.998 9.003a5 5 0 1 0 8-.005"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5059398978c42dc9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2 2 22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$64253a56f6a21be6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "15",
                    "y1": "15",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1e364c27f7e1f611(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "6",
                    "height": "6",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ef8cfbc405f2e0c5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20a6 6 0 0 0-12 0"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$86f9c606816b31d1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1f065998f0e45246(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 9 6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8a0dcffb90863054(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$89027371050152ff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h4a2 2 0 0 0 2-2V3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21v-4a2 2 0 0 1 2-2h4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "15",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$db38c02dc129b5a3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.65 15.66A8 8 0 0 1 8.35 4.34"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 10-5.5 5.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17.85V10H6.15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ee6840d81da26728(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.2 5.3 3.1 3.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.4 3.4 3.1 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b5b484f07cff69ec(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "4",
                    "x": "8",
                    "y": "2",
                    "rx": "1",
                    "ry": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 14 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bb97a0f58700ef1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "4",
                    "x": "8",
                    "y": "2",
                    "rx": "1",
                    "ry": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14H11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 10-4 4 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ed5c429cb857ed9f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "4",
                    "x": "8",
                    "y": "2",
                    "rx": "1",
                    "ry": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2e659914c135a0d2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "4",
                    "x": "8",
                    "y": "2",
                    "rx": "1",
                    "ry": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1162f746143b77e3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 10 4 4-4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$404ce1bc2ed4e921(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "4",
                    "x": "8",
                    "y": "2",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 1.73 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a0ed490a92c043dc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "4",
                    "x": "8",
                    "y": "2",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13.5V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ae8cc52577bca5a9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "4",
                    "x": "8",
                    "y": "2",
                    "rx": "1",
                    "ry": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e64ddb7b571aeb56(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "4",
                    "x": "8",
                    "y": "2",
                    "rx": "1",
                    "ry": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12v-1h6v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$30f82ee0bad55464(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "4",
                    "x": "8",
                    "y": "2",
                    "rx": "1",
                    "ry": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 11-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 11 6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1830bb9cbbb00295(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "4",
                    "x": "8",
                    "y": "2",
                    "rx": "1",
                    "ry": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$61832c59019c006f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 14.5 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3fa280edf4dd6a8a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 8 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ebd245e308b59034(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 9.5 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$61804206e0fb9f0f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cf71c7fbcd914065(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 16 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7c80400862d738d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 16.5 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$610778801d5030d8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 16 14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6fc749f1fd93d511(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 14.5 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$89277b6ef0131654(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 12 16.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$37f10d5759ccc54e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 9.5 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$69576f1d8e508608(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 8 14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fa69840562ac28f4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 7.5 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5373db63022d8eca(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v6l4 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21.16a10 10 0 1 1 5-13.516"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11.5v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21.5h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a7c47b8684e24a07(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.338 21.994A10 10 0 1 1 21.925 13.227"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v6l2 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 18 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14v8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c6152ce3112728fb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.228 21.925A10 10 0 1 1 21.994 12.338"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v6l1.562.781"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 18 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22v-8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3e4b3a5ce6564e64(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 16 14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$47e62d2ea3303f6c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$899d7741bd401225(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "17",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.7 18.4-.9-.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.2 15.9-.9-.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.6 20.7.3-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.1 14.2.3-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.6 20.7-.4-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.8 14.3-.4-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.3 18.6 1-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.7 15.8 1-.4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c3d8146a17f0c04b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13v8l-4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 21 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$37d20255dde8d7a8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 19v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$336dd5af55435951(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17H7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21H9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4d4b39765892a8e2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$25224068cf86399f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 12-3 5h4l-3 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$51ae9db8d61336e2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b9e3f419c467b59b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a7e728500f557931(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cb056f6321ea128a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.2 22 3-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 13-3 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 13-3 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$df082cddea0a2178(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fc3f7f50bc177d43(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 19h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9c1aa5b4244d54e5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.93 4.93 1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.07 4.93-1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.947 12.65a4 4 0 0 0-5.925-4.128"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$261da343966849c9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.93 4.93 1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.07 4.93-1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.947 12.65a4 4 0 0 0-5.925-4.128"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$71695bc0fcf61aad(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 17 4-4 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$79149b6e5401517e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$85ee7a7a8d8e483a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cd10f19fb56ca0a9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.17 7.83 2 22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.83 7.83 8.34 8.34"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ae49ca3c2d8b40c1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.66L12 22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c834ab60c223e10(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 16 4-4-4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 8-4 4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 4-5 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$581db56922c28661(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 18 22 12 16 6"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 6 2 12 8 18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2799967aad6ec019(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "22",
                    "y2": "15.5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 8.5 12 15.5 2 8.5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 15.5 12 8.5 22 15.5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "2",
                    "y2": "8.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$af4fd427b7a14939(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7.5 4.21 12 6.81 16.5 4.21"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7.5 19.79 7.5 14.6 3 12"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 12 16.5 14.6 16.5 19.79"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "22.08",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5057e4b7f64a0880(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$32acb477786981f4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 20.66-1-1.73"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10.27 7 3.34"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20.66 17-1.73-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.34 7 1.73 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20.66 7-1.73 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.34 17 1.73-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 3.34-1 1.73"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 13.73-4 6.93"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fb1b91af617fd42b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.09 10.37A6 6 0 1 1 10.34 18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h1v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.71 13.88.7.71-2.82 2.82"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b46bd89969b68870(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1876fdbf9781e099(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5b44df9fd6a93b11(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ce381d99c69531ae(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18H5a3 3 0 0 1-3-3v-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 21 3-3-3-3"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "14",
                    "width": "8",
                    "height": "8",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "8",
                    "height": "8",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ca61532cad63b5ae(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$611c68033bdee9c7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$59581cb88369b7c8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.536 11.293a1 1 0 0 0 0 1.414l2.376 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.297 11.293a1 1 0 0 0 0 1.414l2.377 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414L6.088 8.916a1 1 0 0 0-1.414 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.916 17.912a1 1 0 0 0 0 1.415l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.415l-2.377-2.376a1 1 0 0 0-1.414 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.916 4.674a1 1 0 0 0 0 1.414l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$da6fa915e175a418(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "8",
                    "x": "5",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "8",
                    "x": "2",
                    "y": "14",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c91b771ba2247ca0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16a8 8 0 1 0-16 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8d9a47daf20e4c04(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98"
                },
                "child": []
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "rx": "9",
                    "ry": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$af2ba086c583bc01(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "6",
                    "width": "20",
                    "height": "8",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14 2.3 6.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 6 7.7 7.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 6 8 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b1850e2274f64c78(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.915 22a6 6 0 0 0-12 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "4",
                    "width": "18",
                    "height": "18",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5b9a4992cad7b799(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "4",
                    "width": "18",
                    "height": "18",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ed9cc9259dbe9b7c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 21.9V14L2.1 9.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 14 11.9-6.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19.8v-8.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17.5V9.4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bf3a36d34a16b13e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18a6 6 0 0 0 0-12v12z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4d9bb3012e95a49(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 8.5v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15.5v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14v.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3f7828bd919f55a3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4 8 16-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$18ad52cb598be5bc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 15 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "14",
                    "x": "8",
                    "y": "8",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$61960f0aaab2b6ee(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "18",
                    "y1": "15",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "14",
                    "x": "8",
                    "y": "8",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e17850dbc00b74fc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "15",
                    "y1": "12",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "18",
                    "y1": "15",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "14",
                    "x": "8",
                    "y": "8",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$831cc54b0aee6eee(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "18",
                    "y1": "18",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "14",
                    "x": "8",
                    "y": "8",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7a6171cda5f0d6e7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "18",
                    "y1": "12",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "18",
                    "y1": "18",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "14",
                    "x": "8",
                    "y": "8",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6e218b3956b36070(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "14",
                    "x": "8",
                    "y": "8",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$85f60e49227e229f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 14.83a4 4 0 1 0 0-5.66"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$caa16ba8d76d1037(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.83 14.83a4 4 0 1 1 0-5.66"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2cbd95c07525813e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 10 4 15 9 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v7a4 4 0 0 1-4 4H4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8036df49d27108ee(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 10 20 15 15 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v7a4 4 0 0 0 4 4h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$769f135b203aaa8a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 15 9 20 4 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-7a4 4 0 0 0-4 4v12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$172b9f5c73c9d323(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 9 9 4 4 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20h-7a4 4 0 0 1-4-4V4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2a1fc437ddad5660(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 15 15 20 20 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h7a4 4 0 0 1 4 4v12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$efaa5f3542cfd23c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 9 15 4 20 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h7a4 4 0 0 0 4-4V4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1c9a78de57190d2d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 14 4 9 9 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20v-7a4 4 0 0 0-4-4H4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cf139dbaf6fca716(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 14 20 9 15 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20v-7a4 4 0 0 1 4-4h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c9830632565a8651(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "16",
                    "x": "4",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "6",
                    "x": "9",
                    "y": "9",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cbef00f6470168c8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2f964ec8e6a953ef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "5",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "10",
                    "y2": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9f9e58f82ceff720(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fadd72a17d210127(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v14a2 2 0 0 0 2 2h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22V8a2 2 0 0 0-2-2H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9a6470d8c0cd19d4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a1 1 0 0 1 1 1v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a1 1 0 0 1-1-1V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a1 1 0 0 1-1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2d8512bed1e1e846(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "18",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "2",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "6",
                    "y2": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "22",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d2a367fc3b807bf4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$378207da21ddb121(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22v-8L2.25 9.15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 14 11.77-6.87"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ac892db2aa0e1ed4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 8 1-6h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3576fdefaf61260d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "6",
                    "y1": "3",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "x2": "18",
                    "y1": "3",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "6",
                    "y1": "21",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "x2": "18",
                    "y1": "21",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2e7da2955e128a45(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "rx": "9",
                    "ry": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a9 3 0 0 0 18 0V5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$85d84583d0add4d2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.31c1.17.56 1.54 1.69 3.5 1.69 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.75 18c.35.5 1.45 1 2.75 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1L10 4a1 1 0 0 0-1-1z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$13c1f196360f14a8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "rx": "9",
                    "ry": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12a9 3 0 0 0 5 2.69"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9.3V5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a9 3 0 0 0 6.47 2.88"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v4h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8dc5118b093fe337(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "rx": "9",
                    "ry": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5V19A9 3 0 0 0 15 21.84"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5V8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12L18 17H22L19 22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12A9 3 0 0 0 14.59 14.87"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$284f0eaceda460ff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "rx": "9",
                    "ry": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5V19A9 3 0 0 0 21 19V5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12A9 3 0 0 0 21 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$38992c6850970274(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 9 6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 9-6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4fcc3d524e185a06(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.2 14.8a9 9 0 0 0 17.6 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3021283ee76cd612(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "5",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.48 3.66a10 10 0 0 1 13.86 13.86"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.41 6.41 11.18 11.18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.66 6.48a10 10 0 0 0 13.86 13.86"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d1e823233fdf16d9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5fff9b1be5276b80(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.2 9.2h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 9.5-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.7 14.8h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b97c7b0e86d8e1fd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$914027352a9d0770(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9ec756938c998fdc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2a38ca1b28a7a66(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8cef2142c5b299b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b0de1a70410af5ca(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$199e70ea00237d9a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$92b25b507ff3a275(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ac005ec27b8bbf83(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "12",
                    "height": "12",
                    "x": "2",
                    "y": "10",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b8a13793bd38ddcd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bf8055609c74954(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2f035d439f91bc90(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12c0-1.7.7-3.2 1.8-4.2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12c0 1.7-.7 3.2-1.8 4.2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$686863e46f0e1404(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$43a51ecf1228d213(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$60ba3550c060c91c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "x2": "19",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$52048936f530f23a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 6-2.891-2.891"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15c3.333-3 6.667-3 10-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 9 .891.891"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.109 14.109 4 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.5 12.5 1 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 18 2.891 2.891"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d3b17932e9d8ec97(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 16 1.5 1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 8-1.5-1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.5 10.5 1 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 6-2.891-2.891"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15c6.667-6 13.333 0 20-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 9 .891.891"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.109 14.109 4 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.5 12.5 1 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 18 2.891 2.891"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 22c1.798-1.998 2.518-3.995 2.807-5.993"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$93391221c008d2bc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8h20"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "16",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 16h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5796c3369198d99(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 16.25h1.5L12 17z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14v.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14v.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4e136ac79beb067a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ec091832fb007f40(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eca8db99390c4440(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12v.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1da44e5d87542bc6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4h3a2 2 0 0 1 2 2v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 20h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d0a281899b6aa703(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.1",
                    "cy": "12.1",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6779a5423cd818a5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 10 12 15 17 10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "15",
                    "y2": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$74c1f1bde42cf729(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.99 6.74 1.93 3.44"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.136 12a10 10 0 0 1-14.271 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-2.16-3.84"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 21 8.02-14.26"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$419789349abc34c0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 13.1h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.4 9.9c-.8.8-2 .8-2.8 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ed763ad8e1332e92(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.56 2.75c4.37 6 6 9.42 8 17.72"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6e9954872f121815(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3 1 1 0 0 1 1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1l-.81 3.242a1 1 0 0 1-.97.758H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 10-2 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 18 2-8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5df3ba098faa631f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cfd120100d8d2d69(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$424708db0347481e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 2-8 8"
                },
                "child": []
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "rx": "10",
                    "ry": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13.4v7.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13.4v7.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9v8a10 5 0 0 0 20 0V9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$90d53e2c9b1879b4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$989c837792d27677(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.4 14.4 9.6 9.6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.5 21.5-1.4-1.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 3.9 2.5 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$af0a7719a67f07b3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8.5c0-.75.13-1.47.36-2.14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$baca0cc4b8a212a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$894c25011b8dfab3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3.34V5a3 3 0 0 0 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.54 15H17a2 2 0 0 0-2 2v4.54"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 9.54 13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6V4a2 2 0 1 0-4 0v2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "5",
                    "x": "14",
                    "y": "6",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f08045fc7bd5874d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.54 15H17a2 2 0 0 0-2 2v4.54"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6fd03299470c9d6f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a7 7 0 1 0 10 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7796f8e609cd5c88(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "12.5",
                    "r": "3.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e233d0b643747594(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$da020b4a8d5c0821(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$36b6ab07b55d262b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$64b588887af0b84d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9962a081595af8bd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a41577ec823f43fc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "x2": "19",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "x2": "19",
                    "y1": "15",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "5",
                    "y1": "5",
                    "y2": "19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5602bda753ced206(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "x2": "19",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "x2": "19",
                    "y1": "15",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e4c5bf130b8b87f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 21H7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 11 9 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1430b192533263d7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 20 3-3h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h2l3 3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8f16b47e22bbd96b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6ba279a856ae5802(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-6-6m6 6v-4.8m0 4.8h-4.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16.2V21m0 0h4.8M3 21l6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7.8V3m0 0h-4.8M21 3l-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7.8V3m0 0h4.8M3 3l6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d55eeea2092c469e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3h6v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14 21 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f4758ead48519f80(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 18-.722-3.25"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8a10.645 10.645 0 0 0 20 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 15-1.726-2.05"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4 15 1.726-2.05"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 18 .722-3.25"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$124cc7e0902fc216(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.084 14.158a3 3 0 0 1-4.242-4.242"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$40748eaddaaba89d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$45d964d03b5a2590(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f808a34acbcb5fa1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18h1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a8b7bad46107df9c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2ee4d79c303689ef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "13 19 22 12 13 5 13 19"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "2 19 11 12 2 5 2 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eeffadf459211854(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8 2 22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 15H9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fafbafdb0c75e2f7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6f79408dc516e982(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.8 15-3.5 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20.7 7-3.5 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.8 9 3.3 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20.7 17-3.5-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 22 3-8 3 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18.7a9 9 0 1 0-12 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d53764161fc72aae(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7bef756c51c1d693(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12v-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "20",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$60a3fdffa44c2709(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3",
                    "cy": "17",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17v-3a4 4 0 0 1 8 0v3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "17",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$993f4ceeec38b623(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$edd15661e85ea6ff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 18 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10v8h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8f70cfce999e7bb1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 12.5 1 5.5-3-1-3 1 1-5.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b66863bf0113d71c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16.5 8 22l-3-1-3 1 1-5.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bd79fb4c4f5f6ecb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.7 14.2 7 17l-4.7-2.8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a0b5634e736e0e5d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18v-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$99ccb5f53ebbfa8f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18v-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18v-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18v-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a22c847297039990(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 13-3.5 3.5-2-2L8 17"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b5a90e15f6588553(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.017 11.512a6 6 0 1 0 8.466 8.475"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$253b5d0fc650d3f7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 15 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$32331ca25579ec04(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 15 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$936ee92cc8a2677d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 17.5 8 16.25V14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$443e4f4566265a7e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 12-3 3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 18 3-3-3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$47b497e622f532b2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12.5 8 15l2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 12.5 2 2.5-2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b41d7d83ee5394b7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.2 12.9-.9-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.2 15.1-.9.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.9 11.2-.4-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.9 16.8-.4.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.5 10.3-.4.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.5 17.7-.4-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.7 12.5-.9.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.7 15.5-.9-.4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "14",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3abedc3407d1cf4f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6e995b469029c719(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "4",
                    "height": "6",
                    "x": "2",
                    "y": "12",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12h2v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bf400537c1c1bfda(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18v-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 15 3 3 3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cab11f3010cf05fc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fee8c0a27db6b0e1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2c1f967abbc9c4d9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 18 3-3-3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7d2712272cde84ef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$db39063b34fd2c4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b17220b3013e8d19(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "16",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 10-4.5 4.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 11 1 1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bdbee2b539b99b72(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "16",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 10-4.5 4.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 11 1 1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$38d97e6625800afb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "5",
                    "x": "2",
                    "y": "13",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13v-2a2 2 0 1 0-4 0v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$169c2ee501f58f81(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "6",
                    "x": "8",
                    "y": "12",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12v-2a2 2 0 1 1 4 0v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1a4895035f9fed59(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5a2b467dde5ca624(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b1c11159536d3d7e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v8.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18v-7.7L16 9v7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "16",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fac472db9050f830(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 11-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 17-3-3h10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6c112ce1a3add36c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18h1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$99349c12eaff7201(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5efdbc4078396134(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c5bcd97fc2d61747(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18v-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b922905fe725589d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7755e18edba37de6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14a2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22a2 2 0 0 0 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 22a2 2 0 0 1-2-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$caa879708960b009(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "14.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.3 16.3 15 18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4137c0fa92e8f6ca(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 18-1.5-1.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "14",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$81623529e7c6ef3a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 17h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 16v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$266f2327e7bcd468(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 17h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d0c3c5f2c686575f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-3a2 2 0 0 1-2-2V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b199c5dc33461809(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 18 3-3-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$91126866da90b992(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 16 2-2-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d2bb9724b2a03909(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17H8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$553fd45fb5cae887(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13v-1h6v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3e03dcaee64db457(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13v-1h6v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$77f530a42c91b579(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 15-3-3-3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b2fa1440ef70f8b5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18a3 3 0 1 0-6 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e8312a3788c38044(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "6",
                    "x": "2",
                    "y": "12",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 15.5 4 2.5v-6l-4 2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ca650c1d7637404a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 11 5 3-5 3v-6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b3b5624377aef407(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 13.5a2.5 2.5 0 0 1 0 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12a5 5 0 0 1 0 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1df0735707f2b32b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11a5 5 0 0 1 0 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6.765V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-.93-.23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10.51a.5.5 0 0 0-.826-.38l-1.893 1.628A1 1 0 0 1 3.63 12H2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1.129a1 1 0 0 1 .652.242l1.893 1.63a.5.5 0 0 0 .826-.38z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a3c65644e103da03(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d8bc6d4a9ac56655(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 12.5-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 12.5 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c47e02646740476a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 12.5-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 12.5 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b357bec024b7bf71(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$89a4def07b6abba7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-3a2 2 0 0 1-2-2V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2e3e86aaef66c58c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7.5h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16.5h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7.5h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.5h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3c5403a612388b6b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 3-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 3 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8be7398e9e3d4af(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cb5e7235ca999475(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13.12c0 2.38 0 6.38-1 8.88"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.29 21.02c.12-.6.43-2.3.5-3.02"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12a10 10 0 0 1 18-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.8 16c.2-2 .131-5.354 0-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.65 22c.21-.66.45-1.32.57-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6.8a6 6 0 0 1 9 5.2v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c8da044c5fac101d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3h-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3a6 6 0 0 0-6 6v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$336d77b73516e67d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6196340d7e99aa85(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16s9-15 20-4C11 23 2 8 2 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5ea46eb3252ce4b8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12v.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17.93a9.77 9.77 0 0 1 0-11.86"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7f21ad933f5ec3db(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2c3 0 5 2 8 2s4-1 4-1v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22V4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15s1-1 4-1 5 2 8 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$adaf8f9b8acf53ba(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 22V2L7 7l10 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$59bcffc3a56e3f4f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22V2l10 5-10 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$10db2e72fc8c00c2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "4",
                    "y1": "22",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cda022e084957cfb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 22 14-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 18 14 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f24b8449c8db4e73(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ca706cc4a6e57086(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2h11v4c0 2-2 2-2 4v1"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "11",
                    "x2": "18",
                    "y1": "6",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$225442c088bbf22(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "18",
                    "y1": "6",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4239003b8162ac88(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10 4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-1.272-2.542"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v2.343"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v6.343"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d715f115b0ae3f64(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$227be3591f8fa19b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v7.31"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9.3V1.99"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9.3a6.5 6.5 0 1 1-4 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.52 16h12.96"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6105c3ee88f89aad(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 7 5 5-5 5V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 7-5 5 5 5V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$364566bd437abcfe(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a7d92f99a4057d77(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17 3-5 5-5-5h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 21-5-5-5 5h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12h-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ef03628b90b190f5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12h-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$20881035f4d5015e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a563940b12d6a2fe(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.5V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 12H9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12H15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16.5V15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 8 1.88 1.88"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.12 9.88 16 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 16 1.88-1.88"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.12 14.12 16 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$39c7dd562d65080a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6cea3aab25780d8e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12h-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 9-3 3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 15 3-3-3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$70e7326b73e0b092(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22v-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 19-3-3-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 5-3 3-3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aa414db270033906(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11v-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17v-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1729d662f7a25a7f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 13 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b32bd4bf0c6447d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14v2l1 1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$88a107b2bd7d0147(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f5517fb0b90a873(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.5 8 13l2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 10.5 2 2.5-2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9d2689e3997fa491(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.7 19.4-.9-.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.2 16.9-.9-.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.6 21.7.3-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.1 15.2.3-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.6 21.7-.4-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.8 15.3-.4-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.3 19.6 1-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20.7 16.8 1-.4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$55139f05bfcfe9e3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$da66429e26b05638(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 13-3 3-3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$61d975a8a384f334(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19c-2.8 0-5-2.2-5-5v8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1d6b64c77e61f5c3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d1e4b58b6fdb5e29(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01c.95.95 1 2.53-.2 3.74L17.5 21Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d6370bb39d50da01(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 16 3-3-3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e85a90b6827357e7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3c080e834919d754(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "20",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 14-4.5 4.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 15 1 1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d8e880476e3c78f4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "5",
                    "x": "14",
                    "y": "17",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17v-2a2 2 0 1 0-4 0v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f25bc543c58ba17(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5f340f67ca9d6906(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "15",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2a42bbfa171435c4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$16e6587261404e26(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 10-3 3 3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$480452bf258e23ec(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.378 13.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2ac7565651de567b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$63c424edf8e4b764(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15v5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c09cb5b198e8633f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "12.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.3 14.3 15 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5de5bbe67edf49ff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-1.9-1.9"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "17",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$90dae49473a45b41(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 16 3-3-3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$16e48990ff4e9532(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v4h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 14 1.535-1.605a5 5 0 0 1 8 1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22v-4h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 18-1.535 1.605a5 5 0 0 1-8-1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3fd2759ecb5dcafe(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5a2 2 0 0 0 2 2h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v13a2 2 0 0 0 2 2h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a79417879ebc2aec(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 13 3-3 3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d8f3a2fed61f6dfa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 10.5 5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 10.5-5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$61d6037db99538fc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c52382809135543f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8v11a2 2 0 0 0 2 2h14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$305395eb84cab163(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4bdc2efb519abdac(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12H5a2 2 0 0 0-2 2v5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$74d52fa91999895d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 17 20 12 15 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18v-2a4 4 0 0 1 4-4h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$22abc18cc6855aef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "2",
                    "y1": "6",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "2",
                    "y1": "18",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "x2": "18",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$489788c6fca5486f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f9476fa584f1c21c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16s-1.5-2-4-2-4 2-4 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "9.01",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "15.01",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1de8944a5e1e6759(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "15",
                    "y1": "22",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "14",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ab031411654835d2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "8",
                    "x": "7",
                    "y": "8",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2bbf09b5d34a7bd4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5v14"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "12",
                    "height": "18",
                    "x": "10",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bfbb1e8b20c2e47d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3v18"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "12",
                    "height": "18",
                    "x": "6",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d7c0c8e4a043f27d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "14",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21h1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6ab267e529b59534(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h14"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "12",
                    "x": "3",
                    "y": "10",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$87f077ef7a49afa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h18"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "12",
                    "x": "3",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 22h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cafe5ac0d24e6c5f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "10",
                    "y1": "11",
                    "y2": "11"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "8",
                    "y1": "9",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "15.01",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "x2": "18.01",
                    "y1": "10",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9b96d308dfc2ff6e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "10",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "8",
                    "y1": "10",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "15.01",
                    "y1": "13",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "x2": "18.01",
                    "y1": "11",
                    "y2": "11"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "12",
                    "x": "2",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f6238d97260d7e24(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 14 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.34 19a10 10 0 1 1 17.32 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1a11d30c8051483(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 16 6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 8 6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 7 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 11-8-8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2240b57b2113c90b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3h12l4 6-10 13L2 9Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3 8 9l4 13 4-13-3-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b78b593f621c5983(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b96dc84aeb046abe(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "8",
                    "width": "18",
                    "height": "4",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9a35a2f9301e5aa1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6a9 9 0 0 0-9 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$82b059cada0f578c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "3",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9a9 9 0 0 1-9 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$447c9c292cbecb13(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "9",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "21",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$285290b2077ec149(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a9a698b69d7a66c3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6h5a2 2 0 0 1 2 2v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-3-3 3-3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18H7a2 2 0 0 1-2-2V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 15 3 3-3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6d11794e8e07c2d9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h3a2 2 0 0 1 2 2v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18H8a2 2 0 0 1-2-2V9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cea696b0af49e8f4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$241f5ef66412d23d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9v6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v18"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15.7A9 9 0 0 0 19 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$daa2fc581b10734b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21V9a9 9 0 0 0 9 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ac2678738e517bff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9v12"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-3-3 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6h5a2 2 0 0 1 2 2v7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f76cfd4bd07f1f24(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9v12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 3-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 9-6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11.5V15"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d72e2689509f27e4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9v12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-3-3 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6h5a2 2 0 0 1 2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c1cdd5c6642122d2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9v12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h3a2 2 0 0 1 2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2c2041d7ef7fe51a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11v-1"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "9",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$df010231a9b135aa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h3a2 2 0 0 1 2 2v7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "9",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ba1cf74706797aa5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18c-4.51 2-5-2-7-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4074b7634dbba268(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bfac8a55ef1acbfb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e59f8f8e0642681a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "15",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "15",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 13 5 7c.7-1.3 1.4-2 3-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 13 19 7c-.7-1.3-1.5-2-3-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ce265a5729218e32(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h8.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6V4a2 2 0 1 0-4 0v2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "5",
                    "x": "14",
                    "y": "6",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$faa5d532664795cc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6e65d3e5c08c5524(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V2l8 4-8 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.561 10.222a9 9 0 1 1-12.55-5.29"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.002 9.997a5 5 0 1 0 8.9 2.02"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4050a51a0356f6d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11.5V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10V8a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.9V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14a2 2 0 0 0-2-2a2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8b61f66b2521d747(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12.5V16a6 3 0 0 0 12 0v-3.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aba235e1046ed23b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5V2l-5.89 5.89"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.6",
                    "cy": "15.89",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.11",
                    "cy": "7.4",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.35",
                    "cy": "11.65",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.91",
                    "cy": "5.85",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.15",
                    "cy": "10.09",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.56",
                    "cy": "13.2",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.8",
                    "cy": "17.44",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "19",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8b017b689221589f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 19 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c47fa31f9fee885b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 19h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 22v-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$62444b642041cdf8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 16 5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 21 5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b547620485f67c59(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h18"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f6bf057bbd750637(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d40f751d2461011f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "9",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "9",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "15",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "15",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "15",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$398b18658af2da26(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "5",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "5",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e309c192a9efc64c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "5",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "5",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f80d8df5f162169c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5c0-1.1.9-2 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2c1.1 0 2 .9 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2c0 1.1-.9 2-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5c-1.1 0-2-.9-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "5",
                    "x": "7",
                    "y": "7",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "5",
                    "x": "10",
                    "y": "12",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8df37e503110f7a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.9 12.1 4.514-4.514"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 16 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.2 9.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4 2 2 0 0 0 1.8-1.2z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "12.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c8d68d074db01d9f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 16.5-1-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8363f64d24742626(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 15 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c596d9d1ae3f5442(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 16 6 6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "9",
                    "r": "2.9"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aa89485ad73f70a6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 15 6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9d0f9820d60d179(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 13 6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$33b8a293ac47f143(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12.5V10a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11V9a2 2 0 1 0-4 0v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.5V5a2 2 0 1 0-4 0v9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e4325c0b4776a19d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.4 17.4 3.2-2.8a2 2 0 1 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2l-1.302-1.464A1 1 0 0 0 6.151 19H5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h12a2 2 0 0 1 0 4h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10a7 7 0 0 1 14 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14v6a1 1 0 0 1-1 1H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8ac5a7a5b74fa7aa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d35bd2b02e45b1b4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11 17 2 2a1 1 0 1 0 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 3 1 11h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ba4d1ffc7c3ff6fc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 6-4 4-4-4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "8",
                    "x": "2",
                    "y": "14",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$28102f096db5fb89(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 6-4-4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v8"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "8",
                    "x": "2",
                    "y": "14",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1998ac60c10decb0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "2",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6.01",
                    "y1": "16",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "x2": "10.01",
                    "y1": "16",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8165e15f4c9cc3fc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6a6 6 0 0 1 6 6v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15v-3a6 6 0 0 1 6-6"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "15",
                    "width": "20",
                    "height": "4",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d845f8ab6c0be09f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "20",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "20",
                    "y1": "15",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "x2": "8",
                    "y1": "3",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "x2": "14",
                    "y1": "3",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8ec278b6c1998901(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.2 6.2 1.4 1.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.4 7.6 1.4-1.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 21H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13a4 4 0 0 0-8 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$69235e3afb59db07(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 12h9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e372cd22139e2337(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 12 3-2v8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$71fde3f77396fdeb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8cee466d69bdc2f6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bbd4c6a8112b721(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10v3a1 1 0 0 0 1 1h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18V6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4270ec3739167a00(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13v-3h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c65b4bd570fe132e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18V6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "16",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10c-2 2-3 3.5-3 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$15a946ec2d12f436(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20V4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20V4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fe2becbe8d32cbed(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14h-1.343"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.128 3.47A9 9 0 0 1 21 12v3.343"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.414 20.414A2 2 0 0 1 19 21h-1a2 2 0 0 1-2-2v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 2.636-6.364"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3402f3caa633daef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a3e8b30e56c6c9c1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v2a4 4 0 0 1-4 4h-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dd736ebdd9bd5266(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 13-1-1 2-2-3-3 2-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$31b84c0f46b40768(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 15-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 18-2-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$160fddc47cc7e58a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "2",
                    "x2": "22",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8b5ce4c06cd300ca(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$31e8dd5e46f01d82(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ea77f849ec73a880(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8c2-3-2-3 0-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 8c2-3-2-3 0-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 16v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 20v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a670fa3624f3738f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1e8c46d3c42224a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 11-6 6v3h9l3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$125a3fbf2fbd72c5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v5h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v5l4 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$239401fbf2d1191d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a13b3a1f75ab73dc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.93 4.93 3 3a.7.7 0 0 1 0-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$46578bc8ea4c2a2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f7a2f37c8e655fd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22v-6.57"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 15.43V22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16a5 5 0 0 0-6 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h.01"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "2",
                    "width": "16",
                    "height": "20",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1aa6163a450a37d4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a7e116e9840a5e1b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12V8.964"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12V8.964"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$520279b05e02a22d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.22 2.416a2 2 0 0 0-2.511.057l-7 5.999A2 2 0 0 0 3 10v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7.354"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$11010f5a4694997c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d51a367b6dec4fb5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.14 11a3.5 3.5 0 1 1 6.71 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 6.5a3.5 3.5 0 1 0-7 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$337a7bf867759054(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7A5 5 0 0 0 7 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$77314b2955546710(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.17 15a3 3 0 0 1 5.66 0"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "11",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "5",
                    "width": "20",
                    "height": "14",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e4202ef8526ac(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 19 3 3v-5.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 22 3-3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cd568156a5d5b389(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "x2": "22",
                    "y1": "5",
                    "y2": "5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4f6c24c5206e0d50(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.41 10.41a2 2 0 1 1-2.83-2.83"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "13.5",
                    "x2": "6",
                    "y1": "13.5",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "x2": "21",
                    "y1": "12",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15V5a2 2 0 0 0-2-2H9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$70ea7ff960dbbe68(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11 16-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.765 22a.5.5 0 0 1-.765-.424V13.38a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$94fe0d825fe211e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1ed204eb6be7755e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 19.5 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 22v-5.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ddb40aead88262e1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3h5v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21h2a2 2 0 0 0 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 3-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 21 4.144-4.144a1.21 1.21 0 0 1 1.712 0L13 19"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3h3"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "11",
                    "width": "10",
                    "height": "10",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f186d87add6bae17(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2a6c796f11fa4772(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22H4a2 2 0 0 1-2-2V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "16",
                    "x": "6",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$720f0979bd1b1189(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 11 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d2d6862ce2af7c72(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 12 16 12 14 15 10 15 8 12 2 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e54bca9859888c13(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12H11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18H11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 8-4 4 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9396bc7f9fee1172(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12H11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18H11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 8 4 4-4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1759bce3ff29d1c7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 13 8.5 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13c6.667 0 6.667-10 0-10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b92b2dd498b17667(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$83f49babc70be9b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2d67d7f4863c205a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7fc729887a50c0b5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "20",
                    "x": "2",
                    "y": "2",
                    "rx": "5",
                    "ry": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.5",
                    "x2": "17.51",
                    "y1": "6.5",
                    "y2": "6.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9b13bfc29b3269ce(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "10",
                    "y1": "4",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "x2": "5",
                    "y1": "20",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "9",
                    "y1": "4",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dcb75c8f381853f5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 14 20 18 16 22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ba6008c592598669(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 22 4 18 8 14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$88430549f410c74d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9.5V21m0-11.5L6 3m6 6.5L18 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f82b95099aa5bec4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15V9"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e6e788e6a6485bfb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5v14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$adc551fe2509e8bd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "7.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1eae1a91e8a493c0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.4 2.7a2.5 2.5 0 0 1 3.4 0l5.5 5.5a2.5 2.5 0 0 1 0 3.4l-3.7 3.7a2.5 2.5 0 0 1-3.4 0L8.7 9.8a2.5 2.5 0 0 1 0-3.4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 7 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.4 10.6-6.814 6.814A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ace48feb8133d35d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 2-9.6 9.6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "15.5",
                    "r": "5.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4aca64b762c299bb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "16",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$19d184eae61dca40(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M 20 4 A2 2 0 0 1 22 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M 22 6 L 22 16.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M 7 16 L 16 16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M 9.69 4 L 20 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a7f0354ce20ebd64(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h.01"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "16",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$32b91b15a7658457(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h12l4 9H2l4-9Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 16a3 3 0 1 0 5.66 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cd98767eb96f620f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14 5-3 3 2 7 8-8-7-2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 5-3 3-3-3 3-3 3 3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 6.5 4 12l3 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$847239e5f1c526ea(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2h6l3 7H6l3-7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9v13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 22h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$63eaea1454a6fa18(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13h6l3 7H8l3-7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13V8a2 2 0 0 0-2-2H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bde6e613f82c0b6a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4h6l3 7H8l3-7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11v5a2 2 0 0 1-2 2H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3c6aa2455bdc432c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2h8l4 10H4L8 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e765ad33d9efebf2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 8 6-3-6-3v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.49 12.85 11.02 6.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.51 12.85 6.5 19.15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5c9b670c2c7cde9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "21",
                    "y1": "22",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "18",
                    "y2": "11"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "x2": "10",
                    "y1": "18",
                    "y2": "11"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "x2": "14",
                    "y1": "18",
                    "y2": "11"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "x2": "18",
                    "y1": "18",
                    "y2": "11"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 20 7 4 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$77734faada805d28(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5 8 6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4 14 6-6 2-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 22-5-10-5 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$70d0fa3be277b8d8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 10 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "4",
                    "width": "18",
                    "height": "12",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d05f8dd9ba12124b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "12",
                    "x": "3",
                    "y": "4",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "20",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8018a602b066b253(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$223d7b2b57d6530a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22a5 5 0 0 1-2-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16.93c.96.43 1.96.74 2.99.91"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bc4f3dccd6f77f84(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22a5 5 0 0 1-2-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$814019bfd209946c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "9.01",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "15.01",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e5f3590941b7c894(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9924bec6314bb56(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.08 9.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.08 14.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6293e912902e1514(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$629cd4cc893778cb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "9",
                    "x": "3",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "5",
                    "x": "14",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "9",
                    "x": "14",
                    "y": "12",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "5",
                    "x": "3",
                    "y": "16",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$824d562d02f198e3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "3",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "14",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "14",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "3",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$da8f2c8329f2362(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "3",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "3",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 15h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 20h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$768f9d40060a87d6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "14",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "14",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c4b8569705e2b579(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "7",
                    "x": "3",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "3",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "7",
                    "x": "14",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$22b5e5ed47627f83(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "7",
                    "x": "3",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "9",
                    "height": "7",
                    "x": "3",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "5",
                    "height": "7",
                    "x": "16",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2ce3fab7451febae(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b3d8740fa872a755(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22 17 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$89f428747a4599b8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h3a2 2 0 0 0 1.902-1.38l1.056-3.333A1 1 0 0 0 21 6H3a1 1 0 0 0-.958 1.287l1.056 3.334A2 2 0 0 0 5 12h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V3a1 1 0 0 0-1-1h-3"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "12",
                    "x": "8",
                    "y": "10",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$57248404ab9abe9c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 13 3.553-7.724a.5.5 0 0 1 .894 0L11 13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$36e2009d83e724a1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b13141dc29226145(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 6 4 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8v12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5f9cd07db83c5ed5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.93 4.93 4.24 4.24"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.83 9.17 4.24-4.24"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.83 14.83 4.24 4.24"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.17 14.83-4.24 4.24"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fd1e91ea3bd31fa5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12h2v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 20h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f728aad44954896a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6d285d04771822ad(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$81d2597c0f157040(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17H7A5 5 0 0 1 7 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h2a5 5 0 0 1 4 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "12",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8a6159100aa9fcb4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17H7A5 5 0 0 1 7 7h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h2a5 5 0 1 1 0 10h-2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "16",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fe7b32b9691d4f98(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f3e66e2eac606754(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "4",
                    "height": "12",
                    "x": "2",
                    "y": "9"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c737e7054cd4ff67(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 18 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d2cefb86e74006f8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 17 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 7 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b0c1ee29b2ec1418(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 10 2.5-2.5L3 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 19 2.5-2.5L3 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6h11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12h11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8804ff60a01a9704(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6v10a2 2 0 0 1-2 2h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 16-2 2 2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eb203525f9e1c652(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d18c1abafed41058(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$40ae08eb7d2b06bb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$41f22dc610ae7ae3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12h11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6h11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h1v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6e822732c3b7a06a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$50e7c369f24e7419(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10v4h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$316ce0f34e825459(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18V8a2 2 0 0 0-2-2h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 8-2-2 2-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$598c53db582d7a8a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "5",
                    "width": "6",
                    "height": "6",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 17 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d0578e07409a0b75(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12h-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18h-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6v4c0 1.1.9 2 2 2h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10v6c0 1.1.9 2 2 2h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$36764dcbee3726a4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 12 5 3-5 3v-6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$39c188ba64d83543(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 10-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 10 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b2a9e8c127783169(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18h13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dda830a58574003f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12a9 9 0 1 1-6.219-8.56"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8f4691f653d2859(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6ece70a92d8dadd8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.2 7.8 2.9-2.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.2 16.2 2.9 2.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.9 19.1 2.9-2.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.9 4.9 2.9 2.9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$545587801760dc7a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "5",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "22",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "2",
                    "y2": "5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "19",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b847b8e74767f29f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "5",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "22",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "2",
                    "y2": "5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "19",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ea74d49c05cf0348(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "5",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "22",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "2",
                    "y2": "5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "19",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f66ffeeba2bf134e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "16",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "12",
                    "x": "3",
                    "y": "10",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10V7a5 5 0 0 1 9.33-2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$487808d75e9d030f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "16",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "10",
                    "width": "18",
                    "height": "12",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10V7a5 5 0 0 1 10 0v3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$df7ca4b83049cb7e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "11",
                    "x": "3",
                    "y": "11",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11V7a5 5 0 0 1 9.9-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5008c54d7cd5d6a3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "11",
                    "x": "3",
                    "y": "11",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11V7a5 5 0 0 1 10 0v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7640a29ecaaf23cf(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 17 15 12 10 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "3",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ed71662c9ab4142d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 17 21 12 16 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "x2": "9",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cfa113c0eb78747a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d8277d687e4272f3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-4.3-4.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7f66d2f930a2d571(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20h4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "20",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "20",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$77d9a06f58873159(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 8 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 15 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5d854c1d3dd08803(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 19 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6a078b77acae2005(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 19h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7b2436cb9250099d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9aed920f6b7f0c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 19h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ca280af2b0e3b33a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22v.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e6f39c248c1a9cf1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 22-1.5-1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$14868612afb211d7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22v.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3a0dc045742385b1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 17 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 17-4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$386317b1ff841213(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "16",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8daa4450a9c27216(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "15,9 18,9 18,11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "7",
                    "y1": "10",
                    "y2": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c0fc794694e7f447(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "13",
                    "x": "6",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8v11c0 1.1.9 2 2 2h14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$13e2e4471989814a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 10 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ae738ea4c18e1637(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.43 12.935c.357-.967.57-1.955.57-2.935a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32.197 32.197 0 0 0 .813-.728"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 18 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1279025d93522c92(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22v-3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e4399f66bec42ce2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b837a07f4735d0d6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2d2e78406f0c5156(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.75 7.09a3 3 0 0 1 2.16 2.16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.13 9.13a3 3 0 0 0 3.74 3.74"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7d43e6e7acdffea0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d22a9b31b968d6f8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1d42e7e842cb86c0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 7.5-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 7.5 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b019ece5e818f8d2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.752 11.901A7.78 7.78 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 19 19 0 0 0 .09-.077"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.5 15.5-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.5 20.5-5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fc3635ffc9700f53(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$70b040a376b57b44(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.714 14h-3.71a1 1 0 0 0-.948.683l-2.004 6A1 1 0 0 0 3 22h18a1 1 0 0 0 .948-1.316l-2-6a1 1 0 0 0-.949-.684h-3.712"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$82306deee9fba23e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5.764v15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3.236v15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$940ba70d31d4dba3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 3-7 8-7-8Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1db06369cb303f36(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 3 21 3 21 9"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 21 3 21 3 15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "x2": "14",
                    "y1": "3",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "10",
                    "y1": "21",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$257d2bfef9d38d90(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H5a2 2 0 0 0-2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8V5a2 2 0 0 0-2-2h-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16v3a2 2 0 0 0 2 2h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21h3a2 2 0 0 0 2-2v-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b3c57a2447d90d11(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12 5.12 2.2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 12 5.88-9.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "17",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18v-2h-.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$68ae26076d670d64(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.26 9.26 3 11v3l14.14 3.14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15.34V6l-7.31 2.03"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.6 16.8a3 3 0 1 1-5.8-1.6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e2b931120944147f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 11 18-5v12L3 14v-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.6 16.8a3 3 0 1 1-5.8-1.6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$261ba31a5551161b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "16",
                    "y1": "15",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "9.01",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "15.01",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ebd03ac2b6d8fbfd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d0e123554f48f98d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "20",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "20",
                    "y1": "6",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "20",
                    "y1": "18",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2b01a1a716b093be(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 6 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 22-5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bececc4ece3acc44(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.5 8 12l2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 9.5 2 2.5-2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.9 20A9 9 0 1 0 4 16.1L2 22z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$44f2c24ace4c6db0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 17.5 2 22l4.5-1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9ee482ae0f10772b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b08cfd8fe73f37a3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e46f58cec0eed2be(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 14.9A9 9 0 0 0 9.1 3.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e5d8a5b76054f567(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fc77b528e4ee7004(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$87548dc501b787a5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 15-3-3 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h7a2 2 0 0 1 2 2v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b8a5cefa9371f574(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9ae11f8b42d10c1e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 9 6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8928c187571fb729(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7be1fff360ab58a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7.5 8 10l2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 7.5 2 2.5-2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5b17395aa5953292(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17H7l-4 4v-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14v1a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3h1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bfcf29d9b6c163b2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2281570325411e0b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$87d572d0b01b6faa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$35a9594d4d561e97(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15v-2a2 2 0 1 0-4 0v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3.5"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "15",
                    "width": "8",
                    "height": "5",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4109df412cde1b76(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6855e1fd5f035d2c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15V5a2 2 0 0 0-2-2H9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cea86eb18c6c7c79(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$65b66366ecc01078(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12a2 2 0 0 0 2-2V8H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12a2 2 0 0 0 2-2V8h-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bd4d5fe3a332d90f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 7-3 3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13v-1a2 2 0 0 0-2-2H7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c5384a86f08f0e7e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3h5v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 8 5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$de03dee543acfac4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8H7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12H7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9ba386c1202dba3d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$967721a0db265088(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 7.5-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 7.5 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$59d0ad5090f71c17(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$959b9a1160f01a29(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ef7e0bf61913e7bd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10v2a7 7 0 0 0 12 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.34V5a3 3 0 0 0-5.68-1.33"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9v3a3 3 0 0 0 5.12 2.12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "19",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$659260199c35c5a8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "7",
                    "r": "5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$565d8e3c18f19516(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10v2a7 7 0 0 1-14 0v-2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "19",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$16ea8db44eb73b8a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$37234f694816d5ec(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 22h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 22a7 7 0 1 0 0-14h-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$316fdb133a529aea(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "15",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "7",
                    "x": "6",
                    "y": "8",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e06603b37a2e9087(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ebbd5a5c25ed6f9a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$95e43db862ad0091(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1c114676811212e7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 14 10 14 10 20"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 10 14 10 14 4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "x2": "21",
                    "y1": "10",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "10",
                    "y1": "21",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$90008e77a5f68eb9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3v3a2 2 0 0 1-2 2H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8h-3a2 2 0 0 1-2-2V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h3a2 2 0 0 1 2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-3a2 2 0 0 1 2-2h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1d86bd2aeca67e5c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12h14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8ac62d7bbe4d808c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 10 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$26646fb4733af4bc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.2 4.9-.9-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.2 7.1-.9.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.9 3.2-.4-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.9 8.8-.4.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.5 2.3-.4.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.5 9.7-.4-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.7 4.5-.9.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.7 7.5-.9-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eb02711068245a22(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d0ff1b8d6e9e31b5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 10-3 3-3-3"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cbfb87f99c8ba804(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 15V5a2 2 0 0 0-2-2H9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$612376ac6b96b6f5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13V7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e9b557d98cd00d43(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "3",
                    "width": "20",
                    "height": "14",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ee9ed9cb6c70a3a9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19v-3.96 3.15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h5"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "10",
                    "x": "16",
                    "y": "12",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6001f45b33a362a6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 20H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9h.01"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "16",
                    "x": "12",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "15",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5eb11441eea74f36(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "3",
                    "width": "20",
                    "height": "14",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "7",
                    "width": "6",
                    "height": "6",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4d7a5a9dbd271487(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 10 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ece08436a68b4895(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 12.5-5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 12.5 5-5"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$64c2745e79fe3353(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "16",
                    "y1": "21",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "17",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3d59642cffbef8e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5h-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$47372706ff0cab12(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$40111080f4271697(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3 4 8 5-5 5 15H2L8 3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2949ddb08605a66e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3 4 8 5-5 5 15H2L8 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$218dfff39cbbe32d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v.343"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13.343V9A7 7 0 0 0 8.56 2.902"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22 2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1549874810af87e6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$99d053809dcb22c5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.034 2.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.944L8.204 7.545a1 1 0 0 0-.66.66l-1.066 3.443a.5.5 0 0 1-.944.033z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.8 11.8 8.4 8.4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$926d5e57a0b30998(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.1 12 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5.1 8-2.9-.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 12-1.9 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.2 2.2 8 5.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5b0c7c2698160370(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.586 12.586 19 19"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ffec8cfbeb0699a9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "2",
                    "width": "14",
                    "height": "20",
                    "rx": "7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d08221f62057afc1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3v16h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 19 6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 6 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 16 3 3-3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aae255058e0c7ecb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13v6h-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11V5h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 5 14 14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$312458e1c1478241(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19H5v-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5h6v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5 5 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f6f03331ae98a81(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19H5V13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5L5 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5ac5d86a480b02f1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13V19H13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5L19 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9ec81b20bf115585(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18L12 22L16 18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2V22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3fc2d577377b41af(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 8 4 4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 8-4 4 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ec754333972dced5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8L2 12L6 16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12H22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$879766bd26c61250(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8L22 12L18 16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12H22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3a2ea944ea3742d5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11V5H11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5L19 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9c6dfbe3defe2f8f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5H19V11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5L5 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dbd3bd6e3a8a0c90(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6L12 2L16 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2V22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$efda31e314f70645(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 18 4 4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 6 4-4 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ba4eb356189d3d71(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 19-3 3-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 9 3 3-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 9-3 3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 5 3-3 3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1cf0fa4ca84fbf83(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "18",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18V2l7 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$739a36616fcc0224(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18V2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4b2734b322f70a43(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18V5l12-2v13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 9 12-2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "16",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$819581df42e4ba25(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18V5l12-2v13"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "16",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ca03c742bdb13009(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.31 9.31 5 21l7-4 7 4-1.17-3.17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.53 8.88 12 2l-1.17 3.17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$35904a59aa703d93(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 19 21 12 17 5 21 12 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4003d490c5da7fa1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.43 8.43 3 11l8 2 2 8 2.57-5.43"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.39 11.73 22 2l-9.73 4.61"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$950281ea5c8e13b4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "3 11 22 2 13 21 11 13 3 11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7bc17c641d3929c9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "16",
                    "y": "16",
                    "width": "6",
                    "height": "6",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "16",
                    "width": "6",
                    "height": "6",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "2",
                    "width": "6",
                    "height": "6",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12V8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fef466eed184bba2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14h-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6h8v4h-8V6Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9c08304f6aa4a210(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8.32a7.43 7.43 0 0 1 0 7.36"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.46 6.21a11.76 11.76 0 0 1 0 11.58"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.37 2a20.16 20.16 0 0 1 0 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$90ed633fa361285c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6cbce8bfaa376448(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "20",
                    "x": "4",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2v20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17h5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$abb622c94a11254a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "20",
                    "x": "4",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 8h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12H16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 16H14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$611de8a2f5e4ed2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "20",
                    "x": "4",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a7e904a33e8ce031(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v2a2 2 0 0 1-2 2h-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 22h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22H6a2 2 0 0 1-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18h5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6f1b9443cb8a4a95(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2v4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "18",
                    "x": "4",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18h5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ef5dd413a4aa73f0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10v3.343"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2c98a2eca8dea06e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d4b3274a52a86f03(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5ee6ce650de5861b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$af1794b7fdd1ae29(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 15V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d4f4f20fb1316abf(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 9 6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e438b06e91000077(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cef51de8b7e2e9c3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20h4.5a.5.5 0 0 0 .5-.5v-.282a.52.52 0 0 0-.247-.437 8 8 0 1 1 8.494-.001.52.52 0 0 0-.247.438v.282a.5.5 0 0 0 .5.5H21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f364a00292664c8b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h6l6 18h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$69866155196e1301(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "5",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4 21.9a10 10 0 0 0 9.941-15.416"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 2.1a10 10 0 0 0-9.841 15.416"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$62d5477433f3b990(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6cb6bac90ebd5425(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3fdcdea11291760d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 16 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.5 4.27 9 5.15"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.29 7 12 12 20.71 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "22",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a2179420f05fe8a4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.5 4.27 9 5.15"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.29 7 12 12 20.71 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "22",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b281d13edaa939fc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22v-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8300f02597f256d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.5 4.27 9 5.15"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.29 7 12 12 20.71 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "22",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7a4063eede8ef2a3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.5 4.27 9 5.15"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.29 7 12 12 20.71 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "22",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "15.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.27 17.27 22 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c4028551dbf9db48(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.5 4.27 9 5.15"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.29 7 12 12 20.71 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "22",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 13 5 5m-5 0 5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$71c3ab3be6c76af7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22V12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.5 4.27 9 5.15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ac5e83683dbb725(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 2 5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13h15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$18f8d6644bbaf419(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "6",
                    "x": "2",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "4",
                    "height": "6",
                    "x": "8",
                    "y": "16",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e615893dcabb2547(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2a1 1 0 0 1 1 1v9H6V3a1 1 0 0 1 1-1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 1 1 1v2.9a2 2 0 1 0 4 0V17a1 1 0 0 1 1-1h2a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d3f0ddc0bd1e62ba(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.622 17.897-10.68-2.913"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2404e9dde49f7e6c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "6.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "10.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "12.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f5b96ef737d30b0c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 8-3 3-3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bf452b768de9d005(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 15h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15h1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$40687eee6b605f21(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 10 3-3 3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$55e00044d746a287(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f0d074db8aef65ff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 15-3-3 3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5087c7c020507bfd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e94491238cc61d82(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 9 3 3-3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bdd86658e49afdd8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4c3c48516f72ae7f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 9 3 3-3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eab1835298c802ae(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 14v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9497540c28321299(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 15-3-3 3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$98d4192ffbd31d19(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bb4331712934230b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 16 3-3 3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$af2ddac9f11affb5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6931d24c9bc9c584(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 14-3 3-3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$37c2ebb86393262f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f9a74408532cbad8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bc451a4778038efe(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$68726926e69e8c5e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21V9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e38a290b991302a5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$77ef0e169151770a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21s-4-3-4-9 4-9 4-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3s4 3 4 9-4 9-4 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e20716a76e2a62ab(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.282 19a1 1 0 0 0 .948-.68l2.37-6.988a7 7 0 1 0-13.2 0l2.37 6.988a1 1 0 0 0 .948.68z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9a3 3 0 1 1 6 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1d4dd758d36c4fc2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.8 11.3 2 22l10.7-3.79"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4dc84a09f66baf87(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "4",
                    "width": "4",
                    "height": "16",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "4",
                    "width": "4",
                    "height": "16",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1df2d47c3c9e6cd6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "16",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$48d566b4bf0df90e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "20",
                    "x": "5",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$68ea9feda2d6d3c8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6eef93e38a8854a8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$88be95cc027fc1b7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2.3 2.3 7.286 7.286"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9c24ff8323043099(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d4ff1531b26b51b8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 5 3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$74a1d8b53213ceae(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 5 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$25f1d0b4e4ab54d3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 6 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 16 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 5 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$61abf46a67e60963(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 5 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$383b6b9b00693f0f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.83 2.38a2 2 0 0 1 2.34 0l8 5.74a2 2 0 0 1 .73 2.25l-3.04 9.26a2 2 0 0 1-1.9 1.37H7.04a2 2 0 0 1-1.9-1.37L2.1 10.37a2 2 0 0 1 .73-2.25z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$80750d966da7c805(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "5",
                    "y1": "5",
                    "y2": "19"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "17.5",
                    "r": "2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$df735cff0bd76660(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 20 3-6 3 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 8 6 2 6-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2bbb2ea2e5cff9ce(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7H4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21V4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 12H7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$569f9220b33c47c0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.05 2a9 9 0 0 1 8 7.94"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.05 6A5 5 0 0 1 18 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e4fdf1b173c313d0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "18 2 22 6 18 10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "x2": "22",
                    "y1": "6",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$74ecc6bed34c783e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 2 16 8 22 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "16",
                    "y1": "2",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b32335c1732406bb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "16",
                    "y1": "2",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "x2": "22",
                    "y1": "2",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d136e47a39eb6b55(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "2",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$319063cc1ef2c253(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 8 22 2 16 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "x2": "22",
                    "y1": "8",
                    "y2": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$223eb0f53bdacdc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f111673005ce71f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "9",
                    "y1": "4",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7c0-1.7 1.3-3 3-3h13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20c-1.7 0-3-1.3-3-3V4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ba54fc9abfd4eee7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2a2348ffc73e6fef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$de9c5af20e0182ca(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "7",
                    "x": "12",
                    "y": "13",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$408b6347d03bfee(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.5v5H3m-1-6 6 6m13 0v-3c0-1.16-.84-2-2-2h-7m-9 9v2c0 1.05.95 2 2 2h3"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "7",
                    "x": "12",
                    "y": "13.5",
                    "ry": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$92aa2b8c79a258c5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9v1c0 1.1.9 2 2 2h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$30f46176e31be657(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-3a3 3 0 0 1 0-6h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18H2l4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 22-4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1b9a32c5481673ef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9H7a1 1 0 0 1 0-6h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 14 4 4H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 18-4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2557db490b7a23df(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H9.5a4.5 4.5 0 0 0 0 9H13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2725e0329c08255c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "5",
                    "x": "4",
                    "y": "2",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aa7f16fd18516d68(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 8.5 7 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$720730f2363af506(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ab2edc3616ea1971(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3230c08bfcf81c7b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 22 1-1h3l9-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21v-3l9-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$70398e67e34e0ca6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 14-1 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.75 18.25-1.25 1.42"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.775 5.654a15.68 15.68 0 0 0-12.121 12.12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.8 9.3a1 1 0 0 0 2.1 7.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.964 20.732a1 1 0 0 1-1.232 1.232l-18-5a1 1 0 0 1-.695-1.232A19.68 19.68 0 0 1 15.732 2.037a1 1 0 0 1 1.232.695z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$daf7811860c06592(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bbd4e8f6f40fc3ba(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b0a7b5832ebf40db(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4358da9bc7b6bacb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "6 3 20 12 6 21 6 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1913ab9eb473f7dc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11V8h12v3a6 6 0 1 1-12 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$314a0f1c5cde3cb6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 22 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 13.5 10 11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 16.5 13 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 3-4 4h6l-4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$517a9723a853660c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22v-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e71a87a1d31a3575(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5v14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5f51aabc7c7fbb46(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11.66V22a4 4 0 0 0 4-4V6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$26bcaa66b325a31e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 10 12 14 16 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$38ec5823c35c7911(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.85 18.58a9 9 0 1 0-9.7 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14a5 5 0 1 1 8 0"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 17a1 1 0 1 0-2 0l.5 4.5a.5.5 0 1 0 1 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8004314bd19b2dfa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4.5V4a2 2 0 0 0-2.41-1.957"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 8.4a2 2 0 0 0-1.26-1.295"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5630e58d8fce88ab(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 14a8 8 0 0 1-8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cfc03a40552b6a62(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22 9 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 22 1-14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$317b886ea0f90df8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 22-5.5-5.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$51736b8419d30ee7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-5.333-8-5.333-8 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7v14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13h10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4fddeac2350b6455(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.36 6.64A9 9 0 0 1 20.77 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.16 6.16a9 9 0 1 0 12.68 12.68"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7017f6fa273975cf(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.4 6.6a9 9 0 1 1-12.77.04"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$37e6739d8c739fef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 21 5-5 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eac8c844284a7c08(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 19 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aafbaba81a7d0d34(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "14",
                    "width": "12",
                    "height": "8",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$14176011bdd06235(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7 3 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 7 2-2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f407d2fb81bce795(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "16",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9h13a2 2 0 0 1 2 2v9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c8fa74f88d4f223e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e2e1e51fd5f1ec6c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b7f82864b7968af(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "5",
                    "height": "5",
                    "x": "3",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "5",
                    "height": "5",
                    "x": "16",
                    "y": "3",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "5",
                    "height": "5",
                    "x": "3",
                    "y": "16",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16h-3a2 2 0 0 0-2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 21v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v3a2 2 0 0 1-2 2H7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21v-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$818a9ecfd7691f5e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$10f242c93a55c0cc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16a3 3 0 0 1 2.24 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.54V4a2 2 0 1 0-4 0v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.612 12.524a3 3 0 1 0-1.6 4.3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5cf08ec27d0961be(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93A10 10 0 0 0 6.99 3.34"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.29 9.62A10 10 0 1 0 21.31 8.35"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 7.76A6 6 0 1 0 8.23 16.67"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.99 11.66A6 6 0 0 1 15.77 16.67"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.41 10.59 5.66-5.66"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3be2af80aec70661(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ba18b7024675968(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h3.28a1 1 0 0 1 .948.684l2.298 7.934a.5.5 0 0 0 .96-.044L13.82 4.771A1 1 0 0 1 14.792 4H21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eee99c4ea2a3f73c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16v2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "8",
                    "x": "2",
                    "y": "8",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$10c94cd09aec3501(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.9 16.1C1 12.2 1 5.8 4.9 1.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2 4.8c2 2 2.26 5.11.8 7.47"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.1 1.9a9.96 9.96 0 0 1 0 14.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 18h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 22 4-11 4 11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$13f8e54c39875707(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.9 19.1C1 15.2 1 8.8 4.9 4.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.1 4.9C23 8.8 23 15.1 19.1 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fac30ab68e7c7d3d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.34 17.52a10 10 0 1 0-2.82 2.82"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.41 13.41 4.18 4.18"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7f55f4293cc77467(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 20-5-5 6-6-5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$72a7bc7d38bea276(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17a10 10 0 0 0-20 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17a6 6 0 0 1 12 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17a2 2 0 0 1 4 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5d990350ee2da02e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 .8.3 1.5.8 2H11c-3.9 0-7 3.1-7 7c0 2.2 1.8 4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.8 3.9c.3-.3.6-.5 1-.7 1.5-.6 3.3.1 3.9 1.6.6 1.5-.1 3.3-1.6 3.9l1.6 2.8c.2.3.2.7.2 1-.2.8-.9 1.2-1.7 1.1 0 0-1.6-.3-2.7-.6H17c-1.7 0-3 1.3-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.2 18a3 3 0 0 0-2.2-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 22H4a2 2 0 0 1 0-4h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$699fe0ee48022358(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "12",
                    "height": "20",
                    "x": "6",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "12",
                    "x": "2",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3111b78e7241077(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.5v11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.4a4 4 0 1 0 0 5.2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4080015cae8a2068(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9.5a4 4 0 1 0 0 5.2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ee41b62ea5ae964c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.5 8 15h1a4 4 0 0 0 0-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b7275c70b062160e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 10 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 7 3 3v7.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6e594de02401922b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17V9.5a2.5 2.5 0 0 1 5 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 17h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bc84b28aeb2441bc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h5a2 2 0 1 0 0-4h-3v10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d47223900f11ed6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17V7h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e3394f4c1c3d53(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16H8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9bd8d2601206b75f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.5v-11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1e570967739f41a8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "12",
                    "x": "2",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5e0173b813f4cf48(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "12",
                    "x": "2",
                    "y": "6",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$42d6ca21eac0fa8e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "12",
                    "height": "20",
                    "x": "6",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bbff6c417d899de0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 16-3 3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.293 13.596 7.196 9.5 3.1 10.598"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.378 9.633 4.096 1.098 1.097-4.096"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ea7f63e892951029(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 14 5-5-5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2ab0bd7b0d792ab3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "17",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7v6h-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fb2b3e1a6a64bbd3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7v6h-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6f1c2f8c6d5ac824(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2v6h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12A9 9 0 0 0 6 5.3L3 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 22v-6h-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12a9 9 0 0 0 15 6.7l3-2.7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$46cffb01453fcd27(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v5h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16h5v5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6351fa8a8aca1928(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16H3v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12C3 9.51 4 7.26 5.64 5.64"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12c0 1-.16 1.97-.47 2.87"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3v5h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22 2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1ee8a6489704ab2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3v5h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16H3v5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fec1d75812de294b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ee02fd1bdb8aef66(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.67 5.5 8.66 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.67 10.5 8.66-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eab3091e5d58b1dd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7V4h16v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4 8 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 15 5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 15-5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$de1a066ad72b75fa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17 2 4 4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11v-1a4 4 0 0 1 4-4h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 22-4-4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13v1a4 4 0 0 1-4 4H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10h1v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b09e56a65e6f3774(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 9 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18H7a2 2 0 0 1-2-2V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 15-3 3-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h6a2 2 0 0 1 2 2v10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$48ad98e8bcae6991(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17 2 4 4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11v-1a4 4 0 0 1 4-4h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 22-4-4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13v1a4 4 0 0 1-4 4H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$323917b65627baad(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4a2 2 0 0 1 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10a2 2 0 0 1-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 7 3 3 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10V5a 3 3 0 0 1 3-3h1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "14",
                    "width": "8",
                    "height": "8",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d3667f335862efce(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4a2 2 0 0 1 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10a2 2 0 0 1-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 7 3 3 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10V5a3 3 0 0 1 3-3h1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "14",
                    "width": "8",
                    "height": "8",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$74c995f5bcfc6adf(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 17 2 12 7 7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 17 7 12 12 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18v-2a4 4 0 0 0-4-4H7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$55bcf390e9267154(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 17 4 12 9 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-2a4 4 0 0 0-4-4H4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$29feb7bd32edf85a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 19 2 12 11 5 11 19"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 19 13 12 22 5 22 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$27a325b126e979fd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 18 2.57-3.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.243 9.016a7 7 0 0 1 11.507-.009"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.35 14.53 12 11.22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d89dbb38a00f607(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d850ca24ef6f6e5e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.5 2 6.5 12.5 18 12.5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9.5",
                    "x2": "5.5",
                    "y1": "12.5",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "18.5",
                    "y1": "12.5",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.75 18a13 13 0 0 0 18.5 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b1af14314c095810(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19V5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19V6.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19v-7.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19v-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$87ee9e740203e819(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.194 13.707 3.814 1.86-1.86 3.814"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ef0da565e67afaac(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V7a2 2 0 0 0-2-2h-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 2-3 3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$58cacda76c83a7a7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v5h5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f1284590f9376afc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5H6a2 2 0 0 0-2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 8 3-3-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$89319dd0c4978e4c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3v5h-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8ffbe24d0f7412f5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "19",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19h8.5c.4 0 .9-.1 1.3-.2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15.3a3.5 3.5 0 0 0-3.3-3.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5h-4.3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$199ff9d949036a67(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "19",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$155cce05a350a4b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "8",
                    "x": "2",
                    "y": "14",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.01 18H6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.01 18H10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.84 7.17a4 4 0 0 0-5.66 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.66 4.34a8 8 0 0 0-11.31 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5660143947a1cb6e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e2819baf1f9275bf(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a492fff78898c9fc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7.5H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16.5H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$10fa1a2ce3c4e2ce(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11a9 9 0 0 1 9 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a16 16 0 0 1 16 16"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1ed981acb75fd456(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 12.5 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.5 9.5 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 6.5 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.5 15.5 2-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$46ecd0865caa5cbc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11h8a4 4 0 0 0 0-8H9v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bdcf579c6bfe47a5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14 10 2 3 14h18Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5baba5534b6eedb9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 12 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c7aedaa9ac017487(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.37 11.223 8.372-6.777a2 2 0 0 1 2.516 0l8.371 6.777"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.25"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.67 15 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "4",
                    "x": "2",
                    "y": "11",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$672febeaee5dc47d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10a7.31 7.31 0 0 0 10 10Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 15 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13a6 6 0 0 0-6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13A10 10 0 0 0 11 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$44017637a66b757b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7 9 3 5 7l4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 11 4 4-4 4-4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 12 4 4 6-6-4-4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 8 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21a6 6 0 0 0-6-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ac0b6207ec2e4ed8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v3a1 1 0 0 0 1 1h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22H4a2 2 0 0 1-2-2V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 22 6.828V16a2 2 0 0 1-2.01 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$215a4ab08465d1dd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13H8a1 1 0 0 0-1 1v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.41 20.41A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .59-1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M29.5 11.5s5 5 4 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3h6.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fc7da795c6a4db15(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3v4a1 1 0 0 0 1 1h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fa087e4d4cd9391c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7v11a1 1 0 0 0 1 1h11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.293 18.707 11 13"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "5",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fc8c76f916309816(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a98ebe3d9e4a378a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 15H9v-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3h5v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3 9 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$24cfbaa8096476cb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7v10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3faa43124b8bd5ce(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$702111f12895a318(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14s1.5 2 4 2 4-2 4-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cc4ae16d7e4a971e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$88c79b25ffd6c4f5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12v4a1 1 0 0 1-1 1h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8V7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "7",
                    "width": "5",
                    "height": "5",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9a046f1cc51e3f9e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 16-1.9-1.9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b2c150e778fa16f8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2d20a527af98b6a6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7V5a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h2a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a9b0872bc9dff236(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 22v-4a2 2 0 1 0-4 0v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 10 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.382a1 1 0 0 1 .553-.894L6 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5v17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4 6 7.106-3.553a2 2 0 0 1 1.788 0L20 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5v17"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1a9ef7f7a3434e7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.42 9.42 8 12"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 6-8.58 8.58"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "16",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.8 14.8 14 18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12h-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$78ce555f96393ad8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.12 8.12 12 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4 8.12 15.88"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8 14.8 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8134bca5e3700e5f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 3-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 3 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b7fb28cf50025e8b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 8 5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h5v5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1dc5b913d646027b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 17V5a2 2 0 0 0-2-2H4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$abc2311f38628c3b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 17V5a2 2 0 0 0-2-2H4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3a88ba9f86a4c82d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 11 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-4.3-4.3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d99f2a6f90937a20(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13 13.5 2-2.5-2-2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-4.3-4.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8.5 7 11l2 2.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$321b548753684abc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.5 8.5-5 5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-4.3-4.3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4e21a95d830c335a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.5 8.5-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 8.5 5 5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-4.3-4.3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$76e323abeb96161e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-4.3-4.3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4e4a2efc01a127aa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5a4 3 0 0 0-8 0c0 4 8 3 8 7a4 3 0 0 1-8 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19a4 3 0 0 0 8 0c0-4-8-3-8-7a4 3 0 0 1 8 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$45e2cb783a3e538b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d03ae8ea6724b9e6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "14",
                    "width": "8",
                    "height": "8",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "8",
                    "height": "8",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14v1a2 2 0 0 0 2 2h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h1a2 2 0 0 1 2 2v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a410e2858f10113e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.854 2.147-10.94 10.939"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d5e6bb12d3cc7729(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "21",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 8 12 4 16 8"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 12 20 8 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$73270da990b77f17(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "3",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 8 4 12 8 16"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 20 12 16 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$76dce213b067c002(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.7 13.4-.9-.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.2 10.9-.9-.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.6 15.7.3-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.6 15.7-.4-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.8 9.3-.4-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.3 13.6 1-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.7 10.8 1-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.4 8.3-.3.9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4f74c94c19fb698b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 6-4 6h6l-4 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3b1686503d20748d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17v-1a2 2 0 0 0-2-2h-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bb900df7c8c0fdd9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "8",
                    "x": "2",
                    "y": "2",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "8",
                    "x": "2",
                    "y": "14",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6.01",
                    "y1": "6",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6.01",
                    "y1": "18",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fb6075a60a6cb488(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17H5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "17",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "7",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a7fedbd2fbba6991(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$96cae6496a1f7092(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "14",
                    "width": "7",
                    "height": "7",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "17.5",
                    "r": "3.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9fa8122648b796a3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "19",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8.59",
                    "x2": "15.42",
                    "y1": "13.51",
                    "y2": "17.49"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15.41",
                    "x2": "8.59",
                    "y1": "6.51",
                    "y2": "10.49"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$de3db490f35ea40c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 6 12 2 8 6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "2",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$937f82f91deda57f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "21",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "21",
                    "y1": "15",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "9",
                    "y1": "9",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "15",
                    "y1": "9",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ac009921d55925de(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b7fba21cef999027(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$43a913a20d2ff592(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.243 5.21 14.39 12.472"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$af3535bd967ed22a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 12 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dd6fd5f6b7deebd8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ac7a67e9db4477c3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22V2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$38aff1ce2439a000(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f36ccfd6fc14edf7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$288dd03ee0a3b3e0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d6899d3038503706(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ca8ab6510c8de381(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.5 9.5-5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 9.5 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5ddecdcdd4eb37cc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$62c21c112f5b7f51(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v7.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 5-5.23 5.23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12h-7.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 19-5.23-5.23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14.5V22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.23 13.77 5 19"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.23 10.23 5 5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$51864aab92d99e7c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.189V14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2e938e3069a9d965(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f60e84749eb87a3b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10a4 4 0 0 1-8 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eb58b05f1bdc4995(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 11-1 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 11-4-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 15.5h15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 11 4-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 11 1 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f41c1999e3bd6c81(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "21",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "21",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$49315b37a6965acd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22v-5l5-5 5 5-5 5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 14.5 16 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c21656c368ca543b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4 4 2.5 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 6.5a4.95 4.95 0 0 0-7 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5 5 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11v.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8ff6363c7edced88(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 15 6 6m-6-6v4.8m0-4.8h4.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19.8V15m0 0H4.2M9 15l-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4.2V9m0 0h4.8M15 9l6-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4.2V9m0 0H4.2M9 9 3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b196670f3379bc13(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22v-7l-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8v.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 14-2 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$581f301561c3090(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 14 4 4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 2 4 4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6h1.972a4 4 0 0 1 3.6 2.2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cf3aa4e576b977ad(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7V5a1 1 0 0 0-1-1H6.5a.5.5 0 0 0-.4.8l4.5 6a2 2 0 0 1 0 2.4l-4.5 6a.5.5 0 0 0 .4.8H17a1 1 0 0 0 1-1v-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$93bd4b3d2cb9602e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20V8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2799c2d655c1ca1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20v-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7cba6989fa0bb3fe(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v-8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bdac3ecc8272e0a5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2ff5fa490966398d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20V8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c038efe4182e68ac(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$26caf1aa5de329e5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9H4L2 7l2-2h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5h6l2 2-2 2h-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22V4a2 2 0 1 1 4 0v18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ad96fea7fd9e6fc3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6a2 2 0 0 1 1.387.56l2.307 2.22a1 1 0 0 1 0 1.44l-2.307 2.22A2 2 0 0 1 18 13H6a2 2 0 0 1-1.387-.56l-2.306-2.22a1 1 0 0 1 0-1.44l2.306-2.22A2 2 0 0 1 6 6z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9b83b4648c401a5b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18v-6a5 5 0 1 1 10 0v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 4.5 18 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.929 4.929.707.707"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ce00363672dc42b7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "19 20 9 12 19 4 19 20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "x2": "5",
                    "y1": "19",
                    "y2": "5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ff38e058bd795f11(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "5 4 15 12 5 20 5 4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "19",
                    "y1": "5",
                    "y2": "19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$616ac2d8f57262e8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.5 17-.5-1-.5 1h1z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22a1 1 0 0 0 1-1v-1a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20v1a1 1 0 0 0 1 1z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c9bef2a74effecba(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "3",
                    "height": "8",
                    "x": "13",
                    "y": "2",
                    "rx": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "3",
                    "height": "8",
                    "x": "8",
                    "y": "14",
                    "rx": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "3",
                    "x": "14",
                    "y": "13",
                    "rx": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "3",
                    "x": "2",
                    "y": "8",
                    "rx": "1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$98ddcc7525e5a3f9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2 2 22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9de2543649c6b244(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a1 1 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-1.414 0L8 14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dcb7b5421d7e212a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "x2": "14",
                    "y1": "4",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "x2": "3",
                    "y1": "4",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "x2": "12",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "3",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "x2": "16",
                    "y1": "20",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "3",
                    "y1": "20",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "x2": "14",
                    "y1": "2",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "8",
                    "y1": "10",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "x2": "16",
                    "y1": "18",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$389ad1118ffad724(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "4",
                    "y1": "21",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "4",
                    "y1": "10",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "21",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "8",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "x2": "20",
                    "y1": "21",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "x2": "20",
                    "y1": "12",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "6",
                    "y1": "14",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "x2": "14",
                    "y1": "8",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "x2": "22",
                    "y1": "16",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3a5d8ea22ce1a8d7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "20",
                    "x": "5",
                    "y": "2",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.667 8 10 12h4l-2.667 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$59c3813f8e32fe16(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "7",
                    "height": "12",
                    "x": "2",
                    "y": "6",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8.32a7.43 7.43 0 0 1 0 7.36"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.46 6.21a11.76 11.76 0 0 1 0 11.58"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6848b6fbfb9cf04(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "14",
                    "height": "20",
                    "x": "5",
                    "y": "2",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e613e33bf5c03424(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11v1a10 10 0 1 1-9-10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14s1.5 2 4 2 4-2 4-2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "9.01",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "15.01",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$649eb20b175f327e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14s1.5 2 4 2 4-2 4-2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "9.01",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "15.01",
                    "y1": "9",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9ff33170951cc5df(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "13",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3 19.1 5.2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3 20.9 5.2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$96715efd3f940623(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20 16-4-4 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4 8 4 4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 4-4 4-4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 20 4-4 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$210e83e12127dea4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4v9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6cb5c76e39532a96(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 12 22 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7ddf3b1cb915ce1f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e1795ee3eeadd4ba(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fb4447c1dc984f35(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aafc7c39372bf92f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d17c29a86d213a97(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "20",
                    "x": "4",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6h.01"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bfd325e8170def2f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15a3.5 3.5 0 0 0-.025-4.975"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a7001357990f465e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 16 6-12 6 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ac0bf6c788553335(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 16 6-12 6 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 20 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2c5f613175297acc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "5",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "19",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17A12 12 0 0 1 17 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a3ba6007ba529355(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3h5v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H3v5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9 6-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$48f7f5ec15c3c715(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h.01"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "4",
                    "height": "4",
                    "x": "15",
                    "y": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 14 8-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 19 8-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1ca3902827cfd7b3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20c5.5-2.5.8-6.4 3-10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$94fdb0feae1cd832(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h-2l-2 5-2-10-2 5H7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5830c1d8ec5b38dd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 8-8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16H8V8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a3475af4171f6bff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 8 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v8H8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$381095d6f85b6dbd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 12 4 4 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bd26e3d9e08abf40(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 8-4 4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12H8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b584e9537b958610(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 21 9-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21H3v-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4c6e1f4d366ca6db(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-9-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v6h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1953e580c662c07(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 3 9 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9V3h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8d25a8f06619768(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 3-9 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3h6v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e362a5fa0a216f6b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 4-4-4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1e7c293baff19635(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16V8h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16 8 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1cb74a8d849b38f3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8h8v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 16 8-8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9b5b1f075f36f296(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 12-4-4-4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16V8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ebc2c5660ec0570c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 14 7-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 10 7 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$afa13d708ba5cc5d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 22h-2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.414 9.414 12 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8 14.8 18 18"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 6-8.586 8.586"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$89de1f483804bd09(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d3a374f9ebc9a6da(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 11 3 3L22 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4399bfc06c123923(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 12 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$76d56256e5659236(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 10-4 4-4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6c33c9eb46627c78(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 16-4-4 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d5b736f86cf15859(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 8 4 4-4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f72ad64f4e5b3c48(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 14 4-4 4 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9cc098378ace2454(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.5 8 12l2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 9.5 2 2.5-2 2.5"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$372654858fe434ed(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.5 8 12l2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 9.5 2 2.5-2 2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$754df1f9d73e56f9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21h1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5f5a01e4cafb1d1a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7v9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21a2 2 0 0 1-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8c226e1e13ea0931(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21a2 2 0 0 1-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$87398f295799edaa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21a2 2 0 0 1-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6587693f18a82da3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "16",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "16",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "8",
                    "y2": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e0c233d42ee8533a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cb973924af52b19c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b559ad00f09a8536(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.2h5.7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$357db2b9f2a101ed(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7v9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d9d3cdbf0fd4c570(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 7 2 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$40b8a223880a3fca(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16V8l4 4 4-4v8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e0d0bdef11c09e86(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8ba317fa652c204b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$93d3e96bbb800cac(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aa503ae07f8818ba(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8.7V19a2 2 0 0 0 2 2h10.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13a3 3 0 1 0 0-6H9v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17v-2.3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b7abe15723e8e8fd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17V7h4a3 3 0 0 1 0 6H9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$38f231434f5983ce(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4fe043fb650a48a8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ca8169f01e8fc814(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17a2 2 0 0 1-2-2V7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d34c116facab8bb1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12H9.5a2.5 2.5 0 0 1 0-5H17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7v10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$998e56e36c6d82d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 8 6 4-6 4Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5d8de8be55bc2e38(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ff6e5b5e05f2d957(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.998 9.003a5 5 0 1 0 8-.005"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cf19cfa0df925d48(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h2l2 5 2-10h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$50727ee916fd9314(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "20",
                    "x": "2",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.414 9.414 12 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8 14.8 18 18"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 6-8.586 8.586"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2783082d3ee209c8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8.9V7H8l4 5-4 5h8v-1.9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bda740d909176d71(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "15",
                    "y1": "15",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e7d10f405700ef71(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "4",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5830b94ccc056fb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "20",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c1cb9d49de68542e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "8",
                    "width": "8",
                    "height": "8",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aca8dc1555ecd3b2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "8",
                    "x": "14",
                    "y": "14",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a728e1e2e96365a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 11 2-2-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b5b741ec27134135(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 21a6 6 0 0 0-12 0"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bb2f808212947345(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$69f94ab94c95cb59(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 9 6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$641ca480bc11a5cc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$423f2fe492348c65(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$625a35df15cacaac(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.236 22a3 3 0 0 0-2.2-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$effebf1c41d29727(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7d6115327c882379(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a086caf4be6bfbe6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5738c5a08ca26c84(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$763cacd72f787c80(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "x2": "18",
                    "y1": "20",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "14,20 4,12 14,4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a92853b7f143506(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "6",
                    "y1": "4",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "10,4 20,12 10,20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7a42e0cf2d62f819(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15a6 6 0 0 0 12 0v-3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "10",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e257443837dee146(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16s.8 1 2 1c1.3 0 2-1 2-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8532c1930a7faaaa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bad9adb6f17ba3b8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$570be994d24c9c09(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "6",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "6",
                    "x": "2",
                    "y": "14",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$be41d9326553574(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "20",
                    "x": "4",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "6",
                    "height": "20",
                    "x": "14",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7b12a6a982e3a93d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4H9a3 3 0 0 0-2.83 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12a4 4 0 0 1 0 8H6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "20",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4de6ca9fef8029d4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4 5 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 5-8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7db26b2e5b57e0f1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.657 6.343h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.657 17.657h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.343 17.657h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.343 6.343h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c8892a50463e5ea1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18.364 5.636-.707.707"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.343 17.657-.707.707"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5.636 5.636.707.707"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.657 17.657.707.707"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ea3b336e070f8417(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.9 4.9 1.4 1.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.7 17.7 1.4 1.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.3 17.7-1.4 1.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.1 4.9-1.4 1.4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f900a1a9f60b1f97(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9a3 3 0 1 0 0 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 21v-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.64 18.36.7-.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.34 6.34-.7-.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 4-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 17 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 15-3-3 3-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ffeb40af83d293a4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.93 4.93 1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.66 17.66 1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.34 17.66-1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.07 4.93-1.41 1.41"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d4f9c3020f985060(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.93 10.93 1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.07 10.93-1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 6 4-4 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18a4 4 0 0 0-8 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f1a09bdd9a199246(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.93 10.93 1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.07 10.93-1.41 1.41"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 6-4 4-4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18a4 4 0 0 0-8 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7037768101b65fb6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4 19 8-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 19-8-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b5293fe3b8f918bb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M 7 17h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$86e93ef0c222fd9d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 21V3h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 16h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.5h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d541b415f1daa628(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 22-3-3 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 2 3 3-3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6af3c9f10bc5eb7b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14.5 17.5 3 6 3 3 6 3 17.5 14.5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "13",
                    "x2": "19",
                    "y1": "19",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "x2": "20",
                    "y1": "16",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "21",
                    "y1": "21",
                    "y2": "19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b468090627c690b0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14.5 17.5 3 6 3 3 6 3 17.5 14.5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "13",
                    "x2": "19",
                    "y1": "19",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "x2": "20",
                    "y1": "16",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "21",
                    "y1": "21",
                    "y2": "19"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14.5 6.5 18 3 21 3 21 6 17.5 9.5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "x2": "9",
                    "y1": "14",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "x2": "4",
                    "y1": "17",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "5",
                    "y1": "19",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4756e73ed2051c3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 2 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 7 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 11 4 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 19-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 4 6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8f510589b8f04a19(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dba43cdc7ffa05f7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21v-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9V3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h18"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6d190cb755a1c98c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15V9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h18"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$43a06e17c7170f30(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 15h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b6655a1e60f3ba88(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1615baeaafcf70e3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3v18"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c6c49351b4f80fa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22v-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 22v-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e65a1640e3cb8733(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v18"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3b29061119c06252(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "14",
                    "x": "3",
                    "y": "8",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8a021f591b9cde7c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "20",
                    "x": "4",
                    "y": "2",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12.01",
                    "y1": "18",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3f411e2571a5b44b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "7",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "17",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.46 10.54 7.08-7.08"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$603f8c518e441b90(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "7.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bced01d51678e31d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "9.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cdd1f8ecdccf7de(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$76a84c31a8b83de3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$538fb9eb62da1480(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$aa4d5e713661f35a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$718583b4712d27a1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6 2 18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7632de11fa993e36(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.59 5.41 5.41 15.59"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "17",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22s-4-9-1.5-11.5S22 12 22 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5a456328370f0488(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e6305162a2ce49f7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.56 11.747 4.332-.924"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 21-3.105-6.21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.158 8.633 1.114 4.456"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 21 3.105-6.21"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5c86e06898e216a2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 5 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 10 3-3 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14H7l-5 8h20Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 14 5 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f48f4bb6d0988245(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 21 14 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 21 10 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 21 12 15l-3.5 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21h20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c0e0dc6ebbee403f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 17 10 11 4 5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "20",
                    "y1": "19",
                    "y2": "19"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9f1ed6820554ba4e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 2 6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16H4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ff15c7a2f279e460(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 16h-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5935249103bf0b8d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2h7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16H4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16h-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$29c0f63095aa709f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7v10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5b17f25291578f20(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22h1a4 4 0 0 0 4-4v-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2h1a4 4 0 0 1 4 4v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8fd20f95b7436729(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$914557cf4f054ee0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18H3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "15",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 19-1.9-1.9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a3e5c0849b595967(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 0 0-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19a2 2 0 0 1-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21a2 2 0 0 1-2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21h1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14v1"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "x2": "15",
                    "y1": "8",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "x2": "17",
                    "y1": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "x2": "13",
                    "y1": "16",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2f96982100083785(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6.1H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.1H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.1 18H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b3b2a4150bc2407d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10s3-3 3-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10s-3-3-3-8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c0 4.4-3.6 8-8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2c0 4.4 3.6 8 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10s2 2 2 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10s-2 2-2 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$640a5499abfb9a59(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 9 3 3-3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6 9 9 6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 18 3-3 1.5 1.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$33e1df979fd392fa(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9a4 4 0 0 0-2 7.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.6 18.4-1.4 1.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.34 7.34 4.93 5.93"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fd4637433ab7c963(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9fc1d9fafc5029b8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b4789c66db6012bf(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10v12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d7254877e344cbc5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 12 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2a06c70d8522212a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bb3033066c4a8214(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 9-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$60d871ac30477ba2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9v6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$de47541557027e2f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 14.5 5-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$46642961f10937ee(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 14.5 5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.5 9.5 5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fe9140b42b703e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 17v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fa6226472686651f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 13.5 3.75.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10V8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19v2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "8",
                    "width": "20",
                    "height": "13",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$daa9f42b51595adc(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10V8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19v2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "8",
                    "width": "20",
                    "height": "13",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$536fa214a9ce6aed(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$71b37f184017048f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17H4v5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c92bae3042f4a49b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "x2": "14",
                    "y1": "2",
                    "y2": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "15",
                    "y1": "14",
                    "y2": "11"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2be8bb4a2ffde3d1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "12",
                    "x": "2",
                    "y": "6",
                    "rx": "6",
                    "ry": "6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$28e8e81438f9e889(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "12",
                    "x": "2",
                    "y": "6",
                    "rx": "6",
                    "ry": "6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8c93a62ac36389cf(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h13a1 1 0 0 1 1 1 5 5 0 0 1-5 5h-.598a.5.5 0 0 0-.424.765l1.544 2.47a.5.5 0 0 1-.424.765H5.402a.5.5 0 0 1-.424-.765L7 18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18a5 5 0 0 1-5-5V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ce8b55bca2c6c640(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8H6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12H9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16h-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20H9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$81c5e7f724c4866(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "rx": "3",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12.5",
                    "rx": "10",
                    "ry": "8.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1a5f5507726050e0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 14h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16V6a2 2 0 0 0-2-2H10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ca1ac3f71689c237(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "16",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4f201eb4a01c3b36(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13v9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 22v-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 6 1 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 6-1 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2h-2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d7228f6bf9c40cd1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "12",
                    "x": "3",
                    "y": "8",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$761c1122e35ec202(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5a1 1 0 0 0-1 1v5.573"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11V4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10.1V4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "15",
                    "r": "5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3ebf3e64d76300a9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.3 6.2a4.55 4.55 0 0 0 5.4 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2be6f3ae165f8c6f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22V12a10 10 0 1 1 20 0v10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 15h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 19-2 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 19 2 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cc0f42e014588d0c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.1V7a4 4 0 0 0 8 0V3.1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 15-1-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 15 1-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 19-2 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 19 2 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7c1e0ee840355ccd(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17 17 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 14 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 11 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 8 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 5 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 2 8 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22 22 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a4e92071221433e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "16",
                    "x": "4",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 19-2 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 22-2-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a8a6abaadd48e7ed(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "x2": "10",
                    "y1": "11",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "x2": "14",
                    "y1": "11",
                    "y2": "17"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b09f8d50748c1b7a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5c132ee81a0e83c6(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19v3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$be39d9a944bf4c92(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$488598de725ead6d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22v-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b839d251542ee244(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 19v3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4dee1d86104fdbaf(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "3",
                    "height": "9",
                    "x": "7",
                    "y": "7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "3",
                    "height": "5",
                    "x": "14",
                    "y": "7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c48db6b623dee4fe(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 17 13.5 8.5 8.5 13.5 2 7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 17 22 17 22 11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a2cf7db6b7e91dd9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.828 14.828 21 21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v5h-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 3-9 9-4-4-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8V3h-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6073d19f5f350773(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 7 13.5 15.5 8.5 10.5 2 17"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 7 22 7 22 13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1beb256e875a6e19(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$40ee8b21b709231a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$78e4523ad26ee7f4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7aff4ef92fea71ef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9H4.5a2.5 2.5 0 0 1 0-5H6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9h1.5a2.5 2.5 0 0 0 0-5H18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6v7a6 6 0 0 0 12 0V2Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$a9b7b5ce5e0b806a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18H9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eb9d2e6765fe1ee0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.82 7.9 8 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.18 7.9 12 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.93 10H20a2 2 0 0 1 0 4H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d89103163f3cd533(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h10"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$67332489ed459b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h10"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "14",
                    "x": "2",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2e1ad4f95fde3c67(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "15",
                    "x": "2",
                    "y": "7",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 2 12 7 7 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b22ce8744d2a09b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7c4a72b6bdbcc5f2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1d90d76b25ed267e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9a1d951af25aa60(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 7 4 4 20 4 20 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "15",
                    "y1": "20",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "4",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6801a2cb93bf8784(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 12H22A10 10 0 0 0 9.004 3.455"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$445e66091ed09e5f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12a10.06 10.06 1 0 0-20 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12v8a2 2 0 0 0 4 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ec44addea4e22030(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4v6a6 6 0 0 0 12 0V4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "x2": "20",
                    "y1": "20",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$52e49c441a145993(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14 4 9l5-5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c600833f6b615581(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17a9 9 0 0 0-15-6.7L3 13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7v6h6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "17",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f9bd3886db7c0e33(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7v6h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$609174d6a99706f8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 15 3-3-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5 9-3 3 3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$50bdc35ed4cd8cb2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22v-6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12H8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12h-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 19-3 3-3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15 5-3-3-3 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$30aa6b30c1ce36f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "6",
                    "x": "5",
                    "y": "4",
                    "rx": "1"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "6",
                    "x": "11",
                    "y": "14",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5e17bd2f5f671799(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 22v-5a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$bc35efa2e49274c8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d9dba1a766254ef(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "8",
                    "y1": "2",
                    "y2": "5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "5",
                    "y1": "8",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "x2": "16",
                    "y1": "19",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "22",
                    "y1": "16",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4cb94f3bbdd80297(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 5 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 22 3-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 13.5 10 11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 16.5 13 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$70a30c861cbe3da0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 8 12 3 7 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "x2": "12",
                    "y1": "3",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5284eac95425b6e1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "7",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "20",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.7 19.3 19 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 3-3 1 2 2Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.26 7.68 5 12l2 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 14 5 2 3.5-3.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 12 1-1 1 1-1 1Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cea4278654a01195(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 11 18 13 22 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d66a2a8c8e845438(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "15",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15H6a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.7 16.4-.9-.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.2 13.9-.9-.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.6 18.7.3-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.1 12.2.3-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.6 18.7-.4-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.8 12.3-.4-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.3 16.6 1-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m20.7 13.8 1-.4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3683c0757c33919d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "16",
                    "y1": "11",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ef759e172c7360c2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 15H7a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$616bce55d4e60ff4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "x2": "19",
                    "y1": "8",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "16",
                    "y1": "11",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$27713dc9d4e80f23(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21a8 8 0 0 1 13.292-6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 19 2 2 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$68e18fca2635b3e3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21a8 8 0 0 1 10.434-7.62"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.5 14.3-.4.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.9 20.8-.4.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.7 19.5-.9-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.2 16.9-.9-.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.7 16.5-.9.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.2 19.1-.9.4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19.5 21.7-.4-.9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.9 15.2-.4-.9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$faf1e65cbef3fb6b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21a8 8 0 0 1 13.292-6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$88365f1078296feb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21a8 8 0 0 1 10.821-7.487"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$92071ddb4e363162(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21a8 8 0 0 1 13.292-6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19h-6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$963e7b1d64ea6755(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21a8 8 0 0 1 10.434-7.62"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 22-1.9-1.9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f63882a54da3433e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21a8 8 0 0 1 11.873-7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 17 5 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 17-5 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7d745b3540f26cf0(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21a8 8 0 0 0-16 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dff1672276299a8a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3 15H7a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "17",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21 21-1.9-1.9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$64f59d74be462726(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "x2": "22",
                    "y1": "8",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "17",
                    "y1": "8",
                    "y2": "13"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cda4af3a73d25220(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3cffbab919a8d633(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 21a8 8 0 0 0-16 0"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c7d8e7a6b52a663(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 21v-2a4 4 0 0 0-3-3.87"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3.13a4 4 0 0 1 0 7.75"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c9116e0df569be2c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2.1 21.8 6.4-6.3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 5-7 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2102de7a0705bfd4(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2v20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9506d51745b5e423(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5h20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m19 5-7 7-7-7"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$95fe23f9099f5f1f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21s-4-3-4-9 4-9 4-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3s4 3 4 9-4 9-4 9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "x2": "9",
                    "y1": "9",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "x2": "15",
                    "y1": "9",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$2cfd9ee8f117f70d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "7.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.9 7.9 2.7 2.7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "7.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.4 10.6 2.7-2.7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "16.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.9 16.1 2.7-2.7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "16.5",
                    "r": ".5",
                    "fill": "currentColor"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.4 13.4 2.7 2.7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$60ef927c6b97219a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8q6 0 6-6-6 0-6 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.41 3.59a10 10 0 1 0 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$7c28346eca44982a(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c-1.5 0-2.5.5-3 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6a2 2 0 0 0-2 2v4a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3a8 8 0 0 0-5 2 8 8 0 0 0-5-2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11c1.5 0 2.5.5 3 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$eaaf325dde3ea3fe(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 8 2 2-2 2 2 2-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 8-2 2 2 2-2 2 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10.34V6c0-.55-.45-1-1-1h-4.34"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8d6906f117271af(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 8 2 2-2 2 2 2-2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m22 8-2 2 2 2-2 2 2 2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "14",
                    "x": "8",
                    "y": "5",
                    "rx": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d8d5ce6da6b881c5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4543b16cf8b657e7(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "6",
                    "width": "14",
                    "height": "12",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$13efc0d809892e10(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "16",
                    "x": "2",
                    "y": "4",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8h20"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "14",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "14",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5237c9810e1d865(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ef5effc66a2f8f12(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "x2": "18",
                    "y1": "16",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5c3ba6c4c2ff1c73(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.1 7.1a16.55 16.55 0 0 1 10.9 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12a12.6 12.6 0 0 1-8.7 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.8 13.6a16.55 16.55 0 0 1-9 7.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.7 17a12.8 12.8 0 0 0-8.7-5 13.3 13.3 0 0 1 0-10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.3 3.8a16.55 16.55 0 0 0 1.9 11.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$1c7332c822f3560e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9a5 5 0 0 1 0 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$21f725b361df6ada(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9a5 5 0 0 1 0 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.364 18.364a9 9 0 0 0 0-12.728"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3634aed6f9eaf666(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9a5 5 0 0 1 .95 2.293"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.364 5.636a9 9 0 0 1 1.889 9.96"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.828 4.172A.686.686 0 0 1 11 4.657v.686"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$ae1ecf4b6526f776(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "x2": "16",
                    "y1": "9",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "x2": "22",
                    "y1": "9",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3f4e82de072d67fb(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5b406a3887b51c47(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 12 2 2 4-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e96abc432da40381(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "18",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$94f152c6d0f5544f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4c0867c215f51c5c(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d2a94cc0045514e9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "9",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dd6dfde7e6b2a6ba(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 7 3 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14v4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8H3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16h-4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3H9"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$46f561dd9e09eef2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4V2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16v-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9h2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.8 11.8 19 13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.8 6.2 19 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3 21 9-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.2 6.2 11 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f33a3ec43510ec27(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h12"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "12",
                    "height": "12",
                    "x": "6",
                    "y": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$e5bfe652e1cca2f8(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6h.01"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "18",
                    "height": "20",
                    "x": "3",
                    "y": "2",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3cd52479483f6720(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "6"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 10 12 12 13 13"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cc8dbfb6d8ff5395(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$d3cadedb352b5093(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.2 6.3-3.9 3.9"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "12",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "12",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.8 17.7 3.9-3.9"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19.5",
                    "r": "2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$864948d7a7cdcbf3(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22v-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c35230b4a43d838(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3.4a4 4 0 0 1 6.52.66"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.3 20.3a4 4 0 0 1-2.3.7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6 13a4 4 0 0 1 3.357 3.414"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 6 .6 1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$94d11fa0af7fb52f(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f31ae516ff868c97(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3a769aa1651d5fff(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 22 10-10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 8-1.17 1.17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$fe360d988bc81fa5(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22 16 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$4975ba9dcd9c33d2(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9v6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$842329f34a03b34(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.859a10 10 0 0 1 14 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 16.429a5 5 0 0 1 7 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$f229049f40f72b7e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 16.429a5 5 0 0 1 7 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$65179b7952f4ca15(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 16.429a5 5 0 0 1 7 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.859a10 10 0 0 1 5.17-2.69"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12.859a10 10 0 0 0-2.007-1.523"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8.82a15 15 0 0 1 4.177-2.643"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8.82a15 15 0 0 0-11.288-3.764"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$cad55cd2c8828f56(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6e196fb849efa572(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h.01"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8.82a15 15 0 0 1 20 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.859a10 10 0 0 1 14 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 16.429a5 5 0 0 1 7 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$6a9a3fa49a7f7b7d(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2v8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.8 21.6A2 2 0 1 0 14 18H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10a2.5 2.5 0 1 1 2 4H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 6 4 4 4-4"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$214c1bb8f38d00d9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.8 19.6A2 2 0 1 0 14 16H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 8a2.5 2.5 0 1 1 2 4H2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.8 4.4A2 2 0 1 1 11 8H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$dece5dcaed232b15(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h3m7 0h-1.343"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "x2": "22",
                    "y1": "2",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$312466aabbb0f3b1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22h8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15v7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3b4299657a09ebd1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "8",
                    "x": "3",
                    "y": "3",
                    "rx": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v4a2 2 0 0 0 2 2h4"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "8",
                    "height": "8",
                    "x": "13",
                    "y": "13",
                    "rx": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9847de93776ce868(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 12-1.5 3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.63 18.81 22 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$3139071d3e4df5f9(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "21",
                    "y1": "6",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12h15a3 3 0 1 1 0 6h-4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 14 18 16 20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "x2": "10",
                    "y1": "18",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c0da6213ca9c70ab(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$c4fb41ada084752b(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6 6 18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6 6 12 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$9a82df85cb510d78(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 15 5-3-5-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5eaa69dbf93b247(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2 2 20 20"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$5e12de7c7ccc870e(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$b5bc041811fbd1ad(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "x2": "16.65",
                    "y1": "21",
                    "y2": "16.65"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "11",
                    "x2": "11",
                    "y1": "8",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "14",
                    "y1": "11",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $4f2ab0198db0e6aa$export$8cd7595826c777f1(props) {
    return (0, $979bbccfede4a2a2$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "x2": "16.65",
                    "y1": "21",
                    "y2": "16.65"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "x2": "14",
                    "y1": "11",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}



var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
'use strict';

$701b6c0516155145$exports = (parcelRequire("iZZ9K"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;


const $3df07944bfa6aab3$var$Header = ()=>{
    const [btnText, setBtnText] = (0, $acw62.useState)('Login');
    const cartItems = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((store)=>store.cart.items);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "header w-[98%] xs:w-[99%] sm:w-[99.5%]",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "logo gap-[10px] xs:gap-4 sm:gap-[30px]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (0, $4eM2B.LOGO_URL),
                        alt: "Logo",
                        className: "w-[30px] xs:w-[50px] sm:w-[100px]"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "company-name hidden xs:block text-lg sm:text-3xl",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/",
                            children: "Food Panda"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "nav-items",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    className: "text-[8px] xs:text-sm sm:text-base gap-[6px] xs:gap-2 sm:gap-[30px]",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "text-[8px] xs:text-sm sm:text-xl",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "text-[8px] xs:text-sm sm:text-xl",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/about",
                                children: "About"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "text-[8px] xs:text-sm sm:text-xl",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/contact",
                                children: "Contact"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "text-[8px] xs:text-sm sm:text-xl",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/cart",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cart-count absolute -top-1 -right-1 xs:-top-2 xs:-right-2 bg-red-500 text-white text-[6px] xs:text-xs rounded-full h-2 w-2 xs:h-4 xs:w-4 sm:h-5 sm:w-5 flex items-center justify-center",
                                            children: cartItems.length
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cart-icon w-4 h-4 xs:w-8 xs:h-8 sm:w-10 sm:h-10 flex items-center justify-center text-sm xs:text-xl sm:text-2xl",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f2ab0198db0e6aa$export$f41c1999e3bd6c81), {})
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "login-btn text-[8px] xs:text-sm sm:text-xl px-1 py-0.5 xs:px-2 sm:px-4",
                                onClick: ()=>{
                                    btnText === 'Login' ? setBtnText('Logout') : setBtnText('Login');
                                },
                                children: btnText
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $3df07944bfa6aab3$export$2e2bcd8739ae039 = $3df07944bfa6aab3$var$Header;



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");

var $4eM2B = parcelRequire("4eM2B");
const $77ea51d6ba3f5eaa$var$Rescard = (props)=>{
    const { resData: resData } = props;
    const { cloudinaryImageId: cloudinaryImageId, name: name, locality: locality, cuisines: cuisines, avgRating: avgRating } = resData?.card?.card?.info;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "res-card relative w-[280px] xs:w-[300px] sm:w-[350px] h-auto",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "res-img",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (0, $4eM2B.CDN_URL) + cloudinaryImageId,
                    alt: "Res -Img",
                    className: "w-[270px] xs:w-[290px] sm:w-[340px] h-[200px] xs:h-[250px] sm:h-[290px] object-cover m-1 xs:m-2 sm:m-5 p-2 xs:p-4 sm:p-9 rounded-[20px]"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "res-card-content p-2 xs:p-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "font-bold text-base xs:text-lg sm:text-xl",
                        children: name || "Restaurant Name Not Available"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "text-sm xs:text-base",
                        children: locality || "Near By location"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                        className: "text-sm xs:text-base truncate",
                        children: cuisines.join(", ") || "N/A"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                        className: "text-sm xs:text-base",
                        children: [
                            "Rating: ",
                            avgRating || "Good Rating",
                            " \u2B50"
                        ]
                    })
                ]
            })
        ]
    });
};
const $77ea51d6ba3f5eaa$export$ccb02a230af14023 = (ResCard)=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "group hover:scale-103 hover:-translate-y-2 transition-transform duration-300 relative",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                    className: "absolute top-2 left-2 bg-slate-600 text-white text-xs xs:text-sm p-1 xs:p-2 z-50 shadow-lg rounded-lg",
                    children: "Promoted"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(ResCard, {
                    ...props
                })
            ]
        });
    };
};
var $77ea51d6ba3f5eaa$export$2e2bcd8739ae039 = $77ea51d6ba3f5eaa$var$Rescard;



var $acw62 = parcelRequire("acw62");

var $YVclQ = parcelRequire("YVclQ");


var $acw62 = parcelRequire("acw62");
const $ce95a10ebee058d7$var$useOffline = ()=>{
    const [onlineStatus, setOnlineStatus] = (0, $acw62.useState)(navigator.onLine);
    (0, $acw62.useEffect)(()=>{
        const handleOffline = ()=>setOnlineStatus(false);
        const handleOnline = ()=>setOnlineStatus(true);
        window.addEventListener("offline", handleOffline);
        window.addEventListener("online", handleOnline);
        // Cleanup event listeners on unmount
        return ()=>{
            window.removeEventListener("offline", handleOffline);
            window.removeEventListener("online", handleOnline);
        };
    }, []);
    return onlineStatus;
};
var $ce95a10ebee058d7$export$2e2bcd8739ae039 = $ce95a10ebee058d7$var$useOffline;



var $acw62 = parcelRequire("acw62");

var $4eM2B = parcelRequire("4eM2B");
const $2421e639739965f3$var$useFetchResList = ()=>{
    const [resList, setResList] = (0, $acw62.useState)([]);
    const fetchData = async ()=>{
        try {
            const res = await fetch((0, $4eM2B.SWIGGY_API));
            const data = await res.json();
            // console.log(data)
            const { cards: cards } = data?.data?.cards?.[1]?.groupedCard?.cardGroupMap?.RESTAURANT;
            console.log(cards);
            setResList(cards);
        // setTimeout(() => {
        //     setResList(data.cards); // Properly set the list after a delay
        //   }, 400);
        } catch (err) {
            console.log(err);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    return resList;
};
var $2421e639739965f3$export$2e2bcd8739ae039 = $2421e639739965f3$var$useFetchResList;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $b32f7dcb0870dac2$var$TicTacToe = ()=>{
    const [board, setBoard] = (0, $acw62.useState)(Array(9).fill(null));
    const [isUserTurn, setIsUserTurn] = (0, $acw62.useState)(true);
    const [winner, setWinner] = (0, $acw62.useState)(null);
    const winningCombinations = [
        [
            0,
            1,
            2
        ],
        [
            3,
            4,
            5
        ],
        [
            6,
            7,
            8
        ],
        [
            0,
            3,
            6
        ],
        [
            1,
            4,
            7
        ],
        [
            2,
            5,
            8
        ],
        [
            0,
            4,
            8
        ],
        [
            2,
            4,
            6
        ]
    ];
    const checkWinner = (newBoard)=>{
        for (let combo of winningCombinations){
            const [a, b, c] = combo;
            if (newBoard[a] && newBoard[a] === newBoard[b] && newBoard[a] === newBoard[c]) return newBoard[a];
        }
        return newBoard.every((cell)=>cell !== null) ? "Draw" : null;
    };
    const handleClick = (index)=>{
        if (board[index] || winner || !isUserTurn) return;
        const newBoard = [
            ...board
        ];
        newBoard[index] = "X";
        setBoard(newBoard);
        const gameWinner = checkWinner(newBoard);
        if (gameWinner) {
            setWinner(gameWinner);
            return;
        }
        setIsUserTurn(false);
        // AI makes a move
        setTimeout(()=>{
            aiMove(newBoard);
        }, 500);
    };
    const aiMove = (currentBoard)=>{
        const newBoard = [
            ...currentBoard
        ];
        // AI tries to win or block user from winning
        const makeStrategicMove = (symbol)=>{
            for (let combo of winningCombinations){
                const [a, b, c] = combo;
                const cells = [
                    newBoard[a],
                    newBoard[b],
                    newBoard[c]
                ];
                if (cells.filter((cell)=>cell === symbol).length === 2 && cells.includes(null)) return combo[cells.indexOf(null)];
            }
            return null;
        };
        let move = makeStrategicMove("O"); // Try to win
        if (move === null) move = makeStrategicMove("X"); // Block user
        // Otherwise, pick the first available cell
        if (move === null) move = newBoard.findIndex((cell)=>cell === null);
        newBoard[move] = "O";
        setBoard(newBoard);
        const gameWinner = checkWinner(newBoard);
        if (gameWinner) setWinner(gameWinner);
        else setIsUserTurn(true);
    };
    const resetGame = ()=>{
        setBoard(Array(9).fill(null));
        setIsUserTurn(true);
        setWinner(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "game",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                children: "Tic-Tac-Toe"
            }),
            winner ? /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                children: winner === "Draw" ? "It's a Draw!" : `${winner} Wins!`
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                children: isUserTurn ? "Your Turn (X)" : "AI's Turn (O)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "board",
                children: board.map((cell, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `cell ${cell ? "filled" : ""}`,
                        onClick: ()=>handleClick(index),
                        children: cell
                    }, index))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "reset-button",
                onClick: resetGame,
                children: "Reset Game"
            })
        ]
    });
};
var $b32f7dcb0870dac2$export$2e2bcd8739ae039 = $b32f7dcb0870dac2$var$TicTacToe;


const $0b506194c06561d2$var$resData = [
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "869093",
                    "name": "BAKENBROWN",
                    "city": "57",
                    "slugs": {
                        "restaurant": "bakenbrown-sahid-nagar-sahid-nagar",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/10/0bb275d4-9f3e-4d15-ba8f-a9bc4b307bfb_869093.JPG",
                    "address": "Shop No : 738/3 , Floor :  , Ward 27 , Near SBI Bank , BAKENBROWN, Biju Pattnaik College Road, near Rath Arcade, Jayadev Vihar, Bhubaneswar, Odisha, India",
                    "locality": "Near SBI Bank",
                    "areaName": "Jaydev Vihar",
                    "costForTwo": "20000",
                    "costForTwoMessage": "\u20B9200 FOR TWO",
                    "cuisines": [
                        "Bakery",
                        "Beverages",
                        "Snacks",
                        "Pizzas",
                        "Pastas",
                        "Burgers",
                        "Cafe"
                    ],
                    "avgRating": 4.3,
                    "feeDetails": {},
                    "avgRatingString": "4.3",
                    "totalRatingsString": "149",
                    "promoted": true,
                    "adTrackingId": "cid=22700977~p=0~adgrpid=22700977#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=869093~st=top rated pizza joints in bhubaneswar~eid=c82c4e92-1332-40e0-86d9-ffd17cbb233b~srvts=1734359967397",
                    "sla": {
                        "deliveryTime": 17,
                        "minDeliveryTime": 15,
                        "maxDeliveryTime": 20,
                        "lastMileTravel": 0.9,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "15-20 MINS",
                        "lastMileTravelString": "0.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT \u20B9139",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    },
                    "campaignId": "22700977"
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22700977~p=0~adgrpid=22700977#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=869093~st=top rated pizza joints in bhubaneswar~eid=c82c4e92-1332-40e0-86d9-ffd17cbb233b~srvts=1734359967397\"}",
                    "objectValue": "869093",
                    "impressionObjectName": "impression-restaurant-ad",
                    "clickObjectName": "click-restaurant-ad"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "869093",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "377102",
                    "name": "Mamma Mia - Mayfair Lagoon",
                    "city": "57",
                    "slugs": {
                        "restaurant": "mamma-mia-sahid-nagar-sahid-nagar-2",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "oteirqk3fmbzwdzztpjo",
                    "address": "8-B, Jaydev Vihar Bhubaneswar, Odisha 751013",
                    "locality": "Jayadev Vihar",
                    "areaName": "Sahid Nagar",
                    "costForTwo": "150000",
                    "costForTwoMessage": "\u20B91500 FOR TWO",
                    "cuisines": [
                        "Continental"
                    ],
                    "avgRating": 4.9,
                    "feeDetails": {},
                    "avgRatingString": "4.9",
                    "totalRatingsString": "78",
                    "sla": {
                        "deliveryTime": 38,
                        "minDeliveryTime": 35,
                        "maxDeliveryTime": 40,
                        "lastMileTravel": 1,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "35-40 MINS",
                        "lastMileTravelString": "1.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                        "visible": true
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV2": {
                        "visible": true
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "4.4",
                            "ratingCount": "367"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "377102",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "377102",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "559248",
                    "name": "Domino's Pizza",
                    "city": "57",
                    "slugs": {
                        "restaurant": "dominos-pizza-pal-heights-sahid-nagar",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/11/29/31c3b0a6-17ff-4afd-8c96-7b9a7aba1e51_559248.jpg",
                    "address": "First Floor, PAL Heights, J/7, Jayadev Vihar,Bhubaneswar 751013, Odisha",
                    "locality": "Jayadev Vihar",
                    "areaName": "Saheed Nagar",
                    "costForTwo": "40000",
                    "costForTwoMessage": "\u20B9400 FOR TWO",
                    "cuisines": [
                        "Pizzas",
                        "Italian",
                        "Pastas",
                        "Desserts"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "1.6K+",
                    "promoted": true,
                    "adTrackingId": "cid=22710502~p=1~adgrpid=22710502#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=559248~st=top rated pizza joints in bhubaneswar~eid=08bededa-73f8-4803-a866-3bd48efb4b4a~srvts=1734359967397",
                    "sla": {
                        "deliveryTime": 25,
                        "minDeliveryTime": 20,
                        "maxDeliveryTime": 25,
                        "lastMileTravel": 0.3,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "20-25 MINS",
                        "lastMileTravelString": "0.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "Rxawards/_CATEGORY-Pizza.png",
                                "description": "Delivery!"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "\u20B9125 OFF",
                        "subHeader": "ABOVE \u20B91199",
                        "discountTag": "FLAT DEAL",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    },
                    "campaignId": "22710502"
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22710502~p=1~adgrpid=22710502#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=559248~st=top rated pizza joints in bhubaneswar~eid=08bededa-73f8-4803-a866-3bd48efb4b4a~srvts=1734359967397\"}",
                    "objectValue": "559248",
                    "impressionObjectName": "impression-restaurant-ad",
                    "clickObjectName": "click-restaurant-ad"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "559248",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "122348",
                    "name": "Bling It On-The New Marrion Hotel",
                    "city": "57",
                    "slugs": {
                        "restaurant": "bling-it-on-the-new-marrion-hotel-janpath-sahid-nagar",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "ek6ujsmnq6aqzxjryofu",
                    "address": "Hotel Marrion, 6, Janpath, Near Ram Mandir, Bhubaneswar, Kharabela Nagar, Bhubaneshwar",
                    "locality": "Kharabela Nager",
                    "areaName": "Kharabela Nagar",
                    "costForTwo": "70000",
                    "costForTwoMessage": "\u20B9700 FOR TWO",
                    "cuisines": [
                        "Indian",
                        "Continental"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "557",
                    "sla": {
                        "deliveryTime": 44,
                        "minDeliveryTime": 40,
                        "maxDeliveryTime": 45,
                        "lastMileTravel": 5,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "40-45 MINS",
                        "lastMileTravelString": "5.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                        "visible": true
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "newg.png",
                                "description": "Gourmet"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV2": {
                        "visible": true
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "4.1",
                            "ratingCount": "418"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "122348",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "122348",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "446796",
                    "name": "Faasos - Wraps, Rolls & Shawarma",
                    "city": "57",
                    "slugs": {
                        "restaurant": "faasos-patia-chandrashekarpur",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/28/c12a8911-b94e-4e1a-b714-f767e6e5bd8c_446796.JPG",
                    "address": "17, Technology Corridor Rd, Infocity, Chandrasekharpur, Bhubaneswar, Odisha 751024",
                    "locality": "Technology Corridor Rd",
                    "areaName": "Patia",
                    "costForTwo": "20000",
                    "costForTwoMessage": "\u20B9200 FOR TWO",
                    "cuisines": [
                        "Kebabs",
                        "Fast Food",
                        "Snacks",
                        "American",
                        "Healthy Food",
                        "Desserts",
                        "Beverages"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "3.1K+",
                    "promoted": true,
                    "adTrackingId": "cid=22688914~p=2~adgrpid=22688914#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=446796~st=top rated pizza joints in bhubaneswar~eid=bc881584-a6c1-4483-9571-d0c6d23b920e~srvts=1734359967397",
                    "sla": {
                        "deliveryTime": 40,
                        "minDeliveryTime": 35,
                        "maxDeliveryTime": 40,
                        "lastMileTravel": 6.2,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "35-40 MINS",
                        "lastMileTravelString": "6.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO \u20B9100",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    },
                    "campaignId": "22688914"
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22688914~p=2~adgrpid=22688914#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=446796~st=top rated pizza joints in bhubaneswar~eid=bc881584-a6c1-4483-9571-d0c6d23b920e~srvts=1734359967397\"}",
                    "objectValue": "446796",
                    "impressionObjectName": "impression-restaurant-ad",
                    "clickObjectName": "click-restaurant-ad"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "446796",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "988657",
                    "name": "KRUTI COFFEE",
                    "city": "57",
                    "slugs": {
                        "restaurant": "kruti-coffee-sahid-nagar-sahid-nagar",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/11/11/a64be4f5-c9fc-4470-8a2d-a690182659f6_988657.jpg",
                    "address": "Shop No : 01 , Floor :  , Pal Height , ",
                    "locality": "Sahid Nagar",
                    "areaName": "Sahid Nagar",
                    "costForTwo": "40000",
                    "costForTwoMessage": "\u20B9400 FOR TWO",
                    "cuisines": [
                        "Cafe"
                    ],
                    "avgRating": 4.6,
                    "feeDetails": {},
                    "avgRatingString": "4.6",
                    "totalRatingsString": "12",
                    "sla": {
                        "deliveryTime": 26,
                        "minDeliveryTime": 25,
                        "maxDeliveryTime": 30,
                        "lastMileTravel": 0.3,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "25-30 MINS",
                        "lastMileTravelString": "0.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "20% OFF",
                        "subHeader": "UPTO \u20B950",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "988657",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "988657",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "831931",
                    "name": "TEALOGY",
                    "city": "57",
                    "slugs": {
                        "restaurant": "tealogy-chandrashekarpur-chandrashekarpur",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "330f7d11d515aad8269ab4e729e339e4",
                    "address": "SHOP NO. B6 , NALCO ROAD, OPPOSITE ODISHA STATE ARMED FORCE POLICE, 7TH BATTALION, SAMANTA VIHAR, CHANDRASEKHARPUR, Samanta Vihar, Ward 12, BHUBANESWAR MUNICIPAL CORPORATION, Orissa - 751017",
                    "locality": "Samanta Vihar",
                    "areaName": "Chandrashekarpur",
                    "costForTwo": "20000",
                    "costForTwoMessage": "\u20B9200 FOR TWO",
                    "cuisines": [
                        "Beverages",
                        "Cafe"
                    ],
                    "avgRating": 4.1,
                    "feeDetails": {},
                    "avgRatingString": "4.1",
                    "totalRatingsString": "71",
                    "promoted": true,
                    "adTrackingId": "cid=22625158~p=3~adgrpid=22625158#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=831931~st=top rated pizza joints in bhubaneswar~eid=93e0e494-365b-449a-aede-642569c8aeb8~srvts=1734359967397",
                    "sla": {
                        "deliveryTime": 28,
                        "minDeliveryTime": 25,
                        "maxDeliveryTime": 30,
                        "lastMileTravel": 2.3,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "25-30 MINS",
                        "lastMileTravelString": "2.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "v1695133679/badges/Pure_Veg111.png",
                                "description": "pureveg"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT \u20B9109",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    },
                    "campaignId": "22625158"
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22625158~p=3~adgrpid=22625158#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=831931~st=top rated pizza joints in bhubaneswar~eid=93e0e494-365b-449a-aede-642569c8aeb8~srvts=1734359967397\"}",
                    "objectValue": "831931",
                    "impressionObjectName": "impression-restaurant-ad",
                    "clickObjectName": "click-restaurant-ad"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "831931",
                        "query": "Top Rated Pizza Joints In Bhubaneswar"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "985234",
                    "name": "Domino's Chicken Fiesta",
                    "city": "57",
                    "slugs": {
                        "restaurant": "dominos-chicken-fiesta-jayadev-vihar-sahid-nagar",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/11/5/8cb3c18b-7d42-44f4-8aad-ea38a76c4c9b_985234.jpg",
                    "address": "First Floor, PAL Heights, J/7, Jayadev Vihar,Bhubaneswar 751013, Odisha",
                    "locality": "Jayadev Vihar",
                    "areaName": "Saheed Nagar",
                    "costForTwo": "40000",
                    "costForTwoMessage": "\u20B9400 FOR TWO",
                    "cuisines": [
                        "Pizzas",
                        "Italian",
                        "Pastas",
                        "Desserts"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "6",
                    "sla": {
                        "deliveryTime": 25,
                        "minDeliveryTime": 20,
                        "maxDeliveryTime": 25,
                        "lastMileTravel": 0.3,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "20-25 MINS",
                        "lastMileTravelString": "0.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "30% OFF",
                        "subHeader": "UPTO \u20B975",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "985234",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "985234"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "446800",
                    "name": "Oven Story Pizza - Standout Toppings",
                    "city": "57",
                    "slugs": {
                        "restaurant": "oven-story-pizza-patia-chandrashekarpur",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/10/1/4f1dcc50-adb0-47fd-9135-b73cd15d17d7_446800.jpg",
                    "address": "17, Technology Corridor Rd, Infocity, Chandrasekharpur, Bhubaneswar, Odisha 751024",
                    "locality": "Technology Corridor Rd",
                    "areaName": "Patia",
                    "costForTwo": "40000",
                    "costForTwoMessage": "\u20B9400 FOR TWO",
                    "cuisines": [
                        "Pizzas",
                        "Pastas",
                        "Italian",
                        "Desserts",
                        "Beverages"
                    ],
                    "avgRating": 4.4,
                    "feeDetails": {},
                    "avgRatingString": "4.4",
                    "totalRatingsString": "2.4K+",
                    "promoted": true,
                    "adTrackingId": "cid=22688921~p=4~adgrpid=22688921#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=446800~st=top rated pizza joints in bhubaneswar~eid=0b541130-b491-4b9c-9344-167f9d5ec48a~srvts=1734359967397",
                    "sla": {
                        "deliveryTime": 43,
                        "minDeliveryTime": 40,
                        "maxDeliveryTime": 45,
                        "lastMileTravel": 6.3,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "40-45 MINS",
                        "lastMileTravelString": "6.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "Rxawards/_CATEGORY-Pizza.png",
                                "description": "Delivery!"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO \u20B9100",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    },
                    "campaignId": "22688921"
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22688921~p=4~adgrpid=22688921#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=446800~st=top rated pizza joints in bhubaneswar~eid=0b541130-b491-4b9c-9344-167f9d5ec48a~srvts=1734359967397\"}",
                    "objectValue": "446800",
                    "impressionObjectName": "impression-restaurant-ad",
                    "clickObjectName": "click-restaurant-ad"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "446800",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "744844",
                    "name": "Burger King",
                    "city": "57",
                    "slugs": {
                        "restaurant": "burger-king-pal-heights-sahid-nagar",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/a5cee281-c25f-494a-8cab-ba7f49acfb03_744844.JPG",
                    "address": "Plot No-J-7, Ground & First Floor, Pal Heights,  Ward 16,Bhubaneswar Municipal Corporation ,Orissa,751013",
                    "locality": "Jayadev Vihar",
                    "areaName": "bhubaneswar",
                    "costForTwo": "35000",
                    "costForTwoMessage": "\u20B9350 FOR TWO",
                    "cuisines": [
                        "Burgers",
                        "American"
                    ],
                    "avgRating": 4.6,
                    "feeDetails": {},
                    "avgRatingString": "4.6",
                    "totalRatingsString": "6.0K+",
                    "sla": {
                        "deliveryTime": 16,
                        "minDeliveryTime": 15,
                        "maxDeliveryTime": 20,
                        "lastMileTravel": 0.5,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "15-20 MINS",
                        "lastMileTravelString": "0.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "bolt/Bolt%20Listing%20badge@3x.png",
                                "description": "bolt!"
                            },
                            {
                                "imageId": "Rxawards/_CATEGORY-Burger.png",
                                "description": "Delivery!"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO \u20B9120",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "4.5",
                            "ratingCount": "821"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "744844",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "744844",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "621140",
                    "name": "McDonald's",
                    "city": "57",
                    "slugs": {
                        "restaurant": "mcdonalds-patia-patia",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/10/22/7d3e0c44-ce41-476a-826b-6799685eb3a0_621140.JPG",
                    "address": "GF-2 & FF-2, Plot No. G/51 corresponding to Revenue Plot No. 457/1952, Khata No.619, Mauza Chandresekkarpur, Bhubaneshwar, Odisha-751015",
                    "locality": "Chandresekkarpur",
                    "areaName": "Chandrasekharpur",
                    "costForTwo": "40000",
                    "costForTwoMessage": "\u20B9400 FOR TWO",
                    "cuisines": [
                        "American",
                        "Fast Food"
                    ],
                    "avgRating": 4.6,
                    "feeDetails": {},
                    "avgRatingString": "4.6",
                    "totalRatingsString": "8.4K+",
                    "promoted": true,
                    "adTrackingId": "cid=22710499~p=5~adgrpid=22710499#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=621140~st=top rated pizza joints in bhubaneswar~eid=52b0a251-4f0a-40b7-865d-e4862b3760ca~srvts=1734359967397",
                    "sla": {
                        "deliveryTime": 28,
                        "minDeliveryTime": 25,
                        "maxDeliveryTime": 30,
                        "lastMileTravel": 5.6,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "25-30 MINS",
                        "lastMileTravelString": "5.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                        "visible": true
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "Rxawards/_CATEGORY-Burger.png",
                                "description": "Delivery!"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV2": {
                        "visible": true
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    },
                    "campaignId": "22710499"
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22710499~p=5~adgrpid=22710499#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=621140~st=top rated pizza joints in bhubaneswar~eid=52b0a251-4f0a-40b7-865d-e4862b3760ca~srvts=1734359967397\"}",
                    "objectValue": "621140",
                    "impressionObjectName": "impression-restaurant-ad",
                    "clickObjectName": "click-restaurant-ad"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "621140",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "325757",
                    "name": "Mio Amore",
                    "city": "57",
                    "slugs": {
                        "restaurant": "mio-amore-sahid-nagar-sahid-nagar",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "tywmcvle4g3fd4culvjr",
                    "address": "Plot- 8(P),Acharya Vihar Chawk,Bhubaneswar 751022",
                    "locality": "Mio Amore Acharya Vihar,Near Acharya Vihar Square",
                    "areaName": "Acharya Vihar",
                    "costForTwo": "15000",
                    "costForTwoMessage": "\u20B9150 FOR TWO",
                    "cuisines": [
                        "Bakery",
                        "Desserts",
                        "Snacks",
                        "Confectionery"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "949",
                    "sla": {
                        "deliveryTime": 21,
                        "minDeliveryTime": 20,
                        "maxDeliveryTime": 25,
                        "lastMileTravel": 1.8,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "20-25 MINS",
                        "lastMileTravelString": "1.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "Rxawards/_CATEGORY-Desserts.png",
                                "description": "Delivery!"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV3": {
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "325757",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "325757",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "408185",
                    "name": "Pizza Hut",
                    "city": "57",
                    "slugs": {
                        "restaurant": "pizza-hut-jaydev-vihar-bbsr-patia",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/17/53d5f5b4-1e37-4855-8f11-aa5ef1d12d47_408185.jpg",
                    "address": "Pizza Hut, XIMB Square, Plot No-P-1 & P-1/A, Jayadev Vihar, Bhubaneswar, Khordha, KHORDHA(EXCEPT MUNICIPAL CORPORATION), Orissa, 751013",
                    "locality": "XIMB Square",
                    "areaName": "Jayadev Vihar",
                    "costForTwo": "30000",
                    "costForTwoMessage": "\u20B9300 FOR TWO",
                    "cuisines": [
                        "Pizzas"
                    ],
                    "avgRating": 4.4,
                    "feeDetails": {},
                    "avgRatingString": "4.4",
                    "totalRatingsString": "6.0K+",
                    "sla": {
                        "deliveryTime": 22,
                        "minDeliveryTime": 20,
                        "maxDeliveryTime": 25,
                        "lastMileTravel": 1.3,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "20-25 MINS",
                        "lastMileTravelString": "1.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "Rxawards/_CATEGORY-Pizza.png",
                                "description": "Delivery!"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO \u20B9100",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "408185",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "408185",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "644648",
                    "name": "Chicago Delights",
                    "city": "57",
                    "slugs": {
                        "restaurant": "chicago-delights-nayapalli-nayapalli",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "ba127c795a238e210ea4d7792503260a",
                    "address": "Plot No-194/4793, Jayadev Vihar, Ekamra Kanan Road, Nayapally, Bolagad, KHORDHA(EXCEPT MUNICIPAL CORPORATION), Orissa - 751013",
                    "locality": "Jayadev Vihar",
                    "areaName": "Sahid Nagar",
                    "costForTwo": "20000",
                    "costForTwoMessage": "\u20B9200 FOR TWO",
                    "cuisines": [
                        "Pizzas"
                    ],
                    "avgRating": 4.4,
                    "feeDetails": {},
                    "avgRatingString": "4.4",
                    "totalRatingsString": "36",
                    "sla": {
                        "deliveryTime": 28,
                        "minDeliveryTime": 25,
                        "maxDeliveryTime": 30,
                        "lastMileTravel": 1.5,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "25-30 MINS",
                        "lastMileTravelString": "1.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT \u20B9169",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "644648",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "644648",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "427907",
                    "name": "Indiana Burgers",
                    "city": "57",
                    "slugs": {
                        "restaurant": "indiana-burgers-sahid-nagar-sahid-nagar",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "fqgpfqk8kpljczpjbkll",
                    "address": "Plot No 1482, Sastri Nagar, Unit-4, Near SBI Colony, PS Capital, Bhubaneswar, Ward 12, BHUBANESWAR MUNICIPAL CORPORATION, Orissa-751001",
                    "locality": "Irc Village",
                    "areaName": "Unit 4",
                    "costForTwo": "15000",
                    "costForTwoMessage": "\u20B9150 FOR TWO",
                    "cuisines": [
                        "Burgers",
                        "American",
                        "Fast Food",
                        "Beverages",
                        "Desserts"
                    ],
                    "avgRating": 4.3,
                    "feeDetails": {},
                    "avgRatingString": "4.3",
                    "totalRatingsString": "224",
                    "sla": {
                        "deliveryTime": 25,
                        "minDeliveryTime": 25,
                        "maxDeliveryTime": 30,
                        "lastMileTravel": 1.8,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "25-30 MINS",
                        "lastMileTravelString": "1.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "bolt/Bolt%20Listing%20badge@3x.png",
                                "description": "bolt!"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT \u20B9129",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "427907",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "427907",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "881320",
                    "name": "Taste With Dibyam",
                    "city": "57",
                    "slugs": {
                        "restaurant": "taste-with-dibyam-old-bbsr-old-bbsr",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/7/a49e808f-deaa-41d7-9688-5975344626f1_881320.jpg",
                    "address": "PLOT NO-2018/2005,3RD LANE ,Chintamaniswar Temple area,Ward 45,BHUBANESWAR MUNICIPAL CORPORATION,Orissa-751006",
                    "locality": "Back side of Chintamaniswar Temple",
                    "areaName": "Chintamaniswar City",
                    "costForTwo": "20000",
                    "costForTwoMessage": "\u20B9200 FOR TWO",
                    "cuisines": [
                        "Fast Food",
                        "Cafe"
                    ],
                    "avgRating": 4.8,
                    "feeDetails": {},
                    "avgRatingString": "4.8",
                    "totalRatingsString": "14",
                    "sla": {
                        "deliveryTime": 45,
                        "minDeliveryTime": 45,
                        "maxDeliveryTime": 50,
                        "lastMileTravel": 7.2,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "45-50 MINS",
                        "lastMileTravelString": "7.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "v1695133679/badges/Pure_Veg111.png",
                                "description": "pureveg"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT \u20B979",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "881320",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "881320"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "78062",
                    "name": "Bocca Cafe",
                    "city": "57",
                    "slugs": {
                        "restaurant": "bocca-cafe-kharbela-nagar-nayapalli",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "ed20b1b021bf37689a603c024eb72fd3",
                    "address": "108/B, 1st Floor, Janpath Road, Master Canteen Area, Kharabela Nagar, Bhubaneshwar",
                    "locality": "Kharvela Nagar",
                    "areaName": "Kharvela Nagar",
                    "costForTwo": "50000",
                    "costForTwoMessage": "\u20B9500 FOR TWO",
                    "cuisines": [
                        "Cafe",
                        "Italian",
                        "Healthy Food"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "2.0K+",
                    "sla": {
                        "deliveryTime": 39,
                        "minDeliveryTime": 35,
                        "maxDeliveryTime": 40,
                        "lastMileTravel": 5,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "35-40 MINS",
                        "lastMileTravelString": "5.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "newg.png",
                                "description": "Gourmet"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "FREE ITEM",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "4.3",
                            "ratingCount": "3.5K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "78062",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "78062"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "336263",
                    "name": "OBERAI BAKERS and CAFE",
                    "city": "57",
                    "slugs": {
                        "restaurant": "oberai-bakers-&-caf\xe9-khandagiri-khandagiri",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "elnoyawchrptpvof2l1d",
                    "address": "Plot No: 1294, CRPF Square, Nayapalli, Bhubaneswar. ",
                    "locality": "Crpf Square",
                    "areaName": "Sahid Nagar",
                    "costForTwo": "20000",
                    "costForTwoMessage": "\u20B9200 FOR TWO",
                    "cuisines": [
                        "Bakery",
                        "North Indian",
                        "Chinese",
                        "Continental",
                        "Tandoor"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "4.1K+",
                    "sla": {
                        "deliveryTime": 31,
                        "minDeliveryTime": 30,
                        "maxDeliveryTime": 35,
                        "lastMileTravel": 3,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "30-35 MINS",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                        "visible": true
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV2": {
                        "visible": true
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "336263",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "336263",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "860595",
                    "name": "Greenwheel Pizza",
                    "city": "57",
                    "slugs": {
                        "restaurant": "greenwheel-pizza-old-bbsr-old-bbsr-2",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "d9b5570d65d8600f10d985a817e0f0ff",
                    "address": "PLOT NO-110,FISHERY LANE, BUDHESWARI, Fishery Tank area,, Ward 43, BHUBANESWAR MUNICIPAL CORPORATION, Orissa - 751006",
                    "locality": "Laxmisagar",
                    "areaName": "Old BBSR",
                    "costForTwo": "20000",
                    "costForTwoMessage": "\u20B9200 FOR TWO",
                    "cuisines": [
                        "Continental",
                        "Mexican",
                        "Cafe"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "19",
                    "sla": {
                        "deliveryTime": 41,
                        "minDeliveryTime": 40,
                        "maxDeliveryTime": 45,
                        "lastMileTravel": 7.5,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "40-45 MINS",
                        "lastMileTravelString": "7.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                        "visible": true
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV2": {
                        "visible": true
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "860595",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "860595",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "191689",
                    "name": "Oberai Bakers & Cafe ",
                    "city": "57",
                    "slugs": {
                        "restaurant": "oberai-bakers-&-cafe-rasulgarh-rasulgarh",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "hykbeg6boj0xydptikrt",
                    "address": "6, Nh-203, Budheswari Colony, Laxmisagar, Bhubaneswar, Odisha 751006, India",
                    "locality": "Lakshmi Sagar",
                    "areaName": "Lakshmi Sagar",
                    "costForTwo": "40000",
                    "costForTwoMessage": "\u20B9400 FOR TWO",
                    "cuisines": [
                        "Biryani",
                        "Chinese",
                        "North Indian",
                        "Bakery",
                        "Continental"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "25K+",
                    "sla": {
                        "deliveryTime": 38,
                        "minDeliveryTime": 35,
                        "maxDeliveryTime": 40,
                        "lastMileTravel": 6.5,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "35-40 MINS",
                        "lastMileTravelString": "6.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                        "visible": true
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "Rxawards/_CATEGORY-Desserts.png",
                                "description": "Delivery!"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV2": {
                        "visible": true
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "4.2",
                            "ratingCount": "2.6K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "191689",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "191689",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "468707",
                    "name": "Insta Food",
                    "city": "57",
                    "slugs": {
                        "restaurant": "insta-food-sahid-nagar-sahid-nagar",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "a1tk3kix54ksdmzxlaov",
                    "address": "Bomikhal Canal Road, GGP Colony, Bhubaneswar, Falcon Motors, Ward 33, BHUBANESWAR MUNICIPAL CORPORATION, Orissa - 751007",
                    "locality": "GGP Colony",
                    "areaName": "Rasulgarh",
                    "costForTwo": "35000",
                    "costForTwoMessage": "\u20B9350 FOR TWO",
                    "cuisines": [
                        "Chinese",
                        "Indian"
                    ],
                    "avgRating": 5,
                    "feeDetails": {},
                    "avgRatingString": "5.0",
                    "totalRatingsString": "3",
                    "sla": {
                        "deliveryTime": 41,
                        "minDeliveryTime": 40,
                        "maxDeliveryTime": 45,
                        "lastMileTravel": 6.1,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "40-45 MINS",
                        "lastMileTravelString": "6.1 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "10% OFF",
                        "subHeader": "UPTO \u20B940",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "468707",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "468707",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "496362",
                    "name": "Paris Bakery",
                    "city": "57",
                    "slugs": {
                        "restaurant": "paris-bakery-khandagiri-khandagiri-2",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "9bfaba19e65952b54795baa397e7f46b",
                    "address": "Plot No-10 P, CITY MART, BARMUNDA, BHUBANESWAR, Ward 50, BHUBANESWAR MUNICIPAL CORPORATION, Orissa-751003",
                    "locality": "Baramunda ,CRP, Sumhospital ,Khandagiri,Beside Domino's Pizza",
                    "areaName": "Baramunda",
                    "costForTwo": "15000",
                    "costForTwoMessage": "\u20B9150 FOR TWO",
                    "cuisines": [
                        "Bakery"
                    ],
                    "avgRating": 4.6,
                    "feeDetails": {},
                    "avgRatingString": "4.6",
                    "totalRatingsString": "93",
                    "sla": {
                        "deliveryTime": 24,
                        "minDeliveryTime": 20,
                        "maxDeliveryTime": 25,
                        "lastMileTravel": 4.2,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "20-25 MINS",
                        "lastMileTravelString": "4.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {
                        "imageBadges": [
                            {
                                "imageId": "v1695133679/badges/Pure_Veg111.png",
                                "description": "pureveg"
                            }
                        ]
                    },
                    "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT \u20B9489",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "496362",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "496362",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "157316",
                    "name": "Rolling Crunchys",
                    "city": "57",
                    "slugs": {
                        "restaurant": "rolling-kitchen-chandrashekarpur",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "st6koojm2pzjzlivrtll",
                    "address": "Plot No-336, Saheed Nagar,Ps-Saheed Nagar, Bhubaneswar, Saheed Nagar Area., Ward 30, Bhubaneswar Municipal Corporation,Orissa-751007",
                    "locality": "Bhatar",
                    "areaName": "Sahid Nagar",
                    "costForTwo": "39900",
                    "costForTwoMessage": "\u20B9399 FOR TWO",
                    "cuisines": [
                        "Italian",
                        "Pizzas",
                        "Pastas",
                        "Beverages"
                    ],
                    "avgRating": 4.6,
                    "feeDetails": {},
                    "avgRatingString": "4.6",
                    "totalRatingsString": "1.9K+",
                    "sla": {
                        "deliveryTime": 32,
                        "minDeliveryTime": 30,
                        "maxDeliveryTime": 35,
                        "lastMileTravel": 4,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "30-35 MINS",
                        "lastMileTravelString": "4.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "30% OFF",
                        "subHeader": "UPTO \u20B975",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "4.4",
                            "ratingCount": "449"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "157316",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "157316"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "716628",
                    "name": "Chicago Pizza",
                    "city": "57",
                    "slugs": {
                        "restaurant": "chicago-pizza-khandagiri-khandagiri",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "df9cda7c0c991be05cc5bb7dd9f13c42",
                    "address": "Ground Floor Plot No1199 2635 Soubhagya Nagar Baramunda Bhubaneswar Khordha Odisha 751003",
                    "locality": "Baramunda",
                    "areaName": "Baramunda",
                    "costForTwo": "50000",
                    "costForTwoMessage": "\u20B9500 FOR TWO",
                    "cuisines": [
                        "Fast Food",
                        "Pizzas"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "794",
                    "sla": {
                        "deliveryTime": 41,
                        "minDeliveryTime": 40,
                        "maxDeliveryTime": 45,
                        "lastMileTravel": 5,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "40-45 MINS",
                        "lastMileTravelString": "5.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT \u20B9119",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "4.3",
                            "ratingCount": "76"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "716628",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "716628",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "920670",
                    "name": "Big Cup Cafe & Restaurant",
                    "city": "57",
                    "slugs": {
                        "restaurant": "big-cup-cafe-&-restaurant-khandagiri-khandagiri",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/4/622103a6-68a0-440d-b667-267acab42e4b_920670.JPG",
                    "address": "Shop No : PLOTNO-1078/110 , Floor : 1 , BIG CUP CAFE, SAMPUR , ",
                    "locality": "SAMPUR",
                    "areaName": "Khandagiri",
                    "costForTwo": "40000",
                    "costForTwoMessage": "\u20B9400 FOR TWO",
                    "cuisines": [
                        "Chinese",
                        "Pizzas",
                        "Burgers",
                        "Cafe"
                    ],
                    "avgRating": 4.7,
                    "feeDetails": {},
                    "avgRatingString": "4.7",
                    "totalRatingsString": "86",
                    "sla": {
                        "deliveryTime": 47,
                        "minDeliveryTime": 45,
                        "maxDeliveryTime": 50,
                        "lastMileTravel": 8.6,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "45-50 MINS",
                        "lastMileTravelString": "8.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                        "visible": true
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV2": {
                        "visible": true
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "920670",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "920670"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "548185",
                    "name": "Biryani Badshah",
                    "city": "57",
                    "slugs": {
                        "restaurant": "biryani-badshah-patia-patia",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "meimzh3k9qvfdo2fe3vk",
                    "address": "HOUSE NO. 301, GROUND FLOOR, DISTRICT CENTER, CHANDRASEKHARPUR, BHUBANESWAR, , ward 9, BHUBANESWAR MUNICIPAL CORPORATION, Orissa-751016",
                    "areaName": "Chandrasekharpur",
                    "costForTwo": "35000",
                    "costForTwoMessage": "\u20B9350 FOR TWO",
                    "cuisines": [
                        "Biryani",
                        "Hyderabadi",
                        "Andhra",
                        "South Indian",
                        "North Indian",
                        "Mughlai",
                        "Kebabs"
                    ],
                    "avgRating": 4.3,
                    "feeDetails": {},
                    "avgRatingString": "4.3",
                    "totalRatingsString": "2.7K+",
                    "sla": {
                        "deliveryTime": 25,
                        "minDeliveryTime": 20,
                        "maxDeliveryTime": 25,
                        "lastMileTravel": 3.8,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "20-25 MINS",
                        "lastMileTravelString": "3.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT \u20B9179",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "548185",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "548185",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "973470",
                    "name": "Sakshata Cafe",
                    "city": "57",
                    "slugs": {
                        "restaurant": "sakshata-cafe-khandagiri-khandagiri",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/10/16/07353551-3e90-4b48-91a5-a2f8ed596546_973470.jpg",
                    "address": "Plot No-42,K7,Kalinga Nagar,Ghatikia,Khandagiri,Bhubaneswar, Kalinga Nagar, Ward 23, BHUBANESWAR MUNICIPAL CORPORATION, Orissa - 751003",
                    "locality": "Khandagiri",
                    "areaName": "Khandagiri",
                    "costForTwo": "20000",
                    "costForTwoMessage": "\u20B9200 FOR TWO",
                    "cuisines": [
                        "Cafe"
                    ],
                    "avgRating": 5,
                    "feeDetails": {},
                    "avgRatingString": "5.0",
                    "totalRatingsString": "4",
                    "sla": {
                        "deliveryTime": 48,
                        "minDeliveryTime": 45,
                        "maxDeliveryTime": 50,
                        "lastMileTravel": 9.9,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "45-50 MINS",
                        "lastMileTravelString": "9.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "\u20B9250 OFF",
                        "subHeader": "ABOVE \u20B9999",
                        "discountTag": "FLAT DEAL",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "973470",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "973470",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "735621",
                    "name": "Bentoz Pizza",
                    "city": "57",
                    "slugs": {
                        "restaurant": "bentoz-pizza---by-warmoven-nayapalli-nayapalli",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "dd841f517c1071baef3aa697d9fe008a",
                    "address": "Plot No 1482, Sastri Nagar, Unit-4, Near SBI Colony, PS Capital, Bhubaneswar, Ward 12, BHUBANESWAR MUNICIPAL CORPORATION, Orissa-751001",
                    "locality": "Sastri nagar",
                    "areaName": "Sahid Nagar",
                    "costForTwo": "50000",
                    "costForTwoMessage": "\u20B9500 FOR TWO",
                    "cuisines": [
                        "Pizzas",
                        "Desserts",
                        "Italian"
                    ],
                    "avgRating": 3.9,
                    "feeDetails": {},
                    "avgRatingString": "3.9",
                    "totalRatingsString": "9",
                    "sla": {
                        "deliveryTime": 27,
                        "minDeliveryTime": 25,
                        "maxDeliveryTime": 30,
                        "lastMileTravel": 1.8,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "25-30 MINS",
                        "lastMileTravelString": "1.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "40% OFF",
                        "subHeader": "UPTO \u20B980",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_4",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "735621",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "735621",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "881905",
                    "name": "The Pizza Project by Oven Story",
                    "city": "57",
                    "slugs": {
                        "restaurant": "the-pizza-project-by-oven-story-technology-corridor-rd-chandrashekarpur",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/8/824f24fd-1c73-4877-99e3-f85305434965_881905.jpg",
                    "address": "17, Technology Corridor Rd, Infocity, Chandrasekharpur, Bhubaneswar, Odisha 751024",
                    "locality": "Technology Corridor Rd",
                    "areaName": "Patia",
                    "costForTwo": "20000",
                    "costForTwoMessage": "\u20B9200 FOR TWO",
                    "cuisines": [
                        "Pizzas",
                        "Italian",
                        "Desserts",
                        "Beverages"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "19",
                    "sla": {
                        "deliveryTime": 38,
                        "minDeliveryTime": 35,
                        "maxDeliveryTime": 40,
                        "lastMileTravel": 6.2,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "35-40 MINS",
                        "lastMileTravelString": "6.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT \u20B989",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "881905",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "881905",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "566517",
                    "name": "Faasos' Signature Wraps & Rolls",
                    "city": "57",
                    "slugs": {
                        "restaurant": "signature-wraps-rolls-by-faasos-patia-chandrashekarpur",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "c583ca6ce40b426797a78ae2ac91f2ec",
                    "address": "17, Technology Corridor Rd, Infocity, Chandrasekharpur, Bhubaneswar, Odisha 751024",
                    "locality": "Technology Corridor Rd",
                    "areaName": "Patia",
                    "costForTwo": "35000",
                    "costForTwoMessage": "\u20B9350 FOR TWO",
                    "cuisines": [
                        "Fast Food",
                        "Snacks",
                        "North Indian",
                        "Desserts",
                        "Beverages"
                    ],
                    "avgRating": 4.6,
                    "feeDetails": {},
                    "avgRatingString": "4.6",
                    "totalRatingsString": "379",
                    "sla": {
                        "deliveryTime": 37,
                        "minDeliveryTime": 35,
                        "maxDeliveryTime": 40,
                        "lastMileTravel": 6.2,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "35-40 MINS",
                        "lastMileTravelString": "6.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO \u20B9100",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "566517",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "566517"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "861589",
                    "name": "Pastas By Pizza Hut",
                    "city": "57",
                    "slugs": {
                        "restaurant": "pastas-by-pizza-hut-ximb-square-patia",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/1/3065f36b-6cfa-4940-8efa-ec0adfe970d3_861589.JPG",
                    "address": "Pizza Hut, XIMB Square, Plot No-P-1 & P-1/A, Jayadev Vihar, Bhubaneswar, Khordha, KHORDHA(EXCEPT MUNICIPAL CORPORATION), Orissa, 751013",
                    "locality": "XIMB Square",
                    "areaName": "Jayadev Vihar",
                    "costForTwo": "40000",
                    "costForTwoMessage": "\u20B9400 FOR TWO",
                    "cuisines": [
                        "Pastas"
                    ],
                    "avgRating": 4.1,
                    "feeDetails": {},
                    "avgRatingString": "4.1",
                    "totalRatingsString": "56",
                    "sla": {
                        "deliveryTime": 27,
                        "minDeliveryTime": 25,
                        "maxDeliveryTime": 30,
                        "lastMileTravel": 1.3,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "25-30 MINS",
                        "lastMileTravelString": "1.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                        "visible": true
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV2": {
                        "visible": true
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "861589",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "861589",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "688306",
                    "name": "Pizza Box",
                    "city": "57",
                    "slugs": {
                        "restaurant": "pizza-box-patia-patia",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "eff8cf705f9d8da14961091d88998168",
                    "address": "CHP-2,LANE-2,KANAN VIHAR PH-1,PATIA,BHUBANESWAR,751017",
                    "locality": "Chandrasekharpur",
                    "areaName": "Chandrashekarpur",
                    "costForTwo": "20000",
                    "costForTwoMessage": "\u20B9200 FOR TWO",
                    "cuisines": [
                        "Pizzas"
                    ],
                    "avgRating": 4.5,
                    "feeDetails": {},
                    "avgRatingString": "4.5",
                    "totalRatingsString": "1.7K+",
                    "sla": {
                        "deliveryTime": 43,
                        "minDeliveryTime": 40,
                        "maxDeliveryTime": 45,
                        "lastMileTravel": 5,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "40-45 MINS",
                        "lastMileTravelString": "5.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "discountTag": "FLAT DEAL",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "688306",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "688306",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "491428",
                    "name": "Divine Inn",
                    "city": "57",
                    "slugs": {
                        "restaurant": "divine-inn-old-bbsr-old-bbsr",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "wjbrf7xup9qndfa44zww",
                    "address": "Plot No. 31/2054/3180(Beside Gangotri Farm House Gate No. 3)Gangotri Nagar Lane No. Sisupalagada Bhubanes Dist:- Khordha  Odisha - 751002",
                    "locality": "Samantarapur",
                    "areaName": "Old BBSR",
                    "costForTwo": "25000",
                    "costForTwoMessage": "\u20B9250 FOR TWO",
                    "cuisines": [
                        "Chinese",
                        "Indian"
                    ],
                    "avgRating": 4.6,
                    "feeDetails": {},
                    "avgRatingString": "4.6",
                    "totalRatingsString": "127",
                    "sla": {
                        "deliveryTime": 53,
                        "minDeliveryTime": 50,
                        "maxDeliveryTime": 55,
                        "lastMileTravel": 10.3,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "50-55 MINS",
                        "lastMileTravelString": "10.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                        "visible": true
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV2": {
                        "visible": true
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "--"
                        }
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "491428",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "restaurant_id": "491428",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false",
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "250916",
                    "name": "Budapest Bake Inn",
                    "city": "57",
                    "slugs": {
                        "restaurant": "budapest-bake--in-khandagiri-khandagiri",
                        "city": "bhubaneswar"
                    },
                    "cloudinaryImageId": "dyb9rmkuadqnhaxwsuoj",
                    "address": "Plot No-1176,Ground Floor,Jagamara,Khandagiri, District - Bhubaneswar Municipal Corporation, State - Orissa - 751030",
                    "locality": "Jagmohan Nagar",
                    "areaName": "Khandagiri",
                    "costForTwo": "25000",
                    "costForTwoMessage": "\u20B9250 FOR TWO",
                    "cuisines": [
                        "Bakery",
                        "Beverages",
                        "Desserts"
                    ],
                    "avgRating": 4.7,
                    "feeDetails": {},
                    "avgRatingString": "4.7",
                    "totalRatingsString": "1.6K+",
                    "sla": {
                        "deliveryTime": 50,
                        "minDeliveryTime": 45,
                        "maxDeliveryTime": 50,
                        "lastMileTravel": 8.8,
                        "serviceability": "SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "slaString": "45-50 MINS",
                        "lastMileTravelString": "8.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "badges": {},
                    "aggregatedDiscountInfoV3": {
                        "header": "10% OFF",
                        "subHeader": "ABOVE \u20B9500",
                        "discountTag": "FLAT DEAL",
                        "logoCtx": {
                            "text": "BENEFITS"
                        }
                    },
                    "ratingSlab": "RATING_SLAB_5",
                    "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {},
                        "commsStyling": {}
                    },
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "externalRatings": {
                        "aggregatedRating": {
                            "rating": "4.6",
                            "ratingCount": "533"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                    },
                    "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                    "featuredSectionInfo": {
                        "sectionTitle": "More"
                    }
                },
                "analytics": {
                    "screenName": "explore",
                    "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                    "objectValue": "250916",
                    "impressionObjectName": "impression-restaurant",
                    "clickObjectName": "click-restaurant"
                },
                "ctaWithParams": {
                    "link": "swiggy://menu",
                    "type": "DEEPLINK",
                    "params": {
                        "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                        "restaurant_id": "250916",
                        "query": "Top Rated Pizza Joints In Bhubaneswar",
                        "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                        "source": "SEARCH",
                        "isSld": "false"
                    }
                }
            }
        }
    }
];
var $0b506194c06561d2$export$2e2bcd8739ae039 = $0b506194c06561d2$var$resData;


const $88d2c9e81e05d815$var$Body = ()=>{
    const [list, setList] = (0, $acw62.useState)([]);
    const [originalList, setOriginalList] = (0, $acw62.useState)([]);
    const [heading, setHeading] = (0, $acw62.useState)("Nearby Restaurants");
    const [searchText, setSearchText] = (0, $acw62.useState)("");
    // const fetchedList = useFetchResList();
    // Update the state when the data is fetched
    (0, $acw62.useEffect)(()=>{
        if ((0, $0b506194c06561d2$export$2e2bcd8739ae039).length > 0) {
            setList((0, $0b506194c06561d2$export$2e2bcd8739ae039));
            setOriginalList((0, $0b506194c06561d2$export$2e2bcd8739ae039));
        }
    }, [
        (0, $0b506194c06561d2$export$2e2bcd8739ae039)
    ]);
    // console.log('printing the reslist',originalList)
    const PromotedLabel = (0, $77ea51d6ba3f5eaa$export$ccb02a230af14023)((0, $77ea51d6ba3f5eaa$export$2e2bcd8739ae039));
    const handleClick = ()=>{
        const searchlist = originalList.filter((res)=>{
            return res.card.card.info.cuisines.join(", ").toLowerCase().includes(searchText.toLowerCase());
        });
        setList(searchlist);
    };
    const handleKeyPress = (e)=>{
        if (e.key === "Enter") handleClick();
    };
    const onlineStatus = (0, $ce95a10ebee058d7$export$2e2bcd8739ae039)();
    if (!onlineStatus) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "offline-page",
        children: [
            "Opps!!! Seems like you are offline. Try reconnecting your internet",
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b32f7dcb0870dac2$export$2e2bcd8739ae039), {})
        ]
    });
    if (list.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $YVclQ.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "body",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "search",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: "search-text w-[80%] xs:w-[40%]",
                        type: "text",
                        placeholder: "Search for restaurant",
                        value: searchText,
                        onChange: (e)=>{
                            setSearchText(e.target.value);
                        },
                        onKeyDown: handleKeyPress
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "search-button",
                        onClick: handleClick,
                        children: "Search"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "btn",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "top-rated-btn",
                    onClick: ()=>{
                        let newResData = originalList.filter((res)=>res.card.card.info.avgRating > 4.5);
                        newResData = newResData.sort((a, b)=>b.card.card.info.avgRating - a.card.card.info.avgRating);
                        setList(newResData);
                        setHeading("Our Top Rated Restaurants");
                    },
                    children: "Top Rated Restaurants"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                children: heading
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "res-container",
                children: list.map((restInfo)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/res/559248",
                        className: "w-[90%] xs:w-auto mx-auto xs:mx-0",
                        children: restInfo.card?.card?.info?.promoted ? /*#__PURE__*/ (0, $ayMG0.jsx)(PromotedLabel, {
                            resData: restInfo
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77ea51d6ba3f5eaa$export$2e2bcd8739ae039), {
                            resData: restInfo
                        })
                    }, restInfo.card?.card?.info?.id))
            })
        ]
    });
};
var $88d2c9e81e05d815$export$2e2bcd8739ae039 = $88d2c9e81e05d815$var$Body;




var $ayMG0 = parcelRequire("ayMG0");

const $8f0cc534f6c9aa78$var$Error = ()=>{
    const err = (0, $5bf6248e1ceb144a$export$ed527bf60f6e05f2)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "error-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Opps something went wrong"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                children: [
                    err.status,
                    " ",
                    err.statusText
                ]
            })
        ]
    });
};
var $8f0cc534f6c9aa78$export$2e2bcd8739ae039 = $8f0cc534f6c9aa78$var$Error;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $18129c3b87767e8f$var$Contact = ()=>{
    const [suggestion, setSuggestion] = (0, $acw62.useState)('');
    const [responseMessage, setResponseMessage] = (0, $acw62.useState)('');
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (suggestion.trim()) {
            setResponseMessage('Thank you for your message!');
            setSuggestion('');
        } else setResponseMessage('Please enter a suggestion before submitting!');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex flex-col items-center justify-center py-8 my-[120px]",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-gray-200 p-6 rounded-lg shadow-lg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "text-2xl font-bold text-center text-gray-800 mb-4",
                    children: "Contact Us"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-gray-700 mb-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Developer Name:"
                                }),
                                " Rahul Yadav"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Email:"
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "mailto:rahulydv1227@gmail.com",
                                    className: "text-blue-600",
                                    children: "rahulydv1227@gmail.com"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Phone:"
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "tel:+918869938463",
                                    className: "text-blue-600",
                                    children: "+91-8869938463"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            htmlFor: "suggestion",
                            className: "block text-gray-700 font-medium",
                            children: "Your Suggestion:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                            id: "suggestion",
                            name: "suggestion",
                            value: suggestion,
                            onChange: (e)=>setSuggestion(e.target.value),
                            rows: "4",
                            className: "w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400",
                            placeholder: "Enter your suggestion here..."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "submit",
                            className: "w-full bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-700 transition",
                            children: "Submit Message"
                        })
                    ]
                }),
                responseMessage && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: `mt-4 ${responseMessage.includes('Thank you') ? 'text-green-600' : 'text-red-600'}`,
                    children: responseMessage
                })
            ]
        })
    });
};
var $18129c3b87767e8f$export$2e2bcd8739ae039 = $18129c3b87767e8f$var$Contact;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $YVclQ = parcelRequire("YVclQ");


var $acw62 = parcelRequire("acw62");

var $4eM2B = parcelRequire("4eM2B");
const $445c636a441ad0f9$var$useResMenu = (id)=>{
    const [resMenu, setResMenu] = (0, $acw62.useState)(null);
    const fetchData = async ()=>{
        try {
            const res = await fetch((0, $4eM2B.MENU_API) + id);
            const data = await res.json();
            setResMenu(data);
        } catch (err) {
            console.log(err);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        id
    ]);
    return resMenu;
};
var $445c636a441ad0f9$export$2e2bcd8739ae039 = $445c636a441ad0f9$var$useResMenu;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4eM2B = parcelRequire("4eM2B");

// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$getPrototypeOf = Object.getPrototypeOf;
function $5f9e38360d79f95a$export$541ac630993a4c84(value) {
    return !!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
}
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || Array.isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = Object.prototype.constructor.toString();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $5f9e38360d79f95a$var$has(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $5f9e38360d79f95a$var$get(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $5f9e38360d79f95a$var$set(thing, propOrOldValue, value) {
    const t = $5f9e38360d79f95a$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5f9e38360d79f95a$var$isMap(target) {
    return target instanceof Map;
}
function $5f9e38360d79f95a$var$isSet(target) {
    return target instanceof Set;
}
function $5f9e38360d79f95a$var$latest(state) {
    return state.copy_ || state.base_;
}
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $5f9e38360d79f95a$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$5f9e38360d79f95a$export$792f3d81ea979f55(value, true));
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
function $5f9e38360d79f95a$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
function $5f9e38360d79f95a$var$getCurrentScope() {
    return $5f9e38360d79f95a$var$currentScope;
}
function $5f9e38360d79f95a$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $5f9e38360d79f95a$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
function $5f9e38360d79f95a$var$enterScope(immer2) {
    return $5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
}
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) {
            result = $5f9e38360d79f95a$var$finalize(scope, result);
            if (!scope.parent_) $5f9e38360d79f95a$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft, []);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value, path) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        $5f9e38360d79f95a$var$each(value, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $5f9e38360d79f95a$var$each(resultEach, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($5f9e38360d79f95a$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$5f9e38360d79f95a$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $5f9e38360d79f95a$var$finalize(rootScope, childValue, path);
        $5f9e38360d79f95a$var$set(targetObject, prop, res);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($5f9e38360d79f95a$export$16e3aed3edb85946(childValue) && !$5f9e38360d79f95a$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $5f9e38360d79f95a$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $5f9e38360d79f95a$var$maybeFreeze(rootScope, childValue);
    }
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            return state.copy_[prop] = $5f9e38360d79f95a$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
$5f9e38360d79f95a$var$each($5f9e38360d79f95a$var$objectTraps, (key, fn)=>{
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin("Patches").applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(value, parent) {
    const draft = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key);
            const value = $5f9e38360d79f95a$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (typeof base !== "object") $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    $5f9e38360d79f95a$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
function $5f9e38360d79f95a$export$c05b21e3257751e5(value) {
    return value;
}
function $5f9e38360d79f95a$export$20f911b3f8cf0b74(value) {
    return value;
}


var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});


// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;



var $hPtJY = parcelRequire("hPtJY");
var $d91034f47eb948f2$var$__defProp = Object.defineProperty;
var $d91034f47eb948f2$var$__defProps = Object.defineProperties;
var $d91034f47eb948f2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d91034f47eb948f2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d91034f47eb948f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d91034f47eb948f2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d91034f47eb948f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $d91034f47eb948f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d91034f47eb948f2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d91034f47eb948f2$var$__hasOwnProp.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    if ($d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(b))if ($d91034f47eb948f2$var$__propIsEnum.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d91034f47eb948f2$var$__spreadProps = (a, b)=>$d91034f47eb948f2$var$__defProps(a, $d91034f47eb948f2$var$__getOwnPropDescs(b));
var $d91034f47eb948f2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d91034f47eb948f2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d91034f47eb948f2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d91034f47eb948f2$var$__publicField = (obj, key, value)=>$d91034f47eb948f2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $375276bea32f9eda$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $d91034f47eb948f2$export$a5d3c27355e35910 = /* @__PURE__ */ $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $375276bea32f9eda$export$8402dc26d96f6902));
var $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d2bed10dff9b4968$export$f672e0b6f7222cd7;
    return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d91034f47eb948f2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $5f9e38360d79f95a$export$16e3aed3edb85946)(val) ? (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d91034f47eb948f2$var$isBoolean(thunk)) middlewareArray.push((0, $44400fc0fe63e7bd$export$dd164f5517779f15));
            else middlewareArray.push((0, $44400fc0fe63e7bd$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
var $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d91034f47eb948f2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $5f9e38360d79f95a$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5f9e38360d79f95a$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
var $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($d91034f47eb948f2$export$23a094319a4b586 || {});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        typeof $hPtJY;
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $d91034f47eb948f2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $d91034f47eb948f2$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $d91034f47eb948f2$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop,
        pending: pending || $d91034f47eb948f2$var$noop,
        rejected: rejected || $d91034f47eb948f2$var$noop,
        settled: settled || $d91034f47eb948f2$var$noop
    });
}
function $d91034f47eb948f2$var$noop() {}
// src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $d91034f47eb948f2$var$isDraftTyped = (0, $5f9e38360d79f95a$export$541ac630993a4c84);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($d91034f47eb948f2$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $d91034f47eb948f2$var$task = "task";
var $d91034f47eb948f2$var$listener = "listener";
var $d91034f47eb948f2$var$completed = "completed";
var $d91034f47eb948f2$var$cancelled = "cancelled";
var $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $d91034f47eb948f2$var$__publicField(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$__publicField(this, "message");
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($d91034f47eb948f2$export$378fa86b259c0280(32));
};
var $d91034f47eb948f2$var$noop2 = ()=>{};
var $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $d91034f47eb948f2$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $d91034f47eb948f2$export$cb1bdac908fed7f(reason);
    }
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop2;
    });
}
var $d91034f47eb948f2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $d91034f47eb948f2$var$assign } = Object;
var $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
var $d91034f47eb948f2$var$alm = "listenerMiddleware";
var $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>$d91034f47eb948f2$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$d91034f47eb948f2$var$abortControllerWithReason(childAbortController, $d91034f47eb948f2$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop2));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                $d91034f47eb948f2$var$abortControllerWithReason(childAbortController, $d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
var $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
var $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d91034f47eb948f2$var$createListenerEntry = /* @__PURE__ */ $d91034f47eb948f2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
var $d91034f47eb948f2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $d91034f47eb948f2$var$abortControllerWithReason(controller, $d91034f47eb948f2$var$listenerCancelled);
    });
};
var $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($d91034f47eb948f2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $d91034f47eb948f2$export$f03a6b845d3fb58b = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
var $d91034f47eb948f2$export$b1b8022855fb2b71 = /* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
var $d91034f47eb948f2$export$b03e9483f936dccb = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
var $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
var $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options)) != null ? _a : $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $d91034f47eb948f2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $d91034f47eb948f2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $d91034f47eb948f2$var$abortControllerWithReason(controller, $d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $d91034f47eb948f2$var$abortControllerWithReason(internalTaskController, $d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $d91034f47eb948f2$var$abortControllerWithReason(internalTaskController, $d91034f47eb948f2$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $d2bed10dff9b4968$export$b956e38827fca970)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $d91034f47eb948f2$var$getOrInsertComputed(middlewareMap, middleware2, $d91034f47eb948f2$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $d91034f47eb948f2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
var $d91034f47eb948f2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d91034f47eb948f2$var$createStateProxy = (state, reducerMap)=>$d91034f47eb948f2$var$getOrInsertComputed($d91034f47eb948f2$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const reducer = reducerMap[prop.toString()];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $d91034f47eb948f2$var$original = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
var $d91034f47eb948f2$var$noopReducer = (state = {})=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $hPtJY;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $32f12e1398bb8790$var$cartSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'cart',
    initialState: {
        items: []
    },
    reducers: {
        addItem: (state, action)=>{
            state.items.push(action.payload);
        },
        removeItem: (state, action)=>{
            state.items.pop();
        },
        clearCart: (state, action)=>{
            state.items.length = 0;
        }
    }
});
const { addItem: $32f12e1398bb8790$export$fb9705de59d96855, removeItem: $32f12e1398bb8790$export$fe2d9b4e03920b4c, clearCart: $32f12e1398bb8790$export$810121176e3e3671 } = $32f12e1398bb8790$var$cartSlice.actions;
var $32f12e1398bb8790$export$2e2bcd8739ae039 = $32f12e1398bb8790$var$cartSlice.reducer;



var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


"use client";
function $b00d3e7401eac195$var$Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
$b00d3e7401eac195$var$Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var $b00d3e7401eac195$var$L = (t)=>typeof t == "number" && !isNaN(t), $b00d3e7401eac195$var$N = (t)=>typeof t == "string", $b00d3e7401eac195$var$P = (t)=>typeof t == "function", $b00d3e7401eac195$var$mt = (t)=>$b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$L(t), $b00d3e7401eac195$var$B = (t)=>$b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$P(t) ? t : null, $b00d3e7401eac195$var$pt = (t, o)=>t === !1 || $b00d3e7401eac195$var$L(t) && t > 0 ? t : o, $b00d3e7401eac195$var$z = (t)=>(0, $acw62.isValidElement)(t) || $b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$P(t) || $b00d3e7401eac195$var$L(t);
function $b00d3e7401eac195$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $b00d3e7401eac195$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, $acw62.useRef)(0);
        return (0, $acw62.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, $acw62.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? $b00d3e7401eac195$export$184cca501f1aed7f(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, a);
    };
}
function $b00d3e7401eac195$var$J(t, o) {
    return {
        content: $b00d3e7401eac195$var$tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $b00d3e7401eac195$var$tt(t, o, e = !1) {
    return (0, $acw62.isValidElement)(t) && !$b00d3e7401eac195$var$N(t.type) ? (0, $acw62.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $b00d3e7401eac195$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $b00d3e7401eac195$var$yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $b00d3e7401eac195$var$gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $b00d3e7401eac195$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var $b00d3e7401eac195$var$Xt = 1, $b00d3e7401eac195$var$at = ()=>`${$b00d3e7401eac195$var$Xt++}`;
function $b00d3e7401eac195$var$_t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($b00d3e7401eac195$var$J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([D, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $b00d3e7401eac195$var$B(n.className || d.toastClassName),
                progressClassName: $b00d3e7401eac195$var$B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : $b00d3e7401eac195$var$pt(n.autoClose, d.autoClose),
                closeToast (D) {
                    c.get(u).removalReason = D, E(u);
                },
                deleteToast () {
                    let D = c.get(u);
                    if (D != null) {
                        if (e($b00d3e7401eac195$var$J(D, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || $b00d3e7401eac195$var$z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $b00d3e7401eac195$var$z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : $b00d3e7401eac195$var$L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var $b00d3e7401eac195$var$I = new Map, $b00d3e7401eac195$var$F = [], $b00d3e7401eac195$var$st = new Set, $b00d3e7401eac195$var$Vt = (t)=>$b00d3e7401eac195$var$st.forEach((o)=>o(t)), $b00d3e7401eac195$var$bt = ()=>$b00d3e7401eac195$var$I.size > 0;
function $b00d3e7401eac195$var$Qt() {
    $b00d3e7401eac195$var$F.forEach((t)=>$b00d3e7401eac195$var$nt(t.content, t.options)), $b00d3e7401eac195$var$F = [];
}
var $b00d3e7401eac195$var$vt = (t, { containerId: o })=>{
    var e;
    return (e = $b00d3e7401eac195$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $b00d3e7401eac195$var$X(t, o) {
    var r;
    if (o) return !!((r = $b00d3e7401eac195$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $b00d3e7401eac195$var$I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function $b00d3e7401eac195$var$ht(t) {
    if (!$b00d3e7401eac195$var$bt()) {
        $b00d3e7401eac195$var$F = $b00d3e7401eac195$var$F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $b00d3e7401eac195$var$mt(t)) $b00d3e7401eac195$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $b00d3e7401eac195$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $b00d3e7401eac195$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $b00d3e7401eac195$var$Ct = (t = {})=>{
    $b00d3e7401eac195$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $b00d3e7401eac195$var$nt(t, o) {
    $b00d3e7401eac195$var$z(t) && ($b00d3e7401eac195$var$bt() || $b00d3e7401eac195$var$F.push({
        content: t,
        options: o
    }), $b00d3e7401eac195$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $b00d3e7401eac195$var$xt(t) {
    var o;
    (o = $b00d3e7401eac195$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $b00d3e7401eac195$var$rt(t, o) {
    $b00d3e7401eac195$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $b00d3e7401eac195$var$Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $b00d3e7401eac195$var$_t(o, t, $b00d3e7401eac195$var$Vt);
            $b00d3e7401eac195$var$I.set(o, r);
            let s = r.observe(e);
            return $b00d3e7401eac195$var$Qt(), ()=>{
                s(), $b00d3e7401eac195$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $b00d3e7401eac195$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $b00d3e7401eac195$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $b00d3e7401eac195$var$Pt(t) {
    return $b00d3e7401eac195$var$st.add(t), ()=>{
        $b00d3e7401eac195$var$st.delete(t);
    };
}
function $b00d3e7401eac195$var$Wt(t) {
    return t && ($b00d3e7401eac195$var$N(t.toastId) || $b00d3e7401eac195$var$L(t.toastId)) ? t.toastId : $b00d3e7401eac195$var$at();
}
function $b00d3e7401eac195$var$U(t, o) {
    return $b00d3e7401eac195$var$nt(t, o), o.toastId;
}
function $b00d3e7401eac195$var$V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $b00d3e7401eac195$var$Wt(o)
    };
}
function $b00d3e7401eac195$var$Q(t) {
    return (o, e)=>$b00d3e7401eac195$var$U(o, $b00d3e7401eac195$var$V(t, e));
}
function $b00d3e7401eac195$export$b410431fab84fa58(t, o) {
    return $b00d3e7401eac195$var$U(t, $b00d3e7401eac195$var$V("default", o));
}
$b00d3e7401eac195$export$b410431fab84fa58.loading = (t, o)=>$b00d3e7401eac195$var$U(t, $b00d3e7401eac195$var$V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $b00d3e7401eac195$var$Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = $b00d3e7401eac195$var$N(o) ? $b00d3e7401eac195$export$b410431fab84fa58.loading(o, s) : $b00d3e7401eac195$export$b410431fab84fa58.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            $b00d3e7401eac195$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = $b00d3e7401eac195$var$N(g) ? {
            render: g
        } : g;
        return l ? $b00d3e7401eac195$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $b00d3e7401eac195$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $b00d3e7401eac195$var$P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
$b00d3e7401eac195$export$b410431fab84fa58.promise = $b00d3e7401eac195$var$Gt;
$b00d3e7401eac195$export$b410431fab84fa58.success = $b00d3e7401eac195$var$Q("success");
$b00d3e7401eac195$export$b410431fab84fa58.info = $b00d3e7401eac195$var$Q("info");
$b00d3e7401eac195$export$b410431fab84fa58.error = $b00d3e7401eac195$var$Q("error");
$b00d3e7401eac195$export$b410431fab84fa58.warning = $b00d3e7401eac195$var$Q("warning");
$b00d3e7401eac195$export$b410431fab84fa58.warn = $b00d3e7401eac195$export$b410431fab84fa58.warning;
$b00d3e7401eac195$export$b410431fab84fa58.dark = (t, o)=>$b00d3e7401eac195$var$U(t, $b00d3e7401eac195$var$V("default", {
        theme: "dark",
        ...o
    }));
function $b00d3e7401eac195$var$qt(t) {
    $b00d3e7401eac195$var$ht(t);
}
$b00d3e7401eac195$export$b410431fab84fa58.dismiss = $b00d3e7401eac195$var$qt;
$b00d3e7401eac195$export$b410431fab84fa58.clearWaitingQueue = $b00d3e7401eac195$var$Ct;
$b00d3e7401eac195$export$b410431fab84fa58.isActive = $b00d3e7401eac195$var$X;
$b00d3e7401eac195$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $b00d3e7401eac195$var$vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $b00d3e7401eac195$var$at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, $b00d3e7401eac195$var$U(a, l);
    }
};
$b00d3e7401eac195$export$b410431fab84fa58.done = (t)=>{
    $b00d3e7401eac195$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$b00d3e7401eac195$export$b410431fab84fa58.onChange = $b00d3e7401eac195$var$Pt;
$b00d3e7401eac195$export$b410431fab84fa58.play = (t)=>$b00d3e7401eac195$var$rt(!0, t);
$b00d3e7401eac195$export$b410431fab84fa58.pause = (t)=>$b00d3e7401eac195$var$rt(!1, t);
function $b00d3e7401eac195$var$It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $acw62.useRef)($b00d3e7401eac195$var$Et(t)).current;
    r(t);
    let s = (a = (0, $acw62.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $b00d3e7401eac195$var$X,
        count: s == null ? void 0 : s.length
    };
}
function $b00d3e7401eac195$var$At(t) {
    let [o, e] = (0, $acw62.useState)(!1), [r, s] = (0, $acw62.useState)(!1), l = (0, $acw62.useRef)(null), a = (0, $acw62.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $b00d3e7401eac195$var$xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $acw62.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $b00d3e7401eac195$var$Ot = typeof window != "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $b00d3e7401eac195$var$G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $b00d3e7401eac195$var$ao(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $b00d3e7401eac195$var$so(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $b00d3e7401eac195$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $b00d3e7401eac195$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $b00d3e7401eac195$var$io() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $b00d3e7401eac195$export$4f13f83fd8bb1dac = {
    info: $b00d3e7401eac195$var$so,
    warning: $b00d3e7401eac195$var$ao,
    success: $b00d3e7401eac195$var$no,
    error: $b00d3e7401eac195$var$ro,
    spinner: $b00d3e7401eac195$var$io
}, $b00d3e7401eac195$var$lo = (t)=>t in $b00d3e7401eac195$export$4f13f83fd8bb1dac;
function $b00d3e7401eac195$var$Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($b00d3e7401eac195$var$P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, $acw62.isValidElement)(r) ? s = (0, $acw62.cloneElement)(r, l) : e ? s = $b00d3e7401eac195$export$4f13f83fd8bb1dac.spinner() : $b00d3e7401eac195$var$lo(o) && (s = $b00d3e7401eac195$export$4f13f83fd8bb1dac[o](l))), s;
}
var $b00d3e7401eac195$var$wt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = $b00d3e7401eac195$var$At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, D = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = $b00d3e7401eac195$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: D
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(D, E), ft = $b00d3e7401eac195$var$Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || ($b00d3e7401eac195$var$P(a) ? H = a(j) : (0, $acw62.isValidElement)(a) ? H = (0, $acw62.cloneElement)(a, j) : H = $b00d3e7401eac195$var$yt(j)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), $b00d3e7401eac195$var$tt(d, t, !o), H, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var $b00d3e7401eac195$var$K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $b00d3e7401eac195$export$d20e79fdc3899e95 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("bounce", !0)), $b00d3e7401eac195$export$d8dc01b5c85a37b9 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("slide", !0)), $b00d3e7401eac195$export$65cfd44a2050f99 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("zoom")), $b00d3e7401eac195$export$4d2fae537bd90431 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("flip"));
var $b00d3e7401eac195$var$_o = {
    position: "top-right",
    transition: $b00d3e7401eac195$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $b00d3e7401eac195$export$f2815235e76a62b9(t) {
    let o = {
        ...$b00d3e7401eac195$var$_o,
        ...t
    }, e = t.stacked, [r, s] = (0, $acw62.useState)(!0), l = (0, $acw62.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = $b00d3e7401eac195$var$It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $b00d3e7401eac195$var$P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(p, $b00d3e7401eac195$var$B(T));
    }
    function E() {
        e && (s(!0), $b00d3e7401eac195$export$b410431fab84fa58.play());
    }
    return $b00d3e7401eac195$var$Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $acw62.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), $b00d3e7401eac195$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), $b00d3e7401eac195$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), $b00d3e7401eac195$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$wt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}



const $13dafc1ce41e6291$var$ResMenuItems = ({ itemdata: itemdata = [] })=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleClick = (item)=>{
        dispatch((0, $32f12e1398bb8790$export$fb9705de59d96855)(item));
        (0, $b00d3e7401eac195$export$b410431fab84fa58).success("Item added successfully!", {
            position: "top-center",
            autoClose: 700
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-2 xs:gap-3 max-w-[95%] xs:max-w-[85%] sm:max-w-[75%] md:max-w-6/12 mx-auto",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {}),
            " ",
            itemdata.map((item, index)=>{
                const name = item?.card?.info?.name || "Unnamed Item";
                const description = item?.card?.info?.description || "No description available.";
                const price = (item?.card?.info?.price || item?.card?.info?.defaultPrice || 0) / 100;
                const imageId = item?.card?.info?.imageId || "";
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between items-center p-2 xs:p-3 sm:p-5 border border-gray-200 rounded-lg bg-white shadow-md hover:shadow-lg transition duration-300",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex-1 min-w-0 pr-2 xs:pr-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "font-bold text-sm xs:text-base sm:text-lg truncate text-gray-800",
                                    children: name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-gray-600 text-xs xs:text-sm sm:text-base line-clamp-2 mt-1",
                                    children: description
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "text-green-600 font-semibold text-xs xs:text-sm sm:text-base mt-2",
                                    children: [
                                        "\u20B9",
                                        price
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "relative w-[50px] h-[50px] xs:w-[80px] xs:h-[80px] sm:w-[100px] sm:h-[100px] flex-shrink-0",
                            children: [
                                imageId ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: `${(0, $4eM2B.CDN_URL)}${imageId}`,
                                    alt: name,
                                    className: "w-full h-full object-cover rounded"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w-full h-full bg-gray-200 rounded flex items-center justify-center text-gray-500 text-xs",
                                    children: "No Image"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "absolute bottom-0 xs:bottom-2 left-1/2 transform -translate-x-1/2 px-2 xs:px-3 py-1 xs:py-2 text-xs xs:text-sm sm:text-base bg-blue-500 text-white font-semibold rounded shadow hover:bg-blue-600 transition duration-300",
                                    onClick: ()=>handleClick(item),
                                    "aria-label": `Add ${name} to cart`,
                                    children: "Add"
                                })
                            ]
                        })
                    ]
                }, index);
            })
        ]
    });
};
var $13dafc1ce41e6291$export$2e2bcd8739ae039 = $13dafc1ce41e6291$var$ResMenuItems;


const $88c187899ad2ae99$var$ResMenuHeader = ({ category: category, showIndex: showIndex, setShowIndex: setShowIndex })=>{
    const handleClick = ()=>{
        setShowIndex();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col flex-wrap border-b-2 border-gray-200",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-center text-black text-xl p-4 cursor-pointer",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            category.title,
                            " (",
                            category.itemCards?.length || 0,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: showIndex ? "\u2B06\uFE0F" : "\u2B07\uFE0F"
                    })
                ]
            }),
            showIndex && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg-gray-100 p-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13dafc1ce41e6291$export$2e2bcd8739ae039), {
                    itemdata: category.itemCards
                })
            })
        ]
    });
};
var $88c187899ad2ae99$export$2e2bcd8739ae039 = $88c187899ad2ae99$var$ResMenuHeader;


const $4801adf787b4d484$var$menu = [
    // 20241225224258
    // https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=20.2959847&lng=85.8246101&restaurantId=559248
    {
        "statusCode": 0,
        "data": {
            "statusMessage": "done successfully",
            "cards": [
                {
                    "card": {
                        "card": {
                            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
                            "text": "Domino's Pizza",
                            "headerStyling": {
                                "textColor": "text_Highest_Emphasis",
                                "textVariant": "header_H3_Black"
                            }
                        }
                    }
                },
                {
                    "card": {
                        "card": {
                            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
                            "tabs": [
                                {
                                    "id": "Order Online",
                                    "title": "Order Online"
                                }
                            ]
                        }
                    }
                },
                {
                    "card": {
                        "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                            "info": {
                                "id": "559248",
                                "name": "Domino's Pizza",
                                "city": "Bhubaneswar",
                                "slugs": {
                                    "restaurant": "dominos-pizza-pal-heights-sahid-nagar",
                                    "city": "bhubaneswar"
                                },
                                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/11/29/31c3b0a6-17ff-4afd-8c96-7b9a7aba1e51_559248.jpg",
                                "locality": "Jayadev Vihar",
                                "areaName": "Saheed Nagar",
                                "costForTwo": "40000",
                                "costForTwoMessage": "\u20B9400 for two",
                                "cuisines": [
                                    "Pizzas",
                                    "Italian"
                                ],
                                "avgRating": 4.5,
                                "feeDetails": {
                                    "restaurantId": "559248",
                                    "icon": "dominos_cod_xc6inc"
                                },
                                "parentId": "2456",
                                "avgRatingString": "4.5",
                                "totalRatingsString": "1.7K+ ratings",
                                "sla": {
                                    "restaurantId": "559248",
                                    "deliveryTime": 25,
                                    "minDeliveryTime": 20,
                                    "maxDeliveryTime": 25,
                                    "lastMileTravel": 0.4,
                                    "serviceability": "SERVICEABLE",
                                    "rainMode": "RAIN_MODE_LIGHT",
                                    "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                                    "zoneId": 692,
                                    "slaString": "20-25 MINS",
                                    "lastMileTravelString": "0.4 km",
                                    "iconType": "ICON_TYPE_EMPTY"
                                },
                                "availability": {
                                    "nextCloseTime": "2024-12-26 02:57:00",
                                    "visibility": true,
                                    "opened": true,
                                    "restaurantClosedMeta": {}
                                },
                                "aggregatedDiscountInfo": {
                                    "header": "Get items under 89",
                                    "shortDescriptionList": [
                                        {
                                            "meta": "Get items under 89",
                                            "discountType": "FinalPrice",
                                            "operationType": "RESTAURANT"
                                        },
                                        {
                                            "meta": "Flat \u20B9200 off on orders above \u20B91099",
                                            "discountType": "Flat",
                                            "operationType": "RESTAURANT"
                                        }
                                    ],
                                    "descriptionList": [
                                        {
                                            "meta": "Get items under 89",
                                            "discountType": "FinalPrice",
                                            "operationType": "RESTAURANT"
                                        },
                                        {
                                            "meta": "Flat \u20B9200 off on orders above \u20B91099| Use code CELEBRATION",
                                            "discountType": "Flat",
                                            "operationType": "RESTAURANT"
                                        }
                                    ],
                                    "visible": true
                                },
                                "badges": {},
                                "slugString": "dominos-pizza-pal-heights-sahid-nagar",
                                "isOpen": true,
                                "labels": [
                                    {
                                        "title": "Timings",
                                        "message": "null"
                                    },
                                    {
                                        "title": "Address",
                                        "message": "First Floor, PAL Heights, J/7, Jayadev Vihar,Bhubaneswar 751013, Odisha"
                                    },
                                    {
                                        "title": "Cuisines",
                                        "message": "Pizzas,Italian"
                                    }
                                ],
                                "totalRatings": 1700,
                                "aggregatedDiscountInfoV2": {
                                    "header": "Get items under 89",
                                    "shortDescriptionList": [
                                        {
                                            "meta": "Get items under 89",
                                            "discountType": "FinalPrice",
                                            "operationType": "RESTAURANT"
                                        },
                                        {
                                            "meta": "Flat \u20B9200 off on orders above \u20B91099",
                                            "discountType": "Flat",
                                            "operationType": "RESTAURANT"
                                        }
                                    ],
                                    "descriptionList": [
                                        {
                                            "meta": "Get items under 89",
                                            "discountType": "FinalPrice",
                                            "operationType": "RESTAURANT"
                                        },
                                        {
                                            "meta": "Flat \u20B9200 off on orders above \u20B91099| Use code CELEBRATION",
                                            "discountType": "Flat",
                                            "operationType": "RESTAURANT"
                                        }
                                    ],
                                    "couponDetailsCta": "View coupon details"
                                },
                                "type": "F",
                                "nudgeBanners": [
                                    {
                                        "minValue": 769,
                                        "maxValue": 1099,
                                        "priority": 4,
                                        "couponCode": "CELEBRATIONS",
                                        "discountInfo": {
                                            "discountType": "Flat",
                                            "value": 200
                                        },
                                        "lockedMessage": "Add items worth \u20B9<amount> to save \u20B9200 | Code CELEBRATIONS",
                                        "unlockedMessage": "CELEBRATIONS Coupon Unlocked! Use it to save \u20B9200",
                                        "logoCtx": {}
                                    },
                                    {
                                        "minValue": 1749,
                                        "maxValue": 2499,
                                        "priority": 5,
                                        "couponCode": "XTRAPARTY",
                                        "discountInfo": {
                                            "discountType": "Percentage",
                                            "value": 20
                                        },
                                        "lockedMessage": "Add items worth \u20B9<amount> to unlock flat 20% off | Code XTRAPARTY",
                                        "unlockedMessage": "XTRAPARTY Coupon Unlocked! Use it to save flat 20% off",
                                        "logoCtx": {}
                                    }
                                ],
                                "headerBanner": {
                                    "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/559248"
                                },
                                "ratingSlab": "RATING_SLAB_5",
                                "orderabilityCommunication": {
                                    "title": {},
                                    "subTitle": {},
                                    "message": {},
                                    "customIcon": {},
                                    "commsStyling": {}
                                },
                                "hasBestsellerItems": true,
                                "cartOrderabilityNudgeBanner": {
                                    "parameters": {},
                                    "presentation": {}
                                },
                                "latLong": "20.299203,85.823148",
                                "backgroundImageOverlayInfo": {},
                                "featuredSectionInfo": {}
                            },
                            "analytics": {}
                        }
                    }
                },
                {
                    "card": {
                        "card": {
                            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                            "layout": {
                                "rows": 1,
                                "columns": 5,
                                "horizontalScrollEnabled": true,
                                "itemSpacing": 12,
                                "lineSpacing": 10,
                                "widgetPadding": {},
                                "containerStyle": {
                                    "containerPadding": {
                                        "left": 10,
                                        "right": 10
                                    }
                                },
                                "scrollBar": {
                                    "scrollThumbColor": "#E46D47",
                                    "scrollTrackColor": "#e4e4e4",
                                    "width": 54,
                                    "height": 4,
                                    "scrollStyling": {
                                        "padding": {
                                            "top": 20,
                                            "bottom": 20
                                        }
                                    }
                                }
                            },
                            "id": "offerCollectionWidget",
                            "gridElements": {
                                "infoWithStyle": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                                    "offers": [
                                        {
                                            "info": {
                                                "header": "ITEMS AT \u20B989",
                                                "offerTag": "DEAL OF DAY",
                                                "offerTagColor": "#E46D47",
                                                "offerIds": [
                                                    "52e79f9e-aa2a-4de7-8224-9a004d3bffc0"
                                                ],
                                                "expiryTime": "1970-01-01T05:16:08Z",
                                                "description": "ON SELECT ITEMS |",
                                                "offerType": "offers",
                                                "restId": "559248",
                                                "offerLogo": "offers/deal-of-day",
                                                "descriptionTextColor": "#7302060C",
                                                "showExpiryTimer": true
                                            },
                                            "cta": {
                                                "type": "OFFER_HALF_CARD"
                                            }
                                        },
                                        {
                                            "info": {
                                                "header": "FLAT \u20B9200 OFF",
                                                "offerTag": "FLAT DEAL",
                                                "offerTagColor": "#E46D47",
                                                "offerIds": [
                                                    "9e068ff6-faeb-42c9-b158-02aa5ddb59d2"
                                                ],
                                                "expiryTime": "1970-01-01T00:00:00Z",
                                                "couponCode": "USE CELEBRATIONS",
                                                "description": "ABOVE \u20B91099",
                                                "offerType": "offers",
                                                "restId": "559248",
                                                "offerLogo": "offers/generic",
                                                "descriptionTextColor": "#7302060C"
                                            },
                                            "cta": {
                                                "type": "OFFER_HALF_CARD"
                                            }
                                        },
                                        {
                                            "info": {
                                                "header": "FLAT 20% OFF",
                                                "offerTag": "FLAT DEAL",
                                                "offerTagColor": "#E46D47",
                                                "offerIds": [
                                                    "d7861ccc-57b9-4444-83b5-5e49e0b9ea88"
                                                ],
                                                "expiryTime": "1970-01-01T00:00:00Z",
                                                "couponCode": "USE XTRAPARTY",
                                                "description": "ABOVE \u20B92499",
                                                "offerType": "offers",
                                                "restId": "559248",
                                                "offerLogo": "offers/generic",
                                                "descriptionTextColor": "#7302060C"
                                            },
                                            "cta": {
                                                "type": "OFFER_HALF_CARD"
                                            }
                                        },
                                        {
                                            "info": {
                                                "header": "15% OFF UPTO \u20B9150",
                                                "offerTagColor": "#E46D47",
                                                "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/12/18/3af21c4c-e42a-4ed7-93f0-53458f60edda_HSBC.png",
                                                "offerIds": [
                                                    "773fb69b-3a7c-4bfe-a4b1-5ab0fa7ca8dd"
                                                ],
                                                "expiryTime": "1970-01-01T00:00:00Z",
                                                "couponCode": "USE HSBCDELIGHTS",
                                                "description": "ABOVE \u20B9499",
                                                "offerType": "offers",
                                                "restId": "559248",
                                                "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/12/18/3af21c4c-e42a-4ed7-93f0-53458f60edda_HSBC.png",
                                                "descriptionTextColor": "#7302060C"
                                            },
                                            "cta": {
                                                "type": "OFFER_HALF_CARD"
                                            }
                                        },
                                        {
                                            "info": {
                                                "header": "10% OFF UPTO \u20B9150",
                                                "offerTagColor": "#E46D47",
                                                "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/11/30/3125048a-92eb-48ea-991c-fd25fe159d24_HSBC.png",
                                                "offerIds": [
                                                    "f2aa5806-6b90-43c8-9c37-8cd046879568"
                                                ],
                                                "expiryTime": "1970-01-01T00:00:00Z",
                                                "couponCode": "USE HSBCFEST",
                                                "description": "ABOVE \u20B9499",
                                                "offerType": "offers",
                                                "restId": "559248",
                                                "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/11/30/3125048a-92eb-48ea-991c-fd25fe159d24_HSBC.png",
                                                "descriptionTextColor": "#7302060C"
                                            },
                                            "cta": {
                                                "type": "OFFER_HALF_CARD"
                                            }
                                        }
                                    ],
                                    "habitMilestoneInfo": {
                                        "callout": {}
                                    },
                                    "loyaltyDiscoverPresentationInfo": {
                                        "logoCtx": {}
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "card": {
                        "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
                            "tabs": [
                                {
                                    "id": "REGULAR",
                                    "title": "Full Menu",
                                    "selected": true,
                                    "analytics": {},
                                    "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                                    "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                                }
                            ]
                        }
                    }
                },
                {
                    "groupedCard": {
                        "cardGroupMap": {
                            "REGULAR": {
                                "cards": [
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                                                "badges": {},
                                                "vegOnlyDetails": {
                                                    "imageId": "AutoVegOnly_qkjowj",
                                                    "title": "Showing only vegetarian options.",
                                                    "description": "Tap on the VEG ONLY button to turn off the setting"
                                                },
                                                "topRatedFilter": {
                                                    "attributes": {
                                                        "displayText": "Ratings 4.0+"
                                                    }
                                                },
                                                "kidsCategoryFilter": {
                                                    "attributes": {
                                                        "displayText": "Kids Favourites",
                                                        "tooltip": {
                                                            "enabled": true,
                                                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                                                        }
                                                    }
                                                },
                                                "vegFilter": {
                                                    "attributes": {
                                                        "displayText": "VEG"
                                                    },
                                                    "isSelected": true
                                                },
                                                "nonvegFilter": {
                                                    "attributes": {
                                                        "displayText": "NONVEG"
                                                    }
                                                }
                                            },
                                            "relevance": {
                                                "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                                                "sectionId": "MENU_FILTER_TOGGLE"
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                                                "title": "Top Picks",
                                                "carousel": [
                                                    {
                                                        "type": "TopCarousel",
                                                        "subtype": "image",
                                                        "bannerId": "4134126",
                                                        "creativeId": "TopPicks/FmC1",
                                                        "title": "Farmhouse Cheese Burst",
                                                        "description": "  ",
                                                        "fontColor": "#FFFFFF",
                                                        "dish": {
                                                            "info": {
                                                                "id": "153334589",
                                                                "name": "Farmhouse Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion, capsicum, tomato & grilled mushroom",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/75e4a60b-8bec-47ab-90c9-b4e70df170d7_06d705be-4b9f-4e93-b1cb-5c97123bfb12.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617947",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661297",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661298",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661299",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661300",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617948",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661301",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661302",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661298"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661298"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661299"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661299"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661300"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661300"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661297"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661297"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882388",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882389",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882392",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882394",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882396",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882399",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "type": "TopCarousel",
                                                        "subtype": "image",
                                                        "bannerId": "4134637",
                                                        "creativeId": "TopPicks/ICTB3",
                                                        "title": "Indi Chicken Tikka Cheese Burst",
                                                        "description": "  ",
                                                        "fontColor": "#FFFFFF",
                                                        "dish": {
                                                            "info": {
                                                                "id": "153334573",
                                                                "name": "Indi Chicken Tikka Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with wholesome flavour of tandoori masala topped with Chicken tikka, onion, red paprika & mint mayo",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/6b860839-56b2-4729-a0cb-ab5086fa49d4_5cac9a1b-ed2c-4a95-bb30-8586499e4f01.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617916",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661194",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661197",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661199",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661200",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617917",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661202",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661203",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661200"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661194"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661194"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661197"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661197"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661199"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661199"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661200"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882297",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882298",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882300",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882302",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882303",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882304",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 45400,
                                                                "ribbon": {},
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "type": "TopCarousel",
                                                        "subtype": "image",
                                                        "bannerId": "4149788",
                                                        "creativeId": "TopPicks/MGaC4",
                                                        "title": "Mini Garlic Cheesiken Rice",
                                                        "description": "  ",
                                                        "fontColor": "#FFFFFF",
                                                        "dish": {
                                                            "info": {
                                                                "id": "155058597",
                                                                "name": "Mini Garlic Cheesiken Rice",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Juicy Chicken| Creamy Garlic Sauce| Molten Cheese with Rice & Veggies - Onion, Jalapeno & Capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/18/198338bb-6f4f-4be5-a34b-cd4d16c7aea2_d93f02a0-fecb-4274-8788-4832d15be689.jpg",
                                                                "inStock": 1,
                                                                "price": 10900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "type": "TopCarousel",
                                                        "subtype": "image",
                                                        "bannerId": "4136990",
                                                        "creativeId": "TopPicks/ChM4",
                                                        "title": "Choco Lava Cake Gift Hamper",
                                                        "description": "  ",
                                                        "fontColor": "#FFFFFF",
                                                        "dish": {
                                                            "info": {
                                                                "id": "151984660",
                                                                "name": "Choco Lava Cake Gift Hamper",
                                                                "category": "DESSERTS",
                                                                "description": "Dive into the ultimate dessert experience with our Lavalicious Combo that\u2019s Made to Share. \n*We don't include a spoon or napkin to support sustainability",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/29/d5e06efa-1d18-4955-b228-d59f8be72347_1a9248a1-9e49-49d7-bb98-3e75101a2de4.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 34500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "type": "TopCarousel",
                                                        "subtype": "image",
                                                        "bannerId": "4135925",
                                                        "creativeId": "TopPicks/CChV6",
                                                        "title": "Corn & Cheese Volcano",
                                                        "description": "  ",
                                                        "fontColor": "#FFFFFF",
                                                        "dish": {
                                                            "info": {
                                                                "id": "146311239",
                                                                "name": "Corn & Cheese Volcano",
                                                                "category": "Cheese Volcano",
                                                                "description": "Centre loaded with Molten Cheese & topped with juicy Golden Corn\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/375ae4df-de00-4235-97c5-3de32ebd969c_c7ea4a4e-86a9-467b-a42d-13e058670d28.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "48415148",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "152760277",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "48415149",
                                                                                        "variationId": "152760278"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "48415149",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "152760278",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium Plus",
                                                                                    "id": "152760279",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415148",
                                                                                    "variationId": "152760277"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415149",
                                                                                    "variationId": "152760278"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101498"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101486"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101500"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101494"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101487"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101502"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101490"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101504"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101485"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101509"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101488"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101489"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101503"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101491"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101505"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969690",
                                                                                    "addonId": "121101480"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415148",
                                                                                    "variationId": "152760277"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415149",
                                                                                    "variationId": "152760279"
                                                                                }
                                                                            ],
                                                                            "price": 52900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101506"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101481"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101493"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101483"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101507"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101478"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101501"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101496"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101497"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101492"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101482"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101508"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101484"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101479"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101495"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969694",
                                                                                    "addonId": "121101499"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "176969690",
                                                                        "groupName": "Extra Cheese Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101480",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969691",
                                                                        "groupName": "Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101498",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101486",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101500",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101494",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101487",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101502",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101490",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101504",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969692",
                                                                        "groupName": "Non-Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101485",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101509",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101488",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101489",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101503",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101491",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101505",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969693",
                                                                        "groupName": "Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101506",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101481",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101493",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101483",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101507",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101478",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101501",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101496",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969694",
                                                                        "groupName": "Extra Cheese Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101499",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969695",
                                                                        "groupName": "Non-Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101497",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101492",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101482",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101508",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101484",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101479",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101495",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "type": "TopCarousel",
                                                        "subtype": "image",
                                                        "bannerId": "4153187",
                                                        "creativeId": "TopPicks/PPnC2",
                                                        "title": "Peppy Paneer Cheese Burst",
                                                        "description": "  ",
                                                        "fontColor": "#FFFFFF",
                                                        "dish": {
                                                            "info": {
                                                                "id": "153334595",
                                                                "name": "Peppy Paneer Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Flavorful trio of juicy paneer, crisp capsicum & spicy red paprika",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/a85a5e4f-7a9a-4eb6-b491-dab24001e15c_b2d956ee-4518-4491-8c5a-99eab6db298e.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617960",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661345",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661346",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661347",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661348",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617961",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661349",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661350",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661346"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661346"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661347"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661347"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661348"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661348"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661345"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661345"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882426",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882427",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882428",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882430",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882431",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882432",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Recommended",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334595",
                                                                "name": "Peppy Paneer Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Flavorful trio of juicy paneer, crisp capsicum & spicy red paprika",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/a85a5e4f-7a9a-4eb6-b491-dab24001e15c_b2d956ee-4518-4491-8c5a-99eab6db298e.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617960",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661345",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661346",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661347",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661348",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617961",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661349",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661350",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661346"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661346"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661347"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661347"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661348"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661348"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661345"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661345"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882426",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882427",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882428",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882430",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882431",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882432",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "5.0",
                                                                        "ratingCount": "5 ratings",
                                                                        "ratingCountV2": "5"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334589",
                                                                "name": "Farmhouse Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion, capsicum, tomato & grilled mushroom",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/75e4a60b-8bec-47ab-90c9-b4e70df170d7_06d705be-4b9f-4e93-b1cb-5c97123bfb12.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617947",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661297",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661298",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661299",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661300",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617948",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661301",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661302",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661298"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661298"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661299"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661299"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661300"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661300"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661297"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661297"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882388",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882389",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882392",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882394",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882396",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882399",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334598",
                                                                "name": "Veggie Paradise Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Golden corn, black olives, capsicum & red paprika",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/64261820-53d1-4c02-83b7-3695fb145d8f_0878efe9-eb9a-4414-a5b8-869668e1ed3f.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617967",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661369",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617968",
                                                                                        "variationId": "155661373"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661370",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617968",
                                                                                        "variationId": "155661373"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661371",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617968",
                                                                                        "variationId": "155661373"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661372",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617968",
                                                                                        "variationId": "155661373"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617968",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661373",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661374",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661370"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661373"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882439",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661370"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661374"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661371"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661373"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882439",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661371"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661374"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661372"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661373"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882439",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661372"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661374"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661369"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661373"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882439",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661369"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661374"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882439",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882440",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882441",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882442",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882443",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882444",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334575",
                                                                "name": "Margherita Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with delight of 100% real mozzarella cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/ccc30e06-ab70-45b6-9825-adf3150441af_3f3d3a2e-855b-4158-bcec-7615525e44b0.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617921",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661211",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617922",
                                                                                        "variationId": "155661215"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661212",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617922",
                                                                                        "variationId": "155661215"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661213",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617922",
                                                                                        "variationId": "155661215"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661214",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617922",
                                                                                        "variationId": "155661215"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617922",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661215",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661216",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661212"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661215"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882312",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661212"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661216"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882317",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661213"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661215"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882312",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661213"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661216"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882317",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661214"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661215"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882312",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661214"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661216"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882317",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661211"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661215"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882312",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661211"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661216"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882317",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882312",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882314",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882315",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882317",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882318",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882319",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 18400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334607",
                                                                "name": "Spiced Double Chicken Pizza",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence with combination of Pepper Barbecue Chicken & Peri Peri Chicken for Chicken lovers",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/bad67b37-0721-45a7-990d-3987f4464e06_62453978-9a8e-4a49-bc81-0ba84e842b65.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617980",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661404",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617981",
                                                                                        "variationId": "155661408"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661405",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617981",
                                                                                        "variationId": "155661408"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661406",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617981",
                                                                                        "variationId": "155661408"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661407",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617981",
                                                                                        "variationId": "155661408"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617981",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661408",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661409",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661404"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661408"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882459",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661404"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661409"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882464",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661405"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661409"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882464",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661405"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661408"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882459",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661406"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661408"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882459",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661406"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661409"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882464",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661407"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661408"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882459",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661407"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661409"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882464",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882459",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882461",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882462",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882464",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882466",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882467",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 39000,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334585",
                                                                "name": "Mexican Green Wave Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/6aef4814-ce61-484e-a7d5-7f3e5d003288_be08f225-0fb1-498f-854a-1ba936aa8d60.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617938",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661267",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617939",
                                                                                        "variationId": "155661272"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661268",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617939",
                                                                                        "variationId": "155661272"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661269",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617939",
                                                                                        "variationId": "155661272"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661270",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617939",
                                                                                        "variationId": "155661272"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617939",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661272",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661274",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661268"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661272"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882361",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661268"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661274"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882365",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661269"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661272"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882361",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661269"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661274"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882365",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661270"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661272"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882361",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661270"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661274"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882365",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661267"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661272"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882361",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661267"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661274"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882365",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882361",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882362",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882363",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882365",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882367",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882369",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334608",
                                                                "name": "Pepper Barbecue Chicken Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Pepper Barbecue chicken for that extra zing",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/b99b241a-b4c7-438f-8d14-3f704dbe1cd4_eb4c709d-ebab-4291-be25-9900ab6b45e1.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617984",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661415",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617985",
                                                                                        "variationId": "155661419"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661416",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617985",
                                                                                        "variationId": "155661419"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661417",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617985",
                                                                                        "variationId": "155661419"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661418",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617985",
                                                                                        "variationId": "155661419"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617985",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661419",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661420",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661416"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661419"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882469",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661416"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661420"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882472",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661417"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661419"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882469",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661417"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661420"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882472",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661418"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661419"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882469",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661418"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661420"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882472",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661415"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661419"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882469",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661415"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661420"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882472",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882469",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882470",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882471",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882472",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882473",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882475",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 34400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334587",
                                                                "name": "Indi Tandoori Paneer Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with spicy tandoori paneer, capsicum, red paprika & mint mayo",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/52268a6e-00c2-4a08-99b6-2ddee4f3bdd3_32c8ad06-4578-43da-9c45-e5848c1b9b43.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617944",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661284",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617945",
                                                                                        "variationId": "155661288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661285",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617945",
                                                                                        "variationId": "155661288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661286",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617945",
                                                                                        "variationId": "155661288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661287",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617945",
                                                                                        "variationId": "155661288"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617945",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661288",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661289",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661287"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661288"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882378",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661287"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882382",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661284"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661288"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882378",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661284"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882382",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661285"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661288"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882378",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661285"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882382",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661286"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661288"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882378",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661286"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882382",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882378",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882380",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882381",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882382",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882383",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882384",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 39400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334573",
                                                                "name": "Indi Chicken Tikka Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with wholesome flavour of tandoori masala topped with Chicken tikka, onion, red paprika & mint mayo",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/6b860839-56b2-4729-a0cb-ab5086fa49d4_5cac9a1b-ed2c-4a95-bb30-8586499e4f01.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617916",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661194",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661197",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661199",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661200",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617917",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661202",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661203",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661200"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661194"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661194"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661197"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661197"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661199"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661199"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661200"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882297",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882298",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882300",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882302",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882303",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882304",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 45400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334578",
                                                                "name": "Double Cheese Margherita Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with loaded delight of 100% real mozzarella cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/b07475c1-97a8-49d3-bba0-9696253d44ca_eb8e4fe6-f157-4e5e-ab8a-173ecb88d9c9.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617924",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661219",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617926",
                                                                                        "variationId": "155661229"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661222",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617926",
                                                                                        "variationId": "155661229"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661225",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617926",
                                                                                        "variationId": "155661229"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661227",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617926",
                                                                                        "variationId": "155661229"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617926",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661229",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661231",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661222"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661229"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882323",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661222"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661231"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882329",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661225"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661229"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882323",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661225"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661231"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882329",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661227"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661229"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882323",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661227"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661231"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882329",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661219"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661229"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882323",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661219"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661231"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882329",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882323",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882325",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882327",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882329",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882332",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882335",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334561",
                                                                "name": "Cheese n Corn Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence with a delectable combination of sweet & juicy golden corn",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/00fb90e9-6c94-41b6-98d4-7812cca42c1c_1331e26c-c671-4caa-82c4-1fcf90c55696.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617899",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661137",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617900",
                                                                                        "variationId": "155661141"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661138",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617900",
                                                                                        "variationId": "155661141"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661139",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617900",
                                                                                        "variationId": "155661141"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661140",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617900",
                                                                                        "variationId": "155661141"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617900",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661141",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661142",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661140"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661141"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882248",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661140"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661142"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882251",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661137"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661141"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882248",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661137"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661142"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882251",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661138"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661142"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882251",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661138"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661141"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882248",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661139"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661141"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882248",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661139"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661142"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882251",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882248",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882249",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882250",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882251",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882252",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882253",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334571",
                                                                "name": "Chicken Golden Delight Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Double pepper Barbecue chicken, golden corn and extra cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/83cc07f2-9ae3-4bbd-a303-1c26d87a2bbc_ae0da352-da9d-4942-a23b-332e554b03c9.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617913",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661188",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617914",
                                                                                        "variationId": "155661192"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661189",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617914",
                                                                                        "variationId": "155661192"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661190",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617914",
                                                                                        "variationId": "155661192"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661191",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617914",
                                                                                        "variationId": "155661192"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617914",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661192",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661193",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661190"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661193"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882288",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661191"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661192"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882293",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661191"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661193"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882288",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661188"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661192"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882293",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661188"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661193"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882288",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661189"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661192"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882293",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661189"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661193"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882288",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661190"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661192"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882293",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882288",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882290",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882291",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882293",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882294",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882295",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 40400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334582",
                                                                "name": "Chicken Fiesta Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Grilled chicken rashers, peri-peri chicken, onion & capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/2d270ed3-34d4-49ed-8ad2-de66252fb494_cf81e686-25f5-49ab-90eb-59cb1ace9151.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617932",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661249",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617933",
                                                                                        "variationId": "155661254"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661251",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617933",
                                                                                        "variationId": "155661254"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661252",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617933",
                                                                                        "variationId": "155661254"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661253",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617933",
                                                                                        "variationId": "155661254"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617933",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661254",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661255",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661251"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661255"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882342",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661251"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661254"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882349",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661252"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661254"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882349",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661252"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661255"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882342",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661253"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661254"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882349",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661253"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661255"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882342",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661249"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661254"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882349",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661249"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661255"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882342",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882342",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882344",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882346",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882349",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882350",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882352",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 40400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334569",
                                                                "name": "Fresh Veggie Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion & capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/9b5b0373-4569-416b-b289-6dd546a21a7f_3f47169f-7fc6-4a59-8ec9-afc5992542cc.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617909",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661173",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617910",
                                                                                        "variationId": "155661177"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661174",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617910",
                                                                                        "variationId": "155661177"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661175",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617910",
                                                                                        "variationId": "155661177"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661176",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617910",
                                                                                        "variationId": "155661177"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617910",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661177",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661178",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661175"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661177"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882278",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661175"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661178"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882281",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661176"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661177"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882278",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661176"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661178"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882281",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661173"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661177"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882278",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661173"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661178"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882281",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661174"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661178"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882281",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661174"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661177"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882278",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882278",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882279",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882280",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882281",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882282",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882283",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334568",
                                                                "name": "Chicken Pepperoni Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with American classic flavored Chicken Pepperoni, topped with extra cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/82e80d82-8d85-4543-bb7e-4dc2b71d7188_e66fc751-937b-4ec1-99a1-86caba8f2420.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617907",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661167",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617908",
                                                                                        "variationId": "155661171"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661168",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617908",
                                                                                        "variationId": "155661171"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661169",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617908",
                                                                                        "variationId": "155661171"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661170",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617908",
                                                                                        "variationId": "155661171"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617908",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661171",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661172",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661168"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661172"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882270",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661168"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661171"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882275",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661169"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661171"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882275",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661169"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661172"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882270",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661170"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661171"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882275",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661170"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661172"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882270",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661167"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661171"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882275",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661167"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661172"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882270",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882270",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882272",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882274",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882275",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882276",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882277",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 45400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334612",
                                                                "name": "Achari Do Pyaza Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with tangy & spicy achari flavours on a super cheesy onion pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/eff260f3-7e8c-4a2a-9b55-bcde4f0522dd_7f54d7d9-96fc-4638-8d2d-c953a79aa5d3.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617997",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661444",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617998",
                                                                                        "variationId": "155661450"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661445",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617998",
                                                                                        "variationId": "155661450"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661447",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617998",
                                                                                        "variationId": "155661450"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661448",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617998",
                                                                                        "variationId": "155661450"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617998",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661450",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661451",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661445"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661451"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882487",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661445"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661450"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882492",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661447"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661450"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882492",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661447"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661451"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882487",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661448"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661450"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882492",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661448"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661451"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882487",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661444"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661450"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882492",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661444"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661451"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882487",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882487",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882488",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882490",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882492",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882493",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882495",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 27400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334615",
                                                                "name": "The 5 Chicken Feast Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence Loaded with 5 different Chicken toppings - grilled Chicken Rashers, Chicken MeatBalls, Chicken Tikka, herby Chicken Sausage & Chicken Keema",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/55cf2f2a-4fe1-4f67-9967-4d260747a5f1_9d96ecf0-9923-428b-baac-c558dfd84d2e.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49618005",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661469",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49618006",
                                                                                        "variationId": "155661473"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661470",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49618006",
                                                                                        "variationId": "155661473"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661471",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49618006",
                                                                                        "variationId": "155661473"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661472",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49618006",
                                                                                        "variationId": "155661473"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49618006",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661473",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661474",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661469"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661474"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882502",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661470"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661474"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882502",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661470"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661473"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882508",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661471"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661473"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882508",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661471"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661474"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882502",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661472"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661473"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882508",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661472"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661474"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882502",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661469"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661473"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882508",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882502",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882504",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882506",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882508",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882509",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882510",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 48000,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334610",
                                                                "name": "Chicken Sausage Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with American classic herbed chicken sausage",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/d8ed092e-1e47-413c-927e-b332ef507097_ed5ffcac-15b7-4ab8-8ba7-51317eefe42c.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617991",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661433",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617992",
                                                                                        "variationId": "155661437"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661434",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617992",
                                                                                        "variationId": "155661437"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661435",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617992",
                                                                                        "variationId": "155661437"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661436",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617992",
                                                                                        "variationId": "155661437"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617992",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661437",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661438",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661434"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661437"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882481",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661434"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661438"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882484",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661435"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661437"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882481",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661435"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661438"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882484",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661436"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661437"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882481",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661436"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661438"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882484",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661433"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661437"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882481",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661433"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661438"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882484",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882481",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882482",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882483",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882484",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882485",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882486",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 29400,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334603",
                                                                "name": "Fiery Jalapeno & Paprika Pizza",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence with jalapeno & red paprika toppings along with spicy peri peri sauce",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/82a43df5-5cdd-4073-971f-b20c3cfa7f4d_5173638b-6513-482b-b0df-9a743ab90496.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617974",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661384",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617975",
                                                                                        "variationId": "155661388"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661385",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617975",
                                                                                        "variationId": "155661388"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661386",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617975",
                                                                                        "variationId": "155661388"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661387",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617975",
                                                                                        "variationId": "155661388"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617975",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661388",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661389",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661386"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661388"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661386"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661389"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882451",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661387"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661388"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661387"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661389"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882451",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661384"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661388"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661384"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661389"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882451",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661385"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661388"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661385"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661389"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882451",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882447",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882448",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882450",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882451",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882453",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882455",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 26000,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334563",
                                                                "name": "Fiery Sausage & Paprika Pizza",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence with spicy & herby chicken sausage and red paprika toppings along with spicy peri peri sauce",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/70dea34a-f906-4a28-8f3c-52271b2383d9_e3804e5e-5b4e-40b5-9199-61b4e8b622af.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617903",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661149",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617904",
                                                                                        "variationId": "155661153"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661150",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617904",
                                                                                        "variationId": "155661153"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661151",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617904",
                                                                                        "variationId": "155661153"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661152",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617904",
                                                                                        "variationId": "155661153"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617904",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661153",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661154",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661150"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661153"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882260",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661150"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661154"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882263",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661151"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661153"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882260",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661151"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661154"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882263",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661152"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661153"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882260",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661152"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661154"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882263",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661149"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661153"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882260",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661149"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661154"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882263",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882260",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882261",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882262",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882263",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882264",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882265",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 33000,
                                                                "ribbon": {},
                                                                "showImage": true,
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "type": "CATEGORY_TYPE_RECOMMENDED",
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Cheese Burst - 3 New Flavours",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334595",
                                                                "name": "Peppy Paneer Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Flavorful trio of juicy paneer, crisp capsicum & spicy red paprika",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/a85a5e4f-7a9a-4eb6-b491-dab24001e15c_b2d956ee-4518-4491-8c5a-99eab6db298e.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617960",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661345",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661346",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661347",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661348",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617961",
                                                                                        "variationId": "155661349"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617961",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661349",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661350",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661346"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661346"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661347"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661347"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661348"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661348"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661345"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661349"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882430",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882432",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882431",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617960",
                                                                                    "variationId": "155661345"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617961",
                                                                                    "variationId": "155661350"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882427",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882428",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882426",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882426",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882427",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882428",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882430",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882431",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882432",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "5.0",
                                                                        "ratingCount": "5 ratings",
                                                                        "ratingCountV2": "5"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334589",
                                                                "name": "Farmhouse Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion, capsicum, tomato & grilled mushroom",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/75e4a60b-8bec-47ab-90c9-b4e70df170d7_06d705be-4b9f-4e93-b1cb-5c97123bfb12.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617947",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661297",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661298",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661299",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661300",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617948",
                                                                                        "variationId": "155661301"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617948",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661301",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661302",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661298"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661298"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661299"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661299"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661300"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661300"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661297"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661301"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882388",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882392",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882389",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617947",
                                                                                    "variationId": "155661297"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617948",
                                                                                    "variationId": "155661302"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882399",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882394",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882388",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882389",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882392",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882394",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882396",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882399",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334598",
                                                                "name": "Veggie Paradise Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Golden corn, black olives, capsicum & red paprika",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/64261820-53d1-4c02-83b7-3695fb145d8f_0878efe9-eb9a-4414-a5b8-869668e1ed3f.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617967",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661369",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617968",
                                                                                        "variationId": "155661373"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661370",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617968",
                                                                                        "variationId": "155661373"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661371",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617968",
                                                                                        "variationId": "155661373"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661372",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617968",
                                                                                        "variationId": "155661373"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617968",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661373",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661374",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661370"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661373"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882439",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661370"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661374"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661371"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661373"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882439",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661371"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661374"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661372"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661373"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882439",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661372"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661374"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661369"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661373"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882439",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882441",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882440",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617967",
                                                                                    "variationId": "155661369"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617968",
                                                                                    "variationId": "155661374"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882443",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882444",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882439",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882440",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882441",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882442",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882443",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882444",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334575",
                                                                "name": "Margherita Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with delight of 100% real mozzarella cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/ccc30e06-ab70-45b6-9825-adf3150441af_3f3d3a2e-855b-4158-bcec-7615525e44b0.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617921",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661211",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617922",
                                                                                        "variationId": "155661215"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661212",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617922",
                                                                                        "variationId": "155661215"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661213",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617922",
                                                                                        "variationId": "155661215"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661214",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617922",
                                                                                        "variationId": "155661215"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617922",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661215",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661216",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661212"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661215"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882312",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661212"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661216"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882317",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661213"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661215"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882312",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661213"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661216"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882317",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661214"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661215"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882312",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661214"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661216"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882317",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661211"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661215"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882312",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882315",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882314",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617921",
                                                                                    "variationId": "155661211"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617922",
                                                                                    "variationId": "155661216"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882319",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882317",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882312",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882314",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882315",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882317",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882318",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882319",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 18400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334607",
                                                                "name": "Spiced Double Chicken Pizza",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence with combination of Pepper Barbecue Chicken & Peri Peri Chicken for Chicken lovers",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/bad67b37-0721-45a7-990d-3987f4464e06_62453978-9a8e-4a49-bc81-0ba84e842b65.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617980",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661404",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617981",
                                                                                        "variationId": "155661408"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661405",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617981",
                                                                                        "variationId": "155661408"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661406",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617981",
                                                                                        "variationId": "155661408"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661407",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617981",
                                                                                        "variationId": "155661408"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617981",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661408",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661409",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661404"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661408"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882459",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661404"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661409"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882464",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661405"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661409"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882464",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661405"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661408"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882459",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661406"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661408"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882459",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661406"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661409"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882464",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661407"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661408"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882459",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882462",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882461",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617980",
                                                                                    "variationId": "155661407"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617981",
                                                                                    "variationId": "155661409"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882466",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882467",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882464",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882459",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882461",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882462",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882464",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882466",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882467",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 39000,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334585",
                                                                "name": "Mexican Green Wave Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/6aef4814-ce61-484e-a7d5-7f3e5d003288_be08f225-0fb1-498f-854a-1ba936aa8d60.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617938",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661267",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617939",
                                                                                        "variationId": "155661272"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661268",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617939",
                                                                                        "variationId": "155661272"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661269",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617939",
                                                                                        "variationId": "155661272"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661270",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617939",
                                                                                        "variationId": "155661272"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617939",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661272",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661274",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661268"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661272"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882361",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661268"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661274"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882365",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661269"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661272"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882361",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661269"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661274"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882365",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661270"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661272"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882361",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661270"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661274"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882365",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661267"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661272"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882361",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882363",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882362",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617938",
                                                                                    "variationId": "155661267"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617939",
                                                                                    "variationId": "155661274"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882367",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882369",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882365",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882361",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882362",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882363",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882365",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882367",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882369",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334608",
                                                                "name": "Pepper Barbecue Chicken Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Pepper Barbecue chicken for that extra zing",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/b99b241a-b4c7-438f-8d14-3f704dbe1cd4_eb4c709d-ebab-4291-be25-9900ab6b45e1.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617984",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661415",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617985",
                                                                                        "variationId": "155661419"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661416",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617985",
                                                                                        "variationId": "155661419"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661417",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617985",
                                                                                        "variationId": "155661419"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661418",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617985",
                                                                                        "variationId": "155661419"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617985",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661419",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661420",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661416"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661419"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882469",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661416"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661420"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882472",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661417"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661419"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882469",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661417"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661420"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882472",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661418"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661419"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882469",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661418"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661420"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882472",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661415"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661419"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882469",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882471",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882470",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617984",
                                                                                    "variationId": "155661415"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617985",
                                                                                    "variationId": "155661420"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882473",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882475",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882472",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882469",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882470",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882471",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882472",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882473",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882475",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 34400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334587",
                                                                "name": "Indi Tandoori Paneer Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with spicy tandoori paneer, capsicum, red paprika & mint mayo",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/52268a6e-00c2-4a08-99b6-2ddee4f3bdd3_32c8ad06-4578-43da-9c45-e5848c1b9b43.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617944",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661284",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617945",
                                                                                        "variationId": "155661288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661285",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617945",
                                                                                        "variationId": "155661288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661286",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617945",
                                                                                        "variationId": "155661288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661287",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617945",
                                                                                        "variationId": "155661288"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617945",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661288",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661289",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661287"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661288"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882378",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661287"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882382",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661284"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661288"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882378",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661284"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882382",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661285"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661288"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882378",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661285"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882382",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661286"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661288"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882378",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882381",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882380",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617944",
                                                                                    "variationId": "155661286"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617945",
                                                                                    "variationId": "155661289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882383",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882384",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882382",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882378",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882380",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882381",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882382",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882383",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882384",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 39400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334573",
                                                                "name": "Indi Chicken Tikka Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with wholesome flavour of tandoori masala topped with Chicken tikka, onion, red paprika & mint mayo",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/6b860839-56b2-4729-a0cb-ab5086fa49d4_5cac9a1b-ed2c-4a95-bb30-8586499e4f01.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617916",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661194",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661197",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661199",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661200",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617917",
                                                                                        "variationId": "155661202"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617917",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661202",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661203",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661200"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661194"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661194"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661197"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661197"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661199"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661199"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661203"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882298",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882300",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882297",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617916",
                                                                                    "variationId": "155661200"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617917",
                                                                                    "variationId": "155661202"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882303",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882297",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882298",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882300",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882302",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882303",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882304",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 45400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334578",
                                                                "name": "Double Cheese Margherita Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with loaded delight of 100% real mozzarella cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/b07475c1-97a8-49d3-bba0-9696253d44ca_eb8e4fe6-f157-4e5e-ab8a-173ecb88d9c9.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617924",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661219",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617926",
                                                                                        "variationId": "155661229"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661222",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617926",
                                                                                        "variationId": "155661229"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661225",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617926",
                                                                                        "variationId": "155661229"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661227",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617926",
                                                                                        "variationId": "155661229"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617926",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661229",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661231",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661222"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661229"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882323",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661222"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661231"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882329",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661225"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661229"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882323",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661225"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661231"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882329",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661227"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661229"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882323",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661227"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661231"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882329",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661219"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661229"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882323",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882327",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882325",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617924",
                                                                                    "variationId": "155661219"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617926",
                                                                                    "variationId": "155661231"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882332",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882335",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882329",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882323",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882325",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882327",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882329",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882332",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882335",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334561",
                                                                "name": "Cheese n Corn Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence with a delectable combination of sweet & juicy golden corn",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/00fb90e9-6c94-41b6-98d4-7812cca42c1c_1331e26c-c671-4caa-82c4-1fcf90c55696.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617899",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661137",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617900",
                                                                                        "variationId": "155661141"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661138",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617900",
                                                                                        "variationId": "155661141"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661139",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617900",
                                                                                        "variationId": "155661141"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661140",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617900",
                                                                                        "variationId": "155661141"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617900",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661141",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661142",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661140"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661141"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882248",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661140"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661142"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882251",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661137"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661141"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882248",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661137"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661142"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882251",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661138"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661142"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882251",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661138"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661141"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882248",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661139"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661141"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882248",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882250",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882249",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617899",
                                                                                    "variationId": "155661139"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617900",
                                                                                    "variationId": "155661142"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882252",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882253",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882251",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882248",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882249",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882250",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882251",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882252",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882253",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334571",
                                                                "name": "Chicken Golden Delight Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Double pepper Barbecue chicken, golden corn and extra cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/83cc07f2-9ae3-4bbd-a303-1c26d87a2bbc_ae0da352-da9d-4942-a23b-332e554b03c9.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617913",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661188",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617914",
                                                                                        "variationId": "155661192"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661189",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617914",
                                                                                        "variationId": "155661192"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661190",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617914",
                                                                                        "variationId": "155661192"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661191",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617914",
                                                                                        "variationId": "155661192"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617914",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661192",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661193",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661190"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661193"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882288",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661191"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661192"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882293",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661191"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661193"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882288",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661188"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661192"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882293",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661188"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661193"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882288",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661189"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661192"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882293",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661189"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661193"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882290",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882291",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882288",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617913",
                                                                                    "variationId": "155661190"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617914",
                                                                                    "variationId": "155661192"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882293",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882295",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882294",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882288",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882290",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882291",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882293",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882294",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882295",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 40400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334582",
                                                                "name": "Chicken Fiesta Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Grilled chicken rashers, peri-peri chicken, onion & capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/2d270ed3-34d4-49ed-8ad2-de66252fb494_cf81e686-25f5-49ab-90eb-59cb1ace9151.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617932",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661249",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617933",
                                                                                        "variationId": "155661254"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661251",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617933",
                                                                                        "variationId": "155661254"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661252",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617933",
                                                                                        "variationId": "155661254"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661253",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617933",
                                                                                        "variationId": "155661254"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617933",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661254",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661255",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661251"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661255"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882342",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661251"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661254"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882349",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661252"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661254"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882349",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661252"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661255"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882342",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661253"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661254"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882349",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661253"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661255"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882342",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661249"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661254"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882349",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882352",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882350",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617932",
                                                                                    "variationId": "155661249"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617933",
                                                                                    "variationId": "155661255"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882344",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882346",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882342",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882342",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882344",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882346",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882349",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882350",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882352",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 40400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334569",
                                                                "name": "Fresh Veggie Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion & capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/9b5b0373-4569-416b-b289-6dd546a21a7f_3f47169f-7fc6-4a59-8ec9-afc5992542cc.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617909",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661173",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617910",
                                                                                        "variationId": "155661177"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661174",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617910",
                                                                                        "variationId": "155661177"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661175",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617910",
                                                                                        "variationId": "155661177"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661176",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617910",
                                                                                        "variationId": "155661177"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617910",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661177",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661178",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661175"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661177"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882278",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661175"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661178"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882281",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661176"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661177"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882278",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661176"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661178"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882281",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661173"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661177"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882278",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661173"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661178"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882281",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661174"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661178"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882282",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882283",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882281",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617909",
                                                                                    "variationId": "155661174"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617910",
                                                                                    "variationId": "155661177"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882278",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882280",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882279",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882278",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882279",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882280",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882281",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882282",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882283",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334568",
                                                                "name": "Chicken Pepperoni Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with American classic flavored Chicken Pepperoni, topped with extra cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/82e80d82-8d85-4543-bb7e-4dc2b71d7188_e66fc751-937b-4ec1-99a1-86caba8f2420.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617907",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661167",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617908",
                                                                                        "variationId": "155661171"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661168",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617908",
                                                                                        "variationId": "155661171"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661169",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617908",
                                                                                        "variationId": "155661171"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661170",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617908",
                                                                                        "variationId": "155661171"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617908",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661171",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661172",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661168"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661172"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882270",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661168"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661171"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882275",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661169"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661171"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882275",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661169"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661172"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882270",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661170"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661171"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882275",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661170"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661172"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882270",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661167"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661171"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882275",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882277",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882276",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617907",
                                                                                    "variationId": "155661167"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617908",
                                                                                    "variationId": "155661172"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882272",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882274",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882270",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882270",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882272",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882274",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882275",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882276",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882277",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 45400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334612",
                                                                "name": "Achari Do Pyaza Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with tangy & spicy achari flavours on a super cheesy onion pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/eff260f3-7e8c-4a2a-9b55-bcde4f0522dd_7f54d7d9-96fc-4638-8d2d-c953a79aa5d3.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617997",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661444",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617998",
                                                                                        "variationId": "155661450"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661445",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617998",
                                                                                        "variationId": "155661450"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661447",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617998",
                                                                                        "variationId": "155661450"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661448",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617998",
                                                                                        "variationId": "155661450"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617998",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661450",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661451",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661445"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661451"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882487",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661445"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661450"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882492",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661447"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661450"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882492",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661447"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661451"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882487",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661448"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661450"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882492",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661448"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661451"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882487",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661444"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661450"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882492",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882495",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882493",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617997",
                                                                                    "variationId": "155661444"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617998",
                                                                                    "variationId": "155661451"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882488",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882490",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882487",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882487",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882488",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882490",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882492",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882493",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882495",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 27400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334615",
                                                                "name": "The 5 Chicken Feast Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence Loaded with 5 different Chicken toppings - grilled Chicken Rashers, Chicken MeatBalls, Chicken Tikka, herby Chicken Sausage & Chicken Keema",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/55cf2f2a-4fe1-4f67-9967-4d260747a5f1_9d96ecf0-9923-428b-baac-c558dfd84d2e.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49618005",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661469",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49618006",
                                                                                        "variationId": "155661473"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661470",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49618006",
                                                                                        "variationId": "155661473"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661471",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49618006",
                                                                                        "variationId": "155661473"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661472",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49618006",
                                                                                        "variationId": "155661473"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49618006",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661473",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661474",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661469"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661474"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882502",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661470"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661474"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882502",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661470"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661473"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882508",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661471"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661473"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882508",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661471"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661474"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882502",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661472"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661473"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882508",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661472"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661474"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882504",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882506",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882502",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49618005",
                                                                                    "variationId": "155661469"
                                                                                },
                                                                                {
                                                                                    "groupId": "49618006",
                                                                                    "variationId": "155661473"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882508",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882510",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882509",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882502",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882504",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882506",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882508",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882509",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882510",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 48000,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334610",
                                                                "name": "Chicken Sausage Cheese Burst",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with American classic herbed chicken sausage",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/d8ed092e-1e47-413c-927e-b332ef507097_ed5ffcac-15b7-4ab8-8ba7-51317eefe42c.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617991",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661433",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617992",
                                                                                        "variationId": "155661437"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661434",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617992",
                                                                                        "variationId": "155661437"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661435",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617992",
                                                                                        "variationId": "155661437"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661436",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617992",
                                                                                        "variationId": "155661437"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617992",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661437",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661438",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661434"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661437"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882481",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661434"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661438"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882484",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661435"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661437"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882481",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661435"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661438"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882484",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661436"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661437"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882481",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661436"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661438"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882484",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661433"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661437"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882481",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882483",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882482",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617991",
                                                                                    "variationId": "155661433"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617992",
                                                                                    "variationId": "155661438"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882485",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882486",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882484",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882481",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882482",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882483",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882484",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882485",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882486",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 29400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334603",
                                                                "name": "Fiery Jalapeno & Paprika Pizza",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence with jalapeno & red paprika toppings along with spicy peri peri sauce",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/82a43df5-5cdd-4073-971f-b20c3cfa7f4d_5173638b-6513-482b-b0df-9a743ab90496.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617974",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661384",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617975",
                                                                                        "variationId": "155661388"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661385",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617975",
                                                                                        "variationId": "155661388"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661386",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617975",
                                                                                        "variationId": "155661388"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661387",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617975",
                                                                                        "variationId": "155661388"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617975",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661388",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661389",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661386"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661388"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661386"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661389"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882451",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661387"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661388"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661387"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661389"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882451",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661384"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661388"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661384"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661389"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882451",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661385"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661388"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882448",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617974",
                                                                                    "variationId": "155661385"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617975",
                                                                                    "variationId": "155661389"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882453",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882455",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882451",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882447",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882448",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882450",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882451",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882453",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882455",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 26000,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334563",
                                                                "name": "Fiery Sausage & Paprika Pizza",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence with spicy & herby chicken sausage and red paprika toppings along with spicy peri peri sauce",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/70dea34a-f906-4a28-8f3c-52271b2383d9_e3804e5e-5b4e-40b5-9199-61b4e8b622af.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617903",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661149",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617904",
                                                                                        "variationId": "155661153"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661150",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617904",
                                                                                        "variationId": "155661153"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661151",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617904",
                                                                                        "variationId": "155661153"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661152",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617904",
                                                                                        "variationId": "155661153"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617904",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661153",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661154",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661150"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661153"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882260",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661150"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661154"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882263",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661151"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661153"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882260",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661151"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661154"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882263",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661152"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661153"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882260",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661152"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661154"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882263",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661149"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661153"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882260",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882262",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882261",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617903",
                                                                                    "variationId": "155661149"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617904",
                                                                                    "variationId": "155661154"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882264",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882265",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882263",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882260",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882261",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882262",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882263",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882264",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882265",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 33000,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334560",
                                                                "name": "Blazing Onion & Paprika Pizza",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence with onion & red paprika toppings along with spicy peri peri sauce",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/670e0759-e3b2-470d-963f-124a362528bf_0dba27c7-1b9c-40c3-8b41-d9a16d3fd02e.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617897",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661131",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617898",
                                                                                        "variationId": "155661135"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661132",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617898",
                                                                                        "variationId": "155661135"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661133",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617898",
                                                                                        "variationId": "155661135"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661134",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617898",
                                                                                        "variationId": "155661135"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617898",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661135",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661136",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617897",
                                                                                    "variationId": "155661132"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617898",
                                                                                    "variationId": "155661136"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882238",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617897",
                                                                                    "variationId": "155661133"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617898",
                                                                                    "variationId": "155661135"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882242",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617897",
                                                                                    "variationId": "155661133"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617898",
                                                                                    "variationId": "155661136"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882238",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617897",
                                                                                    "variationId": "155661134"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617898",
                                                                                    "variationId": "155661135"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882242",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617897",
                                                                                    "variationId": "155661134"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617898",
                                                                                    "variationId": "155661136"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882238",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617897",
                                                                                    "variationId": "155661131"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617898",
                                                                                    "variationId": "155661135"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882242",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617897",
                                                                                    "variationId": "155661131"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617898",
                                                                                    "variationId": "155661136"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882239",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882241",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882238",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617897",
                                                                                    "variationId": "155661132"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617898",
                                                                                    "variationId": "155661135"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882242",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882246",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882244",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882238",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882239",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882241",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882242",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882244",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882246",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 26000,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334592",
                                                                "name": "Blazing Chicken & Paprika Pizza",
                                                                "category": "Cheese Burst - 3 New Flavours",
                                                                "description": "Molten Cheese Indulgence with a combination of chicken keema & red paprika toppings along with spicy peri peri sauce",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/ac6f8b27-ee28-46b6-b106-226976ad2008_5e3d3531-285b-472c-8a89-94b69b24337c.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "49617954",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661322",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617955",
                                                                                        "variationId": "155661326"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "155661323",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617955",
                                                                                        "variationId": "155661326"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661324",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617955",
                                                                                        "variationId": "155661326"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661325",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "49617955",
                                                                                        "variationId": "155661326"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "49617955",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "155661326",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "155661327",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617954",
                                                                                    "variationId": "155661324"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617955",
                                                                                    "variationId": "155661327"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882405",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617954",
                                                                                    "variationId": "155661325"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617955",
                                                                                    "variationId": "155661326"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882413",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617954",
                                                                                    "variationId": "155661325"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617955",
                                                                                    "variationId": "155661327"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882405",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617954",
                                                                                    "variationId": "155661322"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617955",
                                                                                    "variationId": "155661326"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882413",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617954",
                                                                                    "variationId": "155661322"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617955",
                                                                                    "variationId": "155661327"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882405",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617954",
                                                                                    "variationId": "155661323"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617955",
                                                                                    "variationId": "155661327"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882407",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882410",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882405",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617954",
                                                                                    "variationId": "155661323"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617955",
                                                                                    "variationId": "155661326"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882413",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "49617954",
                                                                                    "variationId": "155661324"
                                                                                },
                                                                                {
                                                                                    "groupId": "49617955",
                                                                                    "variationId": "155661326"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "180882413",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882416",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "180882415",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "180882405",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882407",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882410",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882413",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882415",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "180882416",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 33000,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Cheese Volcano",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "146311238",
                                                                "name": "Cheese Volcano Peppy Paneer",
                                                                "category": "Cheese Volcano",
                                                                "description": "Centre loaded with Molten Cheese & topped with peppy Paneer, Capsicum & Red Paprika\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/3ab84285-8164-4447-b534-f371913491c6_f91a0f02-a155-4a2a-8567-ae9d56ec5b2b.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "48415150",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "152760280",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "48415151",
                                                                                        "variationId": "152760281"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "48415151",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "152760281",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium Plus",
                                                                                    "id": "152760282",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415150",
                                                                                    "variationId": "152760280"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415151",
                                                                                    "variationId": "152760281"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969697",
                                                                                    "addonId": "121101498"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969697",
                                                                                    "addonId": "121101486"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969697",
                                                                                    "addonId": "121101500"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969697",
                                                                                    "addonId": "121101494"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969697",
                                                                                    "addonId": "121101487"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969697",
                                                                                    "addonId": "121101502"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969697",
                                                                                    "addonId": "121101490"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969697",
                                                                                    "addonId": "121101504"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969698",
                                                                                    "addonId": "121101485"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969698",
                                                                                    "addonId": "121101509"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969698",
                                                                                    "addonId": "121101488"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969698",
                                                                                    "addonId": "121101489"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969698",
                                                                                    "addonId": "121101503"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969698",
                                                                                    "addonId": "121101491"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969698",
                                                                                    "addonId": "121101505"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969696",
                                                                                    "addonId": "121101480"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415150",
                                                                                    "variationId": "152760280"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415151",
                                                                                    "variationId": "152760282"
                                                                                }
                                                                            ],
                                                                            "price": 52900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969699",
                                                                                    "addonId": "121101506"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969699",
                                                                                    "addonId": "121101481"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969699",
                                                                                    "addonId": "121101493"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969699",
                                                                                    "addonId": "121101483"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969699",
                                                                                    "addonId": "121101507"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969699",
                                                                                    "addonId": "121101478"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969699",
                                                                                    "addonId": "121101501"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969699",
                                                                                    "addonId": "121101496"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969701",
                                                                                    "addonId": "121101497"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969701",
                                                                                    "addonId": "121101492"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969701",
                                                                                    "addonId": "121101482"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969701",
                                                                                    "addonId": "121101508"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969701",
                                                                                    "addonId": "121101484"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969701",
                                                                                    "addonId": "121101479"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969701",
                                                                                    "addonId": "121101495"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969700",
                                                                                    "addonId": "121101499"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "176969696",
                                                                        "groupName": "Extra Cheese Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101480",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969697",
                                                                        "groupName": "Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101498",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101486",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101500",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101494",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101487",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101502",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101490",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101504",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969698",
                                                                        "groupName": "Non-Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101485",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101509",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101488",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101489",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101503",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101491",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101505",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969699",
                                                                        "groupName": "Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101506",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101481",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101493",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101483",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101507",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101478",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101501",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101496",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969700",
                                                                        "groupName": "Extra Cheese Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101499",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969701",
                                                                        "groupName": "Non-Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101497",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101492",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101482",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101508",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101484",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101479",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101495",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.7",
                                                                        "ratingCount": "11 ratings",
                                                                        "ratingCountV2": "11"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "146311240",
                                                                "name": "Cheese Volcano Farmhouse",
                                                                "category": "Cheese Volcano",
                                                                "description": "Centre loaded with Molten Cheese & topped with Onion, Capsicum, Tomato & Grilled Mushroom\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/4e30b1ff-dbe8-41d3-b083-d46b9d742ffc_636d161e-7f34-4371-b63c-bf9e3d091a0f.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "48415176",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "152760319",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "48415177",
                                                                                        "variationId": "152760320"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "48415177",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "152760320",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium Plus",
                                                                                    "id": "152760321",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415176",
                                                                                    "variationId": "152760319"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415177",
                                                                                    "variationId": "152760320"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969773",
                                                                                    "addonId": "121101498"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969773",
                                                                                    "addonId": "121101486"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969773",
                                                                                    "addonId": "121101500"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969773",
                                                                                    "addonId": "121101494"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969773",
                                                                                    "addonId": "121101487"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969773",
                                                                                    "addonId": "121101502"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969773",
                                                                                    "addonId": "121101490"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969773",
                                                                                    "addonId": "121101504"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969776",
                                                                                    "addonId": "121101485"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969776",
                                                                                    "addonId": "121101509"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969776",
                                                                                    "addonId": "121101488"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969776",
                                                                                    "addonId": "121101489"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969776",
                                                                                    "addonId": "121101503"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969776",
                                                                                    "addonId": "121101491"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969776",
                                                                                    "addonId": "121101505"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969771",
                                                                                    "addonId": "121101480"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415176",
                                                                                    "variationId": "152760319"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415177",
                                                                                    "variationId": "152760321"
                                                                                }
                                                                            ],
                                                                            "price": 52900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969777",
                                                                                    "addonId": "121101506"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969777",
                                                                                    "addonId": "121101481"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969777",
                                                                                    "addonId": "121101493"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969777",
                                                                                    "addonId": "121101483"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969777",
                                                                                    "addonId": "121101507"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969777",
                                                                                    "addonId": "121101478"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969777",
                                                                                    "addonId": "121101501"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969777",
                                                                                    "addonId": "121101496"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969781",
                                                                                    "addonId": "121101497"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969781",
                                                                                    "addonId": "121101492"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969781",
                                                                                    "addonId": "121101482"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969781",
                                                                                    "addonId": "121101508"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969781",
                                                                                    "addonId": "121101484"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969781",
                                                                                    "addonId": "121101479"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969781",
                                                                                    "addonId": "121101495"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969780",
                                                                                    "addonId": "121101499"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "176969771",
                                                                        "groupName": "Extra Cheese Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101480",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969773",
                                                                        "groupName": "Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101498",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101486",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101500",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101494",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101487",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101502",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101490",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101504",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969776",
                                                                        "groupName": "Non-Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101485",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101509",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101488",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101489",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101503",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101491",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101505",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969777",
                                                                        "groupName": "Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101506",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101481",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101493",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101483",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101507",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101478",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101501",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101496",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969780",
                                                                        "groupName": "Extra Cheese Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101499",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969781",
                                                                        "groupName": "Non-Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101497",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101492",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101482",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101508",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101484",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101479",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101495",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.5",
                                                                        "ratingCount": "10 ratings",
                                                                        "ratingCountV2": "10"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "146311245",
                                                                "name": "Cheese Volcano Veg Paradise",
                                                                "category": "Cheese Volcano",
                                                                "description": "Centre loaded with Molten Cheese & topped with Golden Corn, Black Olives, Capsicum & Red Paprika\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/3e08f33d-98b7-41d2-acca-182da98e80f4_dd0b2e67-2a47-4a5e-b906-63e1277e7fa2.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "48415154",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "152760286",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "48415155",
                                                                                        "variationId": "152760287"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "48415155",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "152760287",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium Plus",
                                                                                    "id": "152760288",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415154",
                                                                                    "variationId": "152760286"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415155",
                                                                                    "variationId": "152760287"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969709",
                                                                                    "addonId": "121101498"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969709",
                                                                                    "addonId": "121101486"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969709",
                                                                                    "addonId": "121101500"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969709",
                                                                                    "addonId": "121101494"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969709",
                                                                                    "addonId": "121101487"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969709",
                                                                                    "addonId": "121101502"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969709",
                                                                                    "addonId": "121101490"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969709",
                                                                                    "addonId": "121101504"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969710",
                                                                                    "addonId": "121101485"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969710",
                                                                                    "addonId": "121101509"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969710",
                                                                                    "addonId": "121101488"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969710",
                                                                                    "addonId": "121101489"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969710",
                                                                                    "addonId": "121101503"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969710",
                                                                                    "addonId": "121101491"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969710",
                                                                                    "addonId": "121101505"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969708",
                                                                                    "addonId": "121101480"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415154",
                                                                                    "variationId": "152760286"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415155",
                                                                                    "variationId": "152760288"
                                                                                }
                                                                            ],
                                                                            "price": 52900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969711",
                                                                                    "addonId": "121101506"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969711",
                                                                                    "addonId": "121101481"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969711",
                                                                                    "addonId": "121101493"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969711",
                                                                                    "addonId": "121101483"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969711",
                                                                                    "addonId": "121101507"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969711",
                                                                                    "addonId": "121101478"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969711",
                                                                                    "addonId": "121101501"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969711",
                                                                                    "addonId": "121101496"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969713",
                                                                                    "addonId": "121101497"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969713",
                                                                                    "addonId": "121101492"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969713",
                                                                                    "addonId": "121101482"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969713",
                                                                                    "addonId": "121101508"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969713",
                                                                                    "addonId": "121101484"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969713",
                                                                                    "addonId": "121101479"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969713",
                                                                                    "addonId": "121101495"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969712",
                                                                                    "addonId": "121101499"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "176969708",
                                                                        "groupName": "Extra Cheese Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101480",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969709",
                                                                        "groupName": "Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101498",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101486",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101500",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101494",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101487",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101502",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101490",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101504",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969710",
                                                                        "groupName": "Non-Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101485",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101509",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101488",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101489",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101503",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101491",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101505",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969711",
                                                                        "groupName": "Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101506",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101481",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101493",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101483",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101507",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101478",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101501",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101496",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969712",
                                                                        "groupName": "Extra Cheese Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101499",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969713",
                                                                        "groupName": "Non-Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101497",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101492",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101482",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101508",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101484",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101479",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101495",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "3.9",
                                                                        "ratingCount": "3 ratings",
                                                                        "ratingCountV2": "3"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "146311239",
                                                                "name": "Corn & Cheese Volcano",
                                                                "category": "Cheese Volcano",
                                                                "description": "Centre loaded with Molten Cheese & topped with juicy Golden Corn\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/375ae4df-de00-4235-97c5-3de32ebd969c_c7ea4a4e-86a9-467b-a42d-13e058670d28.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "48415148",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "152760277",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "48415149",
                                                                                        "variationId": "152760278"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "48415149",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "152760278",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium Plus",
                                                                                    "id": "152760279",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415148",
                                                                                    "variationId": "152760277"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415149",
                                                                                    "variationId": "152760278"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101498"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101486"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101500"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101494"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101487"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101502"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101490"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969691",
                                                                                    "addonId": "121101504"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101485"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101509"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101488"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101489"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101503"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101491"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969692",
                                                                                    "addonId": "121101505"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969690",
                                                                                    "addonId": "121101480"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415148",
                                                                                    "variationId": "152760277"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415149",
                                                                                    "variationId": "152760279"
                                                                                }
                                                                            ],
                                                                            "price": 52900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101506"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101481"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101493"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101483"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101507"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101478"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101501"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969693",
                                                                                    "addonId": "121101496"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101497"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101492"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101482"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101508"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101484"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101479"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969695",
                                                                                    "addonId": "121101495"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969694",
                                                                                    "addonId": "121101499"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "176969690",
                                                                        "groupName": "Extra Cheese Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101480",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969691",
                                                                        "groupName": "Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101498",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101486",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101500",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101494",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101487",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101502",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101490",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101504",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969692",
                                                                        "groupName": "Non-Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101485",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101509",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101488",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101489",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101503",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101491",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101505",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969693",
                                                                        "groupName": "Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101506",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101481",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101493",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101483",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101507",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101478",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101501",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101496",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969694",
                                                                        "groupName": "Extra Cheese Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101499",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969695",
                                                                        "groupName": "Non-Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101497",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101492",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101482",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101508",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101484",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101479",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101495",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "146311244",
                                                                "name": "Cheese Volcano BBQ Chicken",
                                                                "category": "Cheese Volcano",
                                                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/bb8bf7b5-d084-4690-893e-ea5af460ad5d_fd69db19-9923-4ab7-936c-e2b1300a9b25.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "48415162",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "152760298",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "48415163",
                                                                                        "variationId": "152760299"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "48415163",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "152760299",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium Plus",
                                                                                    "id": "152760300",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415162",
                                                                                    "variationId": "152760298"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415163",
                                                                                    "variationId": "152760299"
                                                                                }
                                                                            ],
                                                                            "price": 36900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969730",
                                                                                    "addonId": "121101498"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969730",
                                                                                    "addonId": "121101486"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969730",
                                                                                    "addonId": "121101500"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969730",
                                                                                    "addonId": "121101494"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969730",
                                                                                    "addonId": "121101487"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969730",
                                                                                    "addonId": "121101502"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969730",
                                                                                    "addonId": "121101490"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969730",
                                                                                    "addonId": "121101504"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969732",
                                                                                    "addonId": "121101485"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969732",
                                                                                    "addonId": "121101509"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969732",
                                                                                    "addonId": "121101488"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969732",
                                                                                    "addonId": "121101489"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969732",
                                                                                    "addonId": "121101503"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969732",
                                                                                    "addonId": "121101491"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969732",
                                                                                    "addonId": "121101505"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969728",
                                                                                    "addonId": "121101480"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415162",
                                                                                    "variationId": "152760298"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415163",
                                                                                    "variationId": "152760300"
                                                                                }
                                                                            ],
                                                                            "price": 57900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969734",
                                                                                    "addonId": "121101506"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969734",
                                                                                    "addonId": "121101481"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969734",
                                                                                    "addonId": "121101493"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969734",
                                                                                    "addonId": "121101483"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969734",
                                                                                    "addonId": "121101507"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969734",
                                                                                    "addonId": "121101478"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969734",
                                                                                    "addonId": "121101501"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969734",
                                                                                    "addonId": "121101496"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969737",
                                                                                    "addonId": "121101497"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969737",
                                                                                    "addonId": "121101492"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969737",
                                                                                    "addonId": "121101482"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969737",
                                                                                    "addonId": "121101508"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969737",
                                                                                    "addonId": "121101484"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969737",
                                                                                    "addonId": "121101479"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969737",
                                                                                    "addonId": "121101495"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969736",
                                                                                    "addonId": "121101499"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "176969728",
                                                                        "groupName": "Extra Cheese Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101480",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969730",
                                                                        "groupName": "Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101498",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101486",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101500",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101494",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101487",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101502",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101490",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101504",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969732",
                                                                        "groupName": "Non-Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101485",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101509",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101488",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101489",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101503",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101491",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101505",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969734",
                                                                        "groupName": "Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101506",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101481",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101493",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101483",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101507",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101478",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101501",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101496",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969736",
                                                                        "groupName": "Extra Cheese Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101499",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969737",
                                                                        "groupName": "Non-Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101497",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101492",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101482",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101508",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101484",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101479",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101495",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 36900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "146311241",
                                                                "name": "Cheese Volcano Chicken Delight",
                                                                "category": "Cheese Volcano",
                                                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken & Golden Corn\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/ec91a814-b0f9-4911-b972-3c2a3583c684_d8de24fd-5109-4870-bf74-66f9ebb4ace5.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "48415170",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "152760310",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "48415171",
                                                                                        "variationId": "152760311"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "48415171",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "152760311",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium Plus",
                                                                                    "id": "152760312",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415170",
                                                                                    "variationId": "152760310"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415171",
                                                                                    "variationId": "152760311"
                                                                                }
                                                                            ],
                                                                            "price": 36900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969754",
                                                                                    "addonId": "121101498"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969754",
                                                                                    "addonId": "121101486"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969754",
                                                                                    "addonId": "121101500"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969754",
                                                                                    "addonId": "121101494"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969754",
                                                                                    "addonId": "121101487"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969754",
                                                                                    "addonId": "121101502"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969754",
                                                                                    "addonId": "121101490"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969754",
                                                                                    "addonId": "121101504"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969756",
                                                                                    "addonId": "121101485"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969756",
                                                                                    "addonId": "121101509"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969756",
                                                                                    "addonId": "121101488"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969756",
                                                                                    "addonId": "121101489"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969756",
                                                                                    "addonId": "121101503"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969756",
                                                                                    "addonId": "121101491"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969756",
                                                                                    "addonId": "121101505"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969752",
                                                                                    "addonId": "121101480"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415170",
                                                                                    "variationId": "152760310"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415171",
                                                                                    "variationId": "152760312"
                                                                                }
                                                                            ],
                                                                            "price": 57900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969758",
                                                                                    "addonId": "121101506"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969758",
                                                                                    "addonId": "121101481"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969758",
                                                                                    "addonId": "121101493"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969758",
                                                                                    "addonId": "121101483"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969758",
                                                                                    "addonId": "121101507"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969758",
                                                                                    "addonId": "121101478"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969758",
                                                                                    "addonId": "121101501"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969758",
                                                                                    "addonId": "121101496"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969763",
                                                                                    "addonId": "121101497"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969763",
                                                                                    "addonId": "121101492"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969763",
                                                                                    "addonId": "121101482"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969763",
                                                                                    "addonId": "121101508"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969763",
                                                                                    "addonId": "121101484"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969763",
                                                                                    "addonId": "121101479"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969763",
                                                                                    "addonId": "121101495"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969761",
                                                                                    "addonId": "121101499"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "176969752",
                                                                        "groupName": "Extra Cheese Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101480",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969754",
                                                                        "groupName": "Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101498",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101486",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101500",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101494",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101487",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101502",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101490",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101504",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969756",
                                                                        "groupName": "Non-Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101485",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101509",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101488",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101489",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101503",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101491",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101505",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969758",
                                                                        "groupName": "Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101506",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101481",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101493",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101483",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101507",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101478",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101501",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101496",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969761",
                                                                        "groupName": "Extra Cheese Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101499",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969763",
                                                                        "groupName": "Non-Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101497",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101492",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101482",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101508",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101484",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101479",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101495",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 36900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "146311243",
                                                                "name": "Cheese Volcano Double Chicken",
                                                                "category": "Cheese Volcano",
                                                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken & Peri Peri Chicken.\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/a842381d-5d56-4a1e-99b8-4594170ae2c1_6d79c2a4-5aec-4067-acea-0afdfd875830.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "48415158",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "152760292",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "48415159",
                                                                                        "variationId": "152760293"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "48415159",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "152760293",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium Plus",
                                                                                    "id": "152760294",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415158",
                                                                                    "variationId": "152760292"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415159",
                                                                                    "variationId": "152760293"
                                                                                }
                                                                            ],
                                                                            "price": 36900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969718",
                                                                                    "addonId": "121101498"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969718",
                                                                                    "addonId": "121101486"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969718",
                                                                                    "addonId": "121101500"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969718",
                                                                                    "addonId": "121101494"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969718",
                                                                                    "addonId": "121101487"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969718",
                                                                                    "addonId": "121101502"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969718",
                                                                                    "addonId": "121101490"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969718",
                                                                                    "addonId": "121101504"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969720",
                                                                                    "addonId": "121101485"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969720",
                                                                                    "addonId": "121101509"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969720",
                                                                                    "addonId": "121101488"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969720",
                                                                                    "addonId": "121101489"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969720",
                                                                                    "addonId": "121101503"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969720",
                                                                                    "addonId": "121101491"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969720",
                                                                                    "addonId": "121101505"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969716",
                                                                                    "addonId": "121101480"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415158",
                                                                                    "variationId": "152760292"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415159",
                                                                                    "variationId": "152760294"
                                                                                }
                                                                            ],
                                                                            "price": 57900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969722",
                                                                                    "addonId": "121101506"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969722",
                                                                                    "addonId": "121101481"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969722",
                                                                                    "addonId": "121101493"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969722",
                                                                                    "addonId": "121101483"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969722",
                                                                                    "addonId": "121101507"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969722",
                                                                                    "addonId": "121101478"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969722",
                                                                                    "addonId": "121101501"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969722",
                                                                                    "addonId": "121101496"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969725",
                                                                                    "addonId": "121101497"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969725",
                                                                                    "addonId": "121101492"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969725",
                                                                                    "addonId": "121101482"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969725",
                                                                                    "addonId": "121101508"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969725",
                                                                                    "addonId": "121101484"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969725",
                                                                                    "addonId": "121101479"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969725",
                                                                                    "addonId": "121101495"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969724",
                                                                                    "addonId": "121101499"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "176969716",
                                                                        "groupName": "Extra Cheese Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101480",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969718",
                                                                        "groupName": "Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101498",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101486",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101500",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101494",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101487",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101502",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101490",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101504",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969720",
                                                                        "groupName": "Non-Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101485",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101509",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101488",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101489",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101503",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101491",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101505",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969722",
                                                                        "groupName": "Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101506",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101481",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101493",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101483",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101507",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101478",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101501",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101496",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969724",
                                                                        "groupName": "Extra Cheese Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101499",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969725",
                                                                        "groupName": "Non-Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101497",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101492",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101482",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101508",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101484",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101479",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101495",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 36900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "5.0",
                                                                        "ratingCount": "7 ratings",
                                                                        "ratingCountV2": "7"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "146311242",
                                                                "name": "Cheese Volcano Blazing Chicken",
                                                                "category": "Cheese Volcano",
                                                                "description": "Centre loaded with Molten Cheese & topped with Chicken Keema & Red Paprika with our spicy Peri Peri Sauce\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/e0d6d213-d5ac-45a7-b53f-d6c836d53659_33957602-94cc-4a32-9a21-6b65d35815fc.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "48415166",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "152760304",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "48415167",
                                                                                        "variationId": "152760305"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "48415167",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "152760305",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium Plus",
                                                                                    "id": "152760306",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415166",
                                                                                    "variationId": "152760304"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415167",
                                                                                    "variationId": "152760305"
                                                                                }
                                                                            ],
                                                                            "price": 36900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969742",
                                                                                    "addonId": "121101498"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969742",
                                                                                    "addonId": "121101486"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969742",
                                                                                    "addonId": "121101500"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969742",
                                                                                    "addonId": "121101494"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969742",
                                                                                    "addonId": "121101487"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969742",
                                                                                    "addonId": "121101502"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969742",
                                                                                    "addonId": "121101490"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969742",
                                                                                    "addonId": "121101504"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969744",
                                                                                    "addonId": "121101485"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969744",
                                                                                    "addonId": "121101509"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969744",
                                                                                    "addonId": "121101488"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969744",
                                                                                    "addonId": "121101489"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969744",
                                                                                    "addonId": "121101503"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969744",
                                                                                    "addonId": "121101491"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969744",
                                                                                    "addonId": "121101505"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969740",
                                                                                    "addonId": "121101480"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "48415166",
                                                                                    "variationId": "152760304"
                                                                                },
                                                                                {
                                                                                    "groupId": "48415167",
                                                                                    "variationId": "152760306"
                                                                                }
                                                                            ],
                                                                            "price": 57900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "176969746",
                                                                                    "addonId": "121101506"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969746",
                                                                                    "addonId": "121101481"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969746",
                                                                                    "addonId": "121101493"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969746",
                                                                                    "addonId": "121101483"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969746",
                                                                                    "addonId": "121101507"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969746",
                                                                                    "addonId": "121101478"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969746",
                                                                                    "addonId": "121101501"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969746",
                                                                                    "addonId": "121101496"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969749",
                                                                                    "addonId": "121101497"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969749",
                                                                                    "addonId": "121101492"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969749",
                                                                                    "addonId": "121101482"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969749",
                                                                                    "addonId": "121101508"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969749",
                                                                                    "addonId": "121101484"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969749",
                                                                                    "addonId": "121101479"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969749",
                                                                                    "addonId": "121101495"
                                                                                },
                                                                                {
                                                                                    "groupId": "176969748",
                                                                                    "addonId": "121101499"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "176969740",
                                                                        "groupName": "Extra Cheese Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101480",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969742",
                                                                        "groupName": "Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101498",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101486",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101500",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101494",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101487",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101502",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101490",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101504",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969744",
                                                                        "groupName": "Non-Veg Toppings Regular Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101485",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101509",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101488",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101489",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101503",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101491",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101505",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969746",
                                                                        "groupName": "Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101506",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101481",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101493",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101483",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101507",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101478",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101501",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101496",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969748",
                                                                        "groupName": "Extra Cheese Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101499",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "176969749",
                                                                        "groupName": "Non-Veg Toppings Medium Plus",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121101497",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101492",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101482",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101508",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101484",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101479",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121101495",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 36900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Party Combo",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "113943670",
                                                                "name": "Special Party for 4 (Veg) @Rs. 180 off",
                                                                "category": "Party Combo",
                                                                "description": "Medium Peppy Paneer + Medium Farmhouse + Garlic Bread + 2 Pepsi",
                                                                "imageId": "4dfd02271e979bdcbed7737473d930c5",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 102500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.8",
                                                                        "ratingCount": "5 ratings",
                                                                        "ratingCountV2": "5"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "119171145",
                                                                "name": "Pizza Party for 4 (Veg) @Rs. 180 Off",
                                                                "category": "Party Combo",
                                                                "description": "Meal for 4: Regular Veg Extravaganza + Regular Indi Tandoori Paneer + Regular Farmhouse + Regular Veggie Paradise",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/31/99380be1-e010-42b9-ac5f-18eca2c4df13_8817bc9d-8a29-4e7e-ab1f-2be79a8a3441.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 101900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "119171144",
                                                                "name": "Party for 4 (Veg) @Rs. 130 off",
                                                                "category": "Party Combo",
                                                                "description": "Meal for 4: Medium Margherita + Medium Farmhouse with Garlic Bread & 2 Pepsi",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/31/1d4d5779-0945-4804-8156-1346d4cc708d_0df4edfa-f7da-4a74-87e8-69b66a894b79.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 85100,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "113943672",
                                                                "name": "Extravaganza Party for 2 (Veg) @Rs. 110 off",
                                                                "category": "Party Combo",
                                                                "description": "Regular Veg Extravaganza + Regular Indi Tandoori Paneer + Garlic Bread + Pepsi",
                                                                "imageId": "0cbd92945fdc750f47e0b6c38ad7108b",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 70500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "119171143",
                                                                "name": "Dominator Party for 2 (Non-Veg) @Rs. 140 off",
                                                                "category": "Party Combo",
                                                                "description": "Meal for 2: Regular Non Veg Supreme + Regular Chicken Dominator with Garlic Bread & Pepsi",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/31/524f9cd4-1390-4805-996b-f17800529004_4b1eb214-7d4d-46b6-873c-17cebe117543.jpg",
                                                                "inStock": 1,
                                                                "price": 79500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "125889585",
                                                                "name": "Special Party for 2 (Veg) @Rs. 105 off",
                                                                "category": "Party Combo",
                                                                "description": "Regular Farmhouse + Regular Peppy Paneer + Garlic Bread + Pepsi",
                                                                "imageId": "fbdef2d7dcfc5374f48cce734867aa30",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 62500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "5.0",
                                                                        "ratingCount": "4 ratings",
                                                                        "ratingCountV2": "4"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "131414961",
                                                                "name": "Match Day Veg Combo @Rs. 110 off",
                                                                "category": "Party Combo",
                                                                "description": "Meal for 2: Regular Veg Extravaganza + Regular Indi Tandoori Paneer with Chocolava Cake & Pepsi",
                                                                "imageId": "80c0a378d5a09f45ca7881518ab276dd",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 70500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "119171142",
                                                                "name": "Special Party for 2 (Non-Veg) @Rs. 115 off",
                                                                "category": "Party Combo",
                                                                "description": "Meal for 2: Regular Pepper BBQ Chicken + Regular Chicken Dominator with Garlic Bread & Pepsi",
                                                                "imageId": "c314a5711c2c1d6cfa607e452abb9719",
                                                                "inStock": 1,
                                                                "price": 70500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "113943669",
                                                                "name": "Party for 2 (Non-Veg) @Rs. 85 off",
                                                                "category": "Party Combo",
                                                                "description": "Regular Pepper BBQ Chicken + Regular Chicken Sausage + Garlic Bread + Pepsi",
                                                                "imageId": "fc7ff3ec875af65564f55a00ce69560e",
                                                                "inStock": 1,
                                                                "price": 57500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "113943668",
                                                                "name": "Party for 2 (Veg) @Rs. 75 off",
                                                                "category": "Party Combo",
                                                                "description": "Regular Margherita +Regular  Farmhouse + Garlic Bread + Pepsi",
                                                                "imageId": "71650740c571a88037477e3293612212",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 48500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.6",
                                                                        "ratingCount": "4 ratings",
                                                                        "ratingCountV2": "4"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "113943673",
                                                                "name": "Dominator Party for 4 (Non-Veg) @Rs. 300 off",
                                                                "category": "Party Combo",
                                                                "description": "Medium Non Veg Supreme + Medium Chicken Dominator + Garlic Bread + 2 Pepsi",
                                                                "imageId": "38bfe017ea257a74608088f0c33e2232",
                                                                "inStock": 1,
                                                                "price": 118500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "5.0",
                                                                        "ratingCount": "5 ratings",
                                                                        "ratingCountV2": "5"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Value Meals",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "107334750",
                                                                "name": "Meal for 4: Veg Loaded Pizza",
                                                                "category": "Value Meals",
                                                                "description": "Regular Veg Extravaganza + Regular Veg Paradise Pizza + Regular Indi Tandoori Paneer + Regular Farmhouse",
                                                                "imageId": "cec2c497598bb14d08214e28b4beb672",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 97300,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "133928410",
                                                                "name": "Meal for 2: Pepper BBQ Chicken & Chicken Dominator",
                                                                "category": "Value Meals",
                                                                "description": "Regular Pepper BBQ Chicken + Regular Chicken Dominator + Garlic Bread + Pepsi",
                                                                "imageId": "eaee2535b8e10b2d2c5204f0af014c62",
                                                                "inStock": 1,
                                                                "price": 67700,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "107334633",
                                                                "name": "Meal for 2: Pepper BBQ Chicken & Spiced Double Chicken",
                                                                "category": "Value Meals",
                                                                "description": "Regular Pepper BBQ Chicken + Regular Spiced Double Chicken + Garlic Bread + Pepsi",
                                                                "imageId": "db7b7c52258c9b4d15f5a20841907c6f",
                                                                "inStock": 1,
                                                                "price": 63700,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "107334704",
                                                                "name": "Meal for 4: Veg Extravaganza & Indi Tandoori Paneer",
                                                                "category": "Value Meals",
                                                                "description": "Medium Veg Extravaganza + Medium Indi Tandoori Paneer + Garlic Bread + 2 Pepsi",
                                                                "imageId": "7e1f7ba41599d73a1bd694f43800d30d",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 114500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.9",
                                                                        "ratingCount": "3 ratings",
                                                                        "ratingCountV2": "3"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "117822940",
                                                                "name": "Choco Lava Cake + Pepsi",
                                                                "category": "Value Meals",
                                                                "description": "Get the indulgent Choco Lava Cake & a Pepsi (475 ml) for just INR 149",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/31/89478d05-215b-454a-b1da-9fdc51814bdd_39e2d28a-812d-4bba-a9ef-5814c349f321.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 15500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.7",
                                                                        "ratingCount": "13 ratings",
                                                                        "ratingCountV2": "13"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "121331277",
                                                                "name": "Spicy Non Veg Combo @ Rs. 95 Off",
                                                                "category": "Value Meals",
                                                                "description": "Reg Blazing ChK & Paprika + Reg Fiery Sausage & Paprika + GB + Pepsi",
                                                                "imageId": "75ed6c50e47f28f1ba1cd70fd422a9ca",
                                                                "inStock": 1,
                                                                "price": 58700,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "107334682",
                                                                "name": "Meal for 4: Margherita & Peppy Paneer",
                                                                "category": "Value Meals",
                                                                "description": "Medium Margherita + Medium Peppy Paneer + Garlic Bread + 2 Pepsi",
                                                                "imageId": "211f75f7fb418271095f26a3d56caac1",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 81100,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "107334561",
                                                                "name": "Meal for 2: Farmhouse & Veg Extravaganza",
                                                                "category": "Value Meals",
                                                                "description": "Regular Farmhouse + Regular Veg Extravaganza + Garlic Bread + Pepsi",
                                                                "imageId": "996ed7334940ce4431e6415b9e31779d",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 63700,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.9",
                                                                        "ratingCount": "3 ratings",
                                                                        "ratingCountV2": "3"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "115659213",
                                                                "name": "Garlic Breadsticks + Pepsi",
                                                                "category": "Value Meals",
                                                                "description": "Enjoy the all time favourite Garlic Breadsticks with Pepsi (475 ml)",
                                                                "imageId": "d4864ae8923187096385912dcc16a5bb",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 15500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "3.5",
                                                                        "ratingCount": "4 ratings",
                                                                        "ratingCountV2": "4"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "107334748",
                                                                "name": "Meal for 4: Veg Cheesy Pizza",
                                                                "category": "Value Meals",
                                                                "description": "Regular Fresh Veggie + Regular Peppy Paneer + Regular Corn n Cheese + Regular Farmhouse",
                                                                "imageId": "4fee651233047ae8a2f077c90c35cc33",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 82300,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "121331282",
                                                                "name": "Spicy Veg Party Combo @ Rs. 140 off",
                                                                "category": "Value Meals",
                                                                "description": "Med Blazing On & Paprika + Med Fiery Jalapeno & Paprika + 2GB + 2 Pepsi",
                                                                "imageId": "29101a5eb18045c038a511e60bee27a9",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 87300,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "107335136",
                                                                "name": "Meal for 4: Non Veg Pizza Mania Value",
                                                                "category": "Value Meals",
                                                                "description": "2 PM Pepper Barbecue Chicken + PM Chicken Sausage + PM Non Veg Loaded",
                                                                "imageId": "db9a1aa724ad79b6a20efb5b311a7af0",
                                                                "inStock": 1,
                                                                "price": 49900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.9",
                                                                        "ratingCount": "10 ratings",
                                                                        "ratingCountV2": "10"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "121331284",
                                                                "name": "Spicy Non Veg Party Combo @ Rs. 180 off",
                                                                "category": "Value Meals",
                                                                "description": "Med Blazing ChK & Paprika + Med Fiery Sausage & Paprika + 2GB + 2 Pepsi",
                                                                "imageId": "7c99650aff626b15071078b319a0c84b",
                                                                "inStock": 1,
                                                                "price": 107300,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "107334578",
                                                                "name": "Meal for 2: Veg Paradise & Farmhouse",
                                                                "category": "Value Meals",
                                                                "description": "Regular Veg Paradise + Regular Farmhouse + Garlic Bread + Pepsi",
                                                                "imageId": "0b454e29d106da0decaf20ad5aeb175a",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 60700,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "121331275",
                                                                "name": "Spicy Veg Combo @ Rs. 75 Off",
                                                                "category": "Value Meals",
                                                                "description": "Reg Blazing On & Paprika + Reg Fiery Jalapeno & Paprika + GB + Pepsi",
                                                                "imageId": "c10f93bce05019d15b4244f800ee9830",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 46700,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "121331273",
                                                                "name": "Garlic Breadsticks + Cheesy Dip",
                                                                "category": "Value Meals",
                                                                "description": "Enjoy the all-time favorite Garlic Breadsticks with the indulgent Cheesy Dip",
                                                                "imageId": "c74e28521828e6654a5ecffff1de9735",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 14357,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.8",
                                                                        "ratingCount": "19 ratings",
                                                                        "ratingCountV2": "19"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "121331279",
                                                                "name": "Hot and Sweet Veg Combo @ Rs. 75 Off",
                                                                "category": "Value Meals",
                                                                "description": "Reg Blazing On & Paprika + Reg Fiery Jalapeno & Paprika + CLC + Pepsi",
                                                                "imageId": "47f24436d2ba7718d6d1d9dd79560c77",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 46700,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Chicken Fiesta",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "155058597",
                                                                "name": "Mini Garlic Cheesiken Rice",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Juicy Chicken| Creamy Garlic Sauce| Molten Cheese with Rice & Veggies - Onion, Jalapeno & Capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/18/198338bb-6f4f-4be5-a34b-cd4d16c7aea2_d93f02a0-fecb-4274-8788-4832d15be689.jpg",
                                                                "inStock": 1,
                                                                "price": 10900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "155058599",
                                                                "name": "Mini Tangy Tomato Cheesiken Rice",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Tender Chicken| Zesty Tomato Sauce| Molten Cheese with Rice & Veggies - Onion, Paprika & Capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/18/4c04c7d4-5b9d-4ad4-bc65-66214176cb40_f6352515-2a22-4df1-89b0-c577a8daef01.jpg",
                                                                "inStock": 1,
                                                                "price": 10900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "155058604",
                                                                "name": "Mini Hot & Fiery Cheesiken Rice",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Tender Chicken| Guntur Chilli Sauce| Molten Cheese with Rice & Veggies - Onion, Olive & Capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/18/dd8c73b5-c23a-4427-842c-98850a063080_dc3dbb4d-1e51-4add-90bd-5366f9794a64.jpg",
                                                                "inStock": 1,
                                                                "price": 10900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "154752759",
                                                                "name": "Spicy Chicken Pops",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Crispy Chicken Popcorn| Bold Chilli sprinkle| Fiery burst of flavour",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/18/f9671ef2-830c-44d0-95e3-147a1bd26ae0_907cb02a-cafd-4f47-8d01-02f2823e4fd7.jpg",
                                                                "inStock": 1,
                                                                "price": 11900,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "154752756",
                                                                "name": "Spicy Chicken Meatballs",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Tender & Juicy Meat Balls| Guntur Chilli Seasoning | Bliss for Chicken Lovers",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/18/eb5898df-71d2-4e68-bdae-d7b7688a5f83_cd931a58-6fe4-4916-8dbe-5c6295d176cd.jpg",
                                                                "inStock": 1,
                                                                "price": 11900,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "154752755",
                                                                "name": "Spicy Roasted Chicken Wings",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Crispy roasted Chicken Wings| Fiery Guntur Seasoning| Spicy burst of flavour",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/18/5f011766-8dfb-4867-b503-1e4b1fda1547_f53d975e-11f5-4d58-8ffb-9baf8064d617.jpg",
                                                                "inStock": 1,
                                                                "price": 14900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "154752760",
                                                                "name": "Saucy Chicken Pops",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Juicy Chicken Popcorn| Bold Guntur Chilli sprinkle| Fiery kick in every bite",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/05f951e6-65e2-4644-82f0-29ff7805ac05_71ae8a69-d936-418e-b011-2142b76b740e.jpg",
                                                                "inStock": 1,
                                                                "price": 14900,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "154752757",
                                                                "name": "Saucy Chicken Meatballs",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Juicy meat balls| Creamy Garlic & Guntur Chilli sauce| Bliss for Chicken Lovers",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/18/2463cdb0-c1dd-4a3c-8bb1-449c5f587008_8561339a-aaee-4595-a8f1-2c51499bc92b.jpg",
                                                                "inStock": 1,
                                                                "price": 14900,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "154752758",
                                                                "name": "Saucy Roasted Chicken Wings",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Juicy Chicken Wings| Creamy Garlic & Guntur Chilli sauce| A fiery treat",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/18/3fa2b21a-5ac9-43a8-9c83-46160d33fa55_dc4b5ac7-afb8-48e4-9c12-d1063e0b237a.jpg",
                                                                "inStock": 1,
                                                                "price": 17900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "155058596",
                                                                "name": "Tangy Tomato Cheesiken",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Tender Chicken| Tangy Tomato Sauce| Molten Cheese| Crunchy Veggies - Onion, Paprika & Capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/d8774178-ddc5-4320-9fbc-44bf43a805d9_43276d31-0e2a-40ef-8557-e8602aa6c1cc.jpg",
                                                                "inStock": 1,
                                                                "price": 16900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "155058601",
                                                                "name": "Garlic Cheesiken",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Tender Chicken| Creamy Garlic Sauce| Molten cheese| Crunchy Veggies - Onion, Paprika & Capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/08bfbefd-8719-408a-bc6c-859cce09f4c4_5ecf4ed8-e555-48e6-b289-eddd3f84a267.jpg",
                                                                "inStock": 1,
                                                                "price": 16900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "155058602",
                                                                "name": "Hot & Fiery Cheesiken",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Juicy Chicken| Guntur Chilli sauce| Molten cheese| Crunchy Veggies - Onion, Paprika & Capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/1c1cec53-26eb-4652-8be4-e8d2e6a63f6c_2597dee4-ae78-432b-a177-627db957800a.jpg",
                                                                "inStock": 1,
                                                                "price": 16900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "155058600",
                                                                "name": "Tangy Tomato Cheesiken Rice",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Tender Chicken| Zesty Tomato Sauce| Molten Cheese with Rice & Veggies - Onion, Paprika & Capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/7a843328-03eb-4c13-bb1c-41491d22ce5f_bca4e59c-c2f8-44b3-8405-e657d087f9bc.jpg",
                                                                "inStock": 1,
                                                                "price": 20900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "155058603",
                                                                "name": "Garlic Cheesiken Rice",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Juicy Chicken| Creamy Garlic Sauce| Molten Cheese with Rice & Veggies - Onion, Jalapeno & Capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/5abe2298-bdbd-4652-85d6-f9e8a41d8f17_452b56f3-e9cc-4e72-9431-2cdc1b371da1.jpg",
                                                                "inStock": 1,
                                                                "price": 20900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "155058598",
                                                                "name": "Hot & Fiery Cheesiken Rice",
                                                                "category": "Chicken Fiesta",
                                                                "description": "Tender Chicken| Guntur Chilli Sauce| Molten Cheese with Rice & Veggies - Onion, Olive & Capsicum",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/687b7bdb-ca74-4eed-918f-aebb06d018c5_67303b13-2db3-4cfe-9f72-32f75f5872bf.jpg",
                                                                "inStock": 1,
                                                                "price": 20900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Dominos Classics",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520657",
                                                                "name": "Margherita Pizza",
                                                                "category": "Dominos Classics",
                                                                "description": "Classic delight with 100% real mozzarella cheese. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "7850b115687ee8594f9d7f0a66c2ee84",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732220",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432001",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732222",
                                                                                        "variationId": "114432008"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432002",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732222",
                                                                                        "variationId": "114432008"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432004",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732222",
                                                                                        "variationId": "114432008"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432005",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732222",
                                                                                        "variationId": "114432008"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432007",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732222",
                                                                                        "variationId": "114432008"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660624",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732222",
                                                                                        "variationId": "114432008"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660625",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732222",
                                                                                        "variationId": "114432008"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660627",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732222",
                                                                                        "variationId": "114432008"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732222",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432008",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432010",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432012",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "155660625"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432008"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847143",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "155660625"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432010"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847147",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "155660627"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432008"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847143",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "155660627"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432010"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847147",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "155660624"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432008"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847143",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "155660624"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432010"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847147",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "114432002"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432008"
                                                                                }
                                                                            ],
                                                                            "price": 13900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847143",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "114432002"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432010"
                                                                                }
                                                                            ],
                                                                            "price": 31500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847147",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "114432001"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432008"
                                                                                }
                                                                            ],
                                                                            "price": 10900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847143",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "114432001"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432012"
                                                                                }
                                                                            ],
                                                                            "price": 48500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640755",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640755",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640755",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640755",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640755",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640755",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640755",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847150",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847151",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847151",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847151",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847151",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847151",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847151",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847151",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847151",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "114432001"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432010"
                                                                                }
                                                                            ],
                                                                            "price": 26500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847147",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "114432004"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432010"
                                                                                }
                                                                            ],
                                                                            "price": 36400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847147",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "114432004"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432008"
                                                                                }
                                                                            ],
                                                                            "price": 18400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847143",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "114432007"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432008"
                                                                                }
                                                                            ],
                                                                            "price": 10900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847143",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "114432005"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432008"
                                                                                }
                                                                            ],
                                                                            "price": 13900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847143",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847145",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640753",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732220",
                                                                                    "variationId": "114432005"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732222",
                                                                                    "variationId": "114432010"
                                                                                }
                                                                            ],
                                                                            "price": 31500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847148",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640754",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847147",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847143",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640753",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847145",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847147",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847148",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640754",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847150",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847151",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640755",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 10900,
                                                                "ribbon": {
                                                                    "text": "Bestseller",
                                                                    "textColor": "#ffffff",
                                                                    "topBackgroundColor": "#d53d4c",
                                                                    "bottomBackgroundColor": "#b02331"
                                                                },
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "isBestseller": true,
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.3",
                                                                        "ratingCount": "112 ratings",
                                                                        "ratingCountV2": "112"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "117107599",
                                                                "name": "Blazing Onion & Paprika",
                                                                "category": "Dominos Classics",
                                                                "description": "Hot & spicy pizza with onion & red paprika toppings and a new spicy peri peri sauce on a Domino's cheesy base.",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/2/e3db1171-0df9-4c02-b6eb-ba8423630c71_28876d94-adb0-4cae-a1cd-06ab38b1a31c.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732225",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432021",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732226",
                                                                                        "variationId": "114432025"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432022",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732226",
                                                                                        "variationId": "114432025"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432023",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732226",
                                                                                        "variationId": "114432025"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432024",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732226",
                                                                                        "variationId": "114432025"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661005",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732226",
                                                                                        "variationId": "114432025"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661006",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732226",
                                                                                        "variationId": "114432025"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661007",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732226",
                                                                                        "variationId": "114432025"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732226",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432025",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432026",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432027",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "155661007"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432026"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349896",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "155661005"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432025"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "155661005"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432026"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349896",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "155661006"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432025"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "155661006"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432026"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349896",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "155661007"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432025"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "114432021"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432025"
                                                                                }
                                                                            ],
                                                                            "price": 18500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "114432021"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432027"
                                                                                }
                                                                            ],
                                                                            "price": 55900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640787",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640787",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640787",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640787",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640787",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640787",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640787",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349894",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349895",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349895",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349895",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349895",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349895",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349895",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349895",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349895",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "114432021"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432026"
                                                                                }
                                                                            ],
                                                                            "price": 33500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349896",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "114432023"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432026"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349896",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "114432023"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432025"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "114432024"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432025"
                                                                                }
                                                                            ],
                                                                            "price": 21500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "114432024"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432026"
                                                                                }
                                                                            ],
                                                                            "price": 38500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349896",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "114432022"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432025"
                                                                                }
                                                                            ],
                                                                            "price": 21500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349893",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640786",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732225",
                                                                                    "variationId": "114432022"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732226",
                                                                                    "variationId": "114432026"
                                                                                }
                                                                            ],
                                                                            "price": 38500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349897",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640788",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349896",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "145349896",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349897",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640788",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349892",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640786",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349893",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349894",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349895",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640787",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 18500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "117107600",
                                                                "name": "Fiery Jalapeno & Paprika",
                                                                "category": "Dominos Classics",
                                                                "description": "Spiciest veg pizza with jalapeno & red paprika toppings and a new spicy peri peri sauce.",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/2/57446390-3a0f-4606-bb8d-68e4b9a7766e_dcfe16e1-64c1-4860-9e1a-1c505f5caaae.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732010",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431375",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732011",
                                                                                        "variationId": "114431379"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431376",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732011",
                                                                                        "variationId": "114431379"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431377",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732011",
                                                                                        "variationId": "114431379"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431378",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732011",
                                                                                        "variationId": "114431379"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660891",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732011",
                                                                                        "variationId": "114431379"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660892",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732011",
                                                                                        "variationId": "114431379"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660893",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732011",
                                                                                        "variationId": "114431379"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732011",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431379",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431380",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431381",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "155660892"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431379"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349908",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "155660892"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431380"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349904",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "155660893"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431379"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349908",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "155660893"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431380"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349904",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "155660891"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431379"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349908",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "155660891"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431380"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349904",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "114431375"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431381"
                                                                                }
                                                                            ],
                                                                            "price": 55900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640833",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640833",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640833",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640833",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640833",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640833",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640833",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349900",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349902",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349902",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349902",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349902",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349902",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349902",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349902",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349902",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "114431375"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431380"
                                                                                }
                                                                            ],
                                                                            "price": 33500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349904",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "114431377"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431380"
                                                                                }
                                                                            ],
                                                                            "price": 43400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349904",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "114431377"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431379"
                                                                                }
                                                                            ],
                                                                            "price": 26000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349908",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "114431378"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431379"
                                                                                }
                                                                            ],
                                                                            "price": 21500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349908",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "114431378"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431380"
                                                                                }
                                                                            ],
                                                                            "price": 38500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349904",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "114431376"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431379"
                                                                                }
                                                                            ],
                                                                            "price": 21500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349908",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "114431376"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431380"
                                                                                }
                                                                            ],
                                                                            "price": 38500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349906",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640834",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349904",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732010",
                                                                                    "variationId": "114431375"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732011",
                                                                                    "variationId": "114431379"
                                                                                }
                                                                            ],
                                                                            "price": 18500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349908",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640835",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "145349908",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640835",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349910",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349904",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349906",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640834",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349900",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349902",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640833",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 18500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520658",
                                                                "name": "Double Cheese Margherita Pizza",
                                                                "category": "Dominos Classics",
                                                                "description": "A classic delight loaded with extra 100% real mozzarella cheese",
                                                                "imageId": "15c3a34b64ec4298f2a0778d1b008919",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732014",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431384",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732015",
                                                                                        "variationId": "114431389"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431385",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732015",
                                                                                        "variationId": "114431389"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431386",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732015",
                                                                                        "variationId": "114431389"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431387",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732015",
                                                                                        "variationId": "114431389"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431388",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732015",
                                                                                        "variationId": "114431389"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660908",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732015",
                                                                                        "variationId": "114431389"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660909",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732015",
                                                                                        "variationId": "114431389"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660911",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732015",
                                                                                        "variationId": "114431389"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732015",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431389",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431390",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431391",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "155660909"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431389"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846742",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "155660909"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431390"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846746",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "155660911"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431389"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846742",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "155660911"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431390"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846746",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "155660908"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431389"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846742",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "155660908"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431390"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846746",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "114431384"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431389"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846742",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "114431384"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431391"
                                                                                }
                                                                            ],
                                                                            "price": 64900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640745",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640745",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640745",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640745",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640745",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640745",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640745",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846744",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846745",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846745",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846745",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846745",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846745",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846745",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846745",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846745",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "114431384"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431390"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846746",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "114431386"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431390"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846746",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "114431386"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431389"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846742",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "114431388"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431389"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846742",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "114431387"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431389"
                                                                                }
                                                                            ],
                                                                            "price": 25900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846742",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "114431387"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431390"
                                                                                }
                                                                            ],
                                                                            "price": 45900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846746",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "114431385"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431389"
                                                                                }
                                                                            ],
                                                                            "price": 25900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846742",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846743",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640744",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732014",
                                                                                    "variationId": "114431385"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732015",
                                                                                    "variationId": "114431390"
                                                                                }
                                                                            ],
                                                                            "price": 45900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846747",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640746",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846746",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131846742",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640744",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846743",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846746",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846747",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640746",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846744",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846745",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640745",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 22900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.3",
                                                                        "ratingCount": "17 ratings",
                                                                        "ratingCountV2": "17"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520665",
                                                                "name": "Fresh Veggie Pizza",
                                                                "category": "Dominos Classics",
                                                                "description": "Delectable combination of onion & capsicum, a veggie lovers pick",
                                                                "imageId": "d9c548f1cb841844f151ffa3de873e4b",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732289",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432226",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732292",
                                                                                        "variationId": "114432235"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432229",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732292",
                                                                                        "variationId": "114432235"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432230",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732292",
                                                                                        "variationId": "114432235"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432232",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732292",
                                                                                        "variationId": "114432235"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432234",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732292",
                                                                                        "variationId": "114432235"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661017",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732292",
                                                                                        "variationId": "114432235"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661018",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732292",
                                                                                        "variationId": "114432235"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661019",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732292",
                                                                                        "variationId": "114432235"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732292",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432235",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432236",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432237",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "155661018"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432235"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "155661018"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432236"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847314",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "155661019"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432235"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "155661019"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432236"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847314",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "155661017"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432235"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "155661017"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432236"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847314",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "114432226"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432235"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "114432226"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432237"
                                                                                }
                                                                            ],
                                                                            "price": 64900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640796",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640796",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640796",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640796",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640796",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640796",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640796",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847306",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847310",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847310",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847310",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847310",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847310",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847310",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847310",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847310",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "114432226"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432236"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847314",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "114432230"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432236"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847314",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "114432230"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432235"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "114432234"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432235"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "114432232"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432235"
                                                                                }
                                                                            ],
                                                                            "price": 25900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "114432232"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432236"
                                                                                }
                                                                            ],
                                                                            "price": 45900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847314",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "114432229"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432235"
                                                                                }
                                                                            ],
                                                                            "price": 25900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847302",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847304",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640795",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732289",
                                                                                    "variationId": "114432229"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732292",
                                                                                    "variationId": "114432236"
                                                                                }
                                                                            ],
                                                                            "price": 45900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847318",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640798",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847314",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847302",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640795",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847304",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847314",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847318",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640798",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847306",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847310",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640796",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 22900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "5.0",
                                                                        "ratingCount": "7 ratings",
                                                                        "ratingCountV2": "7"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520667",
                                                                "name": "Cheese n Corn Pizza",
                                                                "category": "Dominos Classics",
                                                                "description": "A delectable combination of sweet & juicy golden corn",
                                                                "imageId": "25f8cd12a914066c7c9627d42eafd926",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732101",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431641",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732102",
                                                                                        "variationId": "114431646"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431642",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732102",
                                                                                        "variationId": "114431646"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431643",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732102",
                                                                                        "variationId": "114431646"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431644",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732102",
                                                                                        "variationId": "114431646"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431645",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732102",
                                                                                        "variationId": "114431646"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660838",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732102",
                                                                                        "variationId": "114431646"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660841",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732102",
                                                                                        "variationId": "114431646"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660844",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732102",
                                                                                        "variationId": "114431646"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732102",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431646",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431647",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431648",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "155660844"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431646"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846909",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "155660844"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431647"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846905",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "155660838"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431646"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846909",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "155660838"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431647"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846905",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "155660841"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431646"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846909",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "155660841"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431647"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846905",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "114431643"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431647"
                                                                                }
                                                                            ],
                                                                            "price": 50800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846905",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "114431643"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431646"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846909",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "114431645"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431646"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846909",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "114431644"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431646"
                                                                                }
                                                                            ],
                                                                            "price": 25900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846909",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "114431644"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431647"
                                                                                }
                                                                            ],
                                                                            "price": 45900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846905",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "114431642"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431646"
                                                                                }
                                                                            ],
                                                                            "price": 25900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846909",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "114431642"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431647"
                                                                                }
                                                                            ],
                                                                            "price": 45900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846905",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "114431641"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431646"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846909",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846910",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640772",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "114431641"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431648"
                                                                                }
                                                                            ],
                                                                            "price": 64900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640773",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640773",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640773",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640773",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640773",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640773",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640773",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846911",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846912",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846912",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846912",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846912",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846912",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846912",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846912",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846912",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732101",
                                                                                    "variationId": "114431641"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732102",
                                                                                    "variationId": "114431647"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846907",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640771",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846905",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131846909",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640772",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846910",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846905",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846907",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640771",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846911",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846912",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640773",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 22900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.8",
                                                                        "ratingCount": "15 ratings",
                                                                        "ratingCountV2": "15"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520660",
                                                                "name": "Peppy Paneer Pizza",
                                                                "category": "Dominos Classics",
                                                                "description": "Flavorful trio of juicy paneer, crisp capsicum with spicy red paprika",
                                                                "imageId": "0581f2e3b7d0b3ede4b476c1d64a6434",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732199",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431949",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732200",
                                                                                        "variationId": "114431954"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431950",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732200",
                                                                                        "variationId": "114431954"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431951",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732200",
                                                                                        "variationId": "114431954"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431952",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732200",
                                                                                        "variationId": "114431954"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431953",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732200",
                                                                                        "variationId": "114431954"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660981",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732200",
                                                                                        "variationId": "114431954"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660982",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732200",
                                                                                        "variationId": "114431954"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660983",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732200",
                                                                                        "variationId": "114431954"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732200",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431954",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431955",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431956",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "155660981"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431955"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847122",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "155660982"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431954"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847119",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "155660982"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431955"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847122",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "155660983"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431954"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847119",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "155660983"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431955"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847122",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "155660981"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431954"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847119",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "114431951"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431954"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847119",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "114431953"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431954"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847119",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "114431952"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431954"
                                                                                }
                                                                            ],
                                                                            "price": 30900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847119",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "114431952"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431955"
                                                                                }
                                                                            ],
                                                                            "price": 53900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847122",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "114431950"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431954"
                                                                                }
                                                                            ],
                                                                            "price": 30900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847119",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "114431950"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431955"
                                                                                }
                                                                            ],
                                                                            "price": 53900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847122",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "114431949"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431954"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847119",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847120",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640824",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "114431949"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431956"
                                                                                }
                                                                            ],
                                                                            "price": 73900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640826",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640826",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640826",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640826",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640826",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640826",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640826",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847124",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847125",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847125",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847125",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847125",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847125",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847125",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847125",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847125",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "114431949"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431955"
                                                                                }
                                                                            ],
                                                                            "price": 48900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847122",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732199",
                                                                                    "variationId": "114431951"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732200",
                                                                                    "variationId": "114431955"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847123",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640825",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847122",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847122",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847123",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640825",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847119",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640824",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847120",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847124",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847125",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640826",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 27900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.1",
                                                                        "ratingCount": "57 ratings",
                                                                        "ratingCountV2": "57"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520690",
                                                                "name": "Chicken Sausage Pizza",
                                                                "category": "Dominos Classics",
                                                                "description": "American classic! Spicy, herbed chicken sausage on pizza",
                                                                "imageId": "5779285fbfb3c04730f0b71ba4132255",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732397",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432558",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732398",
                                                                                        "variationId": "114432565"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432560",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732398",
                                                                                        "variationId": "114432565"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432562",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732398",
                                                                                        "variationId": "114432565"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432563",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732398",
                                                                                        "variationId": "114432565"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432564",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732398",
                                                                                        "variationId": "114432565"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660966",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732398",
                                                                                        "variationId": "114432565"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660967",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732398",
                                                                                        "variationId": "114432565"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660968",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732398",
                                                                                        "variationId": "114432565"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732398",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432565",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432566",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432567",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "155660967"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432565"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847522",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "155660967"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432566"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847524",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "155660968"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432565"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847522",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "155660968"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432566"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847524",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "155660966"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432565"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847522",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "155660966"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432566"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847524",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "114432560"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432565"
                                                                                }
                                                                            ],
                                                                            "price": 24900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847522",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "114432560"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432566"
                                                                                }
                                                                            ],
                                                                            "price": 43900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847524",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "114432558"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432565"
                                                                                }
                                                                            ],
                                                                            "price": 21900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847522",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "114432558"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432567"
                                                                                }
                                                                            ],
                                                                            "price": 62900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640782",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640782",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640782",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640782",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640782",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640782",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640782",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847527",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847529",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847529",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847529",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847529",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847529",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847529",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847529",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847529",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "114432558"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432566"
                                                                                }
                                                                            ],
                                                                            "price": 38900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847524",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "114432562"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432566"
                                                                                }
                                                                            ],
                                                                            "price": 48800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847524",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "114432562"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432565"
                                                                                }
                                                                            ],
                                                                            "price": 29400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847522",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "114432564"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432565"
                                                                                }
                                                                            ],
                                                                            "price": 21900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847522",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "114432563"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432565"
                                                                                }
                                                                            ],
                                                                            "price": 24900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847522",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847523",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640780",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732397",
                                                                                    "variationId": "114432563"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732398",
                                                                                    "variationId": "114432566"
                                                                                }
                                                                            ],
                                                                            "price": 43900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847525",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640781",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847524",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847522",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640780",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847523",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847524",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847525",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640781",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847527",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847529",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640782",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 21900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.4",
                                                                        "ratingCount": "5 ratings",
                                                                        "ratingCountV2": "5"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520691",
                                                                "name": "Pepper Barbecue Chicken Pizza",
                                                                "category": "Dominos Classics",
                                                                "description": "Pepper barbecue chicken for that extra zing. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "7602a3d88b2aeb0053954d96be9a9829",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732547",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114433045",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732548",
                                                                                        "variationId": "114433053"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114433049",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732548",
                                                                                        "variationId": "114433053"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114433050",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732548",
                                                                                        "variationId": "114433053"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114433051",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732548",
                                                                                        "variationId": "114433053"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114433052",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732548",
                                                                                        "variationId": "114433053"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660924",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732548",
                                                                                        "variationId": "114433053"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660925",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732548",
                                                                                        "variationId": "114433053"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660926",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732548",
                                                                                        "variationId": "114433053"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732548",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114433053",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114433054",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114433055",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "155660925"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433053"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847851",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "155660925"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433054"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847843",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "155660926"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433053"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847851",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "155660926"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433054"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847843",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "155660924"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433053"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847851",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "155660924"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433054"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847843",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "114433051"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433054"
                                                                                }
                                                                            ],
                                                                            "price": 52900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847843",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "114433049"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433053"
                                                                                }
                                                                            ],
                                                                            "price": 29900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847851",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "114433049"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433054"
                                                                                }
                                                                            ],
                                                                            "price": 52900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847843",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "114433045"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433053"
                                                                                }
                                                                            ],
                                                                            "price": 26900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847851",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "114433045"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433055"
                                                                                }
                                                                            ],
                                                                            "price": 70900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640841",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640841",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640841",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640841",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640841",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640841",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640841",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847860",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847863",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847863",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847863",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847863",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847863",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847863",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847863",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847863",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "114433045"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433054"
                                                                                }
                                                                            ],
                                                                            "price": 47900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847843",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "114433050"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433054"
                                                                                }
                                                                            ],
                                                                            "price": 57800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847847",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640839",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847843",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "114433050"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433053"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847851",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "114433052"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433053"
                                                                                }
                                                                            ],
                                                                            "price": 26900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847851",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732547",
                                                                                    "variationId": "114433051"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732548",
                                                                                    "variationId": "114433053"
                                                                                }
                                                                            ],
                                                                            "price": 29900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847851",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847855",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640840",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847851",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640840",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847855",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847843",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847847",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640839",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847860",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847863",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640841",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 26900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.4",
                                                                        "ratingCount": "31 ratings",
                                                                        "ratingCountV2": "31"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "117107603",
                                                                "name": "Blazing Chicken & Paprika",
                                                                "category": "Dominos Classics",
                                                                "description": "Hot & spicy chicken pizza with a combination of chicken keema & red paprika toppings and a new spicy peri peri sauce.",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/2/381126cc-5ec8-4475-9e13-7100a1238287_f147bac1-9e8e-43fa-921d-3a8f3958c8e8.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732453",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432731",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732454",
                                                                                        "variationId": "114432735"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432732",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732454",
                                                                                        "variationId": "114432735"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432733",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732454",
                                                                                        "variationId": "114432735"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432734",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732454",
                                                                                        "variationId": "114432735"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661080",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732454",
                                                                                        "variationId": "114432735"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661081",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732454",
                                                                                        "variationId": "114432735"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661082",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732454",
                                                                                        "variationId": "114432735"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732454",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432735",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432737",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432739",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "155661081"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432737"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349866",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "155661082"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432735"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349862",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "155661082"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432737"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349866",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "155661080"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432735"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349862",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "155661080"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432737"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349866",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "155661081"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432735"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349862",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "114432731"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432735"
                                                                                }
                                                                            ],
                                                                            "price": 25500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349862",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "114432731"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432739"
                                                                                }
                                                                            ],
                                                                            "price": 67900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640822",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640822",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640822",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640822",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640822",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640822",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640822",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349864",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349865",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349865",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349865",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349865",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349865",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349865",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349865",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349865",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "114432731"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432737"
                                                                                }
                                                                            ],
                                                                            "price": 45500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349866",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "114432733"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432737"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349866",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "114432733"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432735"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349862",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "114432734"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432735"
                                                                                }
                                                                            ],
                                                                            "price": 28500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349862",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "114432734"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432737"
                                                                                }
                                                                            ],
                                                                            "price": 50500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349866",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "114432732"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432735"
                                                                                }
                                                                            ],
                                                                            "price": 28500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349862",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349863",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640821",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732453",
                                                                                    "variationId": "114432732"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732454",
                                                                                    "variationId": "114432737"
                                                                                }
                                                                            ],
                                                                            "price": 50500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349867",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640823",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349866",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "145349866",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349867",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640823",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349862",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640821",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349863",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349864",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349865",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640822",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 25500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "117107601",
                                                                "name": "Fiery Sausage & Paprika",
                                                                "category": "Dominos Classics",
                                                                "description": "Spiciest non veg pizza with spicy & herby chicken sausage and red paprika toppings on a new spicy peri peri sauce base.",
                                                                "imageId": "2190eb54162d9a61e34e6970d53cbcc2",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732417",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432617",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732418",
                                                                                        "variationId": "114432621"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432618",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732418",
                                                                                        "variationId": "114432621"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432619",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732418",
                                                                                        "variationId": "114432621"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432620",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732418",
                                                                                        "variationId": "114432621"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660975",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732418",
                                                                                        "variationId": "114432621"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660976",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732418",
                                                                                        "variationId": "114432621"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660977",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732418",
                                                                                        "variationId": "114432621"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732418",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432621",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432622",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432623",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "155660976"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432621"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349868",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "155660976"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432622"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349872",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "155660977"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432621"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349868",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "155660977"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432622"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349872",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "155660975"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432621"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349868",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "155660975"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432622"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349872",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "114432617"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432621"
                                                                                }
                                                                            ],
                                                                            "price": 25500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349868",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "114432617"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432623"
                                                                                }
                                                                            ],
                                                                            "price": 67900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640831",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640831",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640831",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640831",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640831",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640831",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640831",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349870",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349871",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349871",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349871",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349871",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349871",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349871",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349871",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349871",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "114432617"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432622"
                                                                                }
                                                                            ],
                                                                            "price": 45500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349872",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "114432619"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432622"
                                                                                }
                                                                            ],
                                                                            "price": 55400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349872",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "114432619"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432621"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349868",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "114432620"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432621"
                                                                                }
                                                                            ],
                                                                            "price": 28500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349868",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "114432620"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432622"
                                                                                }
                                                                            ],
                                                                            "price": 50500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349872",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "114432618"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432621"
                                                                                }
                                                                            ],
                                                                            "price": 28500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349868",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349869",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640830",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732417",
                                                                                    "variationId": "114432618"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732418",
                                                                                    "variationId": "114432622"
                                                                                }
                                                                            ],
                                                                            "price": 50500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349873",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640832",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "145349872",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "145349868",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640830",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349869",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349872",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349873",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640832",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349870",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "145349871",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640831",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 25500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520646",
                                                                "name": "Spiced Double Chicken",
                                                                "category": "Dominos Classics",
                                                                "description": "Delightful combination of our spicy duo- Pepper Barbecue Chicken and Peri Peri Chicken for Chicken Lovers.",
                                                                "imageId": "613401a1232b2bd8ba3c5ecb6173dc38",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732469",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432774",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732470",
                                                                                        "variationId": "114432779"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432775",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732470",
                                                                                        "variationId": "114432779"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432776",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732470",
                                                                                        "variationId": "114432779"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432777",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732470",
                                                                                        "variationId": "114432779"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432778",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732470",
                                                                                        "variationId": "114432779"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661098",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732470",
                                                                                        "variationId": "114432779"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661099",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732470",
                                                                                        "variationId": "114432779"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661100",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732470",
                                                                                        "variationId": "114432779"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732470",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432779",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432781",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432783",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "155661100"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432779"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847649",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "155661100"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432781"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847655",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "155661098"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432779"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847649",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "155661098"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432781"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847655",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "155661099"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432779"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847649",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "155661099"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432781"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847655",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "114432777"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432779"
                                                                                }
                                                                            ],
                                                                            "price": 34500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847649",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "114432777"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432781"
                                                                                }
                                                                            ],
                                                                            "price": 60900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847655",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "114432775"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432779"
                                                                                }
                                                                            ],
                                                                            "price": 34500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847649",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "114432775"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432781"
                                                                                }
                                                                            ],
                                                                            "price": 60900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847655",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "114432774"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432779"
                                                                                }
                                                                            ],
                                                                            "price": 31500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847649",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "114432774"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432783"
                                                                                }
                                                                            ],
                                                                            "price": 84500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640767",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640767",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640767",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640767",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640767",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640767",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640767",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847662",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847666",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847666",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847666",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847666",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847666",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847666",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847666",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847666",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "114432774"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432781"
                                                                                }
                                                                            ],
                                                                            "price": 56900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847655",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "114432776"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432781"
                                                                                }
                                                                            ],
                                                                            "price": 65800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847658",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640766",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847655",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "114432776"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432779"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847649",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732469",
                                                                                    "variationId": "114432778"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732470",
                                                                                    "variationId": "114432779"
                                                                                }
                                                                            ],
                                                                            "price": 31500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847649",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847651",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640765",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847649",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640765",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847651",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847655",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847658",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640766",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847662",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847666",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640767",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 31500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.1",
                                                                        "ratingCount": "9 ratings",
                                                                        "ratingCountV2": "9"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520694",
                                                                "name": "Chicken Golden Delight Pizza",
                                                                "category": "Dominos Classics",
                                                                "description": "Double pepper barbecue chicken, golden corn and extra cheese, true delight",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/27/3d22946c-ef95-495c-bedf-658566549a56_e29b66d9-60a0-4a1e-abe3-bec70737fab1.jpg",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732306",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432279",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732308",
                                                                                        "variationId": "114432288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432281",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732308",
                                                                                        "variationId": "114432288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432284",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732308",
                                                                                        "variationId": "114432288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432286",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732308",
                                                                                        "variationId": "114432288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432287",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732308",
                                                                                        "variationId": "114432288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660813",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732308",
                                                                                        "variationId": "114432288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660814",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732308",
                                                                                        "variationId": "114432288"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660815",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732308",
                                                                                        "variationId": "114432288"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732308",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432288",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432289",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432290",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "155660814"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847333",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "155660815"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432288"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847343",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "155660815"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847333",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "155660813"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432288"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847343",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "155660813"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847333",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "155660814"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432288"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847343",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "114432281"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432289"
                                                                                }
                                                                            ],
                                                                            "price": 63900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847333",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "114432279"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432288"
                                                                                }
                                                                            ],
                                                                            "price": 32900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847343",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "114432279"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432290"
                                                                                }
                                                                            ],
                                                                            "price": 87900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640752",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640752",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640752",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640752",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640752",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640752",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640752",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847348",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847350",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847350",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847350",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847350",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847350",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847350",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847350",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847350",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "114432279"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432289"
                                                                                }
                                                                            ],
                                                                            "price": 58900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847333",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "114432284"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432289"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847333",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "114432284"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432288"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847343",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "114432287"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432288"
                                                                                }
                                                                            ],
                                                                            "price": 32900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847343",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "114432286"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432288"
                                                                                }
                                                                            ],
                                                                            "price": 35900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847343",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "114432286"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432289"
                                                                                }
                                                                            ],
                                                                            "price": 63900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847337",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640750",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847333",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732306",
                                                                                    "variationId": "114432281"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732308",
                                                                                    "variationId": "114432288"
                                                                                }
                                                                            ],
                                                                            "price": 35900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847343",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847346",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640751",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847333",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847337",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640750",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847343",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640751",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847346",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847348",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847350",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640752",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 32900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520695",
                                                                "name": "Chicken Pepperoni Pizza",
                                                                "category": "Dominos Classics",
                                                                "description": "A classic American taste! Relish the delectable flavor of Chicken Pepperoni, topped with extra cheese",
                                                                "imageId": "973d3c0fcc111b4c92bc49fbb775266c",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732028",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431418",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732029",
                                                                                        "variationId": "114431423"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431419",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732029",
                                                                                        "variationId": "114431423"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431420",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732029",
                                                                                        "variationId": "114431423"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431421",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732029",
                                                                                        "variationId": "114431423"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431422",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732029",
                                                                                        "variationId": "114431423"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660945",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732029",
                                                                                        "variationId": "114431423"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660946",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732029",
                                                                                        "variationId": "114431423"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660947",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732029",
                                                                                        "variationId": "114431423"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732029",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431423",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431424",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431425",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "155660946"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431423"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846766",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "155660946"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431424"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846768",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "155660947"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431423"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846766",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "155660947"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431424"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846768",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "155660945"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431423"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846766",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "155660945"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431424"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846768",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "114431419"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431423"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846766",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "114431419"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431424"
                                                                                }
                                                                            ],
                                                                            "price": 67900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846768",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "114431418"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431423"
                                                                                }
                                                                            ],
                                                                            "price": 37900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846766",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "114431418"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431425"
                                                                                }
                                                                            ],
                                                                            "price": 96900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640811",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640811",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640811",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640811",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640811",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640811",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640811",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846770",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846771",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846771",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846771",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846771",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846771",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846771",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846771",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846771",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "114431418"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431424"
                                                                                }
                                                                            ],
                                                                            "price": 62900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846768",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "114431420"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431424"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846768",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "114431420"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431423"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846766",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "114431422"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431423"
                                                                                }
                                                                            ],
                                                                            "price": 37900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846766",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "114431421"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431423"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846766",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846767",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640809",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732028",
                                                                                    "variationId": "114431421"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732029",
                                                                                    "variationId": "114431424"
                                                                                }
                                                                            ],
                                                                            "price": 67900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846769",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640810",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846768",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131846766",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640809",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846767",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846768",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846769",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640810",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846770",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846771",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640811",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 37900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.9",
                                                                        "ratingCount": "7 ratings",
                                                                        "ratingCountV2": "7"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Loaded Pizza",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520664",
                                                                "name": "Veggie Paradise Pizza",
                                                                "category": "Loaded Pizza",
                                                                "description": "The awesome foursome! Golden corn, black olives, capsicum, red paprika",
                                                                "imageId": "2a8ea479040d62f82871e1be7470672a",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732421",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432626",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732422",
                                                                                        "variationId": "114432631"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432627",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732422",
                                                                                        "variationId": "114432631"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432628",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732422",
                                                                                        "variationId": "114432631"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432629",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732422",
                                                                                        "variationId": "114432631"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432630",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732422",
                                                                                        "variationId": "114432631"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661047",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732422",
                                                                                        "variationId": "114432631"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661048",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732422",
                                                                                        "variationId": "114432631"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661049",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732422",
                                                                                        "variationId": "114432631"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732422",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432631",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432632",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432633",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "155661048"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432631"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847564",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "155661048"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432632"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847576",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "155661049"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432631"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847564",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "155661049"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432632"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847576",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "155661047"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432631"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847564",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "155661047"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432632"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847576",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "114432626"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432631"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847564",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "114432626"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432633"
                                                                                }
                                                                            ],
                                                                            "price": 73900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640760",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640760",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640760",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640760",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640760",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640760",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640760",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847570",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847573",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847573",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847573",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847573",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847573",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847573",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847573",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847573",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "114432626"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432632"
                                                                                }
                                                                            ],
                                                                            "price": 48900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847576",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "114432628"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432632"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847576",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "114432628"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432631"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847564",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "114432630"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432631"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847564",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "114432629"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432631"
                                                                                }
                                                                            ],
                                                                            "price": 30900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847564",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "114432629"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432632"
                                                                                }
                                                                            ],
                                                                            "price": 53900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847576",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "114432627"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432631"
                                                                                }
                                                                            ],
                                                                            "price": 30900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847564",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847567",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640759",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732421",
                                                                                    "variationId": "114432627"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732422",
                                                                                    "variationId": "114432632"
                                                                                }
                                                                            ],
                                                                            "price": 53900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847578",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640761",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847576",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847564",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640759",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847567",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847576",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847578",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640761",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847570",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847573",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640760",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 27900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.5",
                                                                        "ratingCount": "33 ratings",
                                                                        "ratingCountV2": "33"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520659",
                                                                "name": "Farmhouse Pizza",
                                                                "category": "Loaded Pizza",
                                                                "description": "Delightful combination of onion, capsicum, tomato & grilled mushroom. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "740a92bd202ffd40813bc354b86005db",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732353",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432409",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732354",
                                                                                        "variationId": "114432414"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432410",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732354",
                                                                                        "variationId": "114432414"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432411",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732354",
                                                                                        "variationId": "114432414"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432412",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732354",
                                                                                        "variationId": "114432414"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432413",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732354",
                                                                                        "variationId": "114432414"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155661113",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732354",
                                                                                        "variationId": "114432414"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155661114",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732354",
                                                                                        "variationId": "114432414"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155661115",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732354",
                                                                                        "variationId": "114432414"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732354",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432414",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432415",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432417",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "155661114"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432414"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847425",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "155661114"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432415"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847433",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "155661115"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432414"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847425",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "155661115"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432415"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847433",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "155661113"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432414"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847425",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "155661113"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432415"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847433",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "114432409"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432414"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847425",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "114432409"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432417"
                                                                                }
                                                                            ],
                                                                            "price": 73900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640837",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640837",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640837",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640837",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640837",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640837",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640837",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847430",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847432",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847432",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847432",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847432",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847432",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847432",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847432",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847432",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "114432409"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432415"
                                                                                }
                                                                            ],
                                                                            "price": 48900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847433",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "114432411"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432415"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847433",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "114432411"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432414"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847425",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "114432413"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432414"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847425",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "114432412"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432414"
                                                                                }
                                                                            ],
                                                                            "price": 30900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847425",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "114432412"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432415"
                                                                                }
                                                                            ],
                                                                            "price": 53900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847433",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "114432410"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432414"
                                                                                }
                                                                            ],
                                                                            "price": 30900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847425",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847427",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640836",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732353",
                                                                                    "variationId": "114432410"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732354",
                                                                                    "variationId": "114432415"
                                                                                }
                                                                            ],
                                                                            "price": 53900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847435",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640838",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847433",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847425",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640836",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847427",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847433",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847435",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640838",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847430",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847432",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640837",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 27900,
                                                                "ribbon": {
                                                                    "text": "Bestseller",
                                                                    "textColor": "#ffffff",
                                                                    "topBackgroundColor": "#d53d4c",
                                                                    "bottomBackgroundColor": "#b02331"
                                                                },
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "isBestseller": true,
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.5",
                                                                        "ratingCount": "136 ratings",
                                                                        "ratingCountV2": "136"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520661",
                                                                "name": "Mexican Green Wave Pizza",
                                                                "category": "Loaded Pizza",
                                                                "description": "Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                                                                "imageId": "0d1949eef23c572096269d890e438efb",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732533",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432999",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732535",
                                                                                        "variationId": "114433006"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114433000",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732535",
                                                                                        "variationId": "114433006"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114433001",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732535",
                                                                                        "variationId": "114433006"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114433002",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732535",
                                                                                        "variationId": "114433006"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114433003",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732535",
                                                                                        "variationId": "114433006"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660729",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732535",
                                                                                        "variationId": "114433006"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660730",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732535",
                                                                                        "variationId": "114433006"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660731",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732535",
                                                                                        "variationId": "114433006"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732535",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114433006",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114433008",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114433010",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "155660730"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433006"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847829",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "155660730"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433008"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847823",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "155660731"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433006"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847829",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "155660731"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433008"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847823",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "155660729"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433006"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847829",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "155660729"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433008"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847823",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "114433000"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433008"
                                                                                }
                                                                            ],
                                                                            "price": 53900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847823",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "114432999"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433006"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847829",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "114432999"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433010"
                                                                                }
                                                                            ],
                                                                            "price": 73900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640829",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640829",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640829",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640829",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640829",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640829",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640829",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847834",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847836",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847836",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847836",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847836",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847836",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847836",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847836",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847836",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "114432999"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433008"
                                                                                }
                                                                            ],
                                                                            "price": 48900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847823",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "114433001"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433008"
                                                                                }
                                                                            ],
                                                                            "price": 58800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847823",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "114433001"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433006"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847829",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "114433003"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433006"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847829",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "114433002"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433006"
                                                                                }
                                                                            ],
                                                                            "price": 30900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847829",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "114433002"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433008"
                                                                                }
                                                                            ],
                                                                            "price": 53900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847826",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640827",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847823",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732533",
                                                                                    "variationId": "114433000"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732535",
                                                                                    "variationId": "114433006"
                                                                                }
                                                                            ],
                                                                            "price": 30900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847829",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847831",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640828",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847829",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640828",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847831",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847823",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847826",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640827",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847834",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847836",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640829",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 27900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "3.4",
                                                                        "ratingCount": "11 ratings",
                                                                        "ratingCountV2": "11"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520663",
                                                                "name": "Veg Extravaganza Pizza",
                                                                "category": "Loaded Pizza",
                                                                "description": "Black olives, capsicum, onion, grilled mushroom, corn, tomato, jalapeno & extra cheese. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "80355befb12f52c22eb75c6f865ca328",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732176",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431874",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732178",
                                                                                        "variationId": "114431883"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431876",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732178",
                                                                                        "variationId": "114431883"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431879",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732178",
                                                                                        "variationId": "114431883"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431881",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732178",
                                                                                        "variationId": "114431883"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431882",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732178",
                                                                                        "variationId": "114431883"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732178",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431883",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431884",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431885",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732176",
                                                                                    "variationId": "114431874"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732178",
                                                                                    "variationId": "114431884"
                                                                                }
                                                                            ],
                                                                            "price": 58900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847069",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732176",
                                                                                    "variationId": "114431879"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732178",
                                                                                    "variationId": "114431884"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847069",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732176",
                                                                                    "variationId": "114431879"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732178",
                                                                                    "variationId": "114431883"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847074",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732176",
                                                                                    "variationId": "114431882"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732178",
                                                                                    "variationId": "114431883"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847074",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732176",
                                                                                    "variationId": "114431881"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732178",
                                                                                    "variationId": "114431883"
                                                                                }
                                                                            ],
                                                                            "price": 34900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847074",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732176",
                                                                                    "variationId": "114431881"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732178",
                                                                                    "variationId": "114431884"
                                                                                }
                                                                            ],
                                                                            "price": 63900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847069",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732176",
                                                                                    "variationId": "114431876"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732178",
                                                                                    "variationId": "114431883"
                                                                                }
                                                                            ],
                                                                            "price": 34900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847074",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732176",
                                                                                    "variationId": "114431876"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732178",
                                                                                    "variationId": "114431884"
                                                                                }
                                                                            ],
                                                                            "price": 63900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847071",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640806",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847069",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732176",
                                                                                    "variationId": "114431874"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732178",
                                                                                    "variationId": "114431883"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847074",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847077",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640807",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732176",
                                                                                    "variationId": "114431874"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732178",
                                                                                    "variationId": "114431885"
                                                                                }
                                                                            ],
                                                                            "price": 84900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640808",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640808",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640808",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640808",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640808",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640808",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640808",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847079",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847080",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847080",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847080",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847080",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847080",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847080",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847080",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847080",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847069",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847071",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640806",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847074",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640807",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847077",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847079",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847080",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640808",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.2",
                                                                        "ratingCount": "38 ratings",
                                                                        "ratingCountV2": "38"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520645",
                                                                "name": "Cheese Overload",
                                                                "category": "Loaded Pizza",
                                                                "description": "Cheese Overloaded Pizza with a medley of Mozzarella, Cheddar & Ghost Pepper flavoured Cheese.",
                                                                "imageId": "fd7f927d5acf2244f17ec2a5b2512773",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732169",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431847",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732170",
                                                                                        "variationId": "114431851"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431848",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732170",
                                                                                        "variationId": "114431851"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431849",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732170",
                                                                                        "variationId": "114431851"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431850",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732170",
                                                                                        "variationId": "114431851"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732170",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431851",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431852",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431853",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732169",
                                                                                    "variationId": "114431847"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732170",
                                                                                    "variationId": "114431851"
                                                                                }
                                                                            ],
                                                                            "price": 35500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847043",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732169",
                                                                                    "variationId": "114431847"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732170",
                                                                                    "variationId": "114431853"
                                                                                }
                                                                            ],
                                                                            "price": 97900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640804",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640804",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640804",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640804",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640804",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640804",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640804",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847051",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847055",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847055",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847055",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847055",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847055",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847055",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847055",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847055",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732169",
                                                                                    "variationId": "114431847"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732170",
                                                                                    "variationId": "114431852"
                                                                                }
                                                                            ],
                                                                            "price": 64900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847059",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732169",
                                                                                    "variationId": "114431850"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732170",
                                                                                    "variationId": "114431851"
                                                                                }
                                                                            ],
                                                                            "price": 35500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847043",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732169",
                                                                                    "variationId": "114431849"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732170",
                                                                                    "variationId": "114431851"
                                                                                }
                                                                            ],
                                                                            "price": 38500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847043",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732169",
                                                                                    "variationId": "114431849"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732170",
                                                                                    "variationId": "114431852"
                                                                                }
                                                                            ],
                                                                            "price": 69900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847059",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732169",
                                                                                    "variationId": "114431848"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732170",
                                                                                    "variationId": "114431851"
                                                                                }
                                                                            ],
                                                                            "price": 38500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847043",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847046",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640803",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732169",
                                                                                    "variationId": "114431848"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732170",
                                                                                    "variationId": "114431852"
                                                                                }
                                                                            ],
                                                                            "price": 69900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847061",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640805",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847059",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847043",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640803",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847046",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847051",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847055",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640804",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847059",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847061",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640805",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "3.9",
                                                                        "ratingCount": "3 ratings",
                                                                        "ratingCountV2": "3"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520693",
                                                                "name": "Chicken Fiesta Pizza",
                                                                "category": "Loaded Pizza",
                                                                "description": "Grilled chicken rashers, peri-peri chicken, onion & capsicum, a complete fiesta",
                                                                "imageId": "274348f5f584d2893c654f7880c3eacb",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732407",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432583",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732411",
                                                                                        "variationId": "114432598"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432584",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732411",
                                                                                        "variationId": "114432598"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432587",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732411",
                                                                                        "variationId": "114432598"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432591",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732411",
                                                                                        "variationId": "114432598"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432594",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732411",
                                                                                        "variationId": "114432598"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660915",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732411",
                                                                                        "variationId": "114432598"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660916",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732411",
                                                                                        "variationId": "114432598"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660917",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732411",
                                                                                        "variationId": "114432598"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732411",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432598",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432601",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432603",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "155660917"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432601"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847543",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "155660915"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432598"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847536",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "155660915"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432601"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847543",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "155660916"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432598"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847536",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "155660916"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432601"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847543",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "155660917"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432598"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847536",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "114432587"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432598"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847536",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "114432594"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432598"
                                                                                }
                                                                            ],
                                                                            "price": 32900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847536",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "114432591"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432598"
                                                                                }
                                                                            ],
                                                                            "price": 35900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847536",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "114432591"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432601"
                                                                                }
                                                                            ],
                                                                            "price": 63900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847543",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "114432584"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432598"
                                                                                }
                                                                            ],
                                                                            "price": 35900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847536",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "114432584"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432601"
                                                                                }
                                                                            ],
                                                                            "price": 63900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847543",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "114432583"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432598"
                                                                                }
                                                                            ],
                                                                            "price": 32900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847536",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847539",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640815",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "114432583"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432603"
                                                                                }
                                                                            ],
                                                                            "price": 87900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640817",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640817",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640817",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640817",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640817",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640817",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640817",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847550",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847553",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847553",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847553",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847553",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847553",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847553",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847553",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847553",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "114432583"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432601"
                                                                                }
                                                                            ],
                                                                            "price": 58900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847543",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732407",
                                                                                    "variationId": "114432587"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732411",
                                                                                    "variationId": "114432601"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847546",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640816",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847543",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847543",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847546",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640816",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847536",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640815",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847539",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847550",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847553",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640817",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 32900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.8",
                                                                        "ratingCount": "14 ratings",
                                                                        "ratingCountV2": "14"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520688",
                                                                "name": "Chicken Dominator Pizza",
                                                                "category": "Loaded Pizza",
                                                                "description": "Loaded with double pepper barbecue chicken, peri-peri chicken, chicken tikka & grilled chicken rashers. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "22118134ebce9f89b2c12b95c19154db",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732036",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431444",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732037",
                                                                                        "variationId": "114431449"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431445",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732037",
                                                                                        "variationId": "114431449"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431446",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732037",
                                                                                        "variationId": "114431449"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431447",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732037",
                                                                                        "variationId": "114431449"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431448",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732037",
                                                                                        "variationId": "114431449"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732037",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431449",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431450",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431451",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732036",
                                                                                    "variationId": "114431444"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732037",
                                                                                    "variationId": "114431449"
                                                                                }
                                                                            ],
                                                                            "price": 37900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846778",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732036",
                                                                                    "variationId": "114431444"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732037",
                                                                                    "variationId": "114431451"
                                                                                }
                                                                            ],
                                                                            "price": 96900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640775",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640775",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640775",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640775",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640775",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640775",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640775",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846780",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846781",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846781",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846781",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846781",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846781",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846781",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846781",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846781",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732036",
                                                                                    "variationId": "114431444"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732037",
                                                                                    "variationId": "114431450"
                                                                                }
                                                                            ],
                                                                            "price": 62900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846784",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732036",
                                                                                    "variationId": "114431446"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732037",
                                                                                    "variationId": "114431450"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846784",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732036",
                                                                                    "variationId": "114431446"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732037",
                                                                                    "variationId": "114431449"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846778",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732036",
                                                                                    "variationId": "114431448"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732037",
                                                                                    "variationId": "114431449"
                                                                                }
                                                                            ],
                                                                            "price": 37900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846778",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732036",
                                                                                    "variationId": "114431447"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732037",
                                                                                    "variationId": "114431449"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846778",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732036",
                                                                                    "variationId": "114431447"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732037",
                                                                                    "variationId": "114431450"
                                                                                }
                                                                            ],
                                                                            "price": 67900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846784",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732036",
                                                                                    "variationId": "114431445"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732037",
                                                                                    "variationId": "114431449"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846778",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846779",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640774",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732036",
                                                                                    "variationId": "114431445"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732037",
                                                                                    "variationId": "114431450"
                                                                                }
                                                                            ],
                                                                            "price": 67900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846785",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640776",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846784",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131846778",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640774",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846779",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846780",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846781",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640775",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846784",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846785",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640776",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 37900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.6",
                                                                        "ratingCount": "46 ratings",
                                                                        "ratingCountV2": "46"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520689",
                                                                "name": "Non Veg Supreme Pizza",
                                                                "category": "Loaded Pizza",
                                                                "description": "Supreme combination of black olives, onion, capsicum, grilled mushroom, pepper barbecue chicken, peri-peri chicken & grilled chicken rashers",
                                                                "imageId": "f03bf80c03fa196e84ccb8f2510b2ef8",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732261",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432141",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732263",
                                                                                        "variationId": "114432150"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432142",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732263",
                                                                                        "variationId": "114432150"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432144",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732263",
                                                                                        "variationId": "114432150"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432146",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732263",
                                                                                        "variationId": "114432150"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432148",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732263",
                                                                                        "variationId": "114432150"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732263",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432150",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432152",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432154",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732261",
                                                                                    "variationId": "114432144"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732263",
                                                                                    "variationId": "114432152"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847234",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732261",
                                                                                    "variationId": "114432144"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732263",
                                                                                    "variationId": "114432150"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847240",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732261",
                                                                                    "variationId": "114432148"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732263",
                                                                                    "variationId": "114432150"
                                                                                }
                                                                            ],
                                                                            "price": 37900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847240",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732261",
                                                                                    "variationId": "114432146"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732263",
                                                                                    "variationId": "114432150"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847240",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732261",
                                                                                    "variationId": "114432146"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732263",
                                                                                    "variationId": "114432152"
                                                                                }
                                                                            ],
                                                                            "price": 67900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847234",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732261",
                                                                                    "variationId": "114432142"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732263",
                                                                                    "variationId": "114432150"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847240",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732261",
                                                                                    "variationId": "114432142"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732263",
                                                                                    "variationId": "114432152"
                                                                                }
                                                                            ],
                                                                            "price": 67900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847234",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732261",
                                                                                    "variationId": "114432141"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732263",
                                                                                    "variationId": "114432150"
                                                                                }
                                                                            ],
                                                                            "price": 37900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847240",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847244",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640813",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732261",
                                                                                    "variationId": "114432141"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732263",
                                                                                    "variationId": "114432154"
                                                                                }
                                                                            ],
                                                                            "price": 96900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640814",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640814",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640814",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640814",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640814",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640814",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640814",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847248",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847252",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847252",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847252",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847252",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847252",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847252",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847252",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847252",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732261",
                                                                                    "variationId": "114432141"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732263",
                                                                                    "variationId": "114432152"
                                                                                }
                                                                            ],
                                                                            "price": 62900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847237",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640812",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847234",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847234",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847237",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640812",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847240",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640813",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847244",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847248",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847252",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640814",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 37900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.7",
                                                                        "ratingCount": "21 ratings",
                                                                        "ratingCountV2": "21"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520648",
                                                                "name": "The 5 Chicken Feast Pizza",
                                                                "category": "Loaded Pizza",
                                                                "description": "Loaded with 5 different Chicken toppings - grilled Chicken Rashers, Chicken Meatballs, Chicken Tikka, herby Chicken Sausage and flavorful Chicken Keema",
                                                                "imageId": "03998b8a2a364faffde45ceb2bb95812",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732044",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431470",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732045",
                                                                                        "variationId": "114431475"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431471",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732045",
                                                                                        "variationId": "114431475"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431472",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732045",
                                                                                        "variationId": "114431475"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431473",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732045",
                                                                                        "variationId": "114431475"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431474",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732045",
                                                                                        "variationId": "114431475"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660564",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732045",
                                                                                        "variationId": "114431475"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660565",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732045",
                                                                                        "variationId": "114431475"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660566",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732045",
                                                                                        "variationId": "114431475"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732045",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431475",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431476",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431477",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "155660564"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431476"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846795",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "155660565"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431475"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846793",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "155660565"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431476"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846795",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "155660566"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431475"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846793",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "155660566"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431476"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846795",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "155660564"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431475"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846793",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "114431473"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431475"
                                                                                }
                                                                            ],
                                                                            "price": 43500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846793",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "114431473"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431476"
                                                                                }
                                                                            ],
                                                                            "price": 75900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846795",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "114431471"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431475"
                                                                                }
                                                                            ],
                                                                            "price": 43500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846793",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "114431471"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431476"
                                                                                }
                                                                            ],
                                                                            "price": 75900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846795",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "114431470"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431475"
                                                                                }
                                                                            ],
                                                                            "price": 40500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846793",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "114431470"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431477"
                                                                                }
                                                                            ],
                                                                            "price": 104900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640749",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640749",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640749",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640749",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640749",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640749",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640749",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846797",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846798",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846798",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846798",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846798",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846798",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846798",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846798",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846798",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "114431470"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431476"
                                                                                }
                                                                            ],
                                                                            "price": 70900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846795",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "114431472"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431476"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846796",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640748",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846795",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "114431472"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431475"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846793",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732044",
                                                                                    "variationId": "114431474"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732045",
                                                                                    "variationId": "114431475"
                                                                                }
                                                                            ],
                                                                            "price": 40500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846793",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846794",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640747",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131846795",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846796",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640748",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846793",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640747",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846794",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846797",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846798",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640749",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 40500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "3.9",
                                                                        "ratingCount": "10 ratings",
                                                                        "ratingCountV2": "10"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Flavours of India",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520670",
                                                                "name": "Achari Do Pyaza Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "Tangy & spicy achari flavours on a super cheesy onion pizza- as desi as it gets!",
                                                                "imageId": "14d8197b31ae36df0b697ba52b204d17",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732187",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431902",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732188",
                                                                                        "variationId": "114431907"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431903",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732188",
                                                                                        "variationId": "114431907"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431904",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732188",
                                                                                        "variationId": "114431907"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431905",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732188",
                                                                                        "variationId": "114431907"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431906",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732188",
                                                                                        "variationId": "114431907"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660936",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732188",
                                                                                        "variationId": "114431907"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660937",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732188",
                                                                                        "variationId": "114431907"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660938",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732188",
                                                                                        "variationId": "114431907"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732188",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431907",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431908",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431909",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "155660937"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431907"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847081",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "155660937"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431908"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847090",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "155660938"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431907"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847081",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "155660938"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431908"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847090",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "155660936"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431907"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847081",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "155660936"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431908"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847090",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "114431902"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431907"
                                                                                }
                                                                            ],
                                                                            "price": 19900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847081",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "114431902"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431909"
                                                                                }
                                                                            ],
                                                                            "price": 58900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640778",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640778",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640778",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640778",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640778",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640778",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640778",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847083",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847085",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847085",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847085",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847085",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847085",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847085",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847085",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847085",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "114431902"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431908"
                                                                                }
                                                                            ],
                                                                            "price": 34900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847090",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "114431904"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431908"
                                                                                }
                                                                            ],
                                                                            "price": 44800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847090",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "114431904"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431907"
                                                                                }
                                                                            ],
                                                                            "price": 27400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847081",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "114431906"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431907"
                                                                                }
                                                                            ],
                                                                            "price": 19900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847081",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "114431905"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431907"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847081",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "114431905"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431908"
                                                                                }
                                                                            ],
                                                                            "price": 39900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847090",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "114431903"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431907"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847081",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847082",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640777",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732187",
                                                                                    "variationId": "114431903"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732188",
                                                                                    "variationId": "114431908"
                                                                                }
                                                                            ],
                                                                            "price": 39900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847094",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640779",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847090",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847081",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640777",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847082",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847090",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847094",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640779",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847083",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847085",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640778",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 19900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "3.6",
                                                                        "ratingCount": "3 ratings",
                                                                        "ratingCountV2": "3"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520642",
                                                                "name": "Corn n Cheese Paratha Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "A crazy fusion like never before. A delicious fusion of corn stuffed paratha and cheesy pizza.",
                                                                "imageId": "4632dbb593cccf672f8e28638ce3e8f8",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732349",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "default": 1,
                                                                                    "id": "114432399",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732350",
                                                                                        "variationId": "114432400"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732350",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432400",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732349",
                                                                                    "variationId": "114432399"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732350",
                                                                                    "variationId": "114432400"
                                                                                }
                                                                            ],
                                                                            "price": 19900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 19900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.6",
                                                                        "ratingCount": "22 ratings",
                                                                        "ratingCountV2": "22"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520668",
                                                                "name": "Indi Tandoori Paneer Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "It is hot. It is spicy. It is oh-so-Indian. Tandoori paneer with capsicum, red paprika & mint mayo. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "010b29da595df93d828ca0dca935821a",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732147",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431782",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732148",
                                                                                        "variationId": "114431787"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431783",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732148",
                                                                                        "variationId": "114431787"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431784",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732148",
                                                                                        "variationId": "114431787"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431785",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732148",
                                                                                        "variationId": "114431787"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431786",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732148",
                                                                                        "variationId": "114431787"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660696",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732148",
                                                                                        "variationId": "114431787"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660699",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732148",
                                                                                        "variationId": "114431787"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660701",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732148",
                                                                                        "variationId": "114431787"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732148",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431787",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431788",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431789",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "155660701"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431787"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847003",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "155660701"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431788"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847011",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "155660696"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431787"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847003",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "155660696"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431788"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847011",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "155660699"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431787"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847003",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "155660699"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431788"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847011",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "114431782"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431787"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847003",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "114431782"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431789"
                                                                                }
                                                                            ],
                                                                            "price": 84900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640763",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640763",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640763",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640763",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640763",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640763",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640763",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847006",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847008",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847008",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847008",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847008",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847008",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847008",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847008",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847008",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "114431782"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431788"
                                                                                }
                                                                            ],
                                                                            "price": 58900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847011",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "114431784"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431788"
                                                                                }
                                                                            ],
                                                                            "price": 68800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847011",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "114431784"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431787"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847003",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "114431786"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431787"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847003",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "114431785"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431787"
                                                                                }
                                                                            ],
                                                                            "price": 34900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847003",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "114431785"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431788"
                                                                                }
                                                                            ],
                                                                            "price": 63900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847011",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "114431783"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431787"
                                                                                }
                                                                            ],
                                                                            "price": 34900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847003",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847004",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640762",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732147",
                                                                                    "variationId": "114431783"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732148",
                                                                                    "variationId": "114431788"
                                                                                }
                                                                            ],
                                                                            "price": 63900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847014",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640764",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847011",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847003",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640762",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847004",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847011",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847014",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640764",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847006",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847008",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640763",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.6",
                                                                        "ratingCount": "48 ratings",
                                                                        "ratingCountV2": "48"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520644",
                                                                "name": "Chicken Keema Paratha Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "Flavourful & meaty chicken keema paratha and goodness of cheesy pizza coming together in an epic crossover!",
                                                                "imageId": "47eaf1f74ab478d1604f4f4da9a3c617",
                                                                "inStock": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732050",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "default": 1,
                                                                                    "id": "114431494",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732051",
                                                                                        "variationId": "114431495"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732051",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431495",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732050",
                                                                                    "variationId": "114431494"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732051",
                                                                                    "variationId": "114431495"
                                                                                }
                                                                            ],
                                                                            "price": 26900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 26900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "5.0",
                                                                        "ratingCount": "17 ratings",
                                                                        "ratingCountV2": "17"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520696",
                                                                "name": "Indi Chicken Tikka Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "The wholesome flavour of tandoori masala with Chicken tikka, onion, red paprika & mint mayo",
                                                                "imageId": "0e1a0ba55f0f03990c7e4331b404845a",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732497",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432869",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732498",
                                                                                        "variationId": "114432874"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432870",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732498",
                                                                                        "variationId": "114432874"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432871",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732498",
                                                                                        "variationId": "114432874"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432872",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732498",
                                                                                        "variationId": "114432874"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432873",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732498",
                                                                                        "variationId": "114432874"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "155660582",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732498",
                                                                                        "variationId": "114432874"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "155660583",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732498",
                                                                                        "variationId": "114432874"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "155660584",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732498",
                                                                                        "variationId": "114432874"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732498",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432874",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432875",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432876",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "155660584"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432875"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847727",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "155660582"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432874"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847722",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "155660582"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432875"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847727",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "155660583"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432874"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847722",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "155660583"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432875"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847727",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "155660584"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432874"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847722",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "114432869"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432874"
                                                                                }
                                                                            ],
                                                                            "price": 37900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847722",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "114432869"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432876"
                                                                                }
                                                                            ],
                                                                            "price": 96900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640793",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640793",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640793",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640793",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640793",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640793",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640793",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847725",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847726",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847726",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847726",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847726",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847726",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847726",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847726",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847726",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "114432869"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432875"
                                                                                }
                                                                            ],
                                                                            "price": 62900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847727",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "114432871"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432875"
                                                                                }
                                                                            ],
                                                                            "price": 72800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847727",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "114432871"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432874"
                                                                                }
                                                                            ],
                                                                            "price": 45400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847722",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "114432873"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432874"
                                                                                }
                                                                            ],
                                                                            "price": 37900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847722",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "114432872"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432874"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847722",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "114432872"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432875"
                                                                                }
                                                                            ],
                                                                            "price": 67900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847727",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "114432870"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432874"
                                                                                }
                                                                            ],
                                                                            "price": 40900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847722",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847723",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640792",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732497",
                                                                                    "variationId": "114432870"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732498",
                                                                                    "variationId": "114432875"
                                                                                }
                                                                            ],
                                                                            "price": 67900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847728",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640794",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847727",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847727",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847728",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640794",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847722",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640792",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847723",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847725",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847726",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640793",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 37900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.7",
                                                                        "ratingCount": "25 ratings",
                                                                        "ratingCountV2": "25"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "101726646",
                                                                "name": "Malai Paneer Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "A enticing combination of spicy jalapenos and Masala Paneer which is built around the traditional combination of coconut , Panchphoran and mustard",
                                                                "imageId": "d5b7f13bedb72defa1f5fed95a3b3860",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732157",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431805",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732158",
                                                                                        "variationId": "114431810"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431806",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732158",
                                                                                        "variationId": "114431810"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431807",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732158",
                                                                                        "variationId": "114431810"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431808",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732158",
                                                                                        "variationId": "114431810"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431809",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732158",
                                                                                        "variationId": "114431810"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732158",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431810",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431811",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431812",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732157",
                                                                                    "variationId": "114431805"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732158",
                                                                                    "variationId": "114431810"
                                                                                }
                                                                            ],
                                                                            "price": 30500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847018",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732157",
                                                                                    "variationId": "114431805"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732158",
                                                                                    "variationId": "114431812"
                                                                                }
                                                                            ],
                                                                            "price": 81500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640784",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640784",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640784",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640784",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640784",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640784",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640784",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847023",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847027",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847027",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847027",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847027",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847027",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847027",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847027",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847027",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732157",
                                                                                    "variationId": "114431805"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732158",
                                                                                    "variationId": "114431811"
                                                                                }
                                                                            ],
                                                                            "price": 55900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847031",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732157",
                                                                                    "variationId": "114431807"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732158",
                                                                                    "variationId": "114431811"
                                                                                }
                                                                            ],
                                                                            "price": 67800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847031",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732157",
                                                                                    "variationId": "114431807"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732158",
                                                                                    "variationId": "114431810"
                                                                                }
                                                                            ],
                                                                            "price": 40000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847018",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732157",
                                                                                    "variationId": "114431809"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732158",
                                                                                    "variationId": "114431810"
                                                                                }
                                                                            ],
                                                                            "price": 30500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847018",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732157",
                                                                                    "variationId": "114431808"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732158",
                                                                                    "variationId": "114431810"
                                                                                }
                                                                            ],
                                                                            "price": 35000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847018",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732157",
                                                                                    "variationId": "114431808"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732158",
                                                                                    "variationId": "114431811"
                                                                                }
                                                                            ],
                                                                            "price": 61400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847031",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732157",
                                                                                    "variationId": "114431806"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732158",
                                                                                    "variationId": "114431810"
                                                                                }
                                                                            ],
                                                                            "price": 35000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847018",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847020",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640783",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732157",
                                                                                    "variationId": "114431806"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732158",
                                                                                    "variationId": "114431811"
                                                                                }
                                                                            ],
                                                                            "price": 62400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847035",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640785",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847031",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847018",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640783",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847020",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847023",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847027",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640784",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847031",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847035",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640785",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "3.3",
                                                                        "ratingCount": "4 ratings",
                                                                        "ratingCountV2": "4"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "101726644",
                                                                "name": "Kosha Veg Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "A veg cheesy pizzas loaded with onion and mushroom made in the authentic Bengali Kosha recipe",
                                                                "imageId": "b49a49795c7b422e9588bda3e4c1549a",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732090",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431604",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732091",
                                                                                        "variationId": "114431609"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114431605",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732091",
                                                                                        "variationId": "114431609"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114431606",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732091",
                                                                                        "variationId": "114431609"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431607",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732091",
                                                                                        "variationId": "114431609"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431608",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732091",
                                                                                        "variationId": "114431609"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732091",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431609",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114431610",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114431611",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732090",
                                                                                    "variationId": "114431604"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732091",
                                                                                    "variationId": "114431611"
                                                                                }
                                                                            ],
                                                                            "price": 81500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640800",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640800",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640800",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640800",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640800",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640800",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640800",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846882",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846884",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846884",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846884",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846884",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846884",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846884",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846884",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846884",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732090",
                                                                                    "variationId": "114431604"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732091",
                                                                                    "variationId": "114431610"
                                                                                }
                                                                            ],
                                                                            "price": 55900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846887",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732090",
                                                                                    "variationId": "114431606"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732091",
                                                                                    "variationId": "114431610"
                                                                                }
                                                                            ],
                                                                            "price": 67800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846887",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732090",
                                                                                    "variationId": "114431606"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732091",
                                                                                    "variationId": "114431609"
                                                                                }
                                                                            ],
                                                                            "price": 40000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732090",
                                                                                    "variationId": "114431608"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732091",
                                                                                    "variationId": "114431609"
                                                                                }
                                                                            ],
                                                                            "price": 30500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732090",
                                                                                    "variationId": "114431607"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732091",
                                                                                    "variationId": "114431609"
                                                                                }
                                                                            ],
                                                                            "price": 35000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732090",
                                                                                    "variationId": "114431607"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732091",
                                                                                    "variationId": "114431610"
                                                                                }
                                                                            ],
                                                                            "price": 61400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846887",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732090",
                                                                                    "variationId": "114431605"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732091",
                                                                                    "variationId": "114431609"
                                                                                }
                                                                            ],
                                                                            "price": 35000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732090",
                                                                                    "variationId": "114431605"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732091",
                                                                                    "variationId": "114431610"
                                                                                }
                                                                            ],
                                                                            "price": 62400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846889",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640801",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846887",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732090",
                                                                                    "variationId": "114431604"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732091",
                                                                                    "variationId": "114431609"
                                                                                }
                                                                            ],
                                                                            "price": 30500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131846892",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131846894",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640802",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131846882",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846884",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640800",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846887",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846889",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640801",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846892",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640802",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131846894",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "106720169",
                                                                "name": "Champaran Veg Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "Inspired by the authentic flavours of Champaran, a cheesy veg pizza loaded with red paparika, capsicum and mushrooms.",
                                                                "imageId": "7c2aeba3013425989fe8c1d662f3450f",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732477",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432806",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732478",
                                                                                        "variationId": "114432811"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432807",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732478",
                                                                                        "variationId": "114432811"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432808",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732478",
                                                                                        "variationId": "114432811"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432809",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732478",
                                                                                        "variationId": "114432811"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432810",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732478",
                                                                                        "variationId": "114432811"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732478",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432811",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432812",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432813",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732477",
                                                                                    "variationId": "114432806"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732478",
                                                                                    "variationId": "114432811"
                                                                                }
                                                                            ],
                                                                            "price": 30500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847681",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732477",
                                                                                    "variationId": "114432806"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732478",
                                                                                    "variationId": "114432813"
                                                                                }
                                                                            ],
                                                                            "price": 81500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640790",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640790",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640790",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640790",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640790",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640790",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640790",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847683",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847684",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847684",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847684",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847684",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847684",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847684",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847684",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847684",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732477",
                                                                                    "variationId": "114432806"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732478",
                                                                                    "variationId": "114432812"
                                                                                }
                                                                            ],
                                                                            "price": 55900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847685",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732477",
                                                                                    "variationId": "114432808"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732478",
                                                                                    "variationId": "114432812"
                                                                                }
                                                                            ],
                                                                            "price": 67800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847685",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732477",
                                                                                    "variationId": "114432808"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732478",
                                                                                    "variationId": "114432811"
                                                                                }
                                                                            ],
                                                                            "price": 40000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847681",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732477",
                                                                                    "variationId": "114432810"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732478",
                                                                                    "variationId": "114432811"
                                                                                }
                                                                            ],
                                                                            "price": 30500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847681",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732477",
                                                                                    "variationId": "114432809"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732478",
                                                                                    "variationId": "114432811"
                                                                                }
                                                                            ],
                                                                            "price": 35000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847681",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732477",
                                                                                    "variationId": "114432809"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732478",
                                                                                    "variationId": "114432812"
                                                                                }
                                                                            ],
                                                                            "price": 61400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847685",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732477",
                                                                                    "variationId": "114432807"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732478",
                                                                                    "variationId": "114432811"
                                                                                }
                                                                            ],
                                                                            "price": 35000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847681",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847682",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640789",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732477",
                                                                                    "variationId": "114432807"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732478",
                                                                                    "variationId": "114432812"
                                                                                }
                                                                            ],
                                                                            "price": 62400,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847688",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640791",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847685",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847681",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640789",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847682",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847683",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847684",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640790",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847685",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847688",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640791",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "126407821",
                                                                "name": "Malai Chingri Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "An irresistible fusion of authentic Malai sauce, succulent Chingri (Prawns) & Red Paprika with a sprinkle of Panch phoran seasoning",
                                                                "imageId": "a9860da5707872e2f0a8231bb542efbf",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732271",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432173",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732272",
                                                                                        "variationId": "114432180"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432175",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732272",
                                                                                        "variationId": "114432180"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432177",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732272",
                                                                                        "variationId": "114432180"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432178",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732272",
                                                                                        "variationId": "114432180"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432179",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732272",
                                                                                        "variationId": "114432180"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732272",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432180",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432181",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432182",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732271",
                                                                                    "variationId": "114432177"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732272",
                                                                                    "variationId": "114432181"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847261",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732271",
                                                                                    "variationId": "114432177"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732272",
                                                                                    "variationId": "114432180"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847265",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732271",
                                                                                    "variationId": "114432178"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732272",
                                                                                    "variationId": "114432181"
                                                                                }
                                                                            ],
                                                                            "price": 75900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847261",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732271",
                                                                                    "variationId": "114432178"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732272",
                                                                                    "variationId": "114432180"
                                                                                }
                                                                            ],
                                                                            "price": 43500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847265",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732271",
                                                                                    "variationId": "114432173"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732272",
                                                                                    "variationId": "114432181"
                                                                                }
                                                                            ],
                                                                            "price": 70900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847261",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732271",
                                                                                    "variationId": "114432179"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732272",
                                                                                    "variationId": "114432180"
                                                                                }
                                                                            ],
                                                                            "price": 40500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847265",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732271",
                                                                                    "variationId": "114432173"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732272",
                                                                                    "variationId": "114432180"
                                                                                }
                                                                            ],
                                                                            "price": 40500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847265",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732271",
                                                                                    "variationId": "114432175"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732272",
                                                                                    "variationId": "114432180"
                                                                                }
                                                                            ],
                                                                            "price": 43500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847265",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847267",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640769",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732271",
                                                                                    "variationId": "114432173"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732272",
                                                                                    "variationId": "114432182"
                                                                                }
                                                                            ],
                                                                            "price": 104900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640770",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640770",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640770",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640770",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640770",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640770",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640770",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847270",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847275",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847275",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847275",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847275",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847275",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847275",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847275",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847275",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732271",
                                                                                    "variationId": "114432175"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732272",
                                                                                    "variationId": "114432181"
                                                                                }
                                                                            ],
                                                                            "price": 75900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847263",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640768",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847261",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847261",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847263",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640768",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847265",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640769",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847267",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847270",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847275",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640770",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 40500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "126407822",
                                                                "name": "Kosha Mangsho Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "A first of its kind Kosha Mangsho pizza. Made with our authentic Kosha sauce topped with our delectable Mutton meatball & Onion",
                                                                "imageId": "e42cc4ef8ebb2ee8f2ec61a1f90e8c21",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732367",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432456",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732369",
                                                                                        "variationId": "114432465"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432457",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732369",
                                                                                        "variationId": "114432465"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432459",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732369",
                                                                                        "variationId": "114432465"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432461",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732369",
                                                                                        "variationId": "114432465"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432463",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732369",
                                                                                        "variationId": "114432465"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732369",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432465",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432467",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432468",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732367",
                                                                                    "variationId": "114432459"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732369",
                                                                                    "variationId": "114432467"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732367",
                                                                                    "variationId": "114432459"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732369",
                                                                                    "variationId": "114432465"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732367",
                                                                                    "variationId": "114432461"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732369",
                                                                                    "variationId": "114432467"
                                                                                }
                                                                            ],
                                                                            "price": 75900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732367",
                                                                                    "variationId": "114432461"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732369",
                                                                                    "variationId": "114432465"
                                                                                }
                                                                            ],
                                                                            "price": 43500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732367",
                                                                                    "variationId": "114432456"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732369",
                                                                                    "variationId": "114432467"
                                                                                }
                                                                            ],
                                                                            "price": 70900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732367",
                                                                                    "variationId": "114432463"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732369",
                                                                                    "variationId": "114432465"
                                                                                }
                                                                            ],
                                                                            "price": 40500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732367",
                                                                                    "variationId": "114432456"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732369",
                                                                                    "variationId": "114432465"
                                                                                }
                                                                            ],
                                                                            "price": 40500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732367",
                                                                                    "variationId": "114432457"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732369",
                                                                                    "variationId": "114432465"
                                                                                }
                                                                            ],
                                                                            "price": 43500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847447",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847450",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640757",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732367",
                                                                                    "variationId": "114432456"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732369",
                                                                                    "variationId": "114432468"
                                                                                }
                                                                            ],
                                                                            "price": 104900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640758",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640758",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640758",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640758",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640758",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640758",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640758",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847453",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847456",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847456",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847456",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847456",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847456",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847456",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847456",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847456",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732367",
                                                                                    "variationId": "114432457"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732369",
                                                                                    "variationId": "114432467"
                                                                                }
                                                                            ],
                                                                            "price": 75900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847445",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640756",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847442",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847442",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847445",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640756",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847447",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640757",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847450",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847453",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847456",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640758",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 40500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "126407823",
                                                                "name": "Champaran Mutton Pizza",
                                                                "category": "Flavours of India",
                                                                "description": "Savor the infusion of authentic Champaran sauce topped with our delectable Mutton meatball & a dash of Red Paprika",
                                                                "imageId": "f5da86b3de65f32fa2540dcb070f9e68",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732339",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432360",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732340",
                                                                                        "variationId": "114432365"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "100% Wheat Thin Crust",
                                                                                    "id": "114432361",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732340",
                                                                                        "variationId": "114432365"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "id": "114432362",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732340",
                                                                                        "variationId": "114432365"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432363",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732340",
                                                                                        "variationId": "114432365"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432364",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732340",
                                                                                        "variationId": "114432365"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732340",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432365",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Medium",
                                                                                    "id": "114432366",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                },
                                                                                {
                                                                                    "name": "Large",
                                                                                    "id": "114432367",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732339",
                                                                                    "variationId": "114432362"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732340",
                                                                                    "variationId": "114432366"
                                                                                }
                                                                            ],
                                                                            "price": 80800,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847393",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732339",
                                                                                    "variationId": "114432362"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732340",
                                                                                    "variationId": "114432365"
                                                                                }
                                                                            ],
                                                                            "price": 48000,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847399",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732339",
                                                                                    "variationId": "114432363"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732340",
                                                                                    "variationId": "114432366"
                                                                                }
                                                                            ],
                                                                            "price": 75900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847393",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732339",
                                                                                    "variationId": "114432363"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732340",
                                                                                    "variationId": "114432365"
                                                                                }
                                                                            ],
                                                                            "price": 43500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847399",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732339",
                                                                                    "variationId": "114432360"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732340",
                                                                                    "variationId": "114432366"
                                                                                }
                                                                            ],
                                                                            "price": 70900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847393",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732339",
                                                                                    "variationId": "114432364"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732340",
                                                                                    "variationId": "114432365"
                                                                                }
                                                                            ],
                                                                            "price": 40500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847399",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732339",
                                                                                    "variationId": "114432360"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732340",
                                                                                    "variationId": "114432365"
                                                                                }
                                                                            ],
                                                                            "price": 40500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847399",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732339",
                                                                                    "variationId": "114432361"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732340",
                                                                                    "variationId": "114432365"
                                                                                }
                                                                            ],
                                                                            "price": 43500,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847399",
                                                                                    "addonId": "100000680"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000691"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000676"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000692"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000677"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000689"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000694"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000674"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847402",
                                                                                    "addonId": "100000683"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424338"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424328"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424340"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424331"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424346"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424334"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640819",
                                                                                    "addonId": "121424337"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732339",
                                                                                    "variationId": "114432360"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732340",
                                                                                    "variationId": "114432367"
                                                                                }
                                                                            ],
                                                                            "price": 104900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "166640820",
                                                                                    "addonId": "121424326"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640820",
                                                                                    "addonId": "121424344"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640820",
                                                                                    "addonId": "121424339"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640820",
                                                                                    "addonId": "121424330"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640820",
                                                                                    "addonId": "121424342"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640820",
                                                                                    "addonId": "121424333"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640820",
                                                                                    "addonId": "121424336"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847403",
                                                                                    "addonId": "100000673"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847405",
                                                                                    "addonId": "100000685"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847405",
                                                                                    "addonId": "100000699"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847405",
                                                                                    "addonId": "100000695"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847405",
                                                                                    "addonId": "100000698"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847405",
                                                                                    "addonId": "100000684"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847405",
                                                                                    "addonId": "100000697"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847405",
                                                                                    "addonId": "100000679"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847405",
                                                                                    "addonId": "100000681"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732339",
                                                                                    "variationId": "114432361"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732340",
                                                                                    "variationId": "114432366"
                                                                                }
                                                                            ],
                                                                            "price": 75900,
                                                                            "addonCombinations": [
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000682"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000678"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000686"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000675"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000690"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000693"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000696"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847396",
                                                                                    "addonId": "100000688"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424327"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424329"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424345"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424341"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424332"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424343"
                                                                                },
                                                                                {
                                                                                    "groupId": "166640818",
                                                                                    "addonId": "121424335"
                                                                                },
                                                                                {
                                                                                    "groupId": "131847393",
                                                                                    "addonId": "100000687"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "addons": [
                                                                    {
                                                                        "groupId": "131847393",
                                                                        "groupName": "Extra Cheese Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000687",
                                                                                "name": "Extra Cheese",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847396",
                                                                        "groupName": "Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000682",
                                                                                "name": "Onion",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000678",
                                                                                "name": "Black Olive",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000686",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000675",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000690",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000693",
                                                                                "name": "Paneer",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000696",
                                                                                "name": "Jalapeno",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000688",
                                                                                "name": "Red Pepper",
                                                                                "price": 6000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640818",
                                                                        "groupName": "Non-Veg Toppings Medium",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424327",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424329",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424345",
                                                                                "name": "Chicken Keema",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424341",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424332",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424343",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424335",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 7500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847399",
                                                                        "groupName": "Extra Cheese Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000680",
                                                                                "name": "Extra Cheese",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640819",
                                                                        "groupName": "Non-Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424338",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424328",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424340",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424331",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424346",
                                                                                "name": "Chicken Keema",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424334",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424337",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 5000,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847402",
                                                                        "groupName": "Veg Toppings Regular",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000691",
                                                                                "name": "Black Olive",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000676",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000692",
                                                                                "name": "Onion",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000677",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000689",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000694",
                                                                                "name": "Red Pepper",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000674",
                                                                                "name": "Paneer",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000683",
                                                                                "name": "Jalapeno",
                                                                                "price": 3500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847403",
                                                                        "groupName": "Extra Cheese Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000673",
                                                                                "name": "Extra Cheese",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "131847405",
                                                                        "groupName": "Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "100000685",
                                                                                "name": "Jalapeno",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000699",
                                                                                "name": "Black Olive",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000695",
                                                                                "name": "Grilled Mushrooms",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000698",
                                                                                "name": "Onion",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000684",
                                                                                "name": "Crisp Capsicum",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000697",
                                                                                "name": "Fresh Tomato",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000679",
                                                                                "name": "Red Pepper",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "100000681",
                                                                                "name": "Paneer",
                                                                                "price": 8000,
                                                                                "inStock": 1,
                                                                                "isVeg": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    },
                                                                    {
                                                                        "groupId": "166640820",
                                                                        "groupName": "Non-Veg Toppings Large",
                                                                        "choices": [
                                                                            {
                                                                                "id": "121424326",
                                                                                "name": "Chicken Pepperoni",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424344",
                                                                                "name": "Chicken Keema",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424339",
                                                                                "name": "Peri - Peri Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424330",
                                                                                "name": "Pepper Barbecue Chicken",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424342",
                                                                                "name": "Chicken Sausage",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424333",
                                                                                "name": "Grilled Chicken Rasher",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            },
                                                                            {
                                                                                "id": "121424336",
                                                                                "name": "Chicken Tikka",
                                                                                "price": 9500,
                                                                                "inStock": 1,
                                                                                "isEnabled": 1
                                                                            }
                                                                        ],
                                                                        "maxAddons": -1,
                                                                        "maxFreeAddons": -1
                                                                    }
                                                                ],
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 40500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "PIZZA MANIA",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "110256290",
                                                                "name": "Chicken Keema & Onion with Desi Makhani Sauce",
                                                                "category": "PIZZA MANIA",
                                                                "description": "Authentic Indian Flavor of Makhani Sauce loaded with meaty Chicken Keema and crunchy Onion.",
                                                                "imageId": "3df23818f7ab45dbd2268ca1d67cb1ad",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732006",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431369",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732007",
                                                                                        "variationId": "114431371"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431370",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732007",
                                                                                        "variationId": "114431371"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732007",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431371",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732006",
                                                                                    "variationId": "114431370"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732007",
                                                                                    "variationId": "114431371"
                                                                                }
                                                                            ],
                                                                            "price": 14900
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732006",
                                                                                    "variationId": "114431369"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732007",
                                                                                    "variationId": "114431371"
                                                                                }
                                                                            ],
                                                                            "price": 19400
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 14900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.5",
                                                                        "ratingCount": "37 ratings",
                                                                        "ratingCountV2": "37"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "110256291",
                                                                "name": "Paneer, Onion & Capsicum with Desi Makhani Sauce",
                                                                "category": "PIZZA MANIA",
                                                                "description": "Authentic Indian Flavor of Makhani Sauce loaded with juicy Paneer, crisp Capsicum and crunchy Onion.",
                                                                "imageId": "d3dcf25529b780071e99443e0fff16d2",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732216",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431992",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732218",
                                                                                        "variationId": "114431997"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431994",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732218",
                                                                                        "variationId": "114431997"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732218",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431997",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732216",
                                                                                    "variationId": "114431994"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732218",
                                                                                    "variationId": "114431997"
                                                                                }
                                                                            ],
                                                                            "price": 13500
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732216",
                                                                                    "variationId": "114431992"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732218",
                                                                                    "variationId": "114431997"
                                                                                }
                                                                            ],
                                                                            "price": 18000
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 13500,
                                                                "ribbon": {
                                                                    "text": "Bestseller",
                                                                    "textColor": "#ffffff",
                                                                    "topBackgroundColor": "#d53d4c",
                                                                    "bottomBackgroundColor": "#b02331"
                                                                },
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "isBestseller": true,
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.5",
                                                                        "ratingCount": "146 ratings",
                                                                        "ratingCountV2": "146"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520733",
                                                                "name": "Non Veg Loaded",
                                                                "category": "PIZZA MANIA",
                                                                "description": "Chicken sausage, pepper barbecue chicken & peri-peri chicken in a fresh pan crust",
                                                                "imageId": "fe37811c8d1a9b0c5923ff1a60926b7d",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732211",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "default": 1,
                                                                                    "id": "114431982",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732212",
                                                                                        "variationId": "114431983"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732212",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431983",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732211",
                                                                                    "variationId": "114431982"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732212",
                                                                                    "variationId": "114431983"
                                                                                }
                                                                            ],
                                                                            "price": 20500
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 20500,
                                                                "ribbon": {
                                                                    "text": "Bestseller",
                                                                    "textColor": "#ffffff",
                                                                    "topBackgroundColor": "#d53d4c",
                                                                    "bottomBackgroundColor": "#b02331"
                                                                },
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "isBestseller": true,
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.4",
                                                                        "ratingCount": "245 ratings",
                                                                        "ratingCountV2": "245"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520734",
                                                                "name": "Veg Loaded",
                                                                "category": "PIZZA MANIA",
                                                                "description": "Tomato, Jalapeno, Corn, Grilled Mushroom & crushed Aranchini Patty in a fresh pan crust",
                                                                "imageId": "67f137415f266758203dea6e20d5ee66",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732058",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "default": 1,
                                                                                    "id": "114431514",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732061",
                                                                                        "variationId": "114431517"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732061",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431517",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732058",
                                                                                    "variationId": "114431514"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732061",
                                                                                    "variationId": "114431517"
                                                                                }
                                                                            ],
                                                                            "price": 19500
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 19500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.4",
                                                                        "ratingCount": "173 ratings",
                                                                        "ratingCountV2": "173"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "110256293",
                                                                "name": "Paneer & Capsicum with Videshi Hot Sauce",
                                                                "category": "PIZZA MANIA",
                                                                "description": "Internationally inspired Hot sauce to cater your spice cravings loaded with juicy Paneer and crisp Capsicum.",
                                                                "imageId": "19e473103f43185544a02acd6c842b94",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732144",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431773",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732145",
                                                                                        "variationId": "114431778"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431775",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732145",
                                                                                        "variationId": "114431778"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732145",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431778",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732144",
                                                                                    "variationId": "114431775"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732145",
                                                                                    "variationId": "114431778"
                                                                                }
                                                                            ],
                                                                            "price": 11500
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732144",
                                                                                    "variationId": "114431773"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732145",
                                                                                    "variationId": "114431778"
                                                                                }
                                                                            ],
                                                                            "price": 16000
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 11500,
                                                                "ribbon": {
                                                                    "text": "Bestseller",
                                                                    "textColor": "#ffffff",
                                                                    "topBackgroundColor": "#d53d4c",
                                                                    "bottomBackgroundColor": "#b02331"
                                                                },
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "isBestseller": true,
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.3",
                                                                        "ratingCount": "71 ratings",
                                                                        "ratingCountV2": "71"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "110256295",
                                                                "name": "Capsicum & Red Paprika with Videshi Hot Sauce",
                                                                "category": "PIZZA MANIA",
                                                                "description": "Internationally inspired Hot sauce to cater your spice cravings loaded with crisp Capsicum and spicy Red Paprika.",
                                                                "imageId": "8a2543c260fc6d8f461de94481723cc6",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732463",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432760",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732465",
                                                                                        "variationId": "114432765"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432762",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732465",
                                                                                        "variationId": "114432765"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732465",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432765",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732463",
                                                                                    "variationId": "114432762"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732465",
                                                                                    "variationId": "114432765"
                                                                                }
                                                                            ],
                                                                            "price": 9500
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732463",
                                                                                    "variationId": "114432760"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732465",
                                                                                    "variationId": "114432765"
                                                                                }
                                                                            ],
                                                                            "price": 14000
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 9500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.2",
                                                                        "ratingCount": "48 ratings",
                                                                        "ratingCountV2": "48"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520736",
                                                                "name": "Pepper Barbecue Chicken",
                                                                "category": "PIZZA MANIA",
                                                                "description": "Pepper barbecue chicken for that extra zing",
                                                                "imageId": "352e0cafc4caef8ef5f4eac224b1db46",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732393",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432550",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732394",
                                                                                        "variationId": "114432552"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432551",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732394",
                                                                                        "variationId": "114432552"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732394",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432552",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732393",
                                                                                    "variationId": "114432551"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732394",
                                                                                    "variationId": "114432552"
                                                                                }
                                                                            ],
                                                                            "price": 12500
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732393",
                                                                                    "variationId": "114432550"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732394",
                                                                                    "variationId": "114432552"
                                                                                }
                                                                            ],
                                                                            "price": 15500
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 12500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.2",
                                                                        "ratingCount": "103 ratings",
                                                                        "ratingCountV2": "103"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520738",
                                                                "name": "Chicken Sausage",
                                                                "category": "PIZZA MANIA",
                                                                "description": "American classic! Spicy, herbed chicken sausage on pizza",
                                                                "imageId": "991a7fd58aa8d1598537b965937fd904",
                                                                "inStock": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732088",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114431601",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732089",
                                                                                        "variationId": "114431603"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114431602",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732089",
                                                                                        "variationId": "114431603"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732089",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431603",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732088",
                                                                                    "variationId": "114431602"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732089",
                                                                                    "variationId": "114431603"
                                                                                }
                                                                            ],
                                                                            "price": 10900
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732088",
                                                                                    "variationId": "114431601"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732089",
                                                                                    "variationId": "114431603"
                                                                                }
                                                                            ],
                                                                            "price": 13900
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 10900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.4",
                                                                        "ratingCount": "44 ratings",
                                                                        "ratingCountV2": "44"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520739",
                                                                "name": "Golden Corn",
                                                                "category": "PIZZA MANIA",
                                                                "description": "Sweet & juicy golden corn for that lipsmacking taste",
                                                                "imageId": "a302da0d414837495c1576b64dd943e0",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732279",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "id": "114432207",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732280",
                                                                                        "variationId": "114432209"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "114432208",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732280",
                                                                                        "variationId": "114432209"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732280",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432209",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732279",
                                                                                    "variationId": "114432208"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732280",
                                                                                    "variationId": "114432209"
                                                                                }
                                                                            ],
                                                                            "price": 9500
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732279",
                                                                                    "variationId": "114432207"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732280",
                                                                                    "variationId": "114432209"
                                                                                }
                                                                            ],
                                                                            "price": 12500
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 9500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.3",
                                                                        "ratingCount": "104 ratings",
                                                                        "ratingCountV2": "104"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520742",
                                                                "name": "Onion",
                                                                "category": "PIZZA MANIA",
                                                                "description": "Our classic Pizza Mania topped with crunchy Onions",
                                                                "imageId": "2cdd0e3b01910393d5e9361822b1b02c",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732283",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "default": 1,
                                                                                    "id": "114432213",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732284",
                                                                                        "variationId": "114432215"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114432214",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732284",
                                                                                        "variationId": "114432215"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732284",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114432215",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732283",
                                                                                    "variationId": "114432213"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732284",
                                                                                    "variationId": "114432215"
                                                                                }
                                                                            ],
                                                                            "price": 10500
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732283",
                                                                                    "variationId": "114432214"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732284",
                                                                                    "variationId": "114432215"
                                                                                }
                                                                            ],
                                                                            "price": 7500
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 10500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.4",
                                                                        "ratingCount": "49 ratings",
                                                                        "ratingCountV2": "49"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "110432585",
                                                                "name": "Classic",
                                                                "category": "PIZZA MANIA",
                                                                "description": "A classic pizza topped with sprinkle of basil and parsley herbs",
                                                                "imageId": "f05bf56a2943904aff5e4a8357a4c3c8",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "36732207",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Fresh Pan Pizza",
                                                                                    "default": 1,
                                                                                    "id": "114431971",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732208",
                                                                                        "variationId": "114431973"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Classic Hand Tossed",
                                                                                    "id": "114431972",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "36732208",
                                                                                        "variationId": "114431973"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "36732208",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "114431973",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732207",
                                                                                    "variationId": "114431971"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732208",
                                                                                    "variationId": "114431973"
                                                                                }
                                                                            ],
                                                                            "price": 7900
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "36732207",
                                                                                    "variationId": "114431972"
                                                                                },
                                                                                {
                                                                                    "groupId": "36732208",
                                                                                    "variationId": "114431973"
                                                                                }
                                                                            ],
                                                                            "price": 4900
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 7900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.6",
                                                                        "ratingCount": "45 ratings",
                                                                        "ratingCountV2": "45"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "GARLIC BREADS & MORE",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334594",
                                                                "name": "Korean Corn & Jalapeno Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly baked garlic bread infused with Korean Sweet Chili Sauce, Molten cheese, juicy corn & tangy jalapeno",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/35184d75-6f5c-41b3-8828-62bf49504081_cb9a47d7-033c-45ab-8d8e-1df1e10e7702.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 17900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334606",
                                                                "name": "Fiery Corn & Jalapeno Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly baked garlic bread infused with Spicy Guntur Sauce, Molten cheese, juicy corn & tangy jalapeno",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/41506801-397d-47b4-b3e8-83941a532d4b_c2dae010-a077-4d16-a92f-8bfc6ce60b9c.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 17900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334613",
                                                                "name": "Makhani Corn & Jalapeno Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly baked garlic bread infused with Creamy Makhani Sauce, Molten cheese, juicy corn & tangy jalapeno",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/06e38828-8fb8-4c1a-9345-38ed7c870837_bf157858-e0d7-48c0-baeb-6268b4011ea9.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 17900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334604",
                                                                "name": "Korean Paneer Tikka Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly Baked Stuffed Garlic Bread infused with Korean Sweet Chili Sauce, Molten Cheese, Onion and Paneer Tikka fillings",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/fc919fcc-93d6-4e06-9863-b156f17b3b5c_c3be0537-efb5-48b8-b9e3-2d8e953523c7.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 17900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334567",
                                                                "name": "Fiery Paneer Tikka Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly Baked Stuffed Garlic Bread infused with Spicy Guntur Sauce, Molten Cheese, Onion and Paneer Tikka fillings",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/e93f73f1-046f-4f4d-9b79-fb363adf2f95_1a3b165d-a610-4a6b-8b82-403695d85f7d.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 17900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334566",
                                                                "name": "Makhani Paneer Tikka Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly Baked Stuffed Garlic Bread infused with Creamy Makhani Sauce, Molten Cheese, Onion and Paneer Tikka fillings",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/4acaeb70-60a1-42c2-a96b-6f6589066c0a_eb8c9567-ebe8-468b-abb4-194bccfd736f.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 17900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334580",
                                                                "name": "Korean Pepperoni Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly Baked Garlic Bread infused with Korean Sweet Chili Sauce, Delectable Chicken Pepperoni & molten Cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/14f097d9-4137-44e5-adf7-1946955691a4_60ca9cf7-9667-4b7c-8c83-822dee18ed70.jpg",
                                                                "inStock": 1,
                                                                "price": 17900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334584",
                                                                "name": "Fiery Pepperoni Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly Baked Garlic Bread infused with Spicy Guntur Sauce, Delectable Chicken Pepperoni & molten Cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/d4615d55-3524-4a49-9a7b-4d552501c547_9b9d462d-8eac-47d0-9030-42f9cb88370d.jpg",
                                                                "inStock": 1,
                                                                "price": 17900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "153334601",
                                                                "name": "Makhani Pepperoni Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly Baked Garlic Bread infused with Creamy Makhani Sauce, Delectable Chicken Pepperoni & molten Cheese",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/433d39f6-fd23-4139-9bbe-9633e924a12d_28f705a6-d03d-48ca-8d94-3a39f4e90f88.jpg",
                                                                "inStock": 1,
                                                                "price": 17900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520707",
                                                                "name": "Garlic Breadsticks",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Baked to perfection. Your perfect pizza partner! Tastes best with dip",
                                                                "imageId": "1633e1c6916141a456e5c4dbda6c0b4e",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 11500,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {
                                                                    "text": "Bestseller",
                                                                    "textColor": "#ffffff",
                                                                    "topBackgroundColor": "#d53d4c",
                                                                    "bottomBackgroundColor": "#b02331"
                                                                },
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "isBestseller": true,
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.5",
                                                                        "ratingCount": "104 ratings",
                                                                        "ratingCountV2": "104"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520708",
                                                                "name": "Classic Stuffed Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly baked garlic bread with cheese, juicy corn & tangy jalapeno",
                                                                "imageId": "676c42f9653340f8fec500bedbab2714",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 16500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {
                                                                    "text": "Bestseller",
                                                                    "textColor": "#ffffff",
                                                                    "topBackgroundColor": "#d53d4c",
                                                                    "bottomBackgroundColor": "#b02331"
                                                                },
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "isBestseller": true,
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.3",
                                                                        "ratingCount": "79 ratings",
                                                                        "ratingCountV2": "79"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520710",
                                                                "name": "Cheesy Dip",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "An all-time favorite with your Garlic Breadsticks & Stuffed Garlic Bread for a Cheesy indulgence",
                                                                "imageId": "a325ca68cb886844e4864a43f7cdf48a",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 2857,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.6",
                                                                        "ratingCount": "72 ratings",
                                                                        "ratingCountV2": "72"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520651",
                                                                "name": "Paneer Tikka Stuffed Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly Baked Stuffed Garlic Bread with Cheese, Onion and Paneer Tikka fillings. Comes with a dash of Basil Parsley Sprinkle on top",
                                                                "imageId": "a3aea7aa78dad6063b9e58dffe137ad4",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 17500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.4",
                                                                        "ratingCount": "38 ratings",
                                                                        "ratingCountV2": "38"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520652",
                                                                "name": "Chicken Pepperoni Stuffed Garlic Bread",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Freshly Baked Garlic Bread stuffed with Delectable Chicken Pepperoni, Cheese and sprinkled with Basil Parsley",
                                                                "imageId": "bef98f394ddb464599cad2b3fe34d7d0",
                                                                "inStock": 1,
                                                                "price": 17500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.6",
                                                                        "ratingCount": "49 ratings",
                                                                        "ratingCountV2": "49"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520730",
                                                                "name": "Taco Mexicana Veg",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Truly irresistible! Crispy taco with veg patty & creamy harissa sauce",
                                                                "imageId": "bff19c7eeec11a2f3da22516d169b178",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 14900,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.4",
                                                                        "ratingCount": "31 ratings",
                                                                        "ratingCountV2": "31"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520729",
                                                                "name": "Taco Mexicana Non Veg",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Truly irresistible! Crispy taco with non-veg patty & creamy harissa sauce",
                                                                "imageId": "118610bb1b497c0090177b709a452636",
                                                                "inStock": 1,
                                                                "price": 18500,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {
                                                                    "text": "Bestseller",
                                                                    "textColor": "#ffffff",
                                                                    "topBackgroundColor": "#d53d4c",
                                                                    "bottomBackgroundColor": "#b02331"
                                                                },
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "isBestseller": true,
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.4",
                                                                        "ratingCount": "71 ratings",
                                                                        "ratingCountV2": "71"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520732",
                                                                "name": "Veg Parcel",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Snacky bites! Pizza rolls with paneer & creamy harissa sauce",
                                                                "imageId": "8ba74a9b3310071b1d40233779a13e1e",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 4900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.3",
                                                                        "ratingCount": "86 ratings",
                                                                        "ratingCountV2": "86"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520713",
                                                                "name": "Chicken Parcel",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Snacky bites! Pizza rolls with chicken sausage & creamy harissa sauce",
                                                                "imageId": "71db5a4175ec65fee10846a8eae012c5",
                                                                "inStock": 1,
                                                                "price": 5900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.0",
                                                                        "ratingCount": "66 ratings",
                                                                        "ratingCountV2": "66"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520715",
                                                                "name": "Burger Pizza - Classic Veg",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Oven-baked buns with cheese, tomato & capsicum in creamy mayo",
                                                                "imageId": "afe9096778a80464e5fe9e31ee4fa85d",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 12900,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.4",
                                                                        "ratingCount": "29 ratings",
                                                                        "ratingCountV2": "29"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "101995983",
                                                                "name": "Harissa Dip",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "A spicy & peppery pizza dip which can help you add the right amount of spiciness to your favorite pizza slices.",
                                                                "imageId": "9a27f14dd6535b2e4017451a6b7ea895",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 4667,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "5.0",
                                                                        "ratingCount": "6 ratings",
                                                                        "ratingCountV2": "6"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "101995982",
                                                                "name": "Basil Pesto Dip",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Your perfect pizza partner!  Savour your pizza slices with this new rich, herby & salty dip with the goodness of basil leaves & nuts that will surely give you a new flavor dimension!",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/11/443745b1-c046-4cfb-99ed-bd62664ef368_d6669a4f-ffd1-4900-98c6-fa165e4bf7ee.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 4667,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.7",
                                                                        "ratingCount": "9 ratings",
                                                                        "ratingCountV2": "9"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520731",
                                                                "name": "Taco Mexicana Veg (Single)",
                                                                "category": "GARLIC BREADS & MORE",
                                                                "description": "Truly irresistible! Crispy taco with veg patty & creamy harissa sauce",
                                                                "imageId": "50bf5f2488d4d147fbd6adf0c47b63b6",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 8500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.1",
                                                                        "ratingCount": "49 ratings",
                                                                        "ratingCountV2": "49"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "DESSERTS",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "151984660",
                                                                "name": "Choco Lava Cake Gift Hamper",
                                                                "category": "DESSERTS",
                                                                "description": "Dive into the ultimate dessert experience with our Lavalicious Combo that\u2019s Made to Share. \n*We don't include a spoon or napkin to support sustainability",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/29/d5e06efa-1d18-4955-b228-d59f8be72347_1a9248a1-9e49-49d7-bb98-3e75101a2de4.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 34500,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "3.6",
                                                                        "ratingCount": "3 ratings",
                                                                        "ratingCountV2": "3"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520653",
                                                                "name": "Red Velvet Lava Cake",
                                                                "category": "DESSERTS",
                                                                "description": "A truly indulgent experience with sweet and rich red velvet cake on a creamy cheese flavoured base to give a burst of flavour in every bite!",
                                                                "imageId": "5b3d592a85ad33a732d18bb41fdfc59f",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 14500,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.2",
                                                                        "ratingCount": "8 ratings",
                                                                        "ratingCountV2": "8"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520709",
                                                                "name": "Choco Lava Cake",
                                                                "category": "DESSERTS",
                                                                "description": "Chocolate lovers delight! Indulgent, gooey molten lava inside chocolate cake",
                                                                "imageId": "517791a68253a9a5084664b470f6e115",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 11500,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {
                                                                    "text": "Bestseller",
                                                                    "textColor": "#ffffff",
                                                                    "topBackgroundColor": "#d53d4c",
                                                                    "bottomBackgroundColor": "#b02331"
                                                                },
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "isBestseller": true,
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.5",
                                                                        "ratingCount": "77 ratings",
                                                                        "ratingCountV2": "77"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520712",
                                                                "name": "Butterscotch Mousse Cake",
                                                                "category": "DESSERTS",
                                                                "description": "Sweet temptation! Butterscotch flavored mousse",
                                                                "imageId": "e91002ccf7239fffeceaab4956a15a3a",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 10381,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.3",
                                                                        "ratingCount": "19 ratings",
                                                                        "ratingCountV2": "19"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "BEVERAGES",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520673",
                                                                "name": "Pepsi 475ml",
                                                                "category": "BEVERAGES",
                                                                "description": "Sparkling and Refreshing Beverage",
                                                                "imageId": "f6af24125864ca5dcd44bd41b5fc9f47",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 5714,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {
                                                                    "text": "Bestseller",
                                                                    "textColor": "#ffffff",
                                                                    "topBackgroundColor": "#d53d4c",
                                                                    "bottomBackgroundColor": "#b02331"
                                                                },
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "isBestseller": true,
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.6",
                                                                        "ratingCount": "103 ratings",
                                                                        "ratingCountV2": "103"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520677",
                                                                "name": "Pepsi Black Can 300ml",
                                                                "category": "BEVERAGES",
                                                                "description": "Maximum Taste Zero Calories",
                                                                "imageId": "1100f94a18b2801492c0909f06eafce1",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 5714,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.8",
                                                                        "ratingCount": "25 ratings",
                                                                        "ratingCountV2": "25"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520674",
                                                                "name": "7Up 475ml",
                                                                "category": "BEVERAGES",
                                                                "description": "Refreshing clear drink with a natural lemon flavor",
                                                                "imageId": "216209b36b8c5be6dc19d1e371027bc1",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 5714,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "2.8",
                                                                        "ratingCount": "6 ratings",
                                                                        "ratingCountV2": "6"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520676",
                                                                "name": "Mirinda 475ml",
                                                                "category": "BEVERAGES",
                                                                "description": "Delicious Orange Flavoured beverage",
                                                                "imageId": "5490c2372f73e90456bc8dbf1e0ad590",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 5714,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.9",
                                                                        "ratingCount": "11 ratings",
                                                                        "ratingCountV2": "11"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "104954946",
                                                                "name": "Nagpur Orange",
                                                                "category": "BEVERAGES",
                                                                "description": "Enjoy Oranges from Nagpur with the goodness of Fiber",
                                                                "imageId": "cace054d6d50a3af9f62284a5ce99192",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 7143,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520682",
                                                                "name": "B Natural Mixed Fruit from Himalayas (300 ml)",
                                                                "category": "BEVERAGES",
                                                                "description": "Premium fruits from Himalayas with the Goodness of Fiber",
                                                                "imageId": "7f82838f68c1908ca6db2141cf7c5e8c",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 7143,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520685",
                                                                "name": "Lipton Ice Tea ( 350 ml)",
                                                                "category": "BEVERAGES",
                                                                "description": "Refreshment Sahi, Gas Nahi",
                                                                "imageId": "357a369a728d26d67e6dafdef7f608e8",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 5714,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.6",
                                                                        "ratingCount": "6 ratings",
                                                                        "ratingCountV2": "6"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "94520678",
                                                                "name": "Mountain Dew 475ml",
                                                                "category": "BEVERAGES",
                                                                "description": "Strong and Refreshing",
                                                                "imageId": "f918a51abf521e6fd8a950ce759a7fbf",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 5714,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "2.8",
                                                                        "ratingCount": "5 ratings",
                                                                        "ratingCountV2": "5"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "155724791",
                                                                "name": "Aquavess Water (500ml)",
                                                                "category": "BEVERAGES",
                                                                "description": "Packaged Drinking Water",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/5/8c6e7af7-c041-498c-9f32-1d7791c25ee0_a8905b77-9e95-4236-a6f4-700034950fc0.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 2858,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Pizza & More",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740129",
                                                                "name": "Margherita Pizza Regular",
                                                                "category": "Pizza & More",
                                                                "description": "Classic delight with 100% real mozzarella cheese.",
                                                                "imageId": "7850b115687ee8594f9d7f0a66c2ee84",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "price": 10900,
                                                                "finalPrice": 8900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "5.0",
                                                                        "ratingCount": "5 ratings",
                                                                        "ratingCountV2": "5"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Deal on Regular Pizza",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150146038",
                                                                "name": "Mexican Green Wave Pizza - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                                                                "imageId": "0d1949eef23c572096269d890e438efb",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528198",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203779",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528199",
                                                                                        "variationId": "164203780"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528199",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203780",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528198",
                                                                                    "variationId": "164203779"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528199",
                                                                                    "variationId": "164203780"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 27900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150146037",
                                                                "name": "Veggie Paradise Pizza - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "The awesome foursome! Golden corn, black olives, capsicum, red paprika",
                                                                "imageId": "2a8ea479040d62f82871e1be7470672a",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528194",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203775",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528195",
                                                                                        "variationId": "164203776"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528195",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203776",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528194",
                                                                                    "variationId": "164203775"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528195",
                                                                                    "variationId": "164203776"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 27900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.7",
                                                                        "ratingCount": "3 ratings",
                                                                        "ratingCountV2": "3"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150146040",
                                                                "name": "Double Cheese Margherita Pizza - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "A classic delight loaded with extra 100% real mozzarella cheese",
                                                                "imageId": "15c3a34b64ec4298f2a0778d1b008919",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528204",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203791",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528205",
                                                                                        "variationId": "164203792"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528205",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203792",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528204",
                                                                                    "variationId": "164203791"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528205",
                                                                                    "variationId": "164203792"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 22900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150146042",
                                                                "name": "Farmhouse Pizza - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "Delightful combination of onion, capsicum, tomato & grilled mushroom. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "740a92bd202ffd40813bc354b86005db",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528232",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203840",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528233",
                                                                                        "variationId": "164203841"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528233",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203841",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528232",
                                                                                    "variationId": "164203840"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528233",
                                                                                    "variationId": "164203841"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 27900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.5",
                                                                        "ratingCount": "5 ratings",
                                                                        "ratingCountV2": "5"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150146041",
                                                                "name": "Peppy Paneer Pizza - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "Flavorful trio of juicy paneer, crisp capsicum with spicy red paprika",
                                                                "imageId": "0581f2e3b7d0b3ede4b476c1d64a6434",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528228",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203833",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528229",
                                                                                        "variationId": "164203834"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528229",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203834",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528228",
                                                                                    "variationId": "164203833"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528229",
                                                                                    "variationId": "164203834"
                                                                                }
                                                                            ],
                                                                            "price": 27900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 27900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150146036",
                                                                "name": "Cheese n Corn Pizza - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "A delectable combination of sweet & juicy golden corn",
                                                                "imageId": "25f8cd12a914066c7c9627d42eafd926",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528184",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203759",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528185",
                                                                                        "variationId": "164203760"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528185",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203760",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528184",
                                                                                    "variationId": "164203759"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528185",
                                                                                    "variationId": "164203760"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 22900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "152102026",
                                                                "name": "Fresh Veggie Pizza - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "Delectable combination of onion & capsicum, a veggie lovers pick",
                                                                "imageId": "d9c548f1cb841844f151ffa3de873e4b",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528220",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203819",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528221",
                                                                                        "variationId": "164203820"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528221",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203820",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528220",
                                                                                    "variationId": "164203819"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528221",
                                                                                    "variationId": "164203820"
                                                                                }
                                                                            ],
                                                                            "price": 22900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 22900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150146043",
                                                                "name": "Fiery Sausage & Paprika - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "Spiciest non veg pizza with spicy & herby chicken sausage and red paprika toppings on a new spicy peri peri sauce base.",
                                                                "imageId": "2190eb54162d9a61e34e6970d53cbcc2",
                                                                "inStock": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528238",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203849",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528239",
                                                                                        "variationId": "164203850"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528239",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203850",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528238",
                                                                                    "variationId": "164203849"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528239",
                                                                                    "variationId": "164203850"
                                                                                }
                                                                            ],
                                                                            "price": 25500,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 25500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150146044",
                                                                "name": "Pepper Barbecue Chicken Pizza - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "Pepper barbecue chicken for that extra zing. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "7602a3d88b2aeb0053954d96be9a9829",
                                                                "inStock": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528242",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203856",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528243",
                                                                                        "variationId": "164203857"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528243",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203857",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528242",
                                                                                    "variationId": "164203856"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528243",
                                                                                    "variationId": "164203857"
                                                                                }
                                                                            ],
                                                                            "price": 26900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 26900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {
                                                                        "rating": "4.7",
                                                                        "ratingCount": "3 ratings",
                                                                        "ratingCountV2": "3"
                                                                    }
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150146035",
                                                                "name": "Blazing Chicken & Paprika - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "Hot & spicy chicken pizza with a combination of chicken keema & red paprika toppings and a new spicy peri peri sauce.",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/2/381126cc-5ec8-4475-9e13-7100a1238287_f147bac1-9e8e-43fa-921d-3a8f3958c8e8.jpg",
                                                                "inStock": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528182",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203757",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528183",
                                                                                        "variationId": "164203758"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528183",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203758",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528182",
                                                                                    "variationId": "164203757"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528183",
                                                                                    "variationId": "164203758"
                                                                                }
                                                                            ],
                                                                            "price": 25500,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 25500,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "152102025",
                                                                "name": "Chicken Sausage Pizza - Regular",
                                                                "category": "Deal on Regular Pizza",
                                                                "description": "American classic! Spicy, herbed chicken sausage on pizza",
                                                                "imageId": "5779285fbfb3c04730f0b71ba4132255",
                                                                "inStock": 1,
                                                                "finalPrice": 17900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528190",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "New Hand Tossed",
                                                                                    "default": 1,
                                                                                    "id": "164203768",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528191",
                                                                                        "variationId": "164203769"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528191",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203769",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528190",
                                                                                    "variationId": "164203768"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528191",
                                                                                    "variationId": "164203769"
                                                                                }
                                                                            ],
                                                                            "price": 21900,
                                                                            "finalPrice": {
                                                                                "units": "179"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 21900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Deal on Cheesy Pizzas",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740121",
                                                                "name": "Farmhouse Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Delightful combination of onion, capsicum, tomato & grilled mushroom. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "96df50829eda0c0ffcc5169aeeb86a14",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528202",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203786",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528203",
                                                                                        "variationId": "164203790"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203787",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528203",
                                                                                        "variationId": "164203790"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203788",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528203",
                                                                                        "variationId": "164203790"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203789",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528203",
                                                                                        "variationId": "164203790"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528203",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203790",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528202",
                                                                                    "variationId": "164203788"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528203",
                                                                                    "variationId": "164203790"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528202",
                                                                                    "variationId": "164203789"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528203",
                                                                                    "variationId": "164203790"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528202",
                                                                                    "variationId": "164203787"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528203",
                                                                                    "variationId": "164203790"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528202",
                                                                                    "variationId": "164203786"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528203",
                                                                                    "variationId": "164203790"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740117",
                                                                "name": "Peppy Paneer Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Flavorful trio of juicy paneer, crisp capsicum with spicy red paprika",
                                                                "imageId": "0581f2e3b7d0b3ede4b476c1d64a6434",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528180",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203752",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528181",
                                                                                        "variationId": "164203756"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203753",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528181",
                                                                                        "variationId": "164203756"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203754",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528181",
                                                                                        "variationId": "164203756"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203755",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528181",
                                                                                        "variationId": "164203756"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528181",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203756",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528180",
                                                                                    "variationId": "164203754"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528181",
                                                                                    "variationId": "164203756"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528180",
                                                                                    "variationId": "164203755"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528181",
                                                                                    "variationId": "164203756"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528180",
                                                                                    "variationId": "164203753"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528181",
                                                                                    "variationId": "164203756"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528180",
                                                                                    "variationId": "164203752"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528181",
                                                                                    "variationId": "164203756"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740122",
                                                                "name": "Indi Tandoori Paneer Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "It is hot. It is spicy. It is oh-so-Indian. Tandoori paneer with capsicum, red paprika & mint mayo. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "010b29da595df93d828ca0dca935821a",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528206",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203793",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528207",
                                                                                        "variationId": "164203797"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203794",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528207",
                                                                                        "variationId": "164203797"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203795",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528207",
                                                                                        "variationId": "164203797"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203796",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528207",
                                                                                        "variationId": "164203797"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528207",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203797",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528206",
                                                                                    "variationId": "164203795"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528207",
                                                                                    "variationId": "164203797"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528206",
                                                                                    "variationId": "164203796"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528207",
                                                                                    "variationId": "164203797"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528206",
                                                                                    "variationId": "164203794"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528207",
                                                                                    "variationId": "164203797"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528206",
                                                                                    "variationId": "164203793"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528207",
                                                                                    "variationId": "164203797"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 39400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740116",
                                                                "name": "Veg Extravaganza Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Black olives, capsicum, onion, grilled mushroom, corn, tomato, jalapeno & extra cheese. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "80355befb12f52c22eb75c6f865ca328",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528178",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203750",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528179",
                                                                                        "variationId": "164203751"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528179",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203751",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528178",
                                                                                    "variationId": "164203750"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528179",
                                                                                    "variationId": "164203751"
                                                                                }
                                                                            ],
                                                                            "price": 39400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 39400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740119",
                                                                "name": "Veggie Paradise Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "The awesome foursome! Golden corn, black olives, capsicum, red paprika",
                                                                "imageId": "2a8ea479040d62f82871e1be7470672a",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528192",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203770",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528193",
                                                                                        "variationId": "164203774"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203771",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528193",
                                                                                        "variationId": "164203774"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203772",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528193",
                                                                                        "variationId": "164203774"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203773",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528193",
                                                                                        "variationId": "164203774"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528193",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203774",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528192",
                                                                                    "variationId": "164203772"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528193",
                                                                                    "variationId": "164203774"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528192",
                                                                                    "variationId": "164203773"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528193",
                                                                                    "variationId": "164203774"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528192",
                                                                                    "variationId": "164203771"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528193",
                                                                                    "variationId": "164203774"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528192",
                                                                                    "variationId": "164203770"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528193",
                                                                                    "variationId": "164203774"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740126",
                                                                "name": "Double Cheese Margherita Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "A classic delight loaded with extra 100% real mozzarella cheese",
                                                                "imageId": "15c3a34b64ec4298f2a0778d1b008919",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528222",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203821",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528223",
                                                                                        "variationId": "164203825"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203822",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528223",
                                                                                        "variationId": "164203825"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203823",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528223",
                                                                                        "variationId": "164203825"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203824",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528223",
                                                                                        "variationId": "164203825"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528223",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203825",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528222",
                                                                                    "variationId": "164203823"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528223",
                                                                                    "variationId": "164203825"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528222",
                                                                                    "variationId": "164203824"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528223",
                                                                                    "variationId": "164203825"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528222",
                                                                                    "variationId": "164203822"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528223",
                                                                                    "variationId": "164203825"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528222",
                                                                                    "variationId": "164203821"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528223",
                                                                                    "variationId": "164203825"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740127",
                                                                "name": "Cheese n Corn Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "A delectable combination of sweet & juicy golden corn",
                                                                "imageId": "25f8cd12a914066c7c9627d42eafd926",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528224",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203826",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528225",
                                                                                        "variationId": "164203830"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203827",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528225",
                                                                                        "variationId": "164203830"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203828",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528225",
                                                                                        "variationId": "164203830"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203829",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528225",
                                                                                        "variationId": "164203830"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528225",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203830",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528224",
                                                                                    "variationId": "164203828"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528225",
                                                                                    "variationId": "164203830"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528224",
                                                                                    "variationId": "164203829"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528225",
                                                                                    "variationId": "164203830"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528224",
                                                                                    "variationId": "164203827"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528225",
                                                                                    "variationId": "164203830"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528224",
                                                                                    "variationId": "164203826"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528225",
                                                                                    "variationId": "164203830"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740130",
                                                                "name": "Pepper Barbecue Chicken Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Pepper barbecue chicken for that extra zing. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                                                "imageId": "7602a3d88b2aeb0053954d96be9a9829",
                                                                "inStock": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528236",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203844",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528237",
                                                                                        "variationId": "164203848"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203845",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528237",
                                                                                        "variationId": "164203848"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203846",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528237",
                                                                                        "variationId": "164203848"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203847",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528237",
                                                                                        "variationId": "164203848"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528237",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203848",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528236",
                                                                                    "variationId": "164203846"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528237",
                                                                                    "variationId": "164203848"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528236",
                                                                                    "variationId": "164203847"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528237",
                                                                                    "variationId": "164203848"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528236",
                                                                                    "variationId": "164203845"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528237",
                                                                                    "variationId": "164203848"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528236",
                                                                                    "variationId": "164203844"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528237",
                                                                                    "variationId": "164203848"
                                                                                }
                                                                            ],
                                                                            "price": 34400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 34400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740123",
                                                                "name": "Mexican Green Wave Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                                                                "imageId": "0d1949eef23c572096269d890e438efb",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528208",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203798",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528209",
                                                                                        "variationId": "164203802"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203799",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528209",
                                                                                        "variationId": "164203802"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203800",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528209",
                                                                                        "variationId": "164203802"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203801",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528209",
                                                                                        "variationId": "164203802"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528209",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203802",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528208",
                                                                                    "variationId": "164203800"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528209",
                                                                                    "variationId": "164203802"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528208",
                                                                                    "variationId": "164203801"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528209",
                                                                                    "variationId": "164203802"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528208",
                                                                                    "variationId": "164203799"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528209",
                                                                                    "variationId": "164203802"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528208",
                                                                                    "variationId": "164203798"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528209",
                                                                                    "variationId": "164203802"
                                                                                }
                                                                            ],
                                                                            "price": 35400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 35400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740120",
                                                                "name": "Fiery Sausage & Paprika \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Spiciest non veg pizza with spicy & herby chicken sausage and red paprika toppings on a new spicy peri peri sauce base.",
                                                                "imageId": "2190eb54162d9a61e34e6970d53cbcc2",
                                                                "inStock": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528200",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203781",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528201",
                                                                                        "variationId": "164203785"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203782",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528201",
                                                                                        "variationId": "164203785"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203783",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528201",
                                                                                        "variationId": "164203785"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203784",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528201",
                                                                                        "variationId": "164203785"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528201",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203785",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528200",
                                                                                    "variationId": "164203783"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528201",
                                                                                    "variationId": "164203785"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528200",
                                                                                    "variationId": "164203784"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528201",
                                                                                    "variationId": "164203785"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528200",
                                                                                    "variationId": "164203782"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528201",
                                                                                    "variationId": "164203785"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528200",
                                                                                    "variationId": "164203781"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528201",
                                                                                    "variationId": "164203785"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 33000,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740118",
                                                                "name": "Blazing Chicken & Paprika \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Hot & spicy chicken pizza with a combination of chicken keema & red paprika toppings and a new spicy peri peri sauce.",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/2/381126cc-5ec8-4475-9e13-7100a1238287_f147bac1-9e8e-43fa-921d-3a8f3958c8e8.jpg",
                                                                "inStock": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528188",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203763",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528189",
                                                                                        "variationId": "164203767"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203764",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528189",
                                                                                        "variationId": "164203767"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203765",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528189",
                                                                                        "variationId": "164203767"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203766",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528189",
                                                                                        "variationId": "164203767"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528189",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203767",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528188",
                                                                                    "variationId": "164203765"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528189",
                                                                                    "variationId": "164203767"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528188",
                                                                                    "variationId": "164203766"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528189",
                                                                                    "variationId": "164203767"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528188",
                                                                                    "variationId": "164203764"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528189",
                                                                                    "variationId": "164203767"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528188",
                                                                                    "variationId": "164203763"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528189",
                                                                                    "variationId": "164203767"
                                                                                }
                                                                            ],
                                                                            "price": 33000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 33000,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740131",
                                                                "name": "Chicken Fiesta Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Grilled chicken rashers, peri-peri chicken, onion & capsicum, a complete fiesta",
                                                                "imageId": "274348f5f584d2893c654f7880c3eacb",
                                                                "inStock": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528240",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203851",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528241",
                                                                                        "variationId": "164203855"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203852",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528241",
                                                                                        "variationId": "164203855"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203853",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528241",
                                                                                        "variationId": "164203855"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203854",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528241",
                                                                                        "variationId": "164203855"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528241",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203855",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528240",
                                                                                    "variationId": "164203853"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528241",
                                                                                    "variationId": "164203855"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528240",
                                                                                    "variationId": "164203854"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528241",
                                                                                    "variationId": "164203855"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528240",
                                                                                    "variationId": "164203852"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528241",
                                                                                    "variationId": "164203855"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528240",
                                                                                    "variationId": "164203851"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528241",
                                                                                    "variationId": "164203855"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 40400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740128",
                                                                "name": "Chicken Golden Delight \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Double pepper barbecue chicken, golden corn and extra cheese, true delight",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/27/3d22946c-ef95-495c-bedf-658566549a56_e29b66d9-60a0-4a1e-abe3-bec70737fab1.jpg",
                                                                "inStock": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528230",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203835",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528231",
                                                                                        "variationId": "164203839"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203836",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528231",
                                                                                        "variationId": "164203839"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203837",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528231",
                                                                                        "variationId": "164203839"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203838",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528231",
                                                                                        "variationId": "164203839"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528231",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203839",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528230",
                                                                                    "variationId": "164203837"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528231",
                                                                                    "variationId": "164203839"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528230",
                                                                                    "variationId": "164203838"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528231",
                                                                                    "variationId": "164203839"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528230",
                                                                                    "variationId": "164203836"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528231",
                                                                                    "variationId": "164203839"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528230",
                                                                                    "variationId": "164203835"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528231",
                                                                                    "variationId": "164203839"
                                                                                }
                                                                            ],
                                                                            "price": 40400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 40400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740124",
                                                                "name": "Fresh Veggie Pizza \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Delectable combination of onion & capsicum, a veggie lovers pick",
                                                                "imageId": "d9c548f1cb841844f151ffa3de873e4b",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528210",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203803",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528211",
                                                                                        "variationId": "164203807"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203804",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528211",
                                                                                        "variationId": "164203807"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203805",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528211",
                                                                                        "variationId": "164203807"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203806",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528211",
                                                                                        "variationId": "164203807"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528211",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203807",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528210",
                                                                                    "variationId": "164203805"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528211",
                                                                                    "variationId": "164203807"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528210",
                                                                                    "variationId": "164203806"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528211",
                                                                                    "variationId": "164203807"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528210",
                                                                                    "variationId": "164203804"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528211",
                                                                                    "variationId": "164203807"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528210",
                                                                                    "variationId": "164203803"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528211",
                                                                                    "variationId": "164203807"
                                                                                }
                                                                            ],
                                                                            "price": 30400,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 30400,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "150740125",
                                                                "name": "Spiced Double Chicken \u2013 Cheese Burst (Reg)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Delightful combination of our spicy duo- Pepper Barbecue Chicken and Peri Peri Chicken for Chicken Lovers.",
                                                                "imageId": "613401a1232b2bd8ba3c5ecb6173dc38",
                                                                "inStock": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528212",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Burst",
                                                                                    "default": 1,
                                                                                    "id": "164203808",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528213",
                                                                                        "variationId": "164203812"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Korean Sweet Chilli Cheese Burst",
                                                                                    "id": "164203809",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528213",
                                                                                        "variationId": "164203812"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Hot n Fiery Cheese Burst",
                                                                                    "id": "164203810",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528213",
                                                                                        "variationId": "164203812"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "name": "Creamy Makhani Cheese Burst",
                                                                                    "id": "164203811",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528213",
                                                                                        "variationId": "164203812"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528213",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular",
                                                                                    "default": 1,
                                                                                    "id": "164203812",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528212",
                                                                                    "variationId": "164203810"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528213",
                                                                                    "variationId": "164203812"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528212",
                                                                                    "variationId": "164203811"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528213",
                                                                                    "variationId": "164203812"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528212",
                                                                                    "variationId": "164203809"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528213",
                                                                                    "variationId": "164203812"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        },
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528212",
                                                                                    "variationId": "164203808"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528213",
                                                                                    "variationId": "164203812"
                                                                                }
                                                                            ],
                                                                            "price": 39000,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 39000,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "158463013",
                                                                "name": "Cheese Volcano Farmhouse (Reg Plus)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Centre loaded with Molten Cheese & topped with Onion, Capsicum, Tomato & Grilled Mushroom\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/4e30b1ff-dbe8-41d3-b083-d46b9d742ffc_636d161e-7f34-4371-b63c-bf9e3d091a0f.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528196",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "164203777",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528197",
                                                                                        "variationId": "164203778"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528197",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "164203778",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528196",
                                                                                    "variationId": "164203777"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528197",
                                                                                    "variationId": "164203778"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "158463018",
                                                                "name": "Cheese Volcano Peppy Paneer (Reg Plus)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Centre loaded with Molten Cheese & topped with peppy Paneer, Capsicum & Red Paprika\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/3ab84285-8164-4447-b534-f371913491c6_f91a0f02-a155-4a2a-8567-ae9d56ec5b2b.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528234",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "164203842",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528235",
                                                                                        "variationId": "164203843"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528235",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "164203843",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528234",
                                                                                    "variationId": "164203842"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528235",
                                                                                    "variationId": "164203843"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "158463011",
                                                                "name": "Cheese Volcano Veg Paradise (Reg Plus)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Centre loaded with Molten Cheese & topped with Golden Corn, Black Olives, Capsicum & Red Paprika\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/3e08f33d-98b7-41d2-acca-182da98e80f4_dd0b2e67-2a47-4a5e-b906-63e1277e7fa2.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528176",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "164203748",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528177",
                                                                                        "variationId": "164203749"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528177",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "164203749",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528176",
                                                                                    "variationId": "164203748"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528177",
                                                                                    "variationId": "164203749"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "158463012",
                                                                "name": "Corn & Cheese Volcano (Reg Plus)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Centre loaded with Molten Cheese & topped with juicy Golden Corn\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/375ae4df-de00-4235-97c5-3de32ebd969c_c7ea4a4e-86a9-467b-a42d-13e058670d28.jpg",
                                                                "inStock": 1,
                                                                "isVeg": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528186",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "164203761",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528187",
                                                                                        "variationId": "164203762"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528187",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "164203762",
                                                                                    "inStock": 1,
                                                                                    "isVeg": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528186",
                                                                                    "variationId": "164203761"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528187",
                                                                                    "variationId": "164203762"
                                                                                }
                                                                            ],
                                                                            "price": 31900,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "defaultPrice": 31900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "158463017",
                                                                "name": "Cheese Volcano BBQ Chicken (Reg Plus)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/bb8bf7b5-d084-4690-893e-ea5af460ad5d_fd69db19-9923-4ab7-936c-e2b1300a9b25.jpg",
                                                                "inStock": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528226",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "164203831",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528227",
                                                                                        "variationId": "164203832"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528227",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "164203832",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528226",
                                                                                    "variationId": "164203831"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528227",
                                                                                    "variationId": "164203832"
                                                                                }
                                                                            ],
                                                                            "price": 36900,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 36900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "158463014",
                                                                "name": "Cheese Volcano Double Chicken (Reg Plus)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken & Peri Peri Chicken.\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/a842381d-5d56-4a1e-99b8-4594170ae2c1_6d79c2a4-5aec-4067-acea-0afdfd875830.jpg",
                                                                "inStock": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528214",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "164203813",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528215",
                                                                                        "variationId": "164203814"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528215",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "164203814",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528214",
                                                                                    "variationId": "164203813"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528215",
                                                                                    "variationId": "164203814"
                                                                                }
                                                                            ],
                                                                            "price": 36900,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 36900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "158463015",
                                                                "name": "Cheese Volcano Blazing Chicken (Reg Plus)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Centre loaded with Molten Cheese & topped with Chicken Keema & Red Paprika with our spicy Peri Peri Sauce\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/e0d6d213-d5ac-45a7-b53f-d6c836d53659_33957602-94cc-4a32-9a21-6b65d35815fc.jpg",
                                                                "inStock": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528216",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "164203815",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528217",
                                                                                        "variationId": "164203816"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528217",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "164203816",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528216",
                                                                                    "variationId": "164203815"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528217",
                                                                                    "variationId": "164203816"
                                                                                }
                                                                            ],
                                                                            "price": 36900,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 36900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "158463016",
                                                                "name": "Cheese Volcano Chicken Delight (Reg Plus)",
                                                                "category": "Deal on Cheesy Pizzas",
                                                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken & Golden Corn\n*Contains non-edible container under the Pizza",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/ec91a814-b0f9-4911-b972-3c2a3583c684_d8de24fd-5109-4870-bf74-66f9ebb4ace5.jpg",
                                                                "inStock": 1,
                                                                "finalPrice": 25900,
                                                                "variants": {},
                                                                "variantsV2": {
                                                                    "variantGroups": [
                                                                        {
                                                                            "groupId": "52528218",
                                                                            "name": "Crust",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Cheese Volcano Crust",
                                                                                    "default": 1,
                                                                                    "id": "164203817",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1,
                                                                                    "dependantVariation": {
                                                                                        "groupId": "52528219",
                                                                                        "variationId": "164203818"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "groupId": "52528219",
                                                                            "name": "Size",
                                                                            "variations": [
                                                                                {
                                                                                    "name": "Regular Plus",
                                                                                    "default": 1,
                                                                                    "id": "164203818",
                                                                                    "inStock": 1,
                                                                                    "isEnabled": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "pricingModels": [
                                                                        {
                                                                            "variations": [
                                                                                {
                                                                                    "groupId": "52528218",
                                                                                    "variationId": "164203817"
                                                                                },
                                                                                {
                                                                                    "groupId": "52528219",
                                                                                    "variationId": "164203818"
                                                                                }
                                                                            ],
                                                                            "price": 36900,
                                                                            "finalPrice": {
                                                                                "units": "259"
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "defaultPrice": 36900,
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "offerTags": [
                                                                    {
                                                                        "matchText": "SILD"
                                                                    }
                                                                ],
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "itemNudgeType": "FinalPrice",
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                                "title": "Lunch Feast @149",
                                                "itemCards": [
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "156696940",
                                                                "name": "5 Course Meal: Classic Pizza",
                                                                "category": "Lunch Feast @149",
                                                                "description": "Pizza Mania Classic + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Pepsi (295ml)",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/21/ab698d6c-bb29-4c9f-b133-b7e464057e21_1fa409ff-2851-4b24-9809-6657fe6a769d.jpg",
                                                                "isVeg": 1,
                                                                "price": 14900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "156696937",
                                                                "name": "5 Course Meal: Onion Pizza",
                                                                "category": "Lunch Feast @149",
                                                                "description": "Pizza Mania Onion + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Pepsi (295ml)",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/21/8fd5b172-dc3e-425a-91e1-226b1fb8d850_5588d22d-7578-47e2-a185-0a4aa4a7f71a.jpg",
                                                                "isVeg": 1,
                                                                "price": 14900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "156696939",
                                                                "name": "5 Course Meal: Golden Corn Pizza",
                                                                "category": "Lunch Feast @149",
                                                                "description": "Pizza Mania Golden Corn + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Pepsi (295ml)",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/21/d930050d-9544-4079-a296-8a28e7ed4ce8_a2cf77de-7aa5-4186-b79a-e32fbaa535cb.jpg",
                                                                "isVeg": 1,
                                                                "price": 14900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                                                "itemAttribute": {
                                                                    "vegClassifier": "VEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "156696938",
                                                                "name": "5 Course Meal: Sausage Pizza",
                                                                "category": "Lunch Feast @149",
                                                                "description": "Pizza Mania Chicken Sausage + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Pepsi (295ml)",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/21/4ef6d858-1925-458d-99f8-cbcbdf5f8b3c_edc0bec2-9f5a-4004-a90c-c302d5d3d69f.jpg",
                                                                "price": 14900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    },
                                                    {
                                                        "card": {
                                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                            "info": {
                                                                "id": "156696936",
                                                                "name": "5 Course Meal: Pepper BBQ Pizza",
                                                                "category": "Lunch Feast @149",
                                                                "description": "Pizza Mania Pepper Barbecue Chicken + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Pepsi (295ml)",
                                                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/21/1e1bee49-56e3-4a2a-9deb-05da97b5aec3_1486d080-e316-42fa-8111-11092580fd19.jpg",
                                                                "price": 14900,
                                                                "variants": {},
                                                                "variantsV2": {},
                                                                "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                                                "itemAttribute": {
                                                                    "vegClassifier": "NONVEG"
                                                                },
                                                                "ribbon": {},
                                                                "type": "ITEM",
                                                                "itemBadge": {},
                                                                "badgesV2": {},
                                                                "ratings": {
                                                                    "aggregatedRating": {}
                                                                },
                                                                "itemPriceStrikeOff": true
                                                            },
                                                            "analytics": {},
                                                            "hideRestaurantDetails": true
                                                        }
                                                    }
                                                ],
                                                "subtitleSuffix": {}
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                                                "type": "FSSAI",
                                                "imageId": "fssai_final_edss9i",
                                                "text": [
                                                    "License No. 12022033000199"
                                                ]
                                            }
                                        }
                                    },
                                    {
                                        "card": {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                                                "name": "Domino's Pizza",
                                                "area": "Saheed Nagar",
                                                "completeAddress": "First Floor, PAL Heights, J/7, Jayadev Vihar,Bhubaneswar 751013, Odisha"
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            ],
            "firstOffsetRequest": true,
            "isQCLink": false
        },
        "tid": "bab4715f-39ae-42e7-b52d-6bd9deddb0b1",
        "sid": "hzye31f9-2cea-4491-9146-60fc1133aaa7",
        "deviceId": "aeaa645f-e1be-73a6-e16e-df98125d9e85",
        "csrfToken": "fZlh9fWJT130-RVraGBPhvpoU5a6xDBQK1Y6BDhM"
    }
];
var $4801adf787b4d484$export$2e2bcd8739ae039 = $4801adf787b4d484$var$menu;


const $2f94e4838a8deda4$var$ResMenu = ()=>{
    // State for restaurant menu data
    const [resInfo, setResInfo] = (0, $acw62.useState)(null);
    // for controlling the child component state
    const [showIndex, setShowIndex] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        // Replace with actual menu data fetching logic if necessary
        setResInfo((0, $4801adf787b4d484$export$2e2bcd8739ae039)); // assuming `menu` is a valid imported object
    }, []);
    console.log('The menu is ', (0, $4801adf787b4d484$export$2e2bcd8739ae039));
    console.log('the resInfo is ', resInfo);
    if (resInfo === null) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $YVclQ.default), {});
    const { name: name, cuisines: cuisines } = resInfo[0]?.data?.cards[2]?.card?.card?.info;
    console.log('The name is', name);
    const allCards = resInfo[0]?.data?.cards?.[5]?.groupedCard?.cardGroupMap?.REGULAR?.cards;
    // Step 1: Filter categories
    const filteredCategories = allCards.filter((res)=>res?.card?.card?.["@type"] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory");
    // Step 2: Map filtered categories to a simpler structure
    const categories = filteredCategories.map((category)=>({
            title: category?.card?.card?.title,
            itemCards: category?.card?.card?.itemCards
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white w-6/12 mt-[120px] mx-auto flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-blue-500 text-center",
                    children: "Menu"
                })
            }),
            categories.map((category, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $88c187899ad2ae99$export$2e2bcd8739ae039), {
                    category: category,
                    showIndex: index === showIndex,
                    setShowIndex: ()=>setShowIndex(index === showIndex ? null : index)
                }, index))
        ]
    });
};
var $2f94e4838a8deda4$export$2e2bcd8739ae039 = $2f94e4838a8deda4$var$ResMenu;




const $8b9d6dc968d848e3$var$appStore = (0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $32f12e1398bb8790$export$2e2bcd8739ae039)
    }
});
var $8b9d6dc968d848e3$export$2e2bcd8739ae039 = $8b9d6dc968d848e3$var$appStore;




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");





const $2112538953213f72$var$Cart = ()=>{
    const cartItems = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((store)=>store.cart.items);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleClearCart = ()=>{
        dispatch((0, $32f12e1398bb8790$export$810121176e3e3671)());
    };
    const handleRemoveItem = ()=>{
        dispatch((0, $32f12e1398bb8790$export$fe2d9b4e03920b4c)());
    };
    const handlePlaceOrder = ()=>{
        (0, $b00d3e7401eac195$export$b410431fab84fa58).success("Order has been placed successfully!", {
            position: "top-center",
            autoClose: 3000
        });
        dispatch((0, $32f12e1398bb8790$export$810121176e3e3671)());
    };
    const grandTotal = cartItems.reduce((total, item)=>total + (item?.card?.info?.price || item?.card?.info?.defaultPrice || 0), 0) / 100;
    const gst = +(grandTotal * 0.18).toFixed(2);
    const discount = +(grandTotal * 0.1).toFixed(2);
    const finalAmount = +(grandTotal + gst - discount).toFixed(2);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "my-[120px] text-center w-[95%] xs:w-[85%] sm:w-[75%] md:w-6/12 mx-auto bg-white p-2 xs:p-3 sm:p-5",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "font-bold p-2 xs:p-3 sm:p-5 text-blue-500 text-lg xs:text-xl sm:text-2xl border-b-2 border-gray-200",
                children: "Cart Items"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "my-2 xs:my-3 text-left",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13dafc1ce41e6291$export$2e2bcd8739ae039), {
                    itemdata: cartItems
                })
            }),
            cartItems.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-base xs:text-lg sm:text-xl",
                children: "No food items added yet...."
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "border-2 border-gray-200 pt-2 xs:pt-3 sm:pt-4 mt-2 xs:mt-3 sm:mt-4 text-left p-2 xs:p-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "font-bold text-base xs:text-lg sm:text-xl text-gray-700 mb-2 xs:mb-3",
                        children: "Summary"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-between text-sm xs:text-base",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Grand Total:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    "\u20B9",
                                    grandTotal
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-between text-sm xs:text-base",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "GST (18%):"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    "\u20B9",
                                    gst
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-between text-sm xs:text-base",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Discount (10%):"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    "-\u20B9",
                                    discount
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-between font-bold text-base xs:text-lg text-green-600 mt-2 xs:mt-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Final Amount:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    "\u20B9",
                                    finalAmount
                                ]
                            })
                        ]
                    })
                ]
            }),
            cartItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex border-t-2 border-gray-200 justify-between pt-2 xs:pt-3 sm:pt-4 mt-2 xs:mt-3 sm:mt-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: handleClearCart,
                        className: "clear-cart-bttn px-2 xs:px-3 sm:px-4 py-1 xs:py-2 text-sm xs:text-base bg-red-500 text-white rounded shadow hover:bg-red-600 transition duration-300",
                        children: "Clear Cart"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: handleRemoveItem,
                        className: "clear-cart-bttn px-2 xs:px-3 sm:px-4 py-1 xs:py-2 text-sm xs:text-base bg-yellow-500 text-white rounded shadow hover:bg-yellow-600 transition duration-300",
                        children: "Remove Item"
                    })
                ]
            }),
            cartItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-center mt-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: handlePlaceOrder,
                    className: "clear-cart-bttn px-2 xs:px-3 sm:px-4 py-1 xs:py-2 text-sm xs:text-base bg-yellow-500 text-white rounded shadow hover:bg-yellow-600 transition duration-300   w-5/12",
                    children: "Place Order"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {})
        ]
    });
};
var $2112538953213f72$export$2e2bcd8739ae039 = $2112538953213f72$var$Cart;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4eM2B = parcelRequire("4eM2B");
const $d5c7001fb908dd0e$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
        className: "py-4 sm:py-6 md:py-8 mt-5 mb-0 w-full bottom-0",
        style: {
            background: "linear-gradient(45deg, #f3a683, #78e08f)",
            color: "black"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container mx-auto px-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "col-span-2 sm:col-span-3 md:col-span-4 lg:col-span-1",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (0, $4eM2B.LOGO_URL),
                                alt: "Food Panda Logo",
                                className: "h-8 w-8 sm:h-12 sm:w-12 mr-2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "text-xl sm:text-2xl md:text-3xl font-semibold",
                                        children: "Food Panda"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-xs sm:text-sm",
                                        children: "\xa9 2024 Food Panda Limited"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "footer-column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "font-bold text-base sm:text-lg mb-2",
                            children: "Company"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "text-sm space-y-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "About Us"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Careers"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Team"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Food Panda Pro"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Food Panda Genie"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Minis"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "footer-column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "font-bold text-base sm:text-lg mb-2",
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "text-sm space-y-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Help & Support"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Partner With Us"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Drive With Us"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "font-bold text-base sm:text-lg mt-4 mb-2",
                            children: "Legal"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "text-sm space-y-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Terms & Conditions"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Privacy Policy"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Cookie Policy"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "footer-column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "font-bold text-base sm:text-lg mb-2",
                            children: "Available in:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "text-sm space-y-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Bhubaneswar"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Bangalore"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Delhi"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Mumbai"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Pune"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Hyderabad"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Chennai"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "footer-column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "font-bold text-base sm:text-lg mb-2",
                            children: "Life at Food Panda"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "text-sm space-y-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Explore with Food Panda"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "News"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Snacks & More"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "footer-social",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "font-bold text-base sm:text-lg mb-2 cursor-pointer",
                            children: "Social Links"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "social-icons flex space-x-4 text-xl sm:text-2xl",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "https://www.linkedin.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "hover:text-blue-600",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-linkedin"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "https://www.instagram.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "hover:text-pink-600",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-instagram"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "https://www.facebook.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "hover:text-blue-800",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-facebook"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "https://www.pinterest.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "hover:text-red-600",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-pinterest"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "https://www.twitter.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "hover:text-blue-400",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-twitter"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $d5c7001fb908dd0e$export$2e2bcd8739ae039 = $d5c7001fb908dd0e$var$Footer;



// import About from './components/About'
// using the lazy loading technique to import the about page
const $4c8cda5d2c6d1d8b$var$About = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("cc1va")));
/*
  Low level designing of the app
   1--> Header
    - logo
    - Nav Items

  2--> Body
    - Res-container
      -Res-card
    
  3--> Footer
    - CopyRight
    - Address
    -Link
    - Contact Info

    */ const $4c8cda5d2c6d1d8b$var$AppLayout = ()=>{
    const [userName, setUserName] = (0, $acw62.useState)("Rahul Ya"); // Moved inside the component
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
        store: (0, $8b9d6dc968d848e3$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3df07944bfa6aab3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bf6248e1ceb144a$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5c7001fb908dd0e$export$2e2bcd8739ae039), {})
        ]
    });
};
const $4c8cda5d2c6d1d8b$var$appRouter = (0, $040dbb9c344a508d$export$1f3f55432a00e06d)([
    {
        path: '/',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)($4c8cda5d2c6d1d8b$var$AppLayout, {}),
        children: [
            {
                path: '/',
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88d2c9e81e05d815$export$2e2bcd8739ae039), {})
            },
            {
                path: '/about',
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                    fallback: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        style: {
                            marginTop: '150px'
                        },
                        children: "Loading........"
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($4c8cda5d2c6d1d8b$var$About, {})
                })
            },
            {
                path: '/contact',
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18129c3b87767e8f$export$2e2bcd8739ae039), {})
            },
            {
                path: '/cart',
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2112538953213f72$export$2e2bcd8739ae039), {})
            },
            {
                path: '/res/:id',
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f94e4838a8deda4$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f0cc534f6c9aa78$export$2e2bcd8739ae039), {})
    }
]);
const $4c8cda5d2c6d1d8b$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root"));
$4c8cda5d2c6d1d8b$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bf6248e1ceb144a$export$323e4fc2fa4753fb), {
    router: $4c8cda5d2c6d1d8b$var$appRouter
}));


//# sourceMappingURL=index.b341fade.js.map
